import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddIdentityResponse = {
  __typename?: 'AddIdentityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Admin = {
  __typename?: 'Admin';
  address?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bvn?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  merchantProfile?: Maybe<MerchantProfile>;
  nin?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralPoint?: Maybe<Scalars['Int']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<AdminTenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminAdmins = {
  __typename?: 'AdminAdmins';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AdminExt = {
  __typename?: 'AdminExt';
  id: Scalars['ID']['output'];
  merchantProfile?: Maybe<MerchantProfilePwa>;
  shortId: Scalars['String']['output'];
};

export type AdminExt1 = {
  __typename?: 'AdminExt1';
  id: Scalars['ID']['output'];
  merchantProfile?: Maybe<MerchantProfileExt>;
  shortId: Scalars['String']['output'];
};

export type AdminExt2 = {
  __typename?: 'AdminExt2';
  id: Scalars['ID']['output'];
  merchantProfile?: Maybe<MerchantProfileExt>;
};

export type AdminFindAllTransactionResponse = {
  __typename?: 'AdminFindAllTransactionResponse';
  data: Array<Maybe<Transaction>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AdminPwa = {
  __typename?: 'AdminPWA';
  id: Scalars['ID']['output'];
  merchantProfile?: Maybe<MerchantProfilePwa>;
};

export type AdminTenant = {
  __typename?: 'AdminTenant';
  branding: TenantBranding;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Alert = {
  __typename?: 'Alert';
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  clickCount?: Maybe<Scalars['Int']['output']>;
  communityIds?: Maybe<Array<Scalars['String']['output']>>;
  communityScopeAll?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  deliveryMode?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSeen?: Maybe<Scalars['Boolean']['output']>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  locationScopeAll?: Maybe<Scalars['Boolean']['output']>;
  queuedCount?: Maybe<Scalars['Int']['output']>;
  readCount?: Maybe<Scalars['Int']['output']>;
  receivedCount?: Maybe<Scalars['Int']['output']>;
  scheduledAt?: Maybe<Scalars['String']['output']>;
  selectionSummary: AlertSelectionSummary;
  targetMode?: Maybe<Scalars['String']['output']>;
  targetUserCount?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  update: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AlertOverviewItem = {
  __typename?: 'AlertOverviewItem';
  totalClicks: Scalars['Int']['output'];
  totalNotificationsQueued: Scalars['Int']['output'];
  totalNotificationsSent: Scalars['Int']['output'];
  totalRead: Scalars['Int']['output'];
  totalUnread: Scalars['Int']['output'];
};

export type AlertOverviewResponse = {
  __typename?: 'AlertOverviewResponse';
  items: Array<AlertOverviewItem>;
};

export type AlertOverviewSummary = {
  __typename?: 'AlertOverviewSummary';
  totalAlerts: Scalars['Int']['output'];
  totalPushNotifications: Scalars['Int']['output'];
  totalSubscribedUsers: Scalars['Int']['output'];
};

export type AlertPwa = {
  __typename?: 'AlertPWA';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSeen?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  update: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AlertSelectionSummary = {
  __typename?: 'AlertSelectionSummary';
  roles: Array<Scalars['String']['output']>;
  targetMode: Scalars['String']['output'];
  userCount?: Maybe<Scalars['Int']['output']>;
  userIds: Array<Scalars['String']['output']>;
};

export type AppSetting = {
  __typename?: 'AppSetting';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEmail: Scalars['Boolean']['output'];
  isNotification: Scalars['Boolean']['output'];
  isPush: Scalars['Boolean']['output'];
  isSMS: Scalars['Boolean']['output'];
  location?: Maybe<LocationPwa>;
  topUpLimit: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type Balance = {
  __typename?: 'Balance';
  available_balance?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  ledger_balance?: Maybe<Scalars['Int']['output']>;
};

export type BalanceResponse = {
  __typename?: 'BalanceResponse';
  data?: Maybe<Balance>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Bank = {
  __typename?: 'Bank';
  bank: Scalars['String']['output'];
  bankCode: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BankListResponse = {
  __typename?: 'BankListResponse';
  data?: Maybe<Array<Maybe<FetchedBank>>>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BankPreference = {
  __typename?: 'BankPreference';
  accountNo: Scalars['String']['output'];
  bank: Bank;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BusinessOnboardingInput = {
  address: Scalars['String']['input'];
  addressAlt?: InputMaybe<Scalars['String']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  businessRegNumber: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyLocation: Scalars['String']['input'];
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  industryId: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regCountry: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type BusinessOnboardingResponse = {
  __typename?: 'BusinessOnboardingResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BusinessOnboardingStepOneResponse = {
  __typename?: 'BusinessOnboardingStepOneResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BusinessOnboardingStepTwoResponse = {
  __typename?: 'BusinessOnboardingStepTwoResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  active?: Maybe<Scalars['Boolean']['output']>;
  adminLevel?: Maybe<Scalars['String']['output']>;
  adminName?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  campaignLink?: Maybe<Scalars['String']['output']>;
  campaignType?: Maybe<Scalars['String']['output']>;
  clickThrough?: Maybe<Scalars['Int']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pollOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  question?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type CampaignClickThroughData = {
  __typename?: 'CampaignClickThroughData';
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CampaignClickThroughResponse = {
  __typename?: 'CampaignClickThroughResponse';
  data: Array<Maybe<CampaignClickThroughData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CampaignOverviewResponse = {
  __typename?: 'CampaignOverviewResponse';
  activeCampaigns?: Maybe<Scalars['Int']['output']>;
  expiredCampaigns?: Maybe<Scalars['Int']['output']>;
  totalCampaigns?: Maybe<Scalars['Int']['output']>;
  totalClicks?: Maybe<Scalars['Int']['output']>;
  totalImpressions?: Maybe<Scalars['Int']['output']>;
};

export type CampaignSubmissionData = {
  __typename?: 'CampaignSubmissionData';
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type CampaignSubmissionResponse = {
  __typename?: 'CampaignSubmissionResponse';
  data: Array<Maybe<CampaignSubmissionData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CashFlowOverviewAdminResponse = {
  __typename?: 'CashFlowOverviewAdminResponse';
  commissionEarned?: Maybe<Scalars['Float']['output']>;
  failedTransactionVolume?: Maybe<Scalars['Int']['output']>;
  pendingTransactionVolume?: Maybe<Scalars['Int']['output']>;
  successfulTransactionVolume?: Maybe<Scalars['Int']['output']>;
  totalPlatformBalance?: Maybe<Scalars['Float']['output']>;
  totalTransactionValue?: Maybe<Scalars['Float']['output']>;
  totalTransactionVolume?: Maybe<Scalars['Int']['output']>;
  totalWithdrawn?: Maybe<Scalars['Float']['output']>;
};

export type CashFlowOverviewResponse = {
  __typename?: 'CashFlowOverviewResponse';
  totalCashWithdrawn?: Maybe<Scalars['Int']['output']>;
  totalCurrentBalance?: Maybe<Scalars['Int']['output']>;
  totalTransactionValue?: Maybe<Scalars['Int']['output']>;
};

export type CashOutPointsResponse = {
  __typename?: 'CashOutPointsResponse';
  amount: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  pointsSpent: Scalars['Int']['output'];
  transactionId: Scalars['ID']['output'];
};

export type Category = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  imgSrc: Scalars['String']['output'];
  isArchive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CategoryMerchant = {
  __typename?: 'CategoryMerchant';
  id: Scalars['ID']['output'];
  imgSrc: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CategoryPwa = {
  __typename?: 'CategoryPWA';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imgSrc: Scalars['String']['output'];
  isArchive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Community = {
  __typename?: 'Community';
  alias: Scalars['String']['output'];
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CommunityEntity = {
  __typename?: 'CommunityEntity';
  createdAt: Scalars['String']['output'];
  createdBy: User;
  entityType?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CommunityEntityPwa = {
  __typename?: 'CommunityEntityPWA';
  entityType?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type CommunityMerchant = {
  __typename?: 'CommunityMerchant';
  alias: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CommunityPwa = {
  __typename?: 'CommunityPWA';
  alias: Scalars['String']['output'];
  colorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CommunityPoint = {
  __typename?: 'CommunityPoint';
  memberCommunityPoint?: Maybe<Scalars['Float']['output']>;
  partnerCommunityExchangeRate?: Maybe<Scalars['Float']['output']>;
};

export type CommunityWithSpend = {
  __typename?: 'CommunityWithSpend';
  community: Community;
  totalSpend: Scalars['Int']['output'];
};

export type CountClickThroughResponse = {
  __typename?: 'CountClickThroughResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CountOfferViewResponse = {
  __typename?: 'CountOfferViewResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateAdminInput = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  level: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAdminResponse = {
  __typename?: 'CreateAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateAlertResponse = {
  __typename?: 'CreateAlertResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateBankInput = {
  bank: Scalars['String']['input'];
  bankCode: Scalars['String']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBankPreferenceInput = {
  accountNo: Scalars['String']['input'];
  bankId: Scalars['String']['input'];
};

export type CreateBankPreferenceResponse = {
  __typename?: 'CreateBankPreferenceResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateBankResponse = {
  __typename?: 'CreateBankResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCampaignResponse = {
  __typename?: 'CreateCampaignResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCategoryResponse = {
  __typename?: 'CreateCategoryResponse';
  errors?: Maybe<Array<Error>>;
  imgSrcUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCommunityEntityInput = {
  entityType?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityEntityResponse = {
  __typename?: 'CreateCommunityEntityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCommunityResponse = {
  __typename?: 'CreateCommunityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerTierResponse = {
  __typename?: 'CreateCustomerTierResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateIndustryResponse = {
  __typename?: 'CreateIndustryResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateInterestResponse = {
  __typename?: 'CreateInterestResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateLocationInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationResponse = {
  __typename?: 'CreateLocationResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateOfferPointsDeductionResponse = {
  __typename?: 'CreateOfferPointsDeductionResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateOfferResponse = {
  __typename?: 'CreateOfferResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
};

export type CreatePartnerExchangeRateResponse = {
  __typename?: 'CreatePartnerExchangeRateResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreatePinResponse = {
  __typename?: 'CreatePinResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateRefundInput = {
  amount: Scalars['Float']['input'];
  customerName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  reasonForRefund?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};

export type CreateRefundInputAdmin = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  reasonForRefund?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};

export type CreateRefundResponse = {
  __typename?: 'CreateRefundResponse';
  data?: Maybe<TransferResponse>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateRepContactResponse = {
  __typename?: 'CreateRepContactResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateTenantInput = {
  branding?: InputMaybe<TenantBrandingInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  memberVerification?: InputMaybe<MemberVerification>;
  name: Scalars['String']['input'];
  ninCommunityAlias?: InputMaybe<Scalars['String']['input']>;
  pointValue?: InputMaybe<Scalars['Float']['input']>;
  pointsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pointsMaxSharePercent?: InputMaybe<Scalars['Int']['input']>;
  pointsMinCashout?: InputMaybe<Scalars['Int']['input']>;
  referralsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sesFromAddress?: InputMaybe<Scalars['String']['input']>;
  sesReplyTo?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  walletEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserPointExchangeResponse = {
  __typename?: 'CreateUserPointExchangeResponse';
  data?: Maybe<UserPointExchangeHistory>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateWithdrawalInput = {
  amount: Scalars['Float']['input'];
  bankPreferenceId: Scalars['String']['input'];
};

export type CreateWithdrawalInputAdmin = {
  amount: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bvn?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAmbassador?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  nin?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralPoint?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CustomerConnectIdReminderResponse = {
  __typename?: 'CustomerConnectIdReminderResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CustomerMerchant = {
  __typename?: 'CustomerMerchant';
  community?: Maybe<Array<Maybe<CommunityMerchant>>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CustomerOnboardingReferrer = {
  __typename?: 'CustomerOnboardingReferrer';
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type CustomerOverviewAdminResponse = {
  __typename?: 'CustomerOverviewAdminResponse';
  activeCustomers?: Maybe<Scalars['Int']['output']>;
  inActiveCustomers?: Maybe<Scalars['Int']['output']>;
  registeredCustomers?: Maybe<Scalars['Int']['output']>;
  totalAmbassador?: Maybe<Scalars['Int']['output']>;
  totalCurrentBalance?: Maybe<Scalars['Float']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
};

export type CustomerPwa = {
  __typename?: 'CustomerPWA';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CustomerPointsHistoryData = {
  __typename?: 'CustomerPointsHistoryData';
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  pointBalance?: Maybe<Scalars['Int']['output']>;
  tierBonus?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerPointsHistoryResponse = {
  __typename?: 'CustomerPointsHistoryResponse';
  data: Array<CustomerPointsHistoryData>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CustomerPointsOverviewResponse = {
  __typename?: 'CustomerPointsOverviewResponse';
  customerTier?: Maybe<Scalars['String']['output']>;
  lifeTimePoint?: Maybe<Scalars['Int']['output']>;
  pointBalance?: Maybe<Scalars['Int']['output']>;
};

export type CustomerRedemption = {
  __typename?: 'CustomerRedemption';
  customer: CustomerMerchant;
  redeemedCode: Scalars['String']['output'];
  redemptionDate: Scalars['String']['output'];
};

export type CustomerReferralOverview = {
  __typename?: 'CustomerReferralOverview';
  totalReferrals?: Maybe<Scalars['Int']['output']>;
};

export type CustomerSlim = {
  __typename?: 'CustomerSlim';
  createdAt?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CustomerTier = {
  __typename?: 'CustomerTier';
  name?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

export type CustomerTransactionGroup = {
  __typename?: 'CustomerTransactionGroup';
  createdAt: Scalars['String']['output'];
  transactions: Array<TransactionPwa>;
};

export type CustomerWhoRedeemedOffer = {
  __typename?: 'CustomerWhoRedeemedOffer';
  customer: Customer;
  location?: Maybe<Scalars['String']['output']>;
  totalSpent: Scalars['Float']['output'];
};

export type CustomerWithSpend = {
  __typename?: 'CustomerWithSpend';
  customer: CustomerMerchant;
  totalSpent: Scalars['Float']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CustomersOverviewOnboardingAdminResponse = {
  __typename?: 'CustomersOverviewOnboardingAdminResponse';
  accountsCreated?: Maybe<Scalars['Int']['output']>;
  accountsVerified?: Maybe<Scalars['Int']['output']>;
  idsConnected?: Maybe<Scalars['Int']['output']>;
  onboarded?: Maybe<Scalars['Int']['output']>;
};

export type DeactivateAdminInput = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type DeactivateAdminResponse = {
  __typename?: 'DeactivateAdminResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeactivateCustomerAdminInput = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type DeactivateCustomerAdminResponse = {
  __typename?: 'DeactivateCustomerAdminResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeactivateCustomerInput = {
  reason: Scalars['String']['input'];
};

export type DeactivateCustomerResponse = {
  __typename?: 'DeactivateCustomerResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeadLetterPushJob = {
  __typename?: 'DeadLetterPushJob';
  alertId: Scalars['String']['output'];
  attempt: Scalars['Int']['output'];
  deadLetteredAt: Scalars['String']['output'];
  enqueuedAt: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  maxAttempts: Scalars['Int']['output'];
};

export type DeleteAlertResponse = {
  __typename?: 'DeleteAlertResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteBankPreferenceResponse = {
  __typename?: 'DeleteBankPreferenceResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteCampaignResponse = {
  __typename?: 'DeleteCampaignResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteCategoryResponse = {
  __typename?: 'DeleteCategoryResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteCommunityResponse = {
  __typename?: 'DeleteCommunityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteIdentityResponse = {
  __typename?: 'DeleteIdentityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteIndustryResponse = {
  __typename?: 'DeleteIndustryResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteLocationResponse = {
  __typename?: 'DeleteLocationResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteOfferPointsDeductionResponse = {
  __typename?: 'DeleteOfferPointsDeductionResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteOfferResponse = {
  __typename?: 'DeleteOfferResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeletePartnerExchangeRateResponse = {
  __typename?: 'DeletePartnerExchangeRateResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteRepContactResponse = {
  __typename?: 'DeleteRepContactResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EmailOtpRequestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type ErrorType = {
  __typename?: 'ErrorType';
  errors?: Maybe<Array<FieldError>>;
};

export type FetchedBank = {
  __typename?: 'FetchedBank';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider_type?: Maybe<Scalars['String']['output']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type FindAdminAdminByIdResponse = {
  __typename?: 'FindAdminAdminByIdResponse';
  adminId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  userIsLocked?: Maybe<Scalars['Boolean']['output']>;
};

export type FindAdminMerchantsResponse = {
  __typename?: 'FindAdminMerchantsResponse';
  adminId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessRegNumber?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FindAllAdminAdminData = {
  __typename?: 'FindAllAdminAdminData';
  adminId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type FindAllAdminAdminResponse = {
  __typename?: 'FindAllAdminAdminResponse';
  data: Array<Maybe<FindAllAdminAdminData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllAlertsResponse = {
  __typename?: 'FindAllAlertsResponse';
  data: Array<Alert>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllAuditLogsResponse = {
  __typename?: 'FindAllAuditLogsResponse';
  data: Array<AuditLog>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalLogs?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
  uniqueEntities?: Maybe<Scalars['Int']['output']>;
};

export type FindAllCampaignsResponse = {
  __typename?: 'FindAllCampaignsResponse';
  data: Array<Maybe<Campaign>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCategoriesAdminResponse = {
  __typename?: 'FindAllCategoriesAdminResponse';
  data: Array<Category>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCommunityEntityResponse = {
  __typename?: 'FindAllCommunityEntityResponse';
  data: Array<CommunityEntity>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCommunitySpendResponse = {
  __typename?: 'FindAllCommunitySpendResponse';
  data: Array<CommunityWithSpend>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCustomerTiersData = {
  __typename?: 'FindAllCustomerTiersData';
  createdAt?: Maybe<Scalars['String']['output']>;
  customerCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  multiplier?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type FindAllCustomerTiersResponse = {
  __typename?: 'FindAllCustomerTiersResponse';
  data: Array<Maybe<FindAllCustomerTiersData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCustomerUserAdmin = {
  __typename?: 'FindAllCustomerUserAdmin';
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAmbassador?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FindAllCustomerUserByLocationIdAdmin = {
  __typename?: 'FindAllCustomerUserByLocationIdAdmin';
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FindAllCustomersAdmin = {
  __typename?: 'FindAllCustomersAdmin';
  community?: Maybe<Array<Maybe<Community>>>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<FindAllCustomerUserAdmin>;
};

export type FindAllCustomersAdminResponse = {
  __typename?: 'FindAllCustomersAdminResponse';
  data: Array<Maybe<FindAllCustomersAdmin>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCustomersByLocationIdAdminData = {
  __typename?: 'FindAllCustomersByLocationIdAdminData';
  community?: Maybe<Array<Maybe<Community>>>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<FindAllCustomerUserByLocationIdAdmin>;
};

export type FindAllCustomersByLocationIdAdminResponse = {
  __typename?: 'FindAllCustomersByLocationIdAdminResponse';
  data: Array<Maybe<FindAllCustomersByLocationIdAdminData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllCustomersOnboardingAdminData = {
  __typename?: 'FindAllCustomersOnboardingAdminData';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<CustomerOnboardingReferrer>;
  stage?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FindAllCustomersOnboardingAdminResponse = {
  __typename?: 'FindAllCustomersOnboardingAdminResponse';
  data: Array<Maybe<FindAllCustomersOnboardingAdminData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllIndustriesAdminResponse = {
  __typename?: 'FindAllIndustriesAdminResponse';
  data: Array<Industry>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllInterestData = {
  __typename?: 'FindAllInterestData';
  id?: Maybe<Scalars['ID']['output']>;
  numberOfCustomers?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  totalReceived?: Maybe<Scalars['Int']['output']>;
};

export type FindAllInterestResponse = {
  __typename?: 'FindAllInterestResponse';
  data: Array<Maybe<FindAllInterestData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllLocationsAdmin = {
  __typename?: 'FindAllLocationsAdmin';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerCount?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type FindAllLocationsAdminResponse = {
  __typename?: 'FindAllLocationsAdminResponse';
  data: Array<FindAllLocationsAdmin>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllMerchantsOnboardingAdminData = {
  __typename?: 'FindAllMerchantsOnboardingAdminData';
  adminId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  websiteOrSocials?: Maybe<Scalars['String']['output']>;
};

export type FindAllMerchantsOnboardingAdminResponse = {
  __typename?: 'FindAllMerchantsOnboardingAdminResponse';
  data: Array<Maybe<FindAllMerchantsOnboardingAdminData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllMerchantsSpendAdminData = {
  __typename?: 'FindAllMerchantsSpendAdminData';
  adminEmail?: Maybe<Scalars['String']['output']>;
  adminId?: Maybe<Scalars['ID']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  totalReceived?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FindAllMerchantsSpendAdminResponse = {
  __typename?: 'FindAllMerchantsSpendAdminResponse';
  data: Array<Maybe<FindAllMerchantsSpendAdminData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllMyCommunitySpendResponse = {
  __typename?: 'FindAllMyCommunitySpendResponse';
  data: Array<CommunityWithSpend>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllOfferPointsDeductionsResponse = {
  __typename?: 'FindAllOfferPointsDeductionsResponse';
  data: Array<Maybe<OfferPointsDeduction>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllOffersAdminResponse = {
  __typename?: 'FindAllOffersAdminResponse';
  data: Array<OfferMerchantAdmin>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllPartnerExchangeRatesResponse = {
  __typename?: 'FindAllPartnerExchangeRatesResponse';
  data: Array<Maybe<PartnerExchangeRate>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllRefundsAdmin = {
  __typename?: 'FindAllRefundsAdmin';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  currency: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reasonForRefund?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type FindAllRefundsAdminResponse = {
  __typename?: 'FindAllRefundsAdminResponse';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  refund?: Maybe<Array<FindAllRefundsAdmin>>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllUserPointExchangeHistoryResponse = {
  __typename?: 'FindAllUserPointExchangeHistoryResponse';
  data: Array<Maybe<UserPointExchangeHistory>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindAllWithdrawalsAdminResponse = {
  __typename?: 'FindAllWithdrawalsAdminResponse';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  withdrawals: Array<Withdrawal>;
};

export type FindBaseUrl = {
  __typename?: 'FindBaseUrl';
  baseUrl?: Maybe<Scalars['String']['output']>;
};

export type FindCustomerByIdAdminResponse = {
  __typename?: 'FindCustomerByIdAdminResponse';
  cbmId?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  customer?: Maybe<Customer>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FindCustomersWhoRedeemedOffersResponse = {
  __typename?: 'FindCustomersWhoRedeemedOffersResponse';
  data: Array<CustomerWhoRedeemedOffer>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindIsInterestResponse = {
  __typename?: 'FindIsInterestResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type FindLocationByIdAdminResponse = {
  __typename?: 'FindLocationByIdAdminResponse';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  customersCount?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FindMerchantByIdAdminResponse = {
  __typename?: 'FindMerchantByIdAdminResponse';
  admin?: Maybe<Admin>;
  createdAt: Scalars['String']['output'];
  forgotPasswordLocked: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  kycStatus: Scalars['String']['output'];
  lastLoggedIn?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Onboarding>;
  role: Scalars['String']['output'];
  suspended: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FindMerchantInterestsInterestedCustomers = {
  __typename?: 'FindMerchantInterestsInterestedCustomers';
  community?: Maybe<Array<Maybe<Community>>>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerUsername?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  totalSpend?: Maybe<Scalars['Int']['output']>;
};

export type FindMerchantInterestsResponse = {
  __typename?: 'FindMerchantInterestsResponse';
  companyName?: Maybe<Scalars['String']['output']>;
  data: Array<Maybe<FindMerchantInterestsInterestedCustomers>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  shortId?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  totalInterests?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type FindMyWithdrawalResponse = {
  __typename?: 'FindMyWithdrawalResponse';
  data: Array<WithdrawalWithTotal>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindRecentOfferRedemptionsResponse = {
  __typename?: 'FindRecentOfferRedemptionsResponse';
  data: Array<CustomerRedemption>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  redeemedCodes: Scalars['Int']['output'];
  remainingCodes: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalOfferViews: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindRedemptionsByOfferIdAdmin = {
  __typename?: 'FindRedemptionsByOfferIdAdmin';
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  redeemedCode?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  wallet?: Maybe<Wallet>;
};

export type FindRedemptionsByOfferIdAdminResponse = {
  __typename?: 'FindRedemptionsByOfferIdAdminResponse';
  data: Array<FindRedemptionsByOfferIdAdmin>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindRefundByIdAdminResponse = {
  __typename?: 'FindRefundByIdAdminResponse';
  admin?: Maybe<Admin>;
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reasonForRefund?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FindSubscribedAlertUsersResponse = {
  __typename?: 'FindSubscribedAlertUsersResponse';
  data: Array<SubscribedAlertUser>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FindTransactionsByCommunityIdResponse = {
  __typename?: 'FindTransactionsByCommunityIdResponse';
  data: Array<TransactionWithOverview>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  redeemedOffers: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalCommunitySize?: Maybe<Scalars['Int']['output']>;
  totalCustomers: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type FinishSignupResponse = {
  __typename?: 'FinishSignupResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCbmResponse = {
  __typename?: 'GetCBMResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCommunityPointResponse = {
  __typename?: 'GetCommunityPointResponse';
  data?: Maybe<CommunityPoint>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Identity = {
  __typename?: 'Identity';
  address?: Maybe<Scalars['String']['output']>;
  community?: Maybe<Community>;
  communityEntity?: Maybe<CommunityEntity>;
  createdAt: Scalars['String']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idNumber: Scalars['String']['output'];
  idType?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: User;
  phoneNumber: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validity: Scalars['String']['output'];
};

export type IdentityPwa = {
  __typename?: 'IdentityPWA';
  community?: Maybe<CommunityPwa>;
  communityEntity?: Maybe<CommunityEntityPwa>;
  dob?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idNumber: Scalars['String']['output'];
  idType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  validity: Scalars['String']['output'];
};

export type Industry = {
  __typename?: 'Industry';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partnerCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IndustryPwa = {
  __typename?: 'IndustryPWA';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InterestOverviewResponse = {
  __typename?: 'InterestOverviewResponse';
  customersWithInterest?: Maybe<Scalars['Int']['output']>;
  partnersWithInterest?: Maybe<Scalars['Int']['output']>;
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  district?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type LocationPwa = {
  __typename?: 'LocationPWA';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LoginAdminResponse = {
  __typename?: 'LoginAdminResponse';
  errors?: Maybe<Array<Error>>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sessionRole?: Maybe<Scalars['String']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type MarkAsSeenResponse = {
  __typename?: 'MarkAsSeenResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MarkCampaignResponse = {
  __typename?: 'MarkCampaignResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MarkNjoyCodeAsUsedResponse = {
  __typename?: 'MarkNjoyCodeAsUsedResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
  njoyCode?: Maybe<Scalars['String']['output']>;
};

export type MarkSharedOfferResponse = {
  __typename?: 'MarkSharedOfferResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum MemberVerification {
  Cbm = 'cbm'
}

export type Merchant = {
  __typename?: 'Merchant';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  merchantProfile?: Maybe<MerchantProfile>;
  phone: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MerchantOverviewAdminResponse = {
  __typename?: 'MerchantOverviewAdminResponse';
  activeMerchants?: Maybe<Scalars['Int']['output']>;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountWithdrawn?: Maybe<Scalars['Float']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  inActiveMerchants?: Maybe<Scalars['Int']['output']>;
  redeemedOffers?: Maybe<Scalars['Int']['output']>;
  registeredMerchants?: Maybe<Scalars['Int']['output']>;
  totalCurrentBalance?: Maybe<Scalars['Float']['output']>;
  totalWithdrawals?: Maybe<Scalars['Float']['output']>;
};

export type MerchantProfile = {
  __typename?: 'MerchantProfile';
  address?: Maybe<Scalars['String']['output']>;
  addressAlt?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessRegNumber?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  commissionRate?: Maybe<Scalars['Float']['output']>;
  companyLocation?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  regCountry?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  websiteOrSocials?: Maybe<Scalars['String']['output']>;
};

export type MerchantProfileExt = {
  __typename?: 'MerchantProfileExt';
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
};

export type MerchantProfilePwa = {
  __typename?: 'MerchantProfilePWA';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  companyLocation?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  websiteOrSocials?: Maybe<Scalars['String']['output']>;
};

export type MerchantsOverviewOnboardingAdminResponse = {
  __typename?: 'MerchantsOverviewOnboardingAdminResponse';
  accountsCreated?: Maybe<Scalars['Int']['output']>;
  accountsVerified?: Maybe<Scalars['Int']['output']>;
  onboarded1?: Maybe<Scalars['Int']['output']>;
  onboarded2?: Maybe<Scalars['Int']['output']>;
};

export type MockCreditWalletInput = {
  accountReference: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};

export type MockCreditWalletResponse = {
  __typename?: 'MockCreditWalletResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addIdentity: AddIdentityResponse;
  businessOnboarding: BusinessOnboardingResponse;
  businessOnboardingStepOne: BusinessOnboardingStepOneResponse;
  businessOnboardingStepTwo: BusinessOnboardingStepTwoResponse;
  cashOutPoints: CashOutPointsResponse;
  countClickThrough?: Maybe<CountClickThroughResponse>;
  countOfferView?: Maybe<CountOfferViewResponse>;
  createAdmin: CreateAdminResponse;
  createAlert: CreateAlertResponse;
  createBank: CreateBankResponse;
  createBankPreference: CreateBankPreferenceResponse;
  createCampaign: CreateCampaignResponse;
  createCategory: CreateCategoryResponse;
  createCommunity: CreateCommunityResponse;
  createCommunityEntity: CreateCommunityEntityResponse;
  createCustomerTier: CreateCustomerTierResponse;
  createIndustry: CreateIndustryResponse;
  createLocation?: Maybe<CreateLocationResponse>;
  createOffer: CreateOfferResponse;
  createOfferPointsDeduction: CreateOfferPointsDeductionResponse;
  createPartnerExchangeRate: CreatePartnerExchangeRateResponse;
  createPin: CreatePinResponse;
  createRefund: CreateRefundResponse;
  createRefundAdmin: CreateRefundResponse;
  createRepContact: CreateRepContactResponse;
  createTenant: Tenant;
  createUserPointExchange: CreateUserPointExchangeResponse;
  createWalletKyc?: Maybe<WalletKycResponse>;
  createWithdrawal: WalletTransferResponse;
  createWithdrawalAdmin: WalletTransferResponse;
  customerConnectIdReminder: CustomerConnectIdReminderResponse;
  deactivateAdmin: DeactivateAdminResponse;
  deactivateCustomer: DeactivateCustomerResponse;
  deactivateCustomerAdmin: DeactivateCustomerAdminResponse;
  deactivateTenant: Tenant;
  deleteAlert: DeleteAlertResponse;
  deleteBank: DeleteResponse;
  deleteBankPreference: DeleteBankPreferenceResponse;
  deleteCampaignById?: Maybe<DeleteCampaignResponse>;
  deleteCategory: DeleteCategoryResponse;
  deleteCommunity: DeleteCommunityResponse;
  deleteCommunityEntity: DeleteResponse;
  deleteIdentity: DeleteIdentityResponse;
  deleteIndustry: DeleteIndustryResponse;
  deleteLocation: DeleteLocationResponse;
  deleteOffer: DeleteOfferResponse;
  deleteOfferPointsDeduction: DeleteOfferPointsDeductionResponse;
  deletePartnerExchangeRate: DeletePartnerExchangeRateResponse;
  deleteRepContact: DeleteRepContactResponse;
  disableMyPushSubscriptions: PushSubscriptionResponse;
  emailOtpRequest: EmailOtpRequestResponse;
  finishSignup: FinishSignupResponse;
  forgotPasswordChange: ResetResponse;
  forgotPasswordChangeAdmin: ResetResponse;
  fundPointsPool: Tenant;
  getBalance: BalanceResponse;
  getBankList: BankListResponse;
  getCBM?: Maybe<GetCbmResponse>;
  getVirtualAccount: VirtualAccountResponse;
  ingestPushProviderEvents: PushProviderEventIngestResponse;
  login: LoginResponse;
  loginAdmin: LoginAdminResponse;
  logout?: Maybe<Scalars['Boolean']['output']>;
  markAsSeen: MarkAsSeenResponse;
  markCampaign?: Maybe<MarkCampaignResponse>;
  markNjoyCodeAsUsed: MarkNjoyCodeAsUsedResponse;
  markSharedOffer?: Maybe<MarkSharedOfferResponse>;
  mockCreditWallet: MockCreditWalletResponse;
  newMerchantApproval: NewMerchantApprovalResponse;
  otpValidate: OtpValidateResponse;
  otpValidateAdmin: OtpValidateAdminResponse;
  otpValidateEmail: OtpValidateEmailResponse;
  otpValidatePhone: OtpValidatePhoneResponse;
  phoneOtpRequest: PhoneOtpRequestResponse;
  reactivateAdmin: ReactivateAdminResponse;
  reactivateCustomer: ReactivateResponse;
  reactivateCustomerAdmin: ReactivateCustomerAdminResponse;
  redeemOffer: RedeemOfferResponse;
  register: RegisterResponse;
  registerMerchant: RegisterMerchantResponse;
  registerPushSubscription: PushSubscriptionResponse;
  replayDeadLetterPushJobs: PushQueueReplayResponse;
  resendOtp: RegisterResponse;
  resendOtpAdmin: RegisterMerchantResponse;
  resetCustomerPasswordAdmin?: Maybe<ResetCustomerPasswordAdminResponse>;
  resetMerchantBankPreferenceAdmin: ResetBankPreferenceAdminResponse;
  resetMerchantPasswordAdmin?: Maybe<ResetCustomerPasswordAdminResponse>;
  sendForgotPasswordEmail: ResetResponse;
  sendForgotPasswordEmailAdmin: ResetResponse;
  submitSupportTicket: SupportTicketResponse;
  toggleCategoryArchiveStatusAdmin: ToggleCategoryArchiveStatusAdminResponse;
  toggleCommunityArchiveStatus: ToggleCommunityArchiveStatusAdminResponse;
  toggleInterest: CreateInterestResponse;
  toggleLocationArchiveStatusAdmin: ToggleLocationArchiveStatusAdminResponse;
  trackAlertClick: TrackAlertClickResponse;
  unlinkCbmMember: UnlinkCbmMemberResponse;
  unregisterPushSubscription: PushSubscriptionResponse;
  updateAdmin: UpdateAdminResponse;
  updateAdminAdmin: CreateAdminResponse;
  updateAlert: UpdateAlertResponse;
  updateBank: UpdateBankResponse;
  updateBusinessInfo: UpdateBusinessInfoResponse;
  updateCampaign: UpdateCampaignResponse;
  updateCategory: UpdateCategoryResponse;
  updateCommunity: UpdateCommunityResponse;
  updateCommunityEntity: UpdateCommunityEntityResponse;
  updateCustomer: UpdateCustomerResponse;
  updateCustomerAdmin: UpdateCustomerResponse;
  updateCustomerTier: UpdateCustomerTierResponse;
  updateCustomerToAmbassador: UpdateCustomerToAmbassadorResponse;
  updateIndustry: UpdateIndustryResponse;
  updateLocation: CreateLocationResponse;
  updateMerchantAdmin: UpdateBusinessInfoResponse;
  updateMerchantAdminDataAdmin: UpdateAdminResponse;
  updateMyAppSetting: UpdateMyAppSettingResponse;
  updateMyBankPreference: UpdateMyBankPreferenceResponse;
  updateOffer: UpdateOfferResponse;
  updateOfferPointsDeduction: UpdateOfferPointsDeductionResponse;
  updatePartnerExchangeRate: UpdatePartnerExchangeRateResponse;
  updatePassword?: Maybe<ResetResponse>;
  updatePasswordChangeAdmin?: Maybe<Array<Error>>;
  updatePin: UpdatePinResponse;
  updatePlatformContact: UpdatePlatformContactResponse;
  updateRepContact: UpdateRepContactResponse;
  updateTenant: Tenant;
  validatePin: ValidatePinResponse;
  verifyNIN: VerifyNinResponse;
  walletTransfer: WalletTransferResponse;
};


export type MutationAddIdentityArgs = {
  communityEntityId?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
};


export type MutationBusinessOnboardingArgs = {
  input: BusinessOnboardingInput;
  merchantId: Scalars['String']['input'];
};


export type MutationBusinessOnboardingStepOneArgs = {
  address: Scalars['String']['input'];
  addressAlt?: InputMaybe<Scalars['String']['input']>;
  businessName: Scalars['String']['input'];
  businessRegNumber: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  regCountry: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBusinessOnboardingStepTwoArgs = {
  bannerUrl: Scalars['String']['input'];
  companyLocation: Scalars['String']['input'];
  description: Scalars['String']['input'];
  industryId: Scalars['String']['input'];
  logoUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCashOutPointsArgs = {
  points: Scalars['Int']['input'];
};


export type MutationCountClickThroughArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationCountOfferViewArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationCreateAdminArgs = {
  input?: InputMaybe<CreateAdminInput>;
};


export type MutationCreateAlertArgs = {
  communityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleTargets?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  update: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateBankArgs = {
  input: CreateBankInput;
};


export type MutationCreateBankPreferenceArgs = {
  input: CreateBankPreferenceInput;
};


export type MutationCreateCampaignArgs = {
  active: Scalars['Boolean']['input'];
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  campaignLink?: InputMaybe<Scalars['String']['input']>;
  campaignType: Scalars['String']['input'];
  colorCode?: InputMaybe<Scalars['String']['input']>;
  communityId: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  locationId: Array<Scalars['String']['input']>;
  pollOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCategoryArgs = {
  imgSrc: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCommunityArgs = {
  alias: Scalars['String']['input'];
  colorCode?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateCommunityEntityArgs = {
  input: CreateCommunityEntityInput;
};


export type MutationCreateCustomerTierArgs = {
  multiplier: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  threshold: Scalars['Int']['input'];
};


export type MutationCreateIndustryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateLocationArgs = {
  input?: InputMaybe<CreateLocationInput>;
};


export type MutationCreateOfferArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  communityId?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  njoyCodeId?: InputMaybe<Scalars['String']['input']>;
  offerTOR: Scalars['String']['input'];
  offerType: Scalars['String']['input'];
  partnerVoucher?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referralUrl?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
  totalUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  usageLimitPerUser: Scalars['Int']['input'];
};


export type MutationCreateOfferPointsDeductionArgs = {
  offerId: Scalars['String']['input'];
  point: Scalars['Int']['input'];
};


export type MutationCreatePartnerExchangeRateArgs = {
  communityId: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
};


export type MutationCreatePinArgs = {
  pin: Scalars['String']['input'];
};


export type MutationCreateRefundArgs = {
  input?: InputMaybe<CreateRefundInput>;
};


export type MutationCreateRefundAdminArgs = {
  input?: InputMaybe<CreateRefundInputAdmin>;
};


export type MutationCreateRepContactArgs = {
  adminId: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateUserPointExchangeArgs = {
  communityId: Scalars['String']['input'];
  point: Scalars['Int']['input'];
};


export type MutationCreateWalletKycArgs = {
  bvn: Scalars['String']['input'];
  dob: Scalars['String']['input'];
  nin: Scalars['String']['input'];
};


export type MutationCreateWithdrawalArgs = {
  input?: InputMaybe<CreateWithdrawalInput>;
};


export type MutationCreateWithdrawalAdminArgs = {
  input?: InputMaybe<CreateWithdrawalInputAdmin>;
};


export type MutationCustomerConnectIdReminderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeactivateAdminArgs = {
  input: DeactivateAdminInput;
};


export type MutationDeactivateCustomerArgs = {
  input: DeactivateCustomerInput;
};


export type MutationDeactivateCustomerAdminArgs = {
  input: DeactivateCustomerAdminInput;
};


export type MutationDeactivateTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAlertArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBankArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBankPreferenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCampaignByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommunityEntityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIdentityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIndustryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfferPointsDeductionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePartnerExchangeRateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRepContactArgs = {
  id: Scalars['String']['input'];
};


export type MutationDisableMyPushSubscriptionsArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmailOtpRequestArgs = {
  input: EmailOtpRequestInput;
};


export type MutationFinishSignupArgs = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationForgotPasswordChangeArgs = {
  confirmNewPassword: Scalars['String']['input'];
  key: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationForgotPasswordChangeAdminArgs = {
  confirmNewPassword: Scalars['String']['input'];
  key: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationFundPointsPoolArgs = {
  amount: Scalars['Float']['input'];
  reference: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationGetCbmArgs = {
  memberId: Scalars['String']['input'];
};


export type MutationIngestPushProviderEventsArgs = {
  events: Array<PushProviderEventInput>;
  ingestKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginAdminArgs = {
  adminId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkAsSeenArgs = {
  id: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkCampaignArgs = {
  close?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkNjoyCodeAsUsedArgs = {
  adminId: Scalars['String']['input'];
  njoyCode: Scalars['String']['input'];
};


export type MutationMarkSharedOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationMockCreditWalletArgs = {
  input?: InputMaybe<MockCreditWalletInput>;
};


export type MutationNewMerchantApprovalArgs = {
  merchantId: Scalars['String']['input'];
};


export type MutationOtpValidateArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationOtpValidateAdminArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationOtpValidateEmailArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationOtpValidatePhoneArgs = {
  phone: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationPhoneOtpRequestArgs = {
  input: PhoneOtpRequestInput;
};


export type MutationReactivateAdminArgs = {
  email: Scalars['String']['input'];
};


export type MutationReactivateCustomerArgs = {
  email: Scalars['String']['input'];
};


export type MutationReactivateCustomerAdminArgs = {
  email: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRedeemOfferArgs = {
  id: Scalars['String']['input'];
  points?: InputMaybe<Scalars['Int']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterArgs = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  nda: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationRegisterMerchantArgs = {
  companyName: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  nda: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  websiteOrSocials?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterPushSubscriptionArgs = {
  input: RegisterPushSubscriptionInput;
};


export type MutationReplayDeadLetterPushJobsArgs = {
  alertId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationResendOtpArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendOtpAdminArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetCustomerPasswordAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetMerchantBankPreferenceAdminArgs = {
  bankPreferenceId: Scalars['String']['input'];
};


export type MutationResetMerchantPasswordAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendForgotPasswordEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendForgotPasswordEmailAdminArgs = {
  email: Scalars['String']['input'];
};


export type MutationSubmitSupportTicketArgs = {
  actionName: Scalars['String']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  supportRef?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToggleCategoryArchiveStatusAdminArgs = {
  categoryId: Scalars['String']['input'];
  isArchive: Scalars['Boolean']['input'];
};


export type MutationToggleCommunityArchiveStatusArgs = {
  communityId: Scalars['String']['input'];
  isArchive: Scalars['Boolean']['input'];
};


export type MutationToggleInterestArgs = {
  merchantUserId: Scalars['String']['input'];
};


export type MutationToggleLocationArchiveStatusAdminArgs = {
  isArchive: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationTrackAlertClickArgs = {
  id: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnlinkCbmMemberArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUnregisterPushSubscriptionArgs = {
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateAdminArgs = {
  input: UpdateAdminInput;
};


export type MutationUpdateAdminAdminArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<UpdateAdminAdminInput>;
};


export type MutationUpdateAlertArgs = {
  alertId: Scalars['String']['input'];
  input: UpdateAlertInput;
};


export type MutationUpdateBankArgs = {
  bankId: Scalars['String']['input'];
  input: UpdateBankInput;
};


export type MutationUpdateBusinessInfoArgs = {
  input: UpdateBusinessInfoInput;
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['String']['input'];
  input: UpdateCampaignInput;
};


export type MutationUpdateCategoryArgs = {
  categoryId: Scalars['String']['input'];
  input: UpdateCategoryInput;
};


export type MutationUpdateCommunityArgs = {
  communityId: Scalars['String']['input'];
  input: UpdateCommunityInput;
};


export type MutationUpdateCommunityEntityArgs = {
  communityEntityId: Scalars['String']['input'];
  input: UpdateCommunityEntityInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAdminArgs = {
  input: UpdateCustomerAdminInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerTierArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomerTierInput;
};


export type MutationUpdateCustomerToAmbassadorArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateIndustryArgs = {
  industryId: Scalars['String']['input'];
  input: UpdateIndustryInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
  locationId: Scalars['String']['input'];
};


export type MutationUpdateMerchantAdminArgs = {
  id: Scalars['String']['input'];
  input: UpdateBusinessInfoInput;
};


export type MutationUpdateMerchantAdminDataAdminArgs = {
  id: Scalars['String']['input'];
  input: UpdateAdminInput;
};


export type MutationUpdateMyAppSettingArgs = {
  input: UpdateMyAppSettingInput;
};


export type MutationUpdateMyBankPreferenceArgs = {
  bankPreferenceId: Scalars['String']['input'];
  input: UpdateMyBankPreferenceInput;
};


export type MutationUpdateOfferArgs = {
  input: UpdateOfferInput;
  offerId: Scalars['String']['input'];
};


export type MutationUpdateOfferPointsDeductionArgs = {
  id: Scalars['String']['input'];
  point: Scalars['Int']['input'];
};


export type MutationUpdatePartnerExchangeRateArgs = {
  id: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
};


export type MutationUpdatePasswordArgs = {
  confirmNewPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdatePasswordChangeAdminArgs = {
  confirmNewPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdatePinArgs = {
  input: UpdatePinInput;
};


export type MutationUpdatePlatformContactArgs = {
  id: Scalars['String']['input'];
  input: UpdatePlatformContactInput;
};


export type MutationUpdateRepContactArgs = {
  id: Scalars['String']['input'];
  input: UpdateRepContactInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
};


export type MutationValidatePinArgs = {
  pin?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyNinArgs = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  nin: Scalars['String']['input'];
};


export type MutationWalletTransferArgs = {
  input?: InputMaybe<WalletTransferInput>;
};

export type NewMerchantApprovalResponse = {
  __typename?: 'NewMerchantApprovalResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type NjoyCode = {
  __typename?: 'NjoyCode';
  code: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['String']['output']>;
  redeemedBy?: Maybe<User>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OtpValidateAdminResponse = {
  __typename?: 'OTPValidateAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OtpValidateEmailResponse = {
  __typename?: 'OTPValidateEmailResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OtpValidatePhoneResponse = {
  __typename?: 'OTPValidatePhoneResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OtpValidateResponse = {
  __typename?: 'OTPValidateResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Offer = {
  __typename?: 'Offer';
  amount?: Maybe<Scalars['Float']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  clickThroughs?: Maybe<Scalars['Int']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Array<Maybe<Location>>>;
  njoyCode?: Maybe<NjoyCode>;
  offerTOR?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  partnerVoucher?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redeemersId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redemptions?: Maybe<Scalars['Int']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  revenueGenerated?: Maybe<Scalars['Int']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalUsageLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageLimitPerUser?: Maybe<Scalars['Int']['output']>;
};

export type OfferMerchant = {
  __typename?: 'OfferMerchant';
  amount?: Maybe<Scalars['Float']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryMerchant>;
  clickThroughs?: Maybe<Scalars['Int']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  createdBy: UserMerchant;
  description: Scalars['String']['output'];
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Array<Maybe<Location>>>;
  njoyCode?: Maybe<NjoyCode>;
  offerTOR?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  partnerVoucher?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redeemersId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redemptions?: Maybe<Scalars['Int']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  revenueGenerated?: Maybe<Scalars['Int']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalUsageLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageLimitPerUser?: Maybe<Scalars['Int']['output']>;
};

export type OfferMerchantAdmin = {
  __typename?: 'OfferMerchantAdmin';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<UserMerchantExt2>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  offerType?: Maybe<Scalars['String']['output']>;
  redemptions?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OfferMerchantExt = {
  __typename?: 'OfferMerchantExt';
  amount?: Maybe<Scalars['Float']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryMerchant>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  createdBy: UserMerchantExt2;
  description: Scalars['String']['output'];
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Array<Maybe<Location>>>;
  offerPointsDeduction?: Maybe<OfferPointsDeduction>;
  offerTOR?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  partnerVoucher?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redemptions?: Maybe<Scalars['Int']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalUsageLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageLimitPerUser?: Maybe<Scalars['Int']['output']>;
};

export type OfferMerchantExt2 = {
  __typename?: 'OfferMerchantExt2';
  amount?: Maybe<Scalars['Float']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  clickThroughs?: Maybe<Scalars['Int']['output']>;
  community?: Maybe<Array<Maybe<Community>>>;
  createdAt: Scalars['String']['output'];
  createdBy: UserMerchantExt2;
  description: Scalars['String']['output'];
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Array<Maybe<Location>>>;
  njoyCode?: Maybe<NjoyCode>;
  offerTOR?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  partnerVoucher?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redeemersId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redemptions?: Maybe<Scalars['Int']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
  revenueGenerated?: Maybe<Scalars['Int']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalUsageLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usageLimitPerUser?: Maybe<Scalars['Int']['output']>;
};

export type OfferPwa = {
  __typename?: 'OfferPWA';
  amount?: Maybe<Scalars['Float']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryPwa>;
  createdAt: Scalars['String']['output'];
  createdBy: UserAdminPwa;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  offerTOR?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OfferPage = {
  __typename?: 'OfferPage';
  data: Array<OfferMerchantAdmin>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OfferPointsDeduction = {
  __typename?: 'OfferPointsDeduction';
  adminLevel?: Maybe<Scalars['String']['output']>;
  adminName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  offerStatus?: Maybe<Scalars['String']['output']>;
  offerTitle?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OfferResponse = {
  __typename?: 'OfferResponse';
  offerClicks?: Maybe<Scalars['Int']['output']>;
  offerViews?: Maybe<Scalars['Int']['output']>;
  pageOffers: OfferPage;
  publishedOffers?: Maybe<Scalars['Int']['output']>;
  redeemedOffers?: Maybe<Scalars['Int']['output']>;
};

export type OfferTypeOverview = {
  __typename?: 'OfferTypeOverview';
  count: Scalars['Int']['output'];
  offerType: Scalars['String']['output'];
};

export type OffersOverviewAdminResponse = {
  __typename?: 'OffersOverviewAdminResponse';
  totalDraftOffers?: Maybe<Scalars['Int']['output']>;
  totalExpiredOffers?: Maybe<Scalars['Int']['output']>;
  totalImpressions?: Maybe<Scalars['Int']['output']>;
  totalOffersClick?: Maybe<Scalars['Int']['output']>;
  totalPublishedOffers?: Maybe<Scalars['Int']['output']>;
  totalRedeemedOffers?: Maybe<Scalars['Int']['output']>;
  totalScheduledOffers?: Maybe<Scalars['Int']['output']>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  completedAt?: Maybe<Scalars['String']['output']>;
  currentStep: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  user: User;
};

export type PartnerExchangeRate = {
  __typename?: 'PartnerExchangeRate';
  adminLevel?: Maybe<Scalars['String']['output']>;
  adminName?: Maybe<Scalars['String']['output']>;
  communityAlias?: Maybe<Scalars['String']['output']>;
  communityId?: Maybe<Scalars['String']['output']>;
  communityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PhoneOtpRequestInput = {
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformContact = {
  __typename?: 'PlatformContact';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<User>;
  website?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
};

export type PointHistoryData = {
  __typename?: 'PointHistoryData';
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['String']['output']>;
  referredFirstName?: Maybe<Scalars['String']['output']>;
  referredLastName?: Maybe<Scalars['String']['output']>;
  referredProfileImage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PointHistoryResponse = {
  __typename?: 'PointHistoryResponse';
  createdAt: Scalars['String']['output'];
  pointHistory: Array<Maybe<PointHistoryData>>;
};

export type PointsCardResponse = {
  __typename?: 'PointsCardResponse';
  currentMonthPoints?: Maybe<Scalars['Float']['output']>;
  customerTier?: Maybe<Scalars['String']['output']>;
  lifeTimePoint?: Maybe<Scalars['Float']['output']>;
  pointBalance?: Maybe<Scalars['Float']['output']>;
  pointsForNextTier?: Maybe<Scalars['Float']['output']>;
  tiers?: Maybe<Array<Maybe<CustomerTier>>>;
};

export type PublicWallet = {
  __typename?: 'PublicWallet';
  barterId: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: PublicWalletOwner;
  status?: Maybe<Scalars['String']['output']>;
};

export type PublicWalletOwner = {
  __typename?: 'PublicWalletOwner';
  id: Scalars['ID']['output'];
};

export type PublishedOffersOverviewResult = {
  __typename?: 'PublishedOffersOverviewResult';
  offerTypes: Array<OfferTypeOverview>;
  totalOffers: Scalars['Int']['output'];
};

export type PushProviderEventBreakdownItem = {
  __typename?: 'PushProviderEventBreakdownItem';
  clicked: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  read: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PushProviderEventBreakdownResponse = {
  __typename?: 'PushProviderEventBreakdownResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  providers: Array<PushProviderEventBreakdownItem>;
  windowHours: Scalars['Int']['output'];
};

export type PushProviderEventIngestResponse = {
  __typename?: 'PushProviderEventIngestResponse';
  clicked: Scalars['Int']['output'];
  duplicate: Scalars['Int']['output'];
  errors?: Maybe<Array<Error>>;
  failed: Scalars['Int']['output'];
  invalid: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  missingAlert: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  read: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type PushProviderEventInput = {
  alertId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type PushQueueMetrics = {
  __typename?: 'PushQueueMetrics';
  deadLetterJobs: Scalars['Int']['output'];
  deadLettered: Scalars['Int']['output'];
  delayedJobs: Scalars['Int']['output'];
  droppedInvalidPayload: Scalars['Int']['output'];
  droppedMissingAlert: Scalars['Int']['output'];
  enqueued: Scalars['Int']['output'];
  pendingJobs: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  replayed: Scalars['Int']['output'];
  requeued: Scalars['Int']['output'];
  retryScheduled: Scalars['Int']['output'];
  workerErrors: Scalars['Int']['output'];
};

export type PushQueueReplayResponse = {
  __typename?: 'PushQueueReplayResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  replayed: Scalars['Int']['output'];
};

export type PushSubscriptionPwa = {
  __typename?: 'PushSubscriptionPWA';
  createdAt: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PushSubscriptionResponse = {
  __typename?: 'PushSubscriptionResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  alertOverview: AlertOverviewSummary;
  alertOverviewByAlertId: AlertOverviewResponse;
  bestPerformingOffers: Array<Maybe<Offer>>;
  bestPerformingOffersAdmin: Array<Maybe<Offer>>;
  campaignClickThroughs?: Maybe<CampaignClickThroughResponse>;
  campaignOverview?: Maybe<CampaignOverviewResponse>;
  campaignSubmissions?: Maybe<CampaignSubmissionResponse>;
  cashFlowOverview: CashFlowOverviewResponse;
  cashFlowOverviewAdmin: CashFlowOverviewAdminResponse;
  categoryOffers: Array<Offer>;
  childOffers: Array<OfferPwa>;
  customerPointsHistory: CustomerPointsHistoryResponse;
  customerPointsOverview?: Maybe<CustomerPointsOverviewResponse>;
  customerReferralOverview?: Maybe<CustomerReferralOverview>;
  customerTransactions: Array<Maybe<CustomerTransactionGroup>>;
  customersOverviewAdmin?: Maybe<CustomerOverviewAdminResponse>;
  customersOverviewOnboardingAdmin?: Maybe<CustomersOverviewOnboardingAdminResponse>;
  deadLetterPushJobs: Array<DeadLetterPushJob>;
  earnedPoints?: Maybe<EarnedPointsResponse>;
  findAdminAdminById: FindAdminAdminByIdResponse;
  findAdminAdmins: Array<AdminAdmins>;
  findAdminMerchants: Array<Maybe<FindAdminMerchantsResponse>>;
  findAdminOffers: OfferResponse;
  findAllAdminAdmin: FindAllAdminAdminResponse;
  findAllAdmins: Array<Admin>;
  findAllAlerts: FindAllAlertsResponse;
  findAllAuditLogs: FindAllAuditLogsResponse;
  findAllBankPreferences: Array<BankPreference>;
  findAllBanks: Array<Bank>;
  findAllCampaigns?: Maybe<FindAllCampaignsResponse>;
  findAllCategories: Array<CategoryPwa>;
  findAllCategoriesAdmin: FindAllCategoriesAdminResponse;
  findAllCommunities: Array<Community>;
  findAllCommunityEntities: Array<CommunityEntityPwa>;
  findAllCommunityEntitiesAdmin: FindAllCommunityEntityResponse;
  findAllCommunitySpend: FindAllCommunitySpendResponse;
  findAllCustomerAndMerchantOfferTransactions: TransactionPage;
  findAllCustomerTiers: FindAllCustomerTiersResponse;
  findAllCustomers: Array<Customer>;
  findAllCustomersAdmin: FindAllCustomersAdminResponse;
  findAllCustomersByLocationIdAdmin: FindAllCustomersByLocationIdAdminResponse;
  findAllCustomersOnboardingAdmin: FindAllCustomersOnboardingAdminResponse;
  findAllIndustries: Array<Industry>;
  findAllIndustriesAdmin: FindAllIndustriesAdminResponse;
  findAllInterests: FindAllInterestResponse;
  findAllLocations?: Maybe<Array<Maybe<Location>>>;
  findAllLocationsAdmin: FindAllLocationsAdminResponse;
  findAllMerchantOffersAdmin: OfferPage;
  findAllMerchantProfiles: Array<MerchantProfile>;
  findAllMerchants: Array<Merchant>;
  findAllMerchantsOnboardingAdmin: FindAllMerchantsOnboardingAdminResponse;
  findAllMerchantsSpendAdmin: FindAllMerchantsSpendAdminResponse;
  findAllMyCommunitySpend: FindAllMyCommunitySpendResponse;
  findAllNjoyCodes: Array<NjoyCode>;
  findAllOfferPointsDeductions?: Maybe<FindAllOfferPointsDeductionsResponse>;
  findAllOffers: Array<Offer>;
  findAllOffersAdmin: FindAllOffersAdminResponse;
  findAllOnboarding: Array<Onboarding>;
  findAllPartnerExchangeRates?: Maybe<FindAllPartnerExchangeRatesResponse>;
  findAllRedemptions: TransactionPage;
  findAllRefundsAdmin: FindAllRefundsAdminResponse;
  findAllTransactions: Array<Transaction>;
  findAllTransactionsAdmin: AdminFindAllTransactionResponse;
  findAllTransactionsByCommunityId: FindTransactionsByCommunityIdResponse;
  findAllUserPointExchangeHistory?: Maybe<FindAllUserPointExchangeHistoryResponse>;
  findAllWithdrawals: Array<Withdrawal>;
  findAllWithdrawalsAdmin: FindAllWithdrawalsAdminResponse;
  findBankById: Array<Bank>;
  findBankPreferenceByUserId?: Maybe<Array<Maybe<BankPreference>>>;
  findBaseUrl?: Maybe<FindBaseUrl>;
  findByEntityType: Array<CommunityEntityPwa>;
  findCampaignById?: Maybe<Campaign>;
  findCommunitiesFromCampaigns: Array<Community>;
  findCustomerByIdAdmin?: Maybe<FindCustomerByIdAdminResponse>;
  findCustomerTierById?: Maybe<FindAllCustomerTiersData>;
  findCustomersWhoRedeemedOffers: FindCustomersWhoRedeemedOffersResponse;
  findIsInterested: FindIsInterestResponse;
  findLocationByIdAdmin?: Maybe<FindLocationByIdAdminResponse>;
  findLocationsFromCampaigns: Array<Location>;
  findMerchantByIdAdmin?: Maybe<FindMerchantByIdAdminResponse>;
  findMerchantCommunitiesFromOffers: Array<Community>;
  findMerchantInterests: FindMerchantInterestsResponse;
  findMyWithdrawals: FindMyWithdrawalResponse;
  findOfferPointsDeductionById?: Maybe<OfferPointsDeduction>;
  findOffers: Array<Offer>;
  findOffersEndingSoon: Array<OfferPwa>;
  findPartnerExchangeRateById?: Maybe<PartnerExchangeRate>;
  findPlatformContacts: Array<PlatformContact>;
  findRecentOfferRedemptionsById: FindRecentOfferRedemptionsResponse;
  findRedemptionsByOfferIdAdmin: FindRedemptionsByOfferIdAdminResponse;
  findReferralsByUserIdAdmin: ReferralPage;
  findRefundByIdAdmin?: Maybe<FindRefundByIdAdminResponse>;
  findRefunds: RefundResponse;
  findRepContacts: Array<RepContact>;
  findSubscribedAlertUsers: FindSubscribedAlertUsersResponse;
  findTransactionsByCommunityId: FindTransactionsByCommunityIdResponse;
  findTransactionsByRecipientWalletId: TransactionsResponse;
  findTransactionsBySession: TransactionPage;
  findTransactionsByUserId: TransactionPage;
  findTransactionsByUserIdAdmin: TransactionPage;
  findUserPointExchangeHistoryById?: Maybe<UserPointExchangeHistory>;
  findWithdrawalByIdAdmin: Withdrawal;
  getCampaign?: Maybe<Campaign>;
  getCommunityPoint: GetCommunityPointResponse;
  getPointsHistory: Array<Maybe<PointHistoryResponse>>;
  interestOverview?: Maybe<InterestOverviewResponse>;
  me?: Maybe<User>;
  merchantOverviewAdmin?: Maybe<MerchantOverviewAdminResponse>;
  merchantsOverviewAdmin?: Maybe<MerchantOverviewAdminResponse>;
  merchantsOverviewOnboardingAdmin?: Maybe<MerchantsOverviewOnboardingAdminResponse>;
  myAlert: Array<AlertPwa>;
  myAppSetting?: Maybe<AppSetting>;
  myBankPreferences: Array<BankPreference>;
  myIdentities: Array<IdentityPwa>;
  myPushSubscriptions: Array<PushSubscriptionPwa>;
  myTransactions: Array<TransactionGroup>;
  offersOverviewAdmin: OffersOverviewAdminResponse;
  pointsCard?: Maybe<PointsCardResponse>;
  publishedOffersOverview: PublishedOffersOverviewResult;
  publishedOffersOverviewAdmin: PublishedOffersOverviewResult;
  pushProviderEventBreakdown: PushProviderEventBreakdownResponse;
  pushProviderEventMetrics: PushProviderEventIngestResponse;
  pushQueueMetrics: PushQueueMetrics;
  recentBeneficiaries: Array<Maybe<User>>;
  referrerData?: Maybe<ReferrerDataResponse>;
  refundOverviewAdmin: RefundOverviewAdminResponse;
  relatedOffers: Array<Offer>;
  searchIdentities: Array<IdentityPwa>;
  searchMerchant?: Maybe<SearchMerchantResponse>;
  searchOffers: Array<OfferPwa>;
  searchOffersByCategory: Array<Offer>;
  searchUser: Array<SearchUserResult>;
  sharedTransactions: Array<TransactionGroup>;
  tenant?: Maybe<Tenant>;
  tenants: Array<Tenant>;
  topMerchants: Array<UserAdminPwa>;
  verifyNjoyCode?: Maybe<VerifyNjoyCodeResponse>;
  viewAlert?: Maybe<Alert>;
  viewAuditLog?: Maybe<AuditLog>;
  viewCategory?: Maybe<Category>;
  viewCategoryPWA?: Maybe<CategoryPwa>;
  viewCommunity: Community;
  viewCommunityEntityById: CommunityEntity;
  viewCustomerWithSpend?: Maybe<CustomerWithSpend>;
  viewIndustry?: Maybe<Industry>;
  viewOffer?: Maybe<OfferMerchantExt>;
  viewOfferPWA?: Maybe<OfferPwa>;
  viewPlatformContact?: Maybe<PlatformContact>;
  viewRepContact?: Maybe<RepContact>;
  viewTransaction?: Maybe<TransactionExt>;
  viewUser?: Maybe<ViewUserResult>;
  viewUserWallet?: Maybe<PublicWallet>;
  wallet?: Maybe<Wallet>;
  withdrawalOverviewAdmin: WithdrawalOverviewAdminResponse;
};


export type QueryAlertOverviewArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAlertOverviewByAlertIdArgs = {
  alertId: Scalars['String']['input'];
};


export type QueryCampaignClickThroughsArgs = {
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignOverviewArgs = {
  duration: Scalars['String']['input'];
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCampaignSubmissionsArgs = {
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCashFlowOverviewArgs = {
  duration: Scalars['String']['input'];
};


export type QueryCashFlowOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryCategoryOffersArgs = {
  categoryId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryChildOffersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};


export type QueryCustomerPointsHistoryArgs = {
  actionFilter?: InputMaybe<Scalars['String']['input']>;
  categoryFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryCustomerPointsOverviewArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerReferralOverviewArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerTransactionsArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomersOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryCustomersOverviewOnboardingAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryDeadLetterPushJobsArgs = {
  alertId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindAdminAdminByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindAdminOffersArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllAdminAdminArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllAlertsArgs = {
  communityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryModes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFindAllAuditLogsArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCampaignsArgs = {
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  locationFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCategoriesAdminArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCommunityEntitiesAdminArgs = {
  entityTypeFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCommunitySpendArgs = {
  aliasFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCustomerAndMerchantOfferTransactionsArgs = {
  customerUserId: Scalars['String']['input'];
  merchantUserId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCustomerTiersArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCustomersAdminArgs = {
  ambassadorFilter?: InputMaybe<Scalars['Boolean']['input']>;
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCustomersByLocationIdAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllCustomersOnboardingAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllIndustriesAdminArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllInterestsArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllLocationsAdminArgs = {
  countryFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllMerchantOffersAdminArgs = {
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllMerchantsOnboardingAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllMerchantsSpendAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllMyCommunitySpendArgs = {
  aliasFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllOfferPointsDeductionsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllOffersAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllPartnerExchangeRatesArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllRedemptionsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllRefundsAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllTransactionsAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllTransactionsByCommunityIdArgs = {
  communityId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllUserPointExchangeHistoryArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllWithdrawalsAdminArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindBankByIdArgs = {
  bankId: Scalars['String']['input'];
};


export type QueryFindBankPreferenceByUserIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindByEntityTypeArgs = {
  entityType: Scalars['String']['input'];
};


export type QueryFindCampaignByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindCustomerByIdAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindCustomerTierByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindCustomersWhoRedeemedOffersArgs = {
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindIsInterestedArgs = {
  merchantUserId: Scalars['String']['input'];
};


export type QueryFindLocationByIdAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindMerchantByIdAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindMerchantInterestsArgs = {
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindMyWithdrawalsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindOfferPointsDeductionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindOffersEndingSoonArgs = {
  limit: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryFindPartnerExchangeRateByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindRecentOfferRedemptionsByIdArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindRedemptionsByOfferIdAdminArgs = {
  duration: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryFindReferralsByUserIdAdminArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFindRefundByIdAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindRefundsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindSubscribedAlertUsersArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTransactionsByCommunityIdArgs = {
  communityId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTransactionsByRecipientWalletIdArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTransactionsBySessionArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTransactionsByUserIdArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFindTransactionsByUserIdAdminArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFindUserPointExchangeHistoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindWithdrawalByIdAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCommunityPointArgs = {
  communityId: Scalars['String']['input'];
};


export type QueryGetPointsHistoryArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInterestOverviewArgs = {
  duration: Scalars['String']['input'];
};


export type QueryMerchantOverviewAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryMerchantsOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryMerchantsOverviewOnboardingAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryMyAlertArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryMyIdentitiesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryMyTransactionsArgs = {
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOffersOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryPushProviderEventBreakdownArgs = {
  windowHours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecentBeneficiariesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryRefundOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};


export type QueryRelatedOffersArgs = {
  communityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySearchIdentitiesArgs = {
  input?: InputMaybe<SearchIdentitiesInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySearchMerchantArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchOffersArgs = {
  input?: InputMaybe<SearchOffersInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySearchOffersByCategoryArgs = {
  input?: InputMaybe<SearchOffersByCategoryInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySearchUserArgs = {
  input: SearchUserInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QuerySharedTransactionsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  recipientWalletId: Scalars['String']['input'];
  walletId: Scalars['String']['input'];
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopMerchantsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryVerifyNjoyCodeArgs = {
  njoyCode: Scalars['String']['input'];
};


export type QueryViewAlertArgs = {
  alertId: Scalars['String']['input'];
};


export type QueryViewAuditLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewCategoryPwaArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewCommunityArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewCommunityEntityByIdArgs = {
  communityEntityId: Scalars['String']['input'];
};


export type QueryViewCustomerWithSpendArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewIndustryArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewOfferPwaArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewPlatformContactArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewRepContactArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewUserWalletArgs = {
  userId: Scalars['String']['input'];
};


export type QueryWithdrawalOverviewAdminArgs = {
  duration: Scalars['String']['input'];
};

export type ReactivateAdminResponse = {
  __typename?: 'ReactivateAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReactivateCustomerAdminResponse = {
  __typename?: 'ReactivateCustomerAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReactivateResponse = {
  __typename?: 'ReactivateResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RedeemOfferResponse = {
  __typename?: 'RedeemOfferResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
  njoyCode?: Maybe<Scalars['String']['output']>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  referralUrl?: Maybe<Scalars['String']['output']>;
};

export type ReferralPage = {
  __typename?: 'ReferralPage';
  data: Array<ReferredCustomerAdmin>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ReferredCustomerAdmin = {
  __typename?: 'ReferredCustomerAdmin';
  customer?: Maybe<CustomerSlim>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ReferrerDataResponse = {
  __typename?: 'ReferrerDataResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralPoint?: Maybe<Scalars['Int']['output']>;
  referrals?: Maybe<Scalars['Int']['output']>;
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reasonForRefund?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type RefundOverviewAdminResponse = {
  __typename?: 'RefundOverviewAdminResponse';
  pendingRefunds?: Maybe<Scalars['Int']['output']>;
  totalPendingRefundValue?: Maybe<Scalars['Float']['output']>;
  totalRefunds?: Maybe<Scalars['Float']['output']>;
};

export type RefundResponse = {
  __typename?: 'RefundResponse';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  refund?: Maybe<Array<Refund>>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RegisterMerchantResponse = {
  __typename?: 'RegisterMerchantResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RegisterPushSubscriptionInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type RepContact = {
  __typename?: 'RepContact';
  admin: Admin;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type ResetBankPreferenceAdminResponse = {
  __typename?: 'ResetBankPreferenceAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResetCustomerPasswordAdminResponse = {
  __typename?: 'ResetCustomerPasswordAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResetResponse = {
  __typename?: 'ResetResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type SearchIdentitiesInput = {
  idNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SearchMerchantData = {
  __typename?: 'SearchMerchantData';
  adminId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  merchantUserId?: Maybe<Scalars['ID']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type SearchMerchantResponse = {
  __typename?: 'SearchMerchantResponse';
  data: Array<Maybe<SearchMerchantData>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchOffersByCategoryInput = {
  categoryId: Scalars['String']['input'];
  endingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  filterByCommunity?: InputMaybe<Scalars['String']['input']>;
  filterByLocationId: Scalars['String']['input'];
  filterByType?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOffersInput = {
  endingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  filterByCommunity?: InputMaybe<Scalars['String']['input']>;
  filterByLocationId: Scalars['String']['input'];
  filterByType?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type SearchUserInput = {
  searchText: Scalars['String']['input'];
};

export type SearchUserResult = AdminPwa | CustomerPwa;

export type SubscribedAlertUser = {
  __typename?: 'SubscribedAlertUser';
  community?: Maybe<Array<Maybe<Community>>>;
  communityId?: Maybe<Array<Scalars['String']['output']>>;
  firstname?: Maybe<Scalars['String']['output']>;
  isAmbassador?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newAlert: Alert;
  newAuditLog: Array<AuditLog>;
  newBank: Bank;
  newBankPreference: BankPreference;
  newCampaign: Array<Campaign>;
  newCategory: Category;
  newCategoryOffer: Offer;
  newChildOffer: Offer;
  newCommunity: Community;
  newCommunityEntity: CommunityEntity;
  newIdentity: Identity;
  newIndustry: Industry;
  newLocation: Array<Location>;
  newNjoyCode: NjoyCode;
  newOffer: Array<Offer>;
  newPlatformContact: Array<PlatformContact>;
  newRefund: Refund;
  newRepContact: Array<RepContact>;
  newTransaction: Transaction;
  walletUpdate: Wallet;
};


export type SubscriptionNewCategoryOfferArgs = {
  categoryId: Scalars['String']['input'];
};


export type SubscriptionNewChildOfferArgs = {
  userId: Scalars['String']['input'];
};

export type SupportTicketResponse = {
  __typename?: 'SupportTicketResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['String']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  branding: TenantBranding;
  createdAt: Scalars['String']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  memberVerification?: Maybe<MemberVerification>;
  name: Scalars['String']['output'];
  ninCommunityAlias?: Maybe<Scalars['String']['output']>;
  pointValue?: Maybe<Scalars['Float']['output']>;
  pointsEnabled: Scalars['Boolean']['output'];
  pointsMaxSharePercent: Scalars['Int']['output'];
  pointsMinCashout: Scalars['Int']['output'];
  pointsPoolBalance: Scalars['Float']['output'];
  referralsEnabled: Scalars['Boolean']['output'];
  sesFromAddress?: Maybe<Scalars['String']['output']>;
  sesReplyTo?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: TenantStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
  walletEnabled: Scalars['Boolean']['output'];
};

export type TenantBranding = {
  __typename?: 'TenantBranding';
  appName?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type TenantBrandingInput = {
  appName?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum TenantStatus {
  Active = 'Active',
  Provisioning = 'Provisioning',
  Suspended = 'Suspended'
}

export type ToggleCategoryArchiveStatusAdminResponse = {
  __typename?: 'ToggleCategoryArchiveStatusAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ToggleCommunityArchiveStatusAdminResponse = {
  __typename?: 'ToggleCommunityArchiveStatusAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ToggleLocationArchiveStatusAdminResponse = {
  __typename?: 'ToggleLocationArchiveStatusAdminResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TrackAlertClickResponse = {
  __typename?: 'TrackAlertClickResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float']['output'];
  bankPreference?: Maybe<BankPreference>;
  charge?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  njoyCode?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  recipientWallet?: Maybe<Wallet>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transferTypes: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  wallet?: Maybe<Wallet>;
};

export type TransactionExt = {
  __typename?: 'TransactionExt';
  amount: Scalars['Float']['output'];
  bankPreference?: Maybe<BankPreference>;
  charge?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  njoyCode?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<OfferMerchantExt2>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  recipientWallet?: Maybe<Wallet>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transferTypes: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  wallet?: Maybe<Wallet>;
};

export type TransactionGroup = {
  __typename?: 'TransactionGroup';
  createdAt: Scalars['String']['output'];
  transactions: Array<Transaction>;
};

export type TransactionMerchant = {
  __typename?: 'TransactionMerchant';
  amount: Scalars['Float']['output'];
  bankPreference?: Maybe<BankPreference>;
  charge?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  njoyCode?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<OfferMerchant>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  recipientWallet?: Maybe<Wallet>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transferTypes: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  wallet?: Maybe<Wallet>;
};

export type TransactionMerchantExt = {
  __typename?: 'TransactionMerchantExt';
  amount: Scalars['Float']['output'];
  bankPreference?: Maybe<BankPreference>;
  charge?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  njoyCode?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<OfferMerchantExt>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  recipientWallet?: Maybe<Wallet>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transferTypes: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  wallet?: Maybe<Wallet>;
};

export type TransactionPwa = {
  __typename?: 'TransactionPWA';
  amount: Scalars['Float']['output'];
  charge?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  njoyCode?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  partnerVoucher?: Maybe<Scalars['String']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  recipientWallet?: Maybe<Wallet>;
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transferTypes: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  wallet?: Maybe<Wallet>;
};

export type TransactionPage = {
  __typename?: 'TransactionPage';
  data: Array<TransactionMerchant>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type TransactionWithOverview = {
  __typename?: 'TransactionWithOverview';
  transaction: TransactionMerchant;
};

export type TransactionsData = {
  __typename?: 'TransactionsData';
  data: Array<Transaction>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type TransactionsResponse = {
  __typename?: 'TransactionsResponse';
  amountReceived: Scalars['Float']['output'];
  amountWithdrawn: Scalars['Float']['output'];
  currentBalance: Scalars['Float']['output'];
  pageTransactions: TransactionsData;
};

export type TransferResponse = {
  __typename?: 'TransferResponse';
  account_number?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  complete_message?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  debit_currency?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_approved?: Maybe<Scalars['Int']['output']>;
  narration?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  requires_approval?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UnlinkCbmMemberResponse = {
  __typename?: 'UnlinkCbmMemberResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateAdminAdminInput = {
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlertInput = {
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  communityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleTargets?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAlertResponse = {
  __typename?: 'UpdateAlertResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateBankInput = {
  bank?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBankResponse = {
  __typename?: 'UpdateBankResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateBusinessInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressAlt?: InputMaybe<Scalars['String']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessRegNumber?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyLocation?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  regCountry?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCampaignInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  campaignLink?: InputMaybe<Scalars['String']['input']>;
  campaignType?: InputMaybe<Scalars['String']['input']>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  pollOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCampaignResponse = {
  __typename?: 'UpdateCampaignResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCategoryInput = {
  imgSrc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateCategoryResponse = {
  __typename?: 'UpdateCategoryResponse';
  errors?: Maybe<Array<Error>>;
  imgSrcUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommunityEntityInput = {
  entityType?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityEntityResponse = {
  __typename?: 'UpdateCommunityEntityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommunityInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityResponse = {
  __typename?: 'UpdateCommunityResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerTierInput = {
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  multiplier?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomerTierResponse = {
  __typename?: 'UpdateCustomerTierResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerToAmbassadorResponse = {
  __typename?: 'UpdateCustomerToAmbassadorResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateIndustryInput = {
  isArchive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateIndustryResponse = {
  __typename?: 'UpdateIndustryResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationResponse = {
  __typename?: 'UpdateLocationResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateMyAppSettingInput = {
  isEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  isPush?: InputMaybe<Scalars['Boolean']['input']>;
  isSMS?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  topUpLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMyAppSettingResponse = {
  __typename?: 'UpdateMyAppSettingResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateMyBankPreferenceInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyBankPreferenceResponse = {
  __typename?: 'UpdateMyBankPreferenceResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateOfferInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferPointsDeductionResponse = {
  __typename?: 'UpdateOfferPointsDeductionResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateOfferResponse = {
  __typename?: 'UpdateOfferResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatePartnerExchangeRateResponse = {
  __typename?: 'UpdatePartnerExchangeRateResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatePinInput = {
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePinResponse = {
  __typename?: 'UpdatePinResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatePlatformContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformContactResponse = {
  __typename?: 'UpdatePlatformContactResponse';
  errors?: Maybe<Array<Error>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateRepContactInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRepContactResponse = {
  __typename?: 'UpdateRepContactResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateTenantInput = {
  branding?: InputMaybe<TenantBrandingInput>;
  domain?: InputMaybe<Scalars['String']['input']>;
  memberVerification?: InputMaybe<MemberVerification>;
  name?: InputMaybe<Scalars['String']['input']>;
  ninCommunityAlias?: InputMaybe<Scalars['String']['input']>;
  pointValue?: InputMaybe<Scalars['Float']['input']>;
  pointsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pointsMaxSharePercent?: InputMaybe<Scalars['Int']['input']>;
  pointsMinCashout?: InputMaybe<Scalars['Int']['input']>;
  referralsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sesFromAddress?: InputMaybe<Scalars['String']['input']>;
  sesReplyTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TenantStatus>;
  walletEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  admin?: Maybe<Admin>;
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  onboarding?: Maybe<Onboarding>;
  role: Scalars['String']['output'];
  suspended: Scalars['Boolean']['output'];
};

export type UserAdminPwa = {
  __typename?: 'UserAdminPWA';
  admin?: Maybe<AdminPwa>;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
};

export type UserMerchant = {
  __typename?: 'UserMerchant';
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type UserMerchantExt = {
  __typename?: 'UserMerchantExt';
  admin?: Maybe<AdminExt>;
  id: Scalars['ID']['output'];
};

export type UserMerchantExt2 = {
  __typename?: 'UserMerchantExt2';
  admin?: Maybe<AdminExt1>;
  id: Scalars['ID']['output'];
};

export type UserPointExchangeHistory = {
  __typename?: 'UserPointExchangeHistory';
  communityId?: Maybe<Scalars['String']['output']>;
  communityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  exchangedPoint?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  point?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type ValidatePinResponse = {
  __typename?: 'ValidatePinResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type VerifyNinResponse = {
  __typename?: 'VerifyNINResponse';
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type VerifyNjoyCodeData = {
  __typename?: 'VerifyNjoyCodeData';
  offerCode?: Maybe<Scalars['String']['output']>;
  offerTitle?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  redeemedDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  usedDate?: Maybe<Scalars['String']['output']>;
};

export type VerifyNjoyCodeResponse = {
  __typename?: 'VerifyNjoyCodeResponse';
  data?: Maybe<VerifyNjoyCodeData>;
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ViewUserResult = AdminPwa | CustomerPwa | ErrorType;

export type VirtualAccount = {
  __typename?: 'VirtualAccount';
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  static_account?: Maybe<Scalars['String']['output']>;
};

export type VirtualAccountResponse = {
  __typename?: 'VirtualAccountResponse';
  data?: Maybe<VirtualAccount>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  balance?: Maybe<Scalars['Float']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  barterId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  flAccountReference?: Maybe<Scalars['String']['output']>;
  flId?: Maybe<Scalars['String']['output']>;
  flNuban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type WalletKycResponse = {
  __typename?: 'WalletKycResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type WalletTransferInput = {
  amount: Scalars['Int']['input'];
  barterId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  narration?: InputMaybe<Scalars['String']['input']>;
  pin: Scalars['String']['input'];
};

export type WalletTransferResponse = {
  __typename?: 'WalletTransferResponse';
  data?: Maybe<TransferResponse>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  bankPreference?: Maybe<BankPreference>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  transaction?: Maybe<Transaction>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type WithdrawalOverviewAdminResponse = {
  __typename?: 'WithdrawalOverviewAdminResponse';
  pendingWithdrawals?: Maybe<Scalars['Float']['output']>;
  totalWithdrawals?: Maybe<Scalars['Float']['output']>;
};

export type WithdrawalWithTotal = {
  __typename?: 'WithdrawalWithTotal';
  totalWithdrawal: Scalars['Float']['output'];
  withdrawal: Withdrawal;
};

export type EarnedPointsResponse = {
  __typename?: 'earnedPointsResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
};

export type EmailOtpRequestResponse = {
  __typename?: 'emailOtpRequestResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PhoneOtpRequestResponse = {
  __typename?: 'phoneOtpRequestResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateAdminResponse = {
  __typename?: 'updateAdminResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateBusinessInfoResponse = {
  __typename?: 'updateBusinessInfoResponse';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerAdminInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bvn?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerResponse = {
  __typename?: 'updateCustomerResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BestPerformingOffersAdminQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BestPerformingOffersAdminQueryQuery = { __typename?: 'Query', bestPerformingOffersAdmin: Array<{ __typename?: 'Offer', id: string, title: string, offerType?: string | null, redemptions?: number | null, createdBy: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, companyName?: string | null, businessName?: string | null } | null } | null } } | null> };

export type CashFlowOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type CashFlowOverviewAdminQueryQuery = { __typename?: 'Query', cashFlowOverviewAdmin: { __typename?: 'CashFlowOverviewAdminResponse', totalPlatformBalance?: number | null, totalTransactionVolume?: number | null, successfulTransactionVolume?: number | null, pendingTransactionVolume?: number | null, failedTransactionVolume?: number | null, totalTransactionValue?: number | null, totalWithdrawn?: number | null, commissionEarned?: number | null } };

export type PublishedOffersOverviewAdminQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishedOffersOverviewAdminQueryQuery = { __typename?: 'Query', publishedOffersOverviewAdmin: { __typename?: 'PublishedOffersOverviewResult', totalOffers: number, offerTypes: Array<{ __typename?: 'OfferTypeOverview', offerType: string, count: number }> } };

export type CreateAdminMutationMutationVariables = Exact<{
  input: CreateAdminInput;
}>;


export type CreateAdminMutationMutation = { __typename?: 'Mutation', createAdmin: { __typename?: 'CreateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAdminAdminByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindAdminAdminByIdQueryQuery = { __typename?: 'Query', findAdminAdminById: { __typename?: 'FindAdminAdminByIdResponse', adminId?: string | null, userId?: string | null, shortId?: string | null, profilePicture?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, level?: string | null, suspended?: boolean | null, userIsDeactivated?: boolean | null, userIsLocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null } };

export type FindAllAdminAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllAdminAdminQueryQuery = { __typename?: 'Query', findAllAdminAdmin: { __typename?: 'FindAllAdminAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllAdminAdminData', adminId?: string | null, userId?: string | null, shortId?: string | null, profilePicture?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, level?: string | null, suspended?: boolean | null, isLocked?: boolean | null, createdAt?: string | null, updatedAt?: string | null } | null> } };

export type UpdateAdminAdminMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAdminAdminInput;
}>;


export type UpdateAdminAdminMutationMutation = { __typename?: 'Mutation', updateAdminAdmin: { __typename?: 'CreateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateCategoryMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  imgSrc: Scalars['String']['input'];
}>;


export type CreateCategoryMutationMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CreateCategoryResponse', message?: string | null, imgSrcUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllCategoriesAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCategoriesAdminQueryQuery = { __typename?: 'Query', findAllCategoriesAdmin: { __typename?: 'FindAllCategoriesAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, isArchive: boolean, createdBy?: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, level?: string | null, firstname?: string | null, lastname?: string | null } | null } | null }> } };

export type ToggleCategoryArchiveStatusAdminMutationMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  isArchive: Scalars['Boolean']['input'];
}>;


export type ToggleCategoryArchiveStatusAdminMutationMutation = { __typename?: 'Mutation', toggleCategoryArchiveStatusAdmin: { __typename?: 'ToggleCategoryArchiveStatusAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UpdateCategoryMutationMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutationMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'UpdateCategoryResponse', message?: string | null, imgSrcUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CustomerConnectIdReminderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerConnectIdReminderMutation = { __typename?: 'Mutation', customerConnectIdReminder: { __typename?: 'CustomerConnectIdReminderResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CustomerPointsHistoryQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  actionFilter?: InputMaybe<Scalars['String']['input']>;
  categoryFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerPointsHistoryQueryQuery = { __typename?: 'Query', customerPointsHistory: { __typename?: 'CustomerPointsHistoryResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CustomerPointsHistoryData', createdAt?: string | null, type?: string | null, action?: string | null, category?: string | null, pointBalance?: number | null, tierBonus?: number | null }> } };

export type CustomerPointsOverviewQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerPointsOverviewQueryQuery = { __typename?: 'Query', customerPointsOverview?: { __typename?: 'CustomerPointsOverviewResponse', customerTier?: string | null, pointBalance?: number | null, lifeTimePoint?: number | null } | null };

export type UpdateCustomerAdminMutationMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  input: UpdateCustomerAdminInput;
}>;


export type UpdateCustomerAdminMutationMutation = { __typename?: 'Mutation', updateCustomerAdmin: { __typename?: 'updateCustomerResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type CustomersOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type CustomersOverviewAdminQueryQuery = { __typename?: 'Query', customersOverviewAdmin?: { __typename?: 'CustomerOverviewAdminResponse', registeredCustomers?: number | null, activeCustomers?: number | null, inActiveCustomers?: number | null, totalCurrentBalance?: number | null, totalSpend?: number | null, totalAmbassador?: number | null } | null };

export type FindAllCustomersAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  ambassadorFilter?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCustomersAdminQueryQuery = { __typename?: 'Query', findAllCustomersAdmin: { __typename?: 'FindAllCustomersAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllCustomersAdmin', totalSpend?: number | null, location?: string | null, suspended?: boolean | null, isLocked?: boolean | null, isDeactivated?: boolean | null, user?: { __typename?: 'FindAllCustomerUserAdmin', id: string, firstname?: string | null, lastname?: string | null, username?: string | null, isAmbassador?: boolean | null } | null, community?: Array<{ __typename?: 'Community', id: string, alias: string, name: string } | null> | null } | null> } };

export type FindAllCustomersByLocationIdAdminQueryQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCustomersByLocationIdAdminQueryQuery = { __typename?: 'Query', findAllCustomersByLocationIdAdmin: { __typename?: 'FindAllCustomersByLocationIdAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllCustomersByLocationIdAdminData', totalSpend?: number | null, location?: string | null, user?: { __typename?: 'FindAllCustomerUserByLocationIdAdmin', id: string, firstname?: string | null, lastname?: string | null, username?: string | null } | null, community?: Array<{ __typename?: 'Community', id: string, alias: string, name: string } | null> | null } | null> } };

export type CustomerReferralOverviewQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerReferralOverviewQueryQuery = { __typename?: 'Query', customerReferralOverview?: { __typename?: 'CustomerReferralOverview', totalReferrals?: number | null } | null };

export type FindReferralsByUserIdAdminQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindReferralsByUserIdAdminQuery = { __typename?: 'Query', findReferralsByUserIdAdmin: { __typename?: 'ReferralPage', referralCode?: string | null, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'ReferredCustomerAdmin', id?: string | null, customer?: { __typename?: 'CustomerSlim', id: string, firstname?: string | null, lastname?: string | null, username?: string | null, createdAt?: string | null, updatedAt?: string | null } | null }> } };

export type ResetCustomerPasswordAdminMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResetCustomerPasswordAdminMutationMutation = { __typename?: 'Mutation', resetCustomerPasswordAdmin?: { __typename?: 'ResetCustomerPasswordAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type UpdateCustomerToAmbassadorMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UpdateCustomerToAmbassadorMutation = { __typename?: 'Mutation', updateCustomerToAmbassador: { __typename?: 'UpdateCustomerToAmbassadorResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindCustomerByIdAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindCustomerByIdAdminQueryQuery = { __typename?: 'Query', findCustomerByIdAdmin?: { __typename?: 'FindCustomerByIdAdminResponse', userId?: string | null, cbmId?: string | null, suspended?: boolean | null, isLocked?: boolean | null, isDeactivated?: boolean | null, totalSpend?: number | null, currentBalance?: number | null, location?: string | null, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null, username?: string | null, email?: string | null, phone?: string | null, dob?: string | null, nin?: string | null, bvn?: string | null, gender?: string | null, address?: string | null, referralCode?: string | null, referralPoint?: number | null, isAmbassador?: boolean | null } | null, community?: Array<{ __typename?: 'Community', id: string, alias: string, name: string } | null> | null } | null };

export type UnlinkCbmMemberMutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UnlinkCbmMemberMutationMutation = { __typename?: 'Mutation', unlinkCbmMember: { __typename?: 'UnlinkCbmMemberResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllLocationsAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  countryFilter?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllLocationsAdminQueryQuery = { __typename?: 'Query', findAllLocationsAdmin: { __typename?: 'FindAllLocationsAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllLocationsAdmin', id?: string | null, district?: string | null, city?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, createdAt?: string | null, latitude?: string | null, longitude?: string | null, isArchive?: boolean | null, customerCount?: number | null }> } };

export type FindLocationByIdAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindLocationByIdAdminQueryQuery = { __typename?: 'Query', findLocationByIdAdmin?: { __typename?: 'FindLocationByIdAdminResponse', id?: string | null, district?: string | null, city?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, createdAt?: string | null, updatedAt?: string | null, latitude?: string | null, longitude?: string | null, isArchive?: boolean | null, customersCount?: number | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, level?: string | null, firstname?: string | null, lastname?: string | null } | null } | null } | null };

export type ToggleLocationArchiveStatusAdminMutationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  isArchive: Scalars['Boolean']['input'];
}>;


export type ToggleLocationArchiveStatusAdminMutationMutation = { __typename?: 'Mutation', toggleLocationArchiveStatusAdmin: { __typename?: 'ToggleLocationArchiveStatusAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllMerchantOffersAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllMerchantOffersAdminQueryQuery = { __typename?: 'Query', findAllMerchantOffersAdmin: { __typename?: 'OfferPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'OfferMerchantAdmin', id: string, title: string, offerType?: string | null, redemptions?: number | null, startDate: string, endDate?: string | null, status?: string | null, createdAt: string, createdBy?: { __typename?: 'UserMerchantExt2', admin?: { __typename?: 'AdminExt1', id: string, merchantProfile?: { __typename?: 'MerchantProfileExt', id: string, companyName?: string | null } | null } | null } | null }> } };

export type FindAllMerchantsSpendAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllMerchantsSpendAdminQueryQuery = { __typename?: 'Query', findAllMerchantsSpendAdmin: { __typename?: 'FindAllMerchantsSpendAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllMerchantsSpendAdminData', userId?: string | null, userIsDeactivated?: boolean | null, adminId?: string | null, adminEmail?: string | null, merchantId?: string | null, username?: string | null, companyName?: string | null, businessName?: string | null, totalReceived?: number | null } | null> } };

export type FindMerchantByIdAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindMerchantByIdAdminQueryQuery = { __typename?: 'Query', findMerchantByIdAdmin?: { __typename?: 'FindMerchantByIdAdminResponse', id: string, kycStatus: string, suspended: boolean, isLocked: boolean, isVerified: boolean, isDeactivated: boolean, forgotPasswordLocked: boolean, role: string, lastLoggedIn?: string | null, createdAt: string, updatedAt?: string | null, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, level?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null, onboarding?: { __typename?: 'Onboarding', id: string, status: string, currentStep: number } | null } | null };

export type MerchantOverviewAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MerchantOverviewAdminQueryQuery = { __typename?: 'Query', merchantOverviewAdmin?: { __typename?: 'MerchantOverviewAdminResponse', redeemedOffers?: number | null, currentBalance?: number | null, amountReceived?: number | null, amountWithdrawn?: number | null } | null };

export type MerchantsOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type MerchantsOverviewAdminQueryQuery = { __typename?: 'Query', merchantsOverviewAdmin?: { __typename?: 'MerchantOverviewAdminResponse', registeredMerchants?: number | null, activeMerchants?: number | null, inActiveMerchants?: number | null, totalCurrentBalance?: number | null, totalWithdrawals?: number | null } | null };

export type ResetMerchantBankPreferenceAdminMutationMutationVariables = Exact<{
  bankPreferenceId: Scalars['String']['input'];
}>;


export type ResetMerchantBankPreferenceAdminMutationMutation = { __typename?: 'Mutation', resetMerchantBankPreferenceAdmin: { __typename?: 'ResetBankPreferenceAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ResetMerchantPasswordAdminMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResetMerchantPasswordAdminMutationMutation = { __typename?: 'Mutation', resetMerchantPasswordAdmin?: { __typename?: 'ResetCustomerPasswordAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type UpdateMerchantAdminMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateBusinessInfoInput;
}>;


export type UpdateMerchantAdminMutationMutation = { __typename?: 'Mutation', updateMerchantAdmin: { __typename?: 'updateBusinessInfoResponse', message?: string | null, logoUrl?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type UpdateMerchantAdminDataAdminMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAdminInput;
}>;


export type UpdateMerchantAdminDataAdminMutationMutation = { __typename?: 'Mutation', updateMerchantAdminDataAdmin: { __typename?: 'updateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type CreateOfferPointsDeductionMutationMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
  point: Scalars['Int']['input'];
}>;


export type CreateOfferPointsDeductionMutationMutation = { __typename?: 'Mutation', createOfferPointsDeduction: { __typename?: 'CreateOfferPointsDeductionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteOfferPointsDeductionMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOfferPointsDeductionMutationMutation = { __typename?: 'Mutation', deleteOfferPointsDeduction: { __typename?: 'DeleteOfferPointsDeductionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllOfferPointsDeductionsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllOfferPointsDeductionsQueryQuery = { __typename?: 'Query', findAllOfferPointsDeductions?: { __typename?: 'FindAllOfferPointsDeductionsResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'OfferPointsDeduction', id?: string | null, offerId?: string | null, offerTitle?: string | null, offerStatus?: string | null, partnerName?: string | null, point?: number | null, createdAt?: string | null, updatedAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null> } | null };

export type FindOfferPointsDeductionByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindOfferPointsDeductionByIdQueryQuery = { __typename?: 'Query', findOfferPointsDeductionById?: { __typename?: 'OfferPointsDeduction', id?: string | null, offerId?: string | null, offerTitle?: string | null, offerStatus?: string | null, partnerName?: string | null, point?: number | null, createdAt?: string | null, updatedAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null };

export type UpdateOfferPointsDeductionMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  point: Scalars['Int']['input'];
}>;


export type UpdateOfferPointsDeductionMutationMutation = { __typename?: 'Mutation', updateOfferPointsDeduction: { __typename?: 'UpdateOfferPointsDeductionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllOffersAdminQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllOffersAdminQuery = { __typename?: 'Query', findAllOffersAdmin: { __typename?: 'FindAllOffersAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'OfferMerchantAdmin', id: string, title: string, offerType?: string | null, redemptions?: number | null, startDate: string, endDate?: string | null, status?: string | null, createdAt: string, createdBy?: { __typename?: 'UserMerchantExt2', admin?: { __typename?: 'AdminExt1', id: string, merchantProfile?: { __typename?: 'MerchantProfileExt', id: string, companyName?: string | null } | null } | null } | null }> } };

export type FindRedemptionsByOfferIdAdminQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  duration: Scalars['String']['input'];
}>;


export type FindRedemptionsByOfferIdAdminQuery = { __typename?: 'Query', findRedemptionsByOfferIdAdmin: { __typename?: 'FindRedemptionsByOfferIdAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindRedemptionsByOfferIdAdmin', createdAt?: string | null, redeemedCode?: string | null, wallet?: { __typename?: 'Wallet', id: string } | null, user?: { __typename?: 'User', customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null, community?: Array<{ __typename?: 'Community', id: string, alias: string } | null> | null } | null } | null }> } };

export type OffersOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type OffersOverviewAdminQueryQuery = { __typename?: 'Query', offersOverviewAdmin: { __typename?: 'OffersOverviewAdminResponse', totalRedeemedOffers?: number | null, totalPublishedOffers?: number | null, totalExpiredOffers?: number | null, totalDraftOffers?: number | null, totalScheduledOffers?: number | null, totalImpressions?: number | null, totalOffersClick?: number | null } };

export type CreatePartnerExchangeRateMutationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
}>;


export type CreatePartnerExchangeRateMutationMutation = { __typename?: 'Mutation', createPartnerExchangeRate: { __typename?: 'CreatePartnerExchangeRateResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeletePartnerExchangeRateMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePartnerExchangeRateMutationMutation = { __typename?: 'Mutation', deletePartnerExchangeRate: { __typename?: 'DeletePartnerExchangeRateResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllPartnerExchangeRatesQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllPartnerExchangeRatesQueryQuery = { __typename?: 'Query', findAllPartnerExchangeRates?: { __typename?: 'FindAllPartnerExchangeRatesResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'PartnerExchangeRate', id?: string | null, communityId?: string | null, communityName?: string | null, communityAlias?: string | null, rate?: number | null, createdAt?: string | null, updatedAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null> } | null };

export type FindPartnerExchangeRateByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindPartnerExchangeRateByIdQueryQuery = { __typename?: 'Query', findPartnerExchangeRateById?: { __typename?: 'PartnerExchangeRate', id?: string | null, communityId?: string | null, communityName?: string | null, communityAlias?: string | null, rate?: number | null, createdAt?: string | null, updatedAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null };

export type UpdatePartnerExchangeRateMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
}>;


export type UpdatePartnerExchangeRateMutationMutation = { __typename?: 'Mutation', updatePartnerExchangeRate: { __typename?: 'UpdatePartnerExchangeRateResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateCustomerTierMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  multiplier: Scalars['Int']['input'];
  threshold: Scalars['Int']['input'];
}>;


export type CreateCustomerTierMutationMutation = { __typename?: 'Mutation', createCustomerTier: { __typename?: 'CreateCustomerTierResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllCustomerTiersQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCustomerTiersQueryQuery = { __typename?: 'Query', findAllCustomerTiers: { __typename?: 'FindAllCustomerTiersResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllCustomerTiersData', id?: string | null, name?: string | null, multiplier?: number | null, threshold?: number | null, createdAt?: string | null, customerCount?: number | null, isArchive?: boolean | null } | null> } };

export type FindCustomerTierByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindCustomerTierByIdQueryQuery = { __typename?: 'Query', findCustomerTierById?: { __typename?: 'FindAllCustomerTiersData', id?: string | null, name?: string | null, multiplier?: number | null, threshold?: number | null, createdAt?: string | null, customerCount?: number | null, isArchive?: boolean | null } | null };

export type UpdateCustomerTierMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCustomerTierInput;
}>;


export type UpdateCustomerTierMutationMutation = { __typename?: 'Mutation', updateCustomerTier: { __typename?: 'UpdateCustomerTierResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateRefundAdminMutationMutationVariables = Exact<{
  input: CreateRefundInputAdmin;
}>;


export type CreateRefundAdminMutationMutation = { __typename?: 'Mutation', createRefundAdmin: { __typename?: 'CreateRefundResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'TransferResponse', id?: number | null, account_number?: string | null, bank_code?: string | null, full_name?: string | null, currency?: string | null, debit_currency?: string | null, amount?: number | null, fee?: number | null, status?: string | null, reference?: string | null, narration?: string | null, complete_message?: string | null, requires_approval?: number | null, is_approved?: number | null, bank_name?: string | null } | null } };

export type FindAllRefundsAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllRefundsAdminQueryQuery = { __typename?: 'Query', findAllRefundsAdmin: { __typename?: 'FindAllRefundsAdminResponse', total: number, page: number, pageSize: number, totalPages: number, refund?: Array<{ __typename?: 'FindAllRefundsAdmin', id: string, amount: number, reasonForRefund?: string | null, description?: string | null, customerName: string, transactionId: string, createdAt: string, reference?: string | null, status: string, currency: string, userId?: string | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null, businessName?: string | null } | null } | null } | null }> | null } };

export type FindRefundByIdAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindRefundByIdAdminQueryQuery = { __typename?: 'Query', findRefundByIdAdmin?: { __typename?: 'FindRefundByIdAdminResponse', id: string, amount: number, reasonForRefund?: string | null, description?: string | null, customerName: string, transactionId: string, createdAt: string, reference?: string | null, status: string, currency: string, userId?: string | null, transaction?: { __typename?: 'Transaction', id: string, offer?: { __typename?: 'Offer', id: string, title: string, offerType?: string | null } | null } | null, user?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null, businessName?: string | null } | null } | null } | null, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null } | null } | null };

export type RefundOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type RefundOverviewAdminQueryQuery = { __typename?: 'Query', refundOverviewAdmin: { __typename?: 'RefundOverviewAdminResponse', totalRefunds?: number | null, pendingRefunds?: number | null, totalPendingRefundValue?: number | null } };

export type CreateWithdrawalAdminMutationMutationVariables = Exact<{
  input: CreateWithdrawalInputAdmin;
}>;


export type CreateWithdrawalAdminMutationMutation = { __typename?: 'Mutation', createWithdrawalAdmin: { __typename?: 'WalletTransferResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllWithdrawalsAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllWithdrawalsAdminQueryQuery = { __typename?: 'Query', findAllWithdrawalsAdmin: { __typename?: 'FindAllWithdrawalsAdminResponse', total: number, page: number, pageSize: number, totalPages: number, withdrawals: Array<{ __typename?: 'Withdrawal', id: string, createdAt?: string | null, updatedAt?: string | null, transaction?: { __typename?: 'Transaction', id: string, amount: number, status: string, currency: string, wallet?: { __typename?: 'Wallet', id: string, flAccountReference?: string | null, barterId: string, balance?: number | null } | null, user: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null, businessName?: string | null } | null } | null } } | null, bankPreference?: { __typename?: 'BankPreference', id: string, accountNo: string, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string } } | null }> } };

export type FindWithdrawalByIdAdminQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindWithdrawalByIdAdminQueryQuery = { __typename?: 'Query', findWithdrawalByIdAdmin: { __typename?: 'Withdrawal', id: string, createdAt?: string | null, transaction?: { __typename?: 'Transaction', id: string, amount: number, status: string, currency: string, wallet?: { __typename?: 'Wallet', id: string, flAccountReference?: string | null, barterId: string, balance?: number | null } | null, user: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null, businessName?: string | null } | null } | null } } | null, bankPreference?: { __typename?: 'BankPreference', id: string, accountNo: string, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string } } | null } };

export type WithdrawalOverviewAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type WithdrawalOverviewAdminQueryQuery = { __typename?: 'Query', withdrawalOverviewAdmin: { __typename?: 'WithdrawalOverviewAdminResponse', totalWithdrawals?: number | null, pendingWithdrawals?: number | null } };

export type CampaignClickThroughsQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignClickThroughsQueryQuery = { __typename?: 'Query', campaignClickThroughs?: { __typename?: 'CampaignClickThroughResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CampaignClickThroughData', id?: string | null, createdAt?: string | null, customer?: string | null } | null> } | null };

export type CampaignOverviewQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
  typeFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignOverviewQueryQuery = { __typename?: 'Query', campaignOverview?: { __typename?: 'CampaignOverviewResponse', totalCampaigns?: number | null, totalImpressions?: number | null, totalClicks?: number | null, activeCampaigns?: number | null, expiredCampaigns?: number | null } | null };

export type CampaignSubmissionsQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignSubmissionsQueryQuery = { __typename?: 'Query', campaignSubmissions?: { __typename?: 'CampaignSubmissionResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CampaignSubmissionData', id?: string | null, createdAt?: string | null, customer?: string | null, response?: string | null } | null> } | null };

export type CreateCampaignMutationMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  locationId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  communityId: Array<Scalars['String']['input']> | Scalars['String']['input'];
  campaignType: Scalars['String']['input'];
  pollOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  campaignLink?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  colorCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCampaignMutationMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'CreateCampaignResponse', message?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteCampaignByIdMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCampaignByIdMutationMutation = { __typename?: 'Mutation', deleteCampaignById?: { __typename?: 'DeleteCampaignResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type FindAllCampaignsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  locationFilter?: InputMaybe<Scalars['String']['input']>;
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCampaignsQueryQuery = { __typename?: 'Query', findAllCampaigns?: { __typename?: 'FindAllCampaignsResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Campaign', id?: string | null, title?: string | null, description?: string | null, question?: string | null, active?: boolean | null, bannerUrl?: string | null, location?: Array<string | null> | null, community?: Array<string | null> | null, campaignType?: string | null, pollOptions?: Array<string | null> | null, campaignLink?: string | null, startDate?: string | null, endDate?: string | null, colorCode?: string | null, views?: number | null, clickThrough?: number | null, createdAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null> } | null };

export type FindCampaignByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindCampaignByIdQueryQuery = { __typename?: 'Query', findCampaignById?: { __typename?: 'Campaign', id?: string | null, title?: string | null, description?: string | null, question?: string | null, active?: boolean | null, bannerUrl?: string | null, location?: Array<string | null> | null, community?: Array<string | null> | null, campaignType?: string | null, pollOptions?: Array<string | null> | null, campaignLink?: string | null, startDate?: string | null, endDate?: string | null, colorCode?: string | null, views?: number | null, clickThrough?: number | null, createdAt?: string | null, adminName?: string | null, adminLevel?: string | null } | null };

export type FindCommunitiesFromCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCommunitiesFromCampaignsQuery = { __typename?: 'Query', findCommunitiesFromCampaigns: Array<{ __typename?: 'Community', id: string, name: string, alias: string }> };

export type NewCampaignSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewCampaignSubscriptionSubscription = { __typename?: 'Subscription', newCampaign: Array<{ __typename?: 'Campaign', id?: string | null, title?: string | null, location?: Array<string | null> | null, community?: Array<string | null> | null }> };

export type FindLocationsFromCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLocationsFromCampaignsQuery = { __typename?: 'Query', findLocationsFromCampaigns: Array<{ __typename?: 'Location', id?: string | null, city?: string | null }> };

export type GetCampaignQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignQueryQuery = { __typename?: 'Query', getCampaign?: { __typename?: 'Campaign', id?: string | null, title?: string | null, description?: string | null, question?: string | null, bannerUrl?: string | null, campaignType?: string | null, pollOptions?: Array<string | null> | null, location?: Array<string | null> | null, community?: Array<string | null> | null, campaignLink?: string | null, colorCode?: string | null } | null };

export type MarkCampaignMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  option?: InputMaybe<Scalars['String']['input']>;
  close?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkCampaignMutationMutation = { __typename?: 'Mutation', markCampaign?: { __typename?: 'MarkCampaignResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type UpdateCampaignMutationMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutationMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'UpdateCampaignResponse', message?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindPlatformContactsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindPlatformContactsQueryQuery = { __typename?: 'Query', findPlatformContacts: Array<{ __typename?: 'PlatformContact', id: string, facebook?: string | null, x?: string | null, linkedin?: string | null, instagram?: string | null, logoUrl?: string | null, email?: string | null, website?: string | null, address?: string | null, updatedAt?: string | null, createdAt: string }> };

export type NewPlatformContactSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewPlatformContactSubscriptionSubscription = { __typename?: 'Subscription', newPlatformContact: Array<{ __typename?: 'PlatformContact', id: string, facebook?: string | null, x?: string | null, linkedin?: string | null, instagram?: string | null, logoUrl?: string | null, email?: string | null, website?: string | null, address?: string | null, updatedAt?: string | null, createdAt: string }> };

export type UpdatePlatformContactMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdatePlatformContactInput;
}>;


export type UpdatePlatformContactMutationMutation = { __typename?: 'Mutation', updatePlatformContact: { __typename?: 'UpdatePlatformContactResponse', message?: string | null, logoUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewPlatformContactQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewPlatformContactQueryQuery = { __typename?: 'Query', viewPlatformContact?: { __typename?: 'PlatformContact', id: string, facebook?: string | null, x?: string | null, linkedin?: string | null, instagram?: string | null, logoUrl?: string | null, email?: string | null, website?: string | null, address?: string | null, updatedAt?: string | null, createdAt: string } | null };

export type CreateRepContactMutationMutationVariables = Exact<{
  adminId: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type CreateRepContactMutationMutation = { __typename?: 'Mutation', createRepContact: { __typename?: 'CreateRepContactResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteRepContactMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteRepContactMutationMutation = { __typename?: 'Mutation', deleteRepContact: { __typename?: 'DeleteRepContactResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindRepContactsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindRepContactsQueryQuery = { __typename?: 'Query', findRepContacts: Array<{ __typename?: 'RepContact', id: string, role: string, createdAt: string, updatedAt?: string | null, admin: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null }, user: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } }> };

export type NewRepContactSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewRepContactSubscriptionSubscription = { __typename?: 'Subscription', newRepContact: Array<{ __typename?: 'RepContact', id: string, role: string, createdAt: string, updatedAt?: string | null, admin: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null }, user: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } }> };

export type UpdateRepContactMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateRepContactInput;
}>;


export type UpdateRepContactMutationMutation = { __typename?: 'Mutation', updateRepContact: { __typename?: 'UpdateRepContactResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewRepContactQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewRepContactQueryQuery = { __typename?: 'Query', viewRepContact?: { __typename?: 'RepContact', id: string, role: string, createdAt: string, updatedAt?: string | null, admin: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null }, user: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } } | null };

export type FindAdminAdminsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAdminAdminsQueryQuery = { __typename?: 'Query', findAdminAdmins: Array<{ __typename?: 'AdminAdmins', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, shortId?: string | null, createdAt: string, updatedAt?: string | null }> };

export type FindAdminMerchantsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAdminMerchantsQueryQuery = { __typename?: 'Query', findAdminMerchants: Array<{ __typename?: 'FindAdminMerchantsResponse', id: string, businessName?: string | null, businessType?: string | null, businessRegNumber?: string | null, companyName?: string | null, username?: string | null, logoUrl?: string | null, createdAt?: string | null, adminId?: string | null, userId?: string | null } | null> };

export type FindAllInterestsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllInterestsQueryQuery = { __typename?: 'Query', findAllInterests: { __typename?: 'FindAllInterestResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllInterestData', id?: string | null, partner?: string | null, numberOfCustomers?: number | null, totalReceived?: number | null } | null> } };

export type FindMerchantInterestsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindMerchantInterestsQueryQuery = { __typename?: 'Query', findMerchantInterests: { __typename?: 'FindMerchantInterestsResponse', companyName?: string | null, username?: string | null, shortId?: string | null, totalInterests?: number | null, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindMerchantInterestsInterestedCustomers', customerName?: string | null, customerUsername?: string | null, location?: string | null, totalSpend?: number | null, community?: Array<{ __typename?: 'Community', id: string, name: string } | null> | null } | null> } };

export type InterestOverviewQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type InterestOverviewQueryQuery = { __typename?: 'Query', interestOverview?: { __typename?: 'InterestOverviewResponse', partnersWithInterest?: number | null, customersWithInterest?: number | null } | null };

export type CustomersOverviewOnboardingAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type CustomersOverviewOnboardingAdminQueryQuery = { __typename?: 'Query', customersOverviewOnboardingAdmin?: { __typename?: 'CustomersOverviewOnboardingAdminResponse', accountsCreated?: number | null, accountsVerified?: number | null, onboarded?: number | null, idsConnected?: number | null } | null };

export type FindAllCustomersOnboardingAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCustomersOnboardingAdminQueryQuery = { __typename?: 'Query', findAllCustomersOnboardingAdmin: { __typename?: 'FindAllCustomersOnboardingAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllCustomersOnboardingAdminData', id?: string | null, firstname?: string | null, lastname?: string | null, stage?: number | null, status?: string | null, email?: string | null, phone?: string | null, createdAt?: string | null, updatedAt?: string | null, referrer?: { __typename?: 'CustomerOnboardingReferrer', userId?: string | null, id?: string | null, firstname?: string | null, lastname?: string | null } | null } | null> } };

export type FindAllMerchantsOnboardingAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllMerchantsOnboardingAdminQueryQuery = { __typename?: 'Query', findAllMerchantsOnboardingAdmin: { __typename?: 'FindAllMerchantsOnboardingAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'FindAllMerchantsOnboardingAdminData', adminId?: string | null, merchantId?: string | null, firstname?: string | null, lastname?: string | null, companyName?: string | null, currentStep?: number | null, status?: string | null, isVerified?: boolean | null, websiteOrSocials?: string | null, email?: string | null, phone?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } };

export type MerchantsOverviewOnboardingAdminQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type MerchantsOverviewOnboardingAdminQueryQuery = { __typename?: 'Query', merchantsOverviewOnboardingAdmin?: { __typename?: 'MerchantsOverviewOnboardingAdminResponse', accountsCreated?: number | null, accountsVerified?: number | null, onboarded1?: number | null, onboarded2?: number | null } | null };

export type TenantsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantsQueryQuery = { __typename?: 'Query', tenants: Array<{ __typename?: 'Tenant', id: string, name: string, slug: string, status: TenantStatus, isDefault: boolean }> };

export type FindAllTransactionsAdminQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllTransactionsAdminQuery = { __typename?: 'Query', findAllTransactionsAdmin: { __typename?: 'AdminFindAllTransactionResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Transaction', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, wallet?: { __typename?: 'Wallet', id: string, balance?: number | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null } } | null, recipientWallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', admin?: { __typename?: 'Admin', merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null } | null } | null } } | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null } } | null> } };

export type FindTransactionsByUserIdAdminQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTransactionsByUserIdAdminQuery = { __typename?: 'Query', findTransactionsByUserIdAdmin: { __typename?: 'TransactionPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, wallet?: { __typename?: 'Wallet', id: string, balance?: number | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', id: string, companyName?: string | null, businessName?: string | null } | null } | null, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } | null, recipientWallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', id: string, companyName?: string | null, businessName?: string | null } | null } | null, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, category?: { __typename?: 'CategoryMerchant', name: string } | null } | null, user: { __typename?: 'User', id: string } }> } };

export type AlertOverviewQueryQueryVariables = Exact<{
  duration?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlertOverviewQueryQuery = { __typename?: 'Query', alertOverview: { __typename?: 'AlertOverviewSummary', totalPushNotifications: number, totalSubscribedUsers: number, totalAlerts: number } };

export type AlertOverviewByAlertIdQueryQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
}>;


export type AlertOverviewByAlertIdQueryQuery = { __typename?: 'Query', alertOverviewByAlertId: { __typename?: 'AlertOverviewResponse', items: Array<{ __typename?: 'AlertOverviewItem', totalNotificationsSent: number, totalNotificationsQueued: number, totalClicks: number, totalRead: number, totalUnread: number }> } };

export type CreateAlertMutationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  update: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  roleTargets?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAlertMutationMutation = { __typename?: 'Mutation', createAlert: { __typename?: 'CreateAlertResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteAlertMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAlertMutationMutation = { __typename?: 'Mutation', deleteAlert: { __typename?: 'DeleteAlertResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllAlertsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  deliveryModes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  communityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  targets?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllAlertsQueryQuery = { __typename?: 'Query', findAllAlerts: { __typename?: 'FindAllAlertsResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Alert', id: string, title: string, update: string, isSeen?: boolean | null, broadcast?: boolean | null, targetMode?: string | null, deliveryMode?: string | null, locationIds?: Array<string> | null, locationScopeAll?: boolean | null, communityIds?: Array<string> | null, communityScopeAll?: boolean | null, targetUserCount?: number | null, receivedCount?: number | null, queuedCount?: number | null, clickCount?: number | null, readCount?: number | null, unreadCount?: number | null, type?: string | null, typeId?: string | null, scheduledAt?: string | null, dispatchedAt?: string | null, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } | null }> } };

export type FindSubscribedAlertUsersQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindSubscribedAlertUsersQueryQuery = { __typename?: 'Query', findSubscribedAlertUsers: { __typename?: 'FindSubscribedAlertUsersResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'SubscribedAlertUser', userId: string, username?: string | null, firstname?: string | null, lastname?: string | null, isAmbassador?: boolean | null, communityId?: Array<string> | null, location?: string | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null }> } };

export type MyAlertQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type MyAlertQueryQuery = { __typename?: 'Query', myAlert: Array<{ __typename?: 'AlertPWA', id: string, title: string, update: string, isSeen?: boolean | null, createdAt: string, updatedAt?: string | null }> };

export type NewAlertSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewAlertSubscriptionSubscription = { __typename?: 'Subscription', newAlert: { __typename?: 'Alert', id: string, title: string, update: string, isSeen?: boolean | null, createdAt: string, updatedAt?: string | null } };

export type PushProviderEventBreakdownQueryQueryVariables = Exact<{
  windowHours?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PushProviderEventBreakdownQueryQuery = { __typename?: 'Query', pushProviderEventBreakdown: { __typename?: 'PushProviderEventBreakdownResponse', message?: string | null, windowHours: number, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, providers: Array<{ __typename?: 'PushProviderEventBreakdownItem', provider: string, received: number, clicked: number, read: number, failed: number, total: number }> } };

export type PushProviderEventMetricsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PushProviderEventMetricsQueryQuery = { __typename?: 'Query', pushProviderEventMetrics: { __typename?: 'PushProviderEventIngestResponse', message?: string | null, processed: number, updated: number, duplicate: number, invalid: number, missingAlert: number, received: number, clicked: number, read: number, failed: number, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UpdateAlertMutationMutationVariables = Exact<{
  alertId: Scalars['String']['input'];
  input: UpdateAlertInput;
}>;


export type UpdateAlertMutationMutation = { __typename?: 'Mutation', updateAlert: { __typename?: 'UpdateAlertResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewAlertQueryQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
}>;


export type ViewAlertQueryQuery = { __typename?: 'Query', viewAlert?: { __typename?: 'Alert', id: string, title: string, update: string, isSeen?: boolean | null, broadcast?: boolean | null, targetMode?: string | null, deliveryMode?: string | null, locationIds?: Array<string> | null, locationScopeAll?: boolean | null, communityIds?: Array<string> | null, communityScopeAll?: boolean | null, targetUserCount?: number | null, receivedCount?: number | null, queuedCount?: number | null, clickCount?: number | null, readCount?: number | null, unreadCount?: number | null, type?: string | null, typeId?: string | null, scheduledAt?: string | null, dispatchedAt?: string | null, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } | null, selectionSummary: { __typename?: 'AlertSelectionSummary', targetMode: string, userCount?: number | null, roles: Array<string>, userIds: Array<string> } } | null };

export type FindAllAuditLogsQueryQueryVariables = Exact<{
  duration?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllAuditLogsQueryQuery = { __typename?: 'Query', findAllAuditLogs: { __typename?: 'FindAllAuditLogsResponse', uniqueEntities?: number | null, totalLogs?: number | null, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'AuditLog', id?: string | null, entity?: string | null, action?: string | null, entityId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: string | null }> } };

export type ViewAuditLogQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewAuditLogQueryQuery = { __typename?: 'Query', viewAuditLog?: { __typename?: 'AuditLog', id?: string | null, entity?: string | null, action?: string | null, entityId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: string | null } | null };

export type ForgotPasswordChangeAdminMutationMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type ForgotPasswordChangeAdminMutationMutation = { __typename?: 'Mutation', forgotPasswordChangeAdmin: { __typename?: 'ResetResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type SendForgotPasswordEmailAdminMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendForgotPasswordEmailAdminMutationMutation = { __typename?: 'Mutation', sendForgotPasswordEmailAdmin: { __typename?: 'ResetResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type LoginAdminMutationMutationVariables = Exact<{
  adminId: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginAdminMutationMutation = { __typename?: 'Mutation', loginAdmin: { __typename?: 'LoginAdminResponse', sessionId?: string | null, sessionRole?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type OtpValidateAdminMutationMutationVariables = Exact<{
  verificationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type OtpValidateAdminMutationMutation = { __typename?: 'Mutation', otpValidateAdmin: { __typename?: 'OTPValidateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ResendOtpAdminMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendOtpAdminMutationMutation = { __typename?: 'Mutation', resendOtpAdmin: { __typename?: 'RegisterMerchantResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UpdatePasswordChangeAdminMutationMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordChangeAdminMutationMutation = { __typename?: 'Mutation', updatePasswordChangeAdmin?: Array<{ __typename?: 'Error', path: string, message: string }> | null };

export type CreateCommunityMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  alias: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCommunityMutationMutation = { __typename?: 'Mutation', createCommunity: { __typename?: 'CreateCommunityResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllCommunitiesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCommunitiesQueryQuery = { __typename?: 'Query', findAllCommunities: Array<{ __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null, isArchive?: boolean | null, createdAt: string, updatedAt?: string | null }> };

export type NewCommunitySubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewCommunitySubscriptionSubscription = { __typename?: 'Subscription', newCommunity: { __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null, isArchive?: boolean | null, createdAt: string, updatedAt?: string | null } };

export type FindAllCommunitySpendQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCommunitySpendQuery = { __typename?: 'Query', findAllCommunitySpend: { __typename?: 'FindAllCommunitySpendResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CommunityWithSpend', totalSpend: number, community: { __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, isArchive?: boolean | null, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, level?: string | null, firstname?: string | null, lastname?: string | null } | null } | null } }> } };

export type ToggleCommunityArchiveStatusMutationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  isArchive: Scalars['Boolean']['input'];
}>;


export type ToggleCommunityArchiveStatusMutationMutation = { __typename?: 'Mutation', toggleCommunityArchiveStatus: { __typename?: 'ToggleCommunityArchiveStatusAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UpdateCommunityMutationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  input: UpdateCommunityInput;
}>;


export type UpdateCommunityMutationMutation = { __typename?: 'Mutation', updateCommunity: { __typename?: 'UpdateCommunityResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateCommunityEntityMutationMutationVariables = Exact<{
  input: CreateCommunityEntityInput;
}>;


export type CreateCommunityEntityMutationMutation = { __typename?: 'Mutation', createCommunityEntity: { __typename?: 'CreateCommunityEntityResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteCommunityEntityMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCommunityEntityMutationMutation = { __typename?: 'Mutation', deleteCommunityEntity: { __typename?: 'DeleteResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllCommunityEntitiesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCommunityEntitiesQueryQuery = { __typename?: 'Query', findAllCommunityEntities: Array<{ __typename?: 'CommunityEntityPWA', id: string, name: string, shortName?: string | null, entityType?: Array<string> | null }> };

export type NewCommunityEntitySubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewCommunityEntitySubscriptionSubscription = { __typename?: 'Subscription', newCommunityEntity: { __typename?: 'CommunityEntity', id: string, name: string, shortName?: string | null, entityType?: Array<string> | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'User', id: string } } };

export type FindAllCommunityEntitiesAdminQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  entityTypeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCommunityEntitiesAdminQuery = { __typename?: 'Query', findAllCommunityEntitiesAdmin: { __typename?: 'FindAllCommunityEntityResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CommunityEntity', id: string, name: string, shortName?: string | null, entityType?: Array<string> | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, level?: string | null } | null } }> } };

export type FindByEntityTypeQueryQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type FindByEntityTypeQueryQuery = { __typename?: 'Query', findByEntityType: Array<{ __typename?: 'CommunityEntityPWA', id: string, name: string, shortName?: string | null, entityType?: Array<string> | null }> };

export type UpdateCommunityEntityMutationMutationVariables = Exact<{
  communityEntityId: Scalars['String']['input'];
  input: UpdateCommunityEntityInput;
}>;


export type UpdateCommunityEntityMutationMutation = { __typename?: 'Mutation', updateCommunityEntity: { __typename?: 'UpdateCommunityEntityResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewCommunityEntityByIdQueryQueryVariables = Exact<{
  communityEntityId: Scalars['String']['input'];
}>;


export type ViewCommunityEntityByIdQueryQuery = { __typename?: 'Query', viewCommunityEntityById: { __typename?: 'CommunityEntity', id: string, name: string, shortName?: string | null, entityType?: Array<string> | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, level?: string | null } | null } } };

export type DeactivateAdminMutationMutationVariables = Exact<{
  input: DeactivateAdminInput;
}>;


export type DeactivateAdminMutationMutation = { __typename?: 'Mutation', deactivateAdmin: { __typename?: 'DeactivateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type ReactivateAdminMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ReactivateAdminMutationMutation = { __typename?: 'Mutation', reactivateAdmin: { __typename?: 'ReactivateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeactivateCustomerAdminMutationVariables = Exact<{
  input: DeactivateCustomerAdminInput;
}>;


export type DeactivateCustomerAdminMutation = { __typename?: 'Mutation', deactivateCustomerAdmin: { __typename?: 'DeactivateCustomerAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type ReactivateCustomerAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ReactivateCustomerAdminMutation = { __typename?: 'Mutation', reactivateCustomerAdmin: { __typename?: 'ReactivateCustomerAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllCategoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCategoriesQueryQuery = { __typename?: 'Query', findAllCategories: Array<{ __typename?: 'CategoryPWA', id: string, name: string, imgSrc: string, createdAt?: string | null }> };

export type NewCategorySubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewCategorySubscriptionSubscription = { __typename?: 'Subscription', newCategory: { __typename?: 'Category', id: string, name: string, imgSrc: string, isArchive: boolean, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } };

export type FindCustomersWhoRedeemedOffersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  communityFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindCustomersWhoRedeemedOffersQuery = { __typename?: 'Query', findCustomersWhoRedeemedOffers: { __typename?: 'FindCustomersWhoRedeemedOffersResponse', pageSize: number, page: number, total: number, totalPages: number, data: Array<{ __typename?: 'CustomerWhoRedeemedOffer', totalSpent: number, location?: string | null, customer: { __typename?: 'Customer', id: string, avatarUrl?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, username?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, address?: string | null, gender?: string | null, dob?: string | null, nin?: string | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null } }> } };

export type CreateIndustryMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateIndustryMutationMutation = { __typename?: 'Mutation', createIndustry: { __typename?: 'CreateIndustryResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteIndustryMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteIndustryMutationMutation = { __typename?: 'Mutation', deleteIndustry: { __typename?: 'DeleteIndustryResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAllIndustriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllIndustriesQueryQuery = { __typename?: 'Query', findAllIndustries: Array<{ __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, isArchive?: boolean | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null, level?: string | null } | null } | null }> };

export type NewIndustrySubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewIndustrySubscriptionSubscription = { __typename?: 'Subscription', newIndustry: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', firstname?: string | null, lastname?: string | null, email?: string | null } | null } | null } };

export type FindAllIndustriesAdminQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllIndustriesAdminQueryQuery = { __typename?: 'Query', findAllIndustriesAdmin: { __typename?: 'FindAllIndustriesAdminResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Industry', id: string, name: string, createdAt: string, isArchive?: boolean | null, partnerCount?: number | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, level?: string | null } | null } | null }> } };

export type ViewIndustryQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewIndustryQueryQuery = { __typename?: 'Query', viewIndustry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, isArchive?: boolean | null, partnerCount?: number | null, createdBy?: { __typename?: 'User', id: string, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, level?: string | null } | null } | null } | null };

export type UpdateIndustryMutationMutationVariables = Exact<{
  industryId: Scalars['String']['input'];
  input: UpdateIndustryInput;
}>;


export type UpdateIndustryMutationMutation = { __typename?: 'Mutation', updateIndustry: { __typename?: 'UpdateIndustryResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type BusinessOnboardingStepOneMutationMutationVariables = Exact<{
  businessName: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  regCountry: Scalars['String']['input'];
  businessRegNumber: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  addressAlt?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type BusinessOnboardingStepOneMutationMutation = { __typename?: 'Mutation', businessOnboardingStepOne: { __typename?: 'BusinessOnboardingStepOneResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type BusinessOnboardingStepTwoMutationMutationVariables = Exact<{
  username: Scalars['String']['input'];
  industryId: Scalars['String']['input'];
  companyLocation: Scalars['String']['input'];
  logoUrl: Scalars['String']['input'];
  bannerUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type BusinessOnboardingStepTwoMutationMutation = { __typename?: 'Mutation', businessOnboardingStepTwo: { __typename?: 'BusinessOnboardingStepTwoResponse', message?: string | null, logoUrl?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type BestPerformingOffersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BestPerformingOffersQueryQuery = { __typename?: 'Query', bestPerformingOffers: Array<{ __typename?: 'Offer', id: string, title: string, offerType?: string | null, redemptions?: number | null } | null> };

export type CashFlowOverviewQueryQueryVariables = Exact<{
  duration: Scalars['String']['input'];
}>;


export type CashFlowOverviewQueryQuery = { __typename?: 'Query', cashFlowOverview: { __typename?: 'CashFlowOverviewResponse', totalCurrentBalance?: number | null, totalCashWithdrawn?: number | null, totalTransactionValue?: number | null } };

export type PublishedOffersOverviewQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishedOffersOverviewQueryQuery = { __typename?: 'Query', publishedOffersOverview: { __typename?: 'PublishedOffersOverviewResult', totalOffers: number, offerTypes: Array<{ __typename?: 'OfferTypeOverview', offerType: string, count: number }> } };

export type FindAllMyCommunitySpendQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllMyCommunitySpendQuery = { __typename?: 'Query', findAllMyCommunitySpend: { __typename?: 'FindAllMyCommunitySpendResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CommunityWithSpend', totalSpend: number, community: { __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, createdAt: string, updatedAt?: string | null } }> } };

export type FindMerchantCommunitiesFromOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMerchantCommunitiesFromOffersQuery = { __typename?: 'Query', findMerchantCommunitiesFromOffers: Array<{ __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null, createdAt: string, updatedAt?: string | null }> };

export type NewMerchantApprovalMutationVariables = Exact<{
  merchantId: Scalars['String']['input'];
}>;


export type NewMerchantApprovalMutation = { __typename?: 'Mutation', newMerchantApproval: { __typename?: 'NewMerchantApprovalResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type RegisterMerchantMutationMutationVariables = Exact<{
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  websiteOrSocials?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
  nda: Scalars['Boolean']['input'];
}>;


export type RegisterMerchantMutationMutation = { __typename?: 'Mutation', registerMerchant: { __typename?: 'RegisterMerchantResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type TopMerchantsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type TopMerchantsQuery = { __typename?: 'Query', topMerchants: Array<{ __typename?: 'UserAdminPWA', id: string, isVerified: boolean, admin?: { __typename?: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null } | null }> };

export type MarkNjoyCodeAsUsedMutationMutationVariables = Exact<{
  adminId: Scalars['String']['input'];
  njoyCode: Scalars['String']['input'];
}>;


export type MarkNjoyCodeAsUsedMutationMutation = { __typename?: 'Mutation', markNjoyCodeAsUsed: { __typename?: 'MarkNjoyCodeAsUsedResponse', message?: string | null, njoyCode?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type VerifyNjoyCodeQueryQueryVariables = Exact<{
  njoyCode: Scalars['String']['input'];
}>;


export type VerifyNjoyCodeQueryQuery = { __typename?: 'Query', verifyNjoyCode?: { __typename?: 'VerifyNjoyCodeResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null, data?: { __typename?: 'VerifyNjoyCodeData', offerTitle?: string | null, offerType?: string | null, offerCode?: string | null, status?: string | null, redeemedDate?: string | null, usedDate?: string | null } | null } | null };

export type CreateOfferMutationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  offerType: Scalars['String']['input'];
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  njoyCodeId?: InputMaybe<Scalars['String']['input']>;
  partnerVoucher?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  referralUrl?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  usageLimitPerUser: Scalars['Int']['input'];
  totalUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationId?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offerTOR: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOfferMutationMutation = { __typename?: 'Mutation', createOffer: { __typename?: 'CreateOfferResponse', message?: string | null, bannerUrl?: string | null, offerId?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type DeleteOfferMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOfferMutationMutation = { __typename?: 'Mutation', deleteOffer: { __typename?: 'DeleteOfferResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type FindAdminOffersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAdminOffersQuery = { __typename?: 'Query', findAdminOffers: { __typename?: 'OfferResponse', redeemedOffers?: number | null, publishedOffers?: number | null, offerViews?: number | null, offerClicks?: number | null, pageOffers: { __typename?: 'OfferPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'OfferMerchantAdmin', id: string, title: string, offerType?: string | null, redemptions?: number | null, startDate: string, endDate?: string | null, status?: string | null, createdAt: string, createdBy?: { __typename?: 'UserMerchantExt2', admin?: { __typename?: 'AdminExt1', id: string, merchantProfile?: { __typename?: 'MerchantProfileExt', id: string, companyName?: string | null } | null } | null } | null }> } } };

export type FindRecentOfferRedemptionsByIdQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindRecentOfferRedemptionsByIdQuery = { __typename?: 'Query', findRecentOfferRedemptionsById: { __typename?: 'FindRecentOfferRedemptionsResponse', redeemedCodes: number, remainingCodes: number, totalOfferViews: number, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'CustomerRedemption', redeemedCode: string, redemptionDate: string, customer: { __typename?: 'CustomerMerchant', id: string, firstname?: string | null, lastname?: string | null, username?: string | null, community?: Array<{ __typename?: 'CommunityMerchant', id: string, name: string, alias: string } | null> | null } }> } };

export type UpdateOfferMutationMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
  input: UpdateOfferInput;
}>;


export type UpdateOfferMutationMutation = { __typename?: 'Mutation', updateOffer: { __typename?: 'UpdateOfferResponse', message?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateRefundMutationMutationVariables = Exact<{
  input: CreateRefundInput;
}>;


export type CreateRefundMutationMutation = { __typename?: 'Mutation', createRefund: { __typename?: 'CreateRefundResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'TransferResponse', id?: number | null, account_number?: string | null, bank_code?: string | null, full_name?: string | null, currency?: string | null, debit_currency?: string | null, amount?: number | null, fee?: number | null, status?: string | null, reference?: string | null, narration?: string | null, complete_message?: string | null, requires_approval?: number | null, is_approved?: number | null, bank_name?: string | null } | null } };

export type FindRefundsQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindRefundsQueryQuery = { __typename?: 'Query', findRefunds: { __typename?: 'RefundResponse', total: number, page: number, pageSize: number, totalPages: number, refund?: Array<{ __typename?: 'Refund', id: string, amount: number, reasonForRefund?: string | null, description?: string | null, customerName: string, transactionId: string, createdAt: string, reference?: string | null, status: string, currency: string }> | null } };

export type NewRefundSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewRefundSubscriptionSubscription = { __typename?: 'Subscription', newRefund: { __typename?: 'Refund', id: string, amount: number, reasonForRefund?: string | null, description?: string | null, customerName: string, transactionId: string, createdAt: string, reference?: string | null, status: string, currency: string } };

export type FindAllCustomerAndMerchantOfferTransactionsQueryVariables = Exact<{
  customerUserId: Scalars['String']['input'];
  merchantUserId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllCustomerAndMerchantOfferTransactionsQuery = { __typename?: 'Query', findAllCustomerAndMerchantOfferTransactions: { __typename?: 'TransactionPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, category?: { __typename?: 'CategoryMerchant', name: string } | null } | null, user: { __typename?: 'User', id: string } }> } };

export type FindAllRedemptionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllRedemptionsQuery = { __typename?: 'Query', findAllRedemptions: { __typename?: 'TransactionPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, amount?: number | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'CategoryMerchant', id: string, name: string, imgSrc: string } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'UserMerchant', id: string, role: string } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null } }> } };

export type FindAllTransactionsByCommunityIdQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllTransactionsByCommunityIdQuery = { __typename?: 'Query', findAllTransactionsByCommunityId: { __typename?: 'FindTransactionsByCommunityIdResponse', redeemedOffers: number, totalSpend: number, totalCustomers: number, totalCommunitySize?: number | null, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionWithOverview', transaction: { __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, category?: { __typename?: 'CategoryMerchant', name: string } | null, createdBy: { __typename?: 'UserMerchant', id: string, role: string } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } }> } };

export type FindTransactionsByCommunityIdQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTransactionsByCommunityIdQuery = { __typename?: 'Query', findTransactionsByCommunityId: { __typename?: 'FindTransactionsByCommunityIdResponse', redeemedOffers: number, totalSpend: number, totalCustomers: number, totalCommunitySize?: number | null, total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionWithOverview', transaction: { __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, category?: { __typename?: 'CategoryMerchant', name: string } | null, createdBy: { __typename?: 'UserMerchant', id: string, role: string } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } }> } };

export type FindTransactionsBySessionQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTransactionsBySessionQuery = { __typename?: 'Query', findTransactionsBySession: { __typename?: 'TransactionPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, amount?: number | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'CategoryMerchant', id: string, name: string, imgSrc: string } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'UserMerchant', id: string, role: string } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null } }> } };

export type FindTransactionsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTransactionsByUserIdQuery = { __typename?: 'Query', findTransactionsByUserId: { __typename?: 'TransactionPage', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'TransactionMerchant', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'OfferMerchant', id: string, title: string, description: string, category?: { __typename?: 'CategoryMerchant', name: string } | null } | null, user: { __typename?: 'User', id: string } }> } };

export type FindTransactionsByRecipientWalletIdQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindTransactionsByRecipientWalletIdQueryQuery = { __typename?: 'Query', findTransactionsByRecipientWalletId: { __typename?: 'TransactionsResponse', currentBalance: number, amountWithdrawn: number, amountReceived: number, pageTransactions: { __typename?: 'TransactionsData', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'Transaction', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, bankPreference?: { __typename?: 'BankPreference', id: string } | null, offer?: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, amount?: number | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } | null, user: { __typename?: 'User', id: string } }> } } };

export type UpdateAdminMutationMutationVariables = Exact<{
  input: UpdateAdminInput;
}>;


export type UpdateAdminMutationMutation = { __typename?: 'Mutation', updateAdmin: { __typename?: 'updateAdminResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type UpdateBusinessInfoMutationMutationVariables = Exact<{
  input: UpdateBusinessInfoInput;
}>;


export type UpdateBusinessInfoMutationMutation = { __typename?: 'Mutation', updateBusinessInfo: { __typename?: 'updateBusinessInfoResponse', message?: string | null, logoUrl?: string | null, bannerUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type UpdateMyBankPreferenceMutationMutationVariables = Exact<{
  bankPreferenceId: Scalars['String']['input'];
  input: UpdateMyBankPreferenceInput;
}>;


export type UpdateMyBankPreferenceMutationMutation = { __typename?: 'Mutation', updateMyBankPreference: { __typename?: 'UpdateMyBankPreferenceResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type CreateWithdrawalMutationMutationVariables = Exact<{
  input: CreateWithdrawalInput;
}>;


export type CreateWithdrawalMutationMutation = { __typename?: 'Mutation', createWithdrawal: { __typename?: 'WalletTransferResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'TransferResponse', id?: number | null, account_number?: string | null, bank_code?: string | null, full_name?: string | null, currency?: string | null, debit_currency?: string | null, amount?: number | null, fee?: number | null, status?: string | null, reference?: string | null, narration?: string | null, complete_message?: string | null, requires_approval?: number | null, is_approved?: number | null, bank_name?: string | null, created_at?: string | null } | null } };

export type FindMyWithdrawalsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  statusFilter?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindMyWithdrawalsQuery = { __typename?: 'Query', findMyWithdrawals: { __typename?: 'FindMyWithdrawalResponse', pageSize: number, page: number, total: number, totalPages: number, data: Array<{ __typename?: 'WithdrawalWithTotal', totalWithdrawal: number, withdrawal: { __typename?: 'Withdrawal', id: string, createdAt?: string | null, updatedAt?: string | null, transaction?: { __typename?: 'Transaction', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, wallet?: { __typename?: 'Wallet', id: string, balance?: number | null, createdAt: string, updatedAt?: string | null } | null, recipientWallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', admin?: { __typename?: 'Admin', merchantProfile?: { __typename?: 'MerchantProfile', companyName?: string | null } | null } | null } } | null, offer?: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, amount?: number | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } | null, user: { __typename?: 'User', id: string } } | null, bankPreference?: { __typename?: 'BankPreference', id: string, accountNo: string, createdAt: string, updatedAt?: string | null, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null, createdAt: string, updatedAt?: string | null }, owner: { __typename?: 'User', id: string } } | null, user?: { __typename?: 'User', id: string } | null } }> } };

export type MyAppSettingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAppSettingQueryQuery = { __typename?: 'Query', myAppSetting?: { __typename?: 'AppSetting', id: string, isNotification: boolean, isPush: boolean, isEmail: boolean, isSMS: boolean, topUpLimit: number, createdAt: string, updatedAt?: string | null, location?: { __typename?: 'LocationPWA', id?: string | null, city?: string | null } | null } | null };

export type UpdateMyAppSettingMutationMutationVariables = Exact<{
  input: UpdateMyAppSettingInput;
}>;


export type UpdateMyAppSettingMutationMutation = { __typename?: 'Mutation', updateMyAppSetting: { __typename?: 'UpdateMyAppSettingResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewCategoryQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewCategoryQueryQuery = { __typename?: 'Query', viewCategory?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, isArchive: boolean, createdBy?: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, firstname?: string | null, lastname?: string | null, level?: string | null } | null } | null } | null };

export type ViewCategoryPwaQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewCategoryPwaQueryQuery = { __typename?: 'Query', viewCategoryPWA?: { __typename?: 'CategoryPWA', id: string, name: string, imgSrc: string, isArchive: boolean, createdAt?: string | null } | null };

export type CreateBankPreferenceMutationMutationVariables = Exact<{
  bankId: Scalars['String']['input'];
  accountNo: Scalars['String']['input'];
}>;


export type CreateBankPreferenceMutationMutation = { __typename?: 'Mutation', createBankPreference: { __typename?: 'CreateBankPreferenceResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type AddIdentityMutationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  communityEntityId?: InputMaybe<Scalars['String']['input']>;
  idNumber: Scalars['String']['input'];
}>;


export type AddIdentityMutationMutation = { __typename?: 'Mutation', addIdentity: { __typename?: 'AddIdentityResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', message: string, path: string }> | null } };

export type ForgotPasswordChangeMutationMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type ForgotPasswordChangeMutationMutation = { __typename?: 'Mutation', forgotPasswordChange: { __typename?: 'ResetResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type SendForgotPasswordEmailMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendForgotPasswordEmailMutationMutation = { __typename?: 'Mutation', sendForgotPasswordEmail: { __typename?: 'ResetResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type LoginMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutationMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', sessionId?: string | null, message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type OtpValidateMutationMutationVariables = Exact<{
  verificationCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type OtpValidateMutationMutation = { __typename?: 'Mutation', otpValidate: { __typename?: 'OTPValidateResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type RegisterMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  password: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
  nda: Scalars['Boolean']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterMutationMutation = { __typename?: 'Mutation', register: { __typename?: 'RegisterResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ResendOtpMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendOtpMutationMutation = { __typename?: 'Mutation', resendOtp: { __typename?: 'RegisterResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UpdatePasswordMutationMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutationMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'ResetResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type GetCbmMutationMutationVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type GetCbmMutationMutation = { __typename?: 'Mutation', getCBM?: { __typename?: 'GetCBMResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type CountClickThroughMutationMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type CountClickThroughMutationMutation = { __typename?: 'Mutation', countClickThrough?: { __typename?: 'CountClickThroughResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type CountOfferViewMutationMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type CountOfferViewMutationMutation = { __typename?: 'Mutation', countOfferView?: { __typename?: 'CountOfferViewResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type CustomerTransactionsQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerTransactionsQueryQuery = { __typename?: 'Query', customerTransactions: Array<{ __typename?: 'CustomerTransactionGroup', createdAt: string, transactions: Array<{ __typename?: 'TransactionPWA', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency?: string | null, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, point?: number | null, createdAt: string, updatedAt?: string | null, wallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, createdAt: string, updatedAt?: string | null, barterId: string, flAccountReference?: string | null, owner: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null, avatarUrl?: string | null } | null } } | null, recipientWallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, createdAt: string, updatedAt?: string | null, barterId: string, flAccountReference?: string | null, owner: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null, avatarUrl?: string | null } | null, admin?: { __typename?: 'Admin', id: string, merchantProfile?: { __typename?: 'MerchantProfile', id: string, companyName?: string | null, logoUrl?: string | null } | null } | null } } | null, offer?: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } | null, user?: { __typename?: 'User', id: string } | null }> } | null> };

export type DeactivateCustomerMutationMutationVariables = Exact<{
  input: DeactivateCustomerInput;
}>;


export type DeactivateCustomerMutationMutation = { __typename?: 'Mutation', deactivateCustomer: { __typename?: 'DeactivateCustomerResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type EarnedPointsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnedPointsQueryQuery = { __typename?: 'Query', earnedPoints?: { __typename?: 'earnedPointsResponse', message?: string | null, totalPoints?: number | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type FindAllCustomersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllCustomersQueryQuery = { __typename?: 'Query', findAllCustomers: Array<{ __typename?: 'Customer', id: string, avatarUrl?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, username?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, address?: string | null, gender?: string | null, dob?: string | null, nin?: string | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null }> };

export type FindBaseUrlQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindBaseUrlQueryQuery = { __typename?: 'Query', findBaseUrl?: { __typename?: 'FindBaseUrl', baseUrl?: string | null } | null };

export type FinishSignupMutationMutationVariables = Exact<{
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  username: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinishSignupMutationMutation = { __typename?: 'Mutation', finishSignup: { __typename?: 'FinishSignupResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type GetCommunityPointQueryQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
}>;


export type GetCommunityPointQueryQuery = { __typename?: 'Query', getCommunityPoint: { __typename?: 'GetCommunityPointResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'CommunityPoint', memberCommunityPoint?: number | null, partnerCommunityExchangeRate?: number | null } | null } };

export type FindIsInterestedQueryQueryVariables = Exact<{
  merchantUserId: Scalars['String']['input'];
}>;


export type FindIsInterestedQueryQuery = { __typename?: 'Query', findIsInterested: { __typename?: 'FindIsInterestResponse', message?: string | null, status: boolean, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ToggleInterestMutationMutationVariables = Exact<{
  merchantUserId: Scalars['String']['input'];
}>;


export type ToggleInterestMutationMutation = { __typename?: 'Mutation', toggleInterest: { __typename?: 'CreateInterestResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type MyIdentitiesQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type MyIdentitiesQueryQuery = { __typename?: 'Query', myIdentities: Array<{ __typename?: 'IdentityPWA', id: string, idNumber: string, name: string, validity: string, dob?: string | null, gender: string, idType?: string | null, community?: { __typename?: 'CommunityPWA', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null } | null }> };

export type NewIdentitySubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewIdentitySubscriptionSubscription = { __typename?: 'Subscription', newIdentity: { __typename?: 'Identity', id: string, photo?: string | null, idNumber: string, phoneNumber: string, name: string, validity: string, dob?: string | null, gender: string, logoUrl?: string | null, idType?: string | null, address?: string | null, createdAt: string, updatedAt?: string | null, community?: { __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null, createdAt: string, updatedAt?: string | null } | null } };

export type EmailOtpRequestMutationMutationVariables = Exact<{
  input: EmailOtpRequestInput;
}>;


export type EmailOtpRequestMutationMutation = { __typename?: 'Mutation', emailOtpRequest: { __typename?: 'emailOtpRequestResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type OtpValidatePhoneMutationMutationVariables = Exact<{
  verificationCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type OtpValidatePhoneMutationMutation = { __typename?: 'Mutation', otpValidatePhone: { __typename?: 'OTPValidatePhoneResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type PhoneOtpRequestMutationMutationVariables = Exact<{
  input: PhoneOtpRequestInput;
}>;


export type PhoneOtpRequestMutationMutation = { __typename?: 'Mutation', phoneOtpRequest: { __typename?: 'phoneOtpRequestResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type UpdatePinMutationMutationVariables = Exact<{
  input: UpdatePinInput;
}>;


export type UpdatePinMutationMutation = { __typename?: 'Mutation', updatePin: { __typename?: 'UpdatePinResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type ValidatePinMutationMutationVariables = Exact<{
  pin: Scalars['String']['input'];
}>;


export type ValidatePinMutationMutation = { __typename?: 'Mutation', validatePin: { __typename?: 'ValidatePinResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type ReactivateCustomerMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ReactivateCustomerMutationMutation = { __typename?: 'Mutation', reactivateCustomer: { __typename?: 'ReactivateResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type RecentBeneficiariesQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type RecentBeneficiariesQueryQuery = { __typename?: 'Query', recentBeneficiaries: Array<{ __typename?: 'User', id: string, suspended: boolean, isLocked: boolean, isVerified: boolean, role: string, customer?: { __typename?: 'Customer', id: string, avatarUrl?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, username?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, address?: string | null, gender?: string | null, dob?: string | null, nin?: string | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null } | null, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null, onboarding?: { __typename?: 'Onboarding', id: string, status: string, currentStep: number } | null } | null> };

export type RedeemOfferMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RedeemOfferMutationMutation = { __typename?: 'Mutation', redeemOffer: { __typename?: 'RedeemOfferResponse', message?: string | null, njoyCode?: string | null, partnerVoucher?: string | null, referralUrl?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type ReferrerDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferrerDataQueryQuery = { __typename?: 'Query', referrerData?: { __typename?: 'ReferrerDataResponse', message?: string | null, referralCode?: string | null, referralPoint?: number | null, referrals?: number | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type SearchMerchantQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchMerchantQueryQuery = { __typename?: 'Query', searchMerchant?: { __typename?: 'SearchMerchantResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'SearchMerchantData', adminId?: string | null, merchantUserId?: string | null, merchantId?: string | null, companyName?: string | null, username?: string | null, logoUrl?: string | null } | null> } | null };

export type SharedTransactionsQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  walletId: Scalars['String']['input'];
  recipientWalletId: Scalars['String']['input'];
}>;


export type SharedTransactionsQueryQuery = { __typename?: 'Query', sharedTransactions: Array<{ __typename?: 'TransactionGroup', createdAt: string, transactions: Array<{ __typename?: 'Transaction', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, createdAt: string, updatedAt?: string | null, wallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, barterId: string, flAccountReference?: string | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } | null, recipientWallet?: { __typename?: 'Wallet', id: string, balance?: number | null, currency: string, barterId: string, flAccountReference?: string | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', id: string, firstname?: string | null, lastname?: string | null } | null } } | null, user: { __typename?: 'User', id: string } }> }> };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'updateCustomerResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } };

export type CreateUserPointExchangeMutationMutationVariables = Exact<{
  communityId: Scalars['String']['input'];
  point: Scalars['Int']['input'];
}>;


export type CreateUserPointExchangeMutationMutation = { __typename?: 'Mutation', createUserPointExchange: { __typename?: 'CreateUserPointExchangeResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'UserPointExchangeHistory', id?: string | null, communityId?: string | null, communityName?: string | null, point?: number | null, rate?: number | null, exchangedPoint?: number | null, createdAt?: string | null } | null } };

export type FindAllUserPointExchangeHistoryQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAllUserPointExchangeHistoryQueryQuery = { __typename?: 'Query', findAllUserPointExchangeHistory?: { __typename?: 'FindAllUserPointExchangeHistoryResponse', total: number, page: number, pageSize: number, totalPages: number, data: Array<{ __typename?: 'UserPointExchangeHistory', id?: string | null, communityId?: string | null, communityName?: string | null, point?: number | null, rate?: number | null, exchangedPoint?: number | null, createdAt?: string | null } | null> } | null };

export type FindUserPointExchangeHistoryByIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindUserPointExchangeHistoryByIdQueryQuery = { __typename?: 'Query', findUserPointExchangeHistoryById?: { __typename?: 'UserPointExchangeHistory', id?: string | null, communityId?: string | null, communityName?: string | null, point?: number | null, rate?: number | null, exchangedPoint?: number | null, createdAt?: string | null } | null };

export type ViewCustomerWithSpendQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewCustomerWithSpendQuery = { __typename?: 'Query', viewCustomerWithSpend?: { __typename?: 'CustomerWithSpend', userId?: string | null, totalSpent: number, customer: { __typename?: 'CustomerMerchant', id: string, firstname?: string | null, lastname?: string | null, username?: string | null, community?: Array<{ __typename?: 'CommunityMerchant', id: string, name: string, alias: string } | null> | null } } | null };

export type FindAllBanksQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllBanksQueryQuery = { __typename?: 'Query', findAllBanks: Array<{ __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null, createdAt: string, updatedAt?: string | null }> };

export type NewBankSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewBankSubscriptionSubscription = { __typename?: 'Subscription', newBank: { __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null, createdAt: string, updatedAt?: string | null } };

export type FindBankPreferenceByUserIdQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindBankPreferenceByUserIdQueryQuery = { __typename?: 'Query', findBankPreferenceByUserId?: Array<{ __typename?: 'BankPreference', id: string, accountNo: string, createdAt: string, updatedAt?: string | null, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null } } | null> | null };

export type CreateLocationMutationMutationVariables = Exact<{
  input?: InputMaybe<CreateLocationInput>;
}>;


export type CreateLocationMutationMutation = { __typename?: 'Mutation', createLocation?: { __typename?: 'CreateLocationResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type FindAllLocationsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllLocationsQueryQuery = { __typename?: 'Query', findAllLocations?: Array<{ __typename?: 'Location', id?: string | null, district?: string | null, city?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, isArchive?: boolean | null, createdAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, level?: string | null, firstname?: string | null, lastname?: string | null } | null } | null } | null> | null };

export type NewLocationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewLocationSubscriptionSubscription = { __typename?: 'Subscription', newLocation: Array<{ __typename?: 'Location', id?: string | null, district?: string | null, city?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, isArchive?: boolean | null, createdAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, level?: string | null, firstname?: string | null, lastname?: string | null } | null } | null }> };

export type UpdateLocationMutationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'CreateLocationResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type LogoutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutationMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type MarkAsSeenMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkAsSeenMutationMutation = { __typename?: 'Mutation', markAsSeen: { __typename?: 'MarkAsSeenResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', message: string, path: string } | null> | null } };

export type TrackAlertClickMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackAlertClickMutationMutation = { __typename?: 'Mutation', trackAlertClick: { __typename?: 'TrackAlertClickResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', message: string, path: string } | null> | null } };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, suspended: boolean, isLocked: boolean, isVerified: boolean, role: string, customer?: { __typename?: 'Customer', id: string, avatarUrl?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, username?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, address?: string | null, gender?: string | null, dob?: string | null, nin?: string | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null } | null, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, level?: string | null, tenantId?: string | null, createdAt: string, updatedAt?: string | null, tenant?: { __typename?: 'AdminTenant', id: string, name: string, slug: string, branding: { __typename?: 'TenantBranding', appName?: string | null, logoUrl?: string | null, iconUrl?: string | null, primaryColor?: string | null } } | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, websiteOrSocials?: string | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null, onboarding?: { __typename?: 'Onboarding', id: string, status: string, currentStep: number } | null } | null };

export type MyBankPreferencesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBankPreferencesQueryQuery = { __typename?: 'Query', myBankPreferences: Array<{ __typename?: 'BankPreference', id: string, accountNo: string, createdAt: string, updatedAt?: string | null, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null } }> };

export type NewBankPreferenceSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewBankPreferenceSubscriptionSubscription = { __typename?: 'Subscription', newBankPreference: { __typename?: 'BankPreference', id: string, accountNo: string, createdAt: string, updatedAt?: string | null, bank: { __typename?: 'Bank', id: string, bank: string, bankCode: string, pictureUrl?: string | null } } };

export type WalletQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletQueryQuery = { __typename?: 'Query', wallet?: { __typename?: 'Wallet', id: string, flId?: string | null, currency: string, barterId: string, balance?: number | null, flNuban?: string | null, bankName?: string | null, bankCode?: string | null, flAccountReference?: string | null, status?: string | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string } } | null };

export type WalletUpdateSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WalletUpdateSubscriptionSubscription = { __typename?: 'Subscription', walletUpdate: { __typename?: 'Wallet', id: string, flId?: string | null, currency: string, barterId: string, balance?: number | null, flNuban?: string | null, bankName?: string | null, bankCode?: string | null, flAccountReference?: string | null, status?: string | null, createdAt: string, updatedAt?: string | null, owner: { __typename?: 'User', id: string } } };

export type FindOffersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOffersQueryQuery = { __typename?: 'Query', findOffers: Array<{ __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, offerTOR?: string | null, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, district?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, createdAt?: string | null } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } }> };

export type NewOfferSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewOfferSubscriptionSubscription = { __typename?: 'Subscription', newOffer: Array<{ __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, district?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, createdAt?: string | null } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } }> };

export type FindOffersEndingSoonQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
}>;


export type FindOffersEndingSoonQueryQuery = { __typename?: 'Query', findOffersEndingSoon: Array<{ __typename?: 'OfferPWA', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, status?: string | null, offerTOR?: string | null, startDate: string, endDate?: string | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'UserAdminPWA', id: string, admin?: { __typename?: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null } | null } }> };

export type MarkSharedOfferMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkSharedOfferMutationMutation = { __typename?: 'Mutation', markSharedOffer?: { __typename?: 'MarkSharedOfferResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } | null };

export type RelatedOffersQueryQueryVariables = Exact<{
  communityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RelatedOffersQueryQuery = { __typename?: 'Query', relatedOffers: Array<{ __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, district?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, createdAt?: string | null } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } }> };

export type SearchOffersQueryQueryVariables = Exact<{
  input?: InputMaybe<SearchOffersInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type SearchOffersQueryQuery = { __typename?: 'Query', searchOffers: Array<{ __typename?: 'OfferPWA', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, status?: string | null, offerTOR?: string | null, startDate: string, endDate?: string | null, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'CategoryPWA', id: string, name: string, imgSrc: string, createdAt?: string | null } | null, createdBy: { __typename?: 'UserAdminPWA', id: string, admin?: { __typename?: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null } | null } }> };

export type SearchOffersByCategoryQueryQueryVariables = Exact<{
  input?: InputMaybe<SearchOffersByCategoryInput>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type SearchOffersByCategoryQueryQuery = { __typename?: 'Query', searchOffersByCategory: Array<{ __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, district?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, createdAt?: string | null } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } }> };

export type ViewCategoryOffersQueryQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ViewCategoryOffersQueryQuery = { __typename?: 'Query', categoryOffers: Array<{ __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } }> };

export type NewCategoryOfferSubscriptionSubscriptionVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type NewCategoryOfferSubscriptionSubscription = { __typename?: 'Subscription', newCategoryOffer: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } };

export type ViewChildOffersQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ViewChildOffersQueryQuery = { __typename?: 'Query', childOffers: Array<{ __typename?: 'OfferPWA', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, status?: string | null, offerTOR?: string | null, startDate: string, endDate?: string | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'UserAdminPWA', id: string, admin?: { __typename?: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null } | null } }> };

export type NewChildOfferSubscriptionSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type NewChildOfferSubscriptionSubscription = { __typename?: 'Subscription', newChildOffer: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, district?: string | null, streetName?: string | null, country?: string | null, postalCode?: string | null, landmark?: string | null, latitude?: string | null, longitude?: string | null, createdAt?: string | null } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } };

export type ViewOfferQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewOfferQueryQuery = { __typename?: 'Query', viewOffer?: { __typename?: 'OfferMerchantExt', id: string, title: string, description: string, offerType?: string | null, startDate: string, endDate?: string | null, offerTOR?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, bannerUrl?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, amount?: number | null, redemptions?: number | null, shareCount?: number | null, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'CategoryMerchant', id: string, name: string, imgSrc: string } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null, country?: string | null } | null> | null, offerPointsDeduction?: { __typename?: 'OfferPointsDeduction', id?: string | null, offerId?: string | null, point?: number | null, createdAt?: string | null, updatedAt?: string | null } | null, createdBy: { __typename?: 'UserMerchantExt2', id: string, admin?: { __typename?: 'AdminExt1', shortId: string, merchantProfile?: { __typename?: 'MerchantProfileExt', id: string, companyName?: string | null, logoUrl?: string | null } | null } | null } } | null };

export type ViewOfferPwaQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewOfferPwaQueryQuery = { __typename?: 'Query', viewOfferPWA?: { __typename?: 'OfferPWA', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, amount?: number | null, status?: string | null, offerTOR?: string | null, startDate: string, endDate?: string | null, createdAt: string, updatedAt?: string | null, createdBy: { __typename?: 'UserAdminPWA', id: string, admin?: { __typename?: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null } | null } } | null };

export type CashOutPointsMutationMutationVariables = Exact<{
  points: Scalars['Int']['input'];
}>;


export type CashOutPointsMutationMutation = { __typename?: 'Mutation', cashOutPoints: { __typename?: 'CashOutPointsResponse', amount: number, pointsSpent: number, transactionId: string, message: string } };

export type GetPointsHistoryQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  typeFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPointsHistoryQueryQuery = { __typename?: 'Query', getPointsHistory: Array<{ __typename?: 'PointHistoryResponse', createdAt: string, pointHistory: Array<{ __typename?: 'PointHistoryData', action?: string | null, category?: string | null, point?: string | null, referredFirstName?: string | null, referredLastName?: string | null, referredProfileImage?: string | null, createdAt?: string | null, type?: string | null } | null> } | null> };

export type PointsCardQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PointsCardQueryQuery = { __typename?: 'Query', pointsCard?: { __typename?: 'PointsCardResponse', customerTier?: string | null, lifeTimePoint?: number | null, pointBalance?: number | null, currentMonthPoints?: number | null, pointsForNextTier?: number | null, tiers?: Array<{ __typename?: 'CustomerTier', name?: string | null, threshold?: number | null } | null> | null } | null };

export type DisableMyPushSubscriptionsMutationMutationVariables = Exact<{
  provider?: InputMaybe<Scalars['String']['input']>;
}>;


export type DisableMyPushSubscriptionsMutationMutation = { __typename?: 'Mutation', disableMyPushSubscriptions: { __typename?: 'PushSubscriptionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type RegisterPushSubscriptionMutationMutationVariables = Exact<{
  input: RegisterPushSubscriptionInput;
}>;


export type RegisterPushSubscriptionMutationMutation = { __typename?: 'Mutation', registerPushSubscription: { __typename?: 'PushSubscriptionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type UnregisterPushSubscriptionMutationMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type UnregisterPushSubscriptionMutationMutation = { __typename?: 'Mutation', unregisterPushSubscription: { __typename?: 'PushSubscriptionResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type SearchUserQueryVariables = Exact<{
  input: SearchUserInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser: Array<
    | { __typename: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, websiteOrSocials?: string | null } | null }
    | { __typename: 'CustomerPWA', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, username?: string | null }
  > };

export type CreateWalletKycMutationMutationVariables = Exact<{
  nin: Scalars['String']['input'];
  dob: Scalars['String']['input'];
  bvn: Scalars['String']['input'];
}>;


export type CreateWalletKycMutationMutation = { __typename?: 'Mutation', createWalletKyc?: { __typename?: 'WalletKycResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string } | null> | null } | null };

export type GetBalanceMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type GetBalanceMutationMutation = { __typename?: 'Mutation', getBalance: { __typename?: 'BalanceResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'Balance', currency?: string | null, available_balance?: number | null, ledger_balance?: number | null } | null } };

export type GetBankListMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type GetBankListMutationMutation = { __typename?: 'Mutation', getBankList: { __typename?: 'BankListResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: Array<{ __typename?: 'FetchedBank', id?: number | null, code?: string | null, name?: string | null, provider_type?: string | null } | null> | null } };

export type GetVirtualAccountMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type GetVirtualAccountMutationMutation = { __typename?: 'Mutation', getVirtualAccount: { __typename?: 'VirtualAccountResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'VirtualAccount', static_account?: string | null, bank_name?: string | null, bank_code?: string | null, currency?: string | null, is_default?: boolean | null } | null } };

export type WalletTransferMutationMutationVariables = Exact<{
  input: WalletTransferInput;
}>;


export type WalletTransferMutationMutation = { __typename?: 'Mutation', walletTransfer: { __typename?: 'WalletTransferResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null, data?: { __typename?: 'TransferResponse', id?: number | null, account_number?: string | null, bank_code?: string | null, full_name?: string | null, currency?: string | null, debit_currency?: string | null, amount?: number | null, fee?: number | null, status?: string | null, reference?: string | null, narration?: string | null, complete_message?: string | null, requires_approval?: number | null, is_approved?: number | null, bank_name?: string | null, created_at?: string | null } | null } };

export type MyTransactionsQueryQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Scalars['String']['input']>;
  typeFilter?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyTransactionsQueryQuery = { __typename?: 'Query', myTransactions: Array<{ __typename?: 'TransactionGroup', createdAt: string, transactions: Array<{ __typename?: 'Transaction', id: string, amount: number, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, transferTypes: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, offer?: { __typename?: 'Offer', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, createdBy: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null, merchantProfile?: { __typename?: 'MerchantProfile', id: string, businessName?: string | null, businessType?: string | null, regCountry?: string | null, businessRegNumber?: string | null, taxId?: string | null, address?: string | null, addressAlt?: string | null, city?: string | null, country?: string | null, postcode?: string | null, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null, commissionRate?: number | null, createdAt: string, updatedAt?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, createdAt: string, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null } | null } | null } } | null, user: { __typename?: 'User', id: string } }> }> };

export type ViewTransactionQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewTransactionQueryQuery = { __typename?: 'Query', viewTransaction?: { __typename?: 'TransactionExt', id: string, amount: number, transferTypes: string, charge?: number | null, reference?: string | null, type: string, status: string, currency: string, njoyCode?: string | null, partnerVoucher?: string | null, createdAt: string, updatedAt?: string | null, offer?: { __typename?: 'OfferMerchantExt2', id: string, title: string, description: string, bannerUrl?: string | null, offerType?: string | null, discountType?: string | null, discountValue?: number | null, partnerVoucher?: Array<string | null> | null, referralUrl?: string | null, status?: string | null, usageLimitPerUser?: number | null, totalUsageLimit?: number | null, startDate: string, endDate?: string | null, redemptions?: number | null, revenueGenerated?: number | null, clickThroughs?: number | null, featured: boolean, offerTOR?: string | null, createdAt: string, updatedAt?: string | null, category?: { __typename?: 'Category', id: string, name: string, imgSrc: string, createdAt?: string | null, updatedAt?: string | null, createdBy?: { __typename?: 'User', id: string, role: string } | null } | null, community?: Array<{ __typename?: 'Community', id: string, name: string, alias: string } | null> | null, location?: Array<{ __typename?: 'Location', id?: string | null, city?: string | null } | null> | null, createdBy: { __typename?: 'UserMerchantExt2', id: string, admin?: { __typename?: 'AdminExt1', id: string, merchantProfile?: { __typename?: 'MerchantProfileExt', id: string, companyName?: string | null, logoUrl?: string | null } | null } | null } } | null, user: { __typename?: 'User', id: string, customer?: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } | null } } | null };

export type VerifyNinMutationMutationVariables = Exact<{
  nin: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
}>;


export type VerifyNinMutationMutation = { __typename?: 'Mutation', verifyNIN: { __typename?: 'VerifyNINResponse', message?: string | null, errors?: Array<{ __typename?: 'Error', path: string, message: string }> | null } };

export type ViewCommunityQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewCommunityQueryQuery = { __typename?: 'Query', viewCommunity: { __typename?: 'Community', id: string, name: string, alias: string, logoUrl?: string | null, colorCode?: string | null, createdAt: string, updatedAt?: string | null, isArchive?: boolean | null, createdBy?: { __typename?: 'User', id: string, role: string, admin?: { __typename?: 'Admin', id: string, shortId?: string | null, level?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null } | null } | null } };

export type ViewUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewUserQuery = { __typename?: 'Query', viewUser?:
    | { __typename: 'AdminPWA', id: string, merchantProfile?: { __typename?: 'MerchantProfilePWA', id: string, companyName?: string | null, username?: string | null, companyLocation?: string | null, logoUrl?: string | null, bannerUrl?: string | null, description?: string | null } | null }
    | { __typename: 'CustomerPWA', id: string, avatarUrl?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, username?: string | null, phone?: string | null, createdAt: string, updatedAt?: string | null }
    | { __typename: 'ErrorType', errors?: Array<{ __typename?: 'FieldError', path: string, message: string }> | null }
   | null };

export type ViewUserWalletQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ViewUserWalletQuery = { __typename?: 'Query', viewUserWallet?: { __typename?: 'PublicWallet', id: string, barterId: string, currency: string, status?: string | null, owner: { __typename?: 'PublicWalletOwner', id: string } } | null };


export const BestPerformingOffersAdminQueryDocument = gql`
    query BestPerformingOffersAdminQuery {
  bestPerformingOffersAdmin {
    id
    title
    offerType
    redemptions
    createdBy {
      id
      admin {
        firstname
        lastname
        merchantProfile {
          id
          companyName
          businessName
        }
      }
    }
  }
}
    `;

/**
 * __useBestPerformingOffersAdminQueryQuery__
 *
 * To run a query within a React component, call `useBestPerformingOffersAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBestPerformingOffersAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBestPerformingOffersAdminQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBestPerformingOffersAdminQueryQuery(baseOptions?: Apollo.QueryHookOptions<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>(BestPerformingOffersAdminQueryDocument, options);
      }
export function useBestPerformingOffersAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>(BestPerformingOffersAdminQueryDocument, options);
        }
// @ts-ignore
export function useBestPerformingOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>;
export function useBestPerformingOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BestPerformingOffersAdminQueryQuery | undefined, BestPerformingOffersAdminQueryQueryVariables>;
export function useBestPerformingOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>(BestPerformingOffersAdminQueryDocument, options);
        }
export type BestPerformingOffersAdminQueryQueryHookResult = ReturnType<typeof useBestPerformingOffersAdminQueryQuery>;
export type BestPerformingOffersAdminQueryLazyQueryHookResult = ReturnType<typeof useBestPerformingOffersAdminQueryLazyQuery>;
export type BestPerformingOffersAdminQuerySuspenseQueryHookResult = ReturnType<typeof useBestPerformingOffersAdminQuerySuspenseQuery>;
export type BestPerformingOffersAdminQueryQueryResult = Apollo.QueryResult<BestPerformingOffersAdminQueryQuery, BestPerformingOffersAdminQueryQueryVariables>;
export const CashFlowOverviewAdminQueryDocument = gql`
    query CashFlowOverviewAdminQuery($duration: String!) {
  cashFlowOverviewAdmin(duration: $duration) {
    totalPlatformBalance
    totalTransactionVolume
    successfulTransactionVolume
    pendingTransactionVolume
    failedTransactionVolume
    totalTransactionValue
    totalWithdrawn
    commissionEarned
  }
}
    `;

/**
 * __useCashFlowOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useCashFlowOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCashFlowOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables> & ({ variables: CashFlowOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>(CashFlowOverviewAdminQueryDocument, options);
      }
export function useCashFlowOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>(CashFlowOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useCashFlowOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>;
export function useCashFlowOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CashFlowOverviewAdminQueryQuery | undefined, CashFlowOverviewAdminQueryQueryVariables>;
export function useCashFlowOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>(CashFlowOverviewAdminQueryDocument, options);
        }
export type CashFlowOverviewAdminQueryQueryHookResult = ReturnType<typeof useCashFlowOverviewAdminQueryQuery>;
export type CashFlowOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useCashFlowOverviewAdminQueryLazyQuery>;
export type CashFlowOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useCashFlowOverviewAdminQuerySuspenseQuery>;
export type CashFlowOverviewAdminQueryQueryResult = Apollo.QueryResult<CashFlowOverviewAdminQueryQuery, CashFlowOverviewAdminQueryQueryVariables>;
export const PublishedOffersOverviewAdminQueryDocument = gql`
    query PublishedOffersOverviewAdminQuery {
  publishedOffersOverviewAdmin {
    offerTypes {
      offerType
      count
    }
    totalOffers
  }
}
    `;

/**
 * __usePublishedOffersOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `usePublishedOffersOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedOffersOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedOffersOverviewAdminQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedOffersOverviewAdminQueryQuery(baseOptions?: Apollo.QueryHookOptions<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>(PublishedOffersOverviewAdminQueryDocument, options);
      }
export function usePublishedOffersOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>(PublishedOffersOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function usePublishedOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>;
export function usePublishedOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PublishedOffersOverviewAdminQueryQuery | undefined, PublishedOffersOverviewAdminQueryQueryVariables>;
export function usePublishedOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>(PublishedOffersOverviewAdminQueryDocument, options);
        }
export type PublishedOffersOverviewAdminQueryQueryHookResult = ReturnType<typeof usePublishedOffersOverviewAdminQueryQuery>;
export type PublishedOffersOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof usePublishedOffersOverviewAdminQueryLazyQuery>;
export type PublishedOffersOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof usePublishedOffersOverviewAdminQuerySuspenseQuery>;
export type PublishedOffersOverviewAdminQueryQueryResult = Apollo.QueryResult<PublishedOffersOverviewAdminQueryQuery, PublishedOffersOverviewAdminQueryQueryVariables>;
export const CreateAdminMutationDocument = gql`
    mutation CreateAdminMutation($input: CreateAdminInput!) {
  createAdmin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateAdminMutationMutationFn = Apollo.MutationFunction<CreateAdminMutationMutation, CreateAdminMutationMutationVariables>;

/**
 * __useCreateAdminMutationMutation__
 *
 * To run a mutation, you first call `useCreateAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminMutationMutation, { data, loading, error }] = useCreateAdminMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminMutationMutation, CreateAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminMutationMutation, CreateAdminMutationMutationVariables>(CreateAdminMutationDocument, options);
      }
export type CreateAdminMutationMutationHookResult = ReturnType<typeof useCreateAdminMutationMutation>;
export type CreateAdminMutationMutationResult = Apollo.MutationResult<CreateAdminMutationMutation>;
export type CreateAdminMutationMutationOptions = Apollo.BaseMutationOptions<CreateAdminMutationMutation, CreateAdminMutationMutationVariables>;
export const FindAdminAdminByIdQueryDocument = gql`
    query FindAdminAdminByIdQuery($id: String!) {
  findAdminAdminById(id: $id) {
    adminId
    userId
    shortId
    profilePicture
    firstname
    lastname
    email
    phone
    level
    suspended
    userIsDeactivated
    userIsLocked
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindAdminAdminByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindAdminAdminByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAdminAdminByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAdminAdminByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindAdminAdminByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables> & ({ variables: FindAdminAdminByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>(FindAdminAdminByIdQueryDocument, options);
      }
export function useFindAdminAdminByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>(FindAdminAdminByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindAdminAdminByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>;
export function useFindAdminAdminByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminAdminByIdQueryQuery | undefined, FindAdminAdminByIdQueryQueryVariables>;
export function useFindAdminAdminByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>(FindAdminAdminByIdQueryDocument, options);
        }
export type FindAdminAdminByIdQueryQueryHookResult = ReturnType<typeof useFindAdminAdminByIdQueryQuery>;
export type FindAdminAdminByIdQueryLazyQueryHookResult = ReturnType<typeof useFindAdminAdminByIdQueryLazyQuery>;
export type FindAdminAdminByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindAdminAdminByIdQuerySuspenseQuery>;
export type FindAdminAdminByIdQueryQueryResult = Apollo.QueryResult<FindAdminAdminByIdQueryQuery, FindAdminAdminByIdQueryQueryVariables>;
export const FindAllAdminAdminQueryDocument = gql`
    query FindAllAdminAdminQuery($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllAdminAdmin(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      adminId
      userId
      shortId
      profilePicture
      firstname
      lastname
      email
      phone
      level
      suspended
      isLocked
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllAdminAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllAdminAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAdminAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAdminAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllAdminAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables> & ({ variables: FindAllAdminAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>(FindAllAdminAdminQueryDocument, options);
      }
export function useFindAllAdminAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>(FindAllAdminAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllAdminAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>;
export function useFindAllAdminAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAdminAdminQueryQuery | undefined, FindAllAdminAdminQueryQueryVariables>;
export function useFindAllAdminAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>(FindAllAdminAdminQueryDocument, options);
        }
export type FindAllAdminAdminQueryQueryHookResult = ReturnType<typeof useFindAllAdminAdminQueryQuery>;
export type FindAllAdminAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllAdminAdminQueryLazyQuery>;
export type FindAllAdminAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllAdminAdminQuerySuspenseQuery>;
export type FindAllAdminAdminQueryQueryResult = Apollo.QueryResult<FindAllAdminAdminQueryQuery, FindAllAdminAdminQueryQueryVariables>;
export const UpdateAdminAdminMutationDocument = gql`
    mutation UpdateAdminAdminMutation($id: String!, $input: UpdateAdminAdminInput!) {
  updateAdminAdmin(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateAdminAdminMutationMutationFn = Apollo.MutationFunction<UpdateAdminAdminMutationMutation, UpdateAdminAdminMutationMutationVariables>;

/**
 * __useUpdateAdminAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAdminAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminAdminMutationMutation, { data, loading, error }] = useUpdateAdminAdminMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminAdminMutationMutation, UpdateAdminAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminAdminMutationMutation, UpdateAdminAdminMutationMutationVariables>(UpdateAdminAdminMutationDocument, options);
      }
export type UpdateAdminAdminMutationMutationHookResult = ReturnType<typeof useUpdateAdminAdminMutationMutation>;
export type UpdateAdminAdminMutationMutationResult = Apollo.MutationResult<UpdateAdminAdminMutationMutation>;
export type UpdateAdminAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAdminAdminMutationMutation, UpdateAdminAdminMutationMutationVariables>;
export const CreateCategoryMutationDocument = gql`
    mutation CreateCategoryMutation($name: String!, $imgSrc: String!) {
  createCategory(name: $name, imgSrc: $imgSrc) {
    errors {
      path
      message
    }
    message
    imgSrcUrl
  }
}
    `;
export type CreateCategoryMutationMutationFn = Apollo.MutationFunction<CreateCategoryMutationMutation, CreateCategoryMutationMutationVariables>;

/**
 * __useCreateCategoryMutationMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutationMutation, { data, loading, error }] = useCreateCategoryMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      imgSrc: // value for 'imgSrc'
 *   },
 * });
 */
export function useCreateCategoryMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutationMutation, CreateCategoryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutationMutation, CreateCategoryMutationMutationVariables>(CreateCategoryMutationDocument, options);
      }
export type CreateCategoryMutationMutationHookResult = ReturnType<typeof useCreateCategoryMutationMutation>;
export type CreateCategoryMutationMutationResult = Apollo.MutationResult<CreateCategoryMutationMutation>;
export type CreateCategoryMutationMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutationMutation, CreateCategoryMutationMutationVariables>;
export const FindAllCategoriesAdminQueryDocument = gql`
    query FindAllCategoriesAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllCategoriesAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      imgSrc
      createdBy {
        id
        role
        admin {
          id
          level
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
      isArchive
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCategoriesAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCategoriesAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCategoriesAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCategoriesAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCategoriesAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables> & ({ variables: FindAllCategoriesAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>(FindAllCategoriesAdminQueryDocument, options);
      }
export function useFindAllCategoriesAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>(FindAllCategoriesAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCategoriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>;
export function useFindAllCategoriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCategoriesAdminQueryQuery | undefined, FindAllCategoriesAdminQueryQueryVariables>;
export function useFindAllCategoriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>(FindAllCategoriesAdminQueryDocument, options);
        }
export type FindAllCategoriesAdminQueryQueryHookResult = ReturnType<typeof useFindAllCategoriesAdminQueryQuery>;
export type FindAllCategoriesAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllCategoriesAdminQueryLazyQuery>;
export type FindAllCategoriesAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCategoriesAdminQuerySuspenseQuery>;
export type FindAllCategoriesAdminQueryQueryResult = Apollo.QueryResult<FindAllCategoriesAdminQueryQuery, FindAllCategoriesAdminQueryQueryVariables>;
export const ToggleCategoryArchiveStatusAdminMutationDocument = gql`
    mutation ToggleCategoryArchiveStatusAdminMutation($categoryId: String!, $isArchive: Boolean!) {
  toggleCategoryArchiveStatusAdmin(categoryId: $categoryId, isArchive: $isArchive) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ToggleCategoryArchiveStatusAdminMutationMutationFn = Apollo.MutationFunction<ToggleCategoryArchiveStatusAdminMutationMutation, ToggleCategoryArchiveStatusAdminMutationMutationVariables>;

/**
 * __useToggleCategoryArchiveStatusAdminMutationMutation__
 *
 * To run a mutation, you first call `useToggleCategoryArchiveStatusAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCategoryArchiveStatusAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCategoryArchiveStatusAdminMutationMutation, { data, loading, error }] = useToggleCategoryArchiveStatusAdminMutationMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      isArchive: // value for 'isArchive'
 *   },
 * });
 */
export function useToggleCategoryArchiveStatusAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCategoryArchiveStatusAdminMutationMutation, ToggleCategoryArchiveStatusAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCategoryArchiveStatusAdminMutationMutation, ToggleCategoryArchiveStatusAdminMutationMutationVariables>(ToggleCategoryArchiveStatusAdminMutationDocument, options);
      }
export type ToggleCategoryArchiveStatusAdminMutationMutationHookResult = ReturnType<typeof useToggleCategoryArchiveStatusAdminMutationMutation>;
export type ToggleCategoryArchiveStatusAdminMutationMutationResult = Apollo.MutationResult<ToggleCategoryArchiveStatusAdminMutationMutation>;
export type ToggleCategoryArchiveStatusAdminMutationMutationOptions = Apollo.BaseMutationOptions<ToggleCategoryArchiveStatusAdminMutationMutation, ToggleCategoryArchiveStatusAdminMutationMutationVariables>;
export const UpdateCategoryMutationDocument = gql`
    mutation UpdateCategoryMutation($categoryId: String!, $input: UpdateCategoryInput!) {
  updateCategory(categoryId: $categoryId, input: $input) {
    errors {
      path
      message
    }
    message
    imgSrcUrl
  }
}
    `;
export type UpdateCategoryMutationMutationFn = Apollo.MutationFunction<UpdateCategoryMutationMutation, UpdateCategoryMutationMutationVariables>;

/**
 * __useUpdateCategoryMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutationMutation, { data, loading, error }] = useUpdateCategoryMutationMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutationMutation, UpdateCategoryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutationMutation, UpdateCategoryMutationMutationVariables>(UpdateCategoryMutationDocument, options);
      }
export type UpdateCategoryMutationMutationHookResult = ReturnType<typeof useUpdateCategoryMutationMutation>;
export type UpdateCategoryMutationMutationResult = Apollo.MutationResult<UpdateCategoryMutationMutation>;
export type UpdateCategoryMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutationMutation, UpdateCategoryMutationMutationVariables>;
export const CustomerConnectIdReminderDocument = gql`
    mutation CustomerConnectIdReminder($id: String!) {
  customerConnectIdReminder(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CustomerConnectIdReminderMutationFn = Apollo.MutationFunction<CustomerConnectIdReminderMutation, CustomerConnectIdReminderMutationVariables>;

/**
 * __useCustomerConnectIdReminderMutation__
 *
 * To run a mutation, you first call `useCustomerConnectIdReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerConnectIdReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerConnectIdReminderMutation, { data, loading, error }] = useCustomerConnectIdReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerConnectIdReminderMutation(baseOptions?: Apollo.MutationHookOptions<CustomerConnectIdReminderMutation, CustomerConnectIdReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerConnectIdReminderMutation, CustomerConnectIdReminderMutationVariables>(CustomerConnectIdReminderDocument, options);
      }
export type CustomerConnectIdReminderMutationHookResult = ReturnType<typeof useCustomerConnectIdReminderMutation>;
export type CustomerConnectIdReminderMutationResult = Apollo.MutationResult<CustomerConnectIdReminderMutation>;
export type CustomerConnectIdReminderMutationOptions = Apollo.BaseMutationOptions<CustomerConnectIdReminderMutation, CustomerConnectIdReminderMutationVariables>;
export const CustomerPointsHistoryQueryDocument = gql`
    query CustomerPointsHistoryQuery($userId: String!, $page: Int!, $pageSize: Int!, $actionFilter: String, $categoryFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  customerPointsHistory(
    userId: $userId
    page: $page
    pageSize: $pageSize
    actionFilter: $actionFilter
    categoryFilter: $categoryFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      createdAt
      type
      action
      category
      pointBalance
      tierBonus
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useCustomerPointsHistoryQueryQuery__
 *
 * To run a query within a React component, call `useCustomerPointsHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerPointsHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerPointsHistoryQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      actionFilter: // value for 'actionFilter'
 *      categoryFilter: // value for 'categoryFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCustomerPointsHistoryQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables> & ({ variables: CustomerPointsHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>(CustomerPointsHistoryQueryDocument, options);
      }
export function useCustomerPointsHistoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>(CustomerPointsHistoryQueryDocument, options);
        }
// @ts-ignore
export function useCustomerPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>;
export function useCustomerPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerPointsHistoryQueryQuery | undefined, CustomerPointsHistoryQueryQueryVariables>;
export function useCustomerPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>(CustomerPointsHistoryQueryDocument, options);
        }
export type CustomerPointsHistoryQueryQueryHookResult = ReturnType<typeof useCustomerPointsHistoryQueryQuery>;
export type CustomerPointsHistoryQueryLazyQueryHookResult = ReturnType<typeof useCustomerPointsHistoryQueryLazyQuery>;
export type CustomerPointsHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useCustomerPointsHistoryQuerySuspenseQuery>;
export type CustomerPointsHistoryQueryQueryResult = Apollo.QueryResult<CustomerPointsHistoryQueryQuery, CustomerPointsHistoryQueryQueryVariables>;
export const CustomerPointsOverviewQueryDocument = gql`
    query CustomerPointsOverviewQuery($id: String!) {
  customerPointsOverview(id: $id) {
    customerTier
    pointBalance
    lifeTimePoint
  }
}
    `;

/**
 * __useCustomerPointsOverviewQueryQuery__
 *
 * To run a query within a React component, call `useCustomerPointsOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerPointsOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerPointsOverviewQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerPointsOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables> & ({ variables: CustomerPointsOverviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>(CustomerPointsOverviewQueryDocument, options);
      }
export function useCustomerPointsOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>(CustomerPointsOverviewQueryDocument, options);
        }
// @ts-ignore
export function useCustomerPointsOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>;
export function useCustomerPointsOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerPointsOverviewQueryQuery | undefined, CustomerPointsOverviewQueryQueryVariables>;
export function useCustomerPointsOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>(CustomerPointsOverviewQueryDocument, options);
        }
export type CustomerPointsOverviewQueryQueryHookResult = ReturnType<typeof useCustomerPointsOverviewQueryQuery>;
export type CustomerPointsOverviewQueryLazyQueryHookResult = ReturnType<typeof useCustomerPointsOverviewQueryLazyQuery>;
export type CustomerPointsOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useCustomerPointsOverviewQuerySuspenseQuery>;
export type CustomerPointsOverviewQueryQueryResult = Apollo.QueryResult<CustomerPointsOverviewQueryQuery, CustomerPointsOverviewQueryQueryVariables>;
export const UpdateCustomerAdminMutationDocument = gql`
    mutation UpdateCustomerAdminMutation($userId: String, $input: updateCustomerAdminInput!) {
  updateCustomerAdmin(userId: $userId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCustomerAdminMutationMutationFn = Apollo.MutationFunction<UpdateCustomerAdminMutationMutation, UpdateCustomerAdminMutationMutationVariables>;

/**
 * __useUpdateCustomerAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAdminMutationMutation, { data, loading, error }] = useUpdateCustomerAdminMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerAdminMutationMutation, UpdateCustomerAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerAdminMutationMutation, UpdateCustomerAdminMutationMutationVariables>(UpdateCustomerAdminMutationDocument, options);
      }
export type UpdateCustomerAdminMutationMutationHookResult = ReturnType<typeof useUpdateCustomerAdminMutationMutation>;
export type UpdateCustomerAdminMutationMutationResult = Apollo.MutationResult<UpdateCustomerAdminMutationMutation>;
export type UpdateCustomerAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerAdminMutationMutation, UpdateCustomerAdminMutationMutationVariables>;
export const CustomersOverviewAdminQueryDocument = gql`
    query CustomersOverviewAdminQuery($duration: String!) {
  customersOverviewAdmin(duration: $duration) {
    registeredCustomers
    activeCustomers
    inActiveCustomers
    totalCurrentBalance
    totalSpend
    totalAmbassador
  }
}
    `;

/**
 * __useCustomersOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useCustomersOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCustomersOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables> & ({ variables: CustomersOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>(CustomersOverviewAdminQueryDocument, options);
      }
export function useCustomersOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>(CustomersOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useCustomersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>;
export function useCustomersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomersOverviewAdminQueryQuery | undefined, CustomersOverviewAdminQueryQueryVariables>;
export function useCustomersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>(CustomersOverviewAdminQueryDocument, options);
        }
export type CustomersOverviewAdminQueryQueryHookResult = ReturnType<typeof useCustomersOverviewAdminQueryQuery>;
export type CustomersOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useCustomersOverviewAdminQueryLazyQuery>;
export type CustomersOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useCustomersOverviewAdminQuerySuspenseQuery>;
export type CustomersOverviewAdminQueryQueryResult = Apollo.QueryResult<CustomersOverviewAdminQueryQuery, CustomersOverviewAdminQueryQueryVariables>;
export const FindAllCustomersAdminQueryDocument = gql`
    query FindAllCustomersAdminQuery($page: Int!, $pageSize: Int!, $communityFilter: String, $ambassadorFilter: Boolean, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllCustomersAdmin(
    page: $page
    pageSize: $pageSize
    communityFilter: $communityFilter
    ambassadorFilter: $ambassadorFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      user {
        id
        firstname
        lastname
        username
        isAmbassador
      }
      community {
        id
        alias
        name
      }
      totalSpend
      location
      suspended
      isLocked
      isDeactivated
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCustomersAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCustomersAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomersAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomersAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      communityFilter: // value for 'communityFilter'
 *      ambassadorFilter: // value for 'ambassadorFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCustomersAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables> & ({ variables: FindAllCustomersAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>(FindAllCustomersAdminQueryDocument, options);
      }
export function useFindAllCustomersAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>(FindAllCustomersAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCustomersAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>;
export function useFindAllCustomersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersAdminQueryQuery | undefined, FindAllCustomersAdminQueryQueryVariables>;
export function useFindAllCustomersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>(FindAllCustomersAdminQueryDocument, options);
        }
export type FindAllCustomersAdminQueryQueryHookResult = ReturnType<typeof useFindAllCustomersAdminQueryQuery>;
export type FindAllCustomersAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllCustomersAdminQueryLazyQuery>;
export type FindAllCustomersAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCustomersAdminQuerySuspenseQuery>;
export type FindAllCustomersAdminQueryQueryResult = Apollo.QueryResult<FindAllCustomersAdminQueryQuery, FindAllCustomersAdminQueryQueryVariables>;
export const FindAllCustomersByLocationIdAdminQueryDocument = gql`
    query FindAllCustomersByLocationIdAdminQuery($locationId: String!, $page: Int!, $pageSize: Int!, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllCustomersByLocationIdAdmin(
    locationId: $locationId
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      user {
        id
        firstname
        lastname
        username
      }
      community {
        id
        alias
        name
      }
      totalSpend
      location
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCustomersByLocationIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCustomersByLocationIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomersByLocationIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomersByLocationIdAdminQueryQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCustomersByLocationIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables> & ({ variables: FindAllCustomersByLocationIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>(FindAllCustomersByLocationIdAdminQueryDocument, options);
      }
export function useFindAllCustomersByLocationIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>(FindAllCustomersByLocationIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCustomersByLocationIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>;
export function useFindAllCustomersByLocationIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersByLocationIdAdminQueryQuery | undefined, FindAllCustomersByLocationIdAdminQueryQueryVariables>;
export function useFindAllCustomersByLocationIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>(FindAllCustomersByLocationIdAdminQueryDocument, options);
        }
export type FindAllCustomersByLocationIdAdminQueryQueryHookResult = ReturnType<typeof useFindAllCustomersByLocationIdAdminQueryQuery>;
export type FindAllCustomersByLocationIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllCustomersByLocationIdAdminQueryLazyQuery>;
export type FindAllCustomersByLocationIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCustomersByLocationIdAdminQuerySuspenseQuery>;
export type FindAllCustomersByLocationIdAdminQueryQueryResult = Apollo.QueryResult<FindAllCustomersByLocationIdAdminQueryQuery, FindAllCustomersByLocationIdAdminQueryQueryVariables>;
export const CustomerReferralOverviewQueryDocument = gql`
    query CustomerReferralOverviewQuery($id: String!) {
  customerReferralOverview(id: $id) {
    totalReferrals
  }
}
    `;

/**
 * __useCustomerReferralOverviewQueryQuery__
 *
 * To run a query within a React component, call `useCustomerReferralOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerReferralOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerReferralOverviewQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerReferralOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables> & ({ variables: CustomerReferralOverviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>(CustomerReferralOverviewQueryDocument, options);
      }
export function useCustomerReferralOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>(CustomerReferralOverviewQueryDocument, options);
        }
// @ts-ignore
export function useCustomerReferralOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>;
export function useCustomerReferralOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerReferralOverviewQueryQuery | undefined, CustomerReferralOverviewQueryQueryVariables>;
export function useCustomerReferralOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>(CustomerReferralOverviewQueryDocument, options);
        }
export type CustomerReferralOverviewQueryQueryHookResult = ReturnType<typeof useCustomerReferralOverviewQueryQuery>;
export type CustomerReferralOverviewQueryLazyQueryHookResult = ReturnType<typeof useCustomerReferralOverviewQueryLazyQuery>;
export type CustomerReferralOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useCustomerReferralOverviewQuerySuspenseQuery>;
export type CustomerReferralOverviewQueryQueryResult = Apollo.QueryResult<CustomerReferralOverviewQueryQuery, CustomerReferralOverviewQueryQueryVariables>;
export const FindReferralsByUserIdAdminDocument = gql`
    query FindReferralsByUserIdAdmin($userId: String!, $page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findReferralsByUserIdAdmin(
    userId: $userId
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      customer {
        id
        firstname
        lastname
        username
        createdAt
        updatedAt
      }
    }
    referralCode
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindReferralsByUserIdAdminQuery__
 *
 * To run a query within a React component, call `useFindReferralsByUserIdAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReferralsByUserIdAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReferralsByUserIdAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindReferralsByUserIdAdminQuery(baseOptions: Apollo.QueryHookOptions<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables> & ({ variables: FindReferralsByUserIdAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>(FindReferralsByUserIdAdminDocument, options);
      }
export function useFindReferralsByUserIdAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>(FindReferralsByUserIdAdminDocument, options);
        }
// @ts-ignore
export function useFindReferralsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>;
export function useFindReferralsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindReferralsByUserIdAdminQuery | undefined, FindReferralsByUserIdAdminQueryVariables>;
export function useFindReferralsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>(FindReferralsByUserIdAdminDocument, options);
        }
export type FindReferralsByUserIdAdminQueryHookResult = ReturnType<typeof useFindReferralsByUserIdAdminQuery>;
export type FindReferralsByUserIdAdminLazyQueryHookResult = ReturnType<typeof useFindReferralsByUserIdAdminLazyQuery>;
export type FindReferralsByUserIdAdminSuspenseQueryHookResult = ReturnType<typeof useFindReferralsByUserIdAdminSuspenseQuery>;
export type FindReferralsByUserIdAdminQueryResult = Apollo.QueryResult<FindReferralsByUserIdAdminQuery, FindReferralsByUserIdAdminQueryVariables>;
export const ResetCustomerPasswordAdminMutationDocument = gql`
    mutation ResetCustomerPasswordAdminMutation($id: String!) {
  resetCustomerPasswordAdmin(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ResetCustomerPasswordAdminMutationMutationFn = Apollo.MutationFunction<ResetCustomerPasswordAdminMutationMutation, ResetCustomerPasswordAdminMutationMutationVariables>;

/**
 * __useResetCustomerPasswordAdminMutationMutation__
 *
 * To run a mutation, you first call `useResetCustomerPasswordAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCustomerPasswordAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCustomerPasswordAdminMutationMutation, { data, loading, error }] = useResetCustomerPasswordAdminMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetCustomerPasswordAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResetCustomerPasswordAdminMutationMutation, ResetCustomerPasswordAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCustomerPasswordAdminMutationMutation, ResetCustomerPasswordAdminMutationMutationVariables>(ResetCustomerPasswordAdminMutationDocument, options);
      }
export type ResetCustomerPasswordAdminMutationMutationHookResult = ReturnType<typeof useResetCustomerPasswordAdminMutationMutation>;
export type ResetCustomerPasswordAdminMutationMutationResult = Apollo.MutationResult<ResetCustomerPasswordAdminMutationMutation>;
export type ResetCustomerPasswordAdminMutationMutationOptions = Apollo.BaseMutationOptions<ResetCustomerPasswordAdminMutationMutation, ResetCustomerPasswordAdminMutationMutationVariables>;
export const UpdateCustomerToAmbassadorDocument = gql`
    mutation UpdateCustomerToAmbassador($id: String!) {
  updateCustomerToAmbassador(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCustomerToAmbassadorMutationFn = Apollo.MutationFunction<UpdateCustomerToAmbassadorMutation, UpdateCustomerToAmbassadorMutationVariables>;

/**
 * __useUpdateCustomerToAmbassadorMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerToAmbassadorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerToAmbassadorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerToAmbassadorMutation, { data, loading, error }] = useUpdateCustomerToAmbassadorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomerToAmbassadorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerToAmbassadorMutation, UpdateCustomerToAmbassadorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerToAmbassadorMutation, UpdateCustomerToAmbassadorMutationVariables>(UpdateCustomerToAmbassadorDocument, options);
      }
export type UpdateCustomerToAmbassadorMutationHookResult = ReturnType<typeof useUpdateCustomerToAmbassadorMutation>;
export type UpdateCustomerToAmbassadorMutationResult = Apollo.MutationResult<UpdateCustomerToAmbassadorMutation>;
export type UpdateCustomerToAmbassadorMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerToAmbassadorMutation, UpdateCustomerToAmbassadorMutationVariables>;
export const FindCustomerByIdAdminQueryDocument = gql`
    query FindCustomerByIdAdminQuery($id: String!) {
  findCustomerByIdAdmin(id: $id) {
    customer {
      id
      firstname
      lastname
      username
      firstname
      lastname
      email
      phone
      dob
      nin
      bvn
      gender
      address
      referralCode
      referralPoint
      isAmbassador
    }
    userId
    cbmId
    suspended
    isLocked
    isDeactivated
    totalSpend
    currentBalance
    community {
      id
      alias
      name
    }
    location
  }
}
    `;

/**
 * __useFindCustomerByIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindCustomerByIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCustomerByIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCustomerByIdAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCustomerByIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables> & ({ variables: FindCustomerByIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>(FindCustomerByIdAdminQueryDocument, options);
      }
export function useFindCustomerByIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>(FindCustomerByIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindCustomerByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>;
export function useFindCustomerByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomerByIdAdminQueryQuery | undefined, FindCustomerByIdAdminQueryQueryVariables>;
export function useFindCustomerByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>(FindCustomerByIdAdminQueryDocument, options);
        }
export type FindCustomerByIdAdminQueryQueryHookResult = ReturnType<typeof useFindCustomerByIdAdminQueryQuery>;
export type FindCustomerByIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindCustomerByIdAdminQueryLazyQuery>;
export type FindCustomerByIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindCustomerByIdAdminQuerySuspenseQuery>;
export type FindCustomerByIdAdminQueryQueryResult = Apollo.QueryResult<FindCustomerByIdAdminQueryQuery, FindCustomerByIdAdminQueryQueryVariables>;
export const UnlinkCbmMemberMutationDocument = gql`
    mutation UnlinkCbmMemberMutation($userId: String!) {
  unlinkCbmMember(userId: $userId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UnlinkCbmMemberMutationMutationFn = Apollo.MutationFunction<UnlinkCbmMemberMutationMutation, UnlinkCbmMemberMutationMutationVariables>;

/**
 * __useUnlinkCbmMemberMutationMutation__
 *
 * To run a mutation, you first call `useUnlinkCbmMemberMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCbmMemberMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCbmMemberMutationMutation, { data, loading, error }] = useUnlinkCbmMemberMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlinkCbmMemberMutationMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCbmMemberMutationMutation, UnlinkCbmMemberMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCbmMemberMutationMutation, UnlinkCbmMemberMutationMutationVariables>(UnlinkCbmMemberMutationDocument, options);
      }
export type UnlinkCbmMemberMutationMutationHookResult = ReturnType<typeof useUnlinkCbmMemberMutationMutation>;
export type UnlinkCbmMemberMutationMutationResult = Apollo.MutationResult<UnlinkCbmMemberMutationMutation>;
export type UnlinkCbmMemberMutationMutationOptions = Apollo.BaseMutationOptions<UnlinkCbmMemberMutationMutation, UnlinkCbmMemberMutationMutationVariables>;
export const FindAllLocationsAdminQueryDocument = gql`
    query FindAllLocationsAdminQuery($page: Int!, $pageSize: Int!, $countryFilter: String, $statusFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllLocationsAdmin(
    page: $page
    pageSize: $pageSize
    countryFilter: $countryFilter
    statusFilter: $statusFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      district
      city
      streetName
      country
      postalCode
      landmark
      createdAt
      latitude
      longitude
      isArchive
      customerCount
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllLocationsAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllLocationsAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationsAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationsAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      countryFilter: // value for 'countryFilter'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllLocationsAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables> & ({ variables: FindAllLocationsAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>(FindAllLocationsAdminQueryDocument, options);
      }
export function useFindAllLocationsAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>(FindAllLocationsAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllLocationsAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>;
export function useFindAllLocationsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLocationsAdminQueryQuery | undefined, FindAllLocationsAdminQueryQueryVariables>;
export function useFindAllLocationsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>(FindAllLocationsAdminQueryDocument, options);
        }
export type FindAllLocationsAdminQueryQueryHookResult = ReturnType<typeof useFindAllLocationsAdminQueryQuery>;
export type FindAllLocationsAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllLocationsAdminQueryLazyQuery>;
export type FindAllLocationsAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllLocationsAdminQuerySuspenseQuery>;
export type FindAllLocationsAdminQueryQueryResult = Apollo.QueryResult<FindAllLocationsAdminQueryQuery, FindAllLocationsAdminQueryQueryVariables>;
export const FindLocationByIdAdminQueryDocument = gql`
    query FindLocationByIdAdminQuery($id: String!) {
  findLocationByIdAdmin(id: $id) {
    id
    district
    city
    streetName
    country
    postalCode
    landmark
    createdAt
    updatedAt
    latitude
    longitude
    isArchive
    createdBy {
      id
      admin {
        id
        level
        firstname
        lastname
      }
    }
    customersCount
  }
}
    `;

/**
 * __useFindLocationByIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindLocationByIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationByIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationByIdAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindLocationByIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables> & ({ variables: FindLocationByIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>(FindLocationByIdAdminQueryDocument, options);
      }
export function useFindLocationByIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>(FindLocationByIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindLocationByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>;
export function useFindLocationByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindLocationByIdAdminQueryQuery | undefined, FindLocationByIdAdminQueryQueryVariables>;
export function useFindLocationByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>(FindLocationByIdAdminQueryDocument, options);
        }
export type FindLocationByIdAdminQueryQueryHookResult = ReturnType<typeof useFindLocationByIdAdminQueryQuery>;
export type FindLocationByIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindLocationByIdAdminQueryLazyQuery>;
export type FindLocationByIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindLocationByIdAdminQuerySuspenseQuery>;
export type FindLocationByIdAdminQueryQueryResult = Apollo.QueryResult<FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables>;
export const ToggleLocationArchiveStatusAdminMutationDocument = gql`
    mutation ToggleLocationArchiveStatusAdminMutation($locationId: String!, $isArchive: Boolean!) {
  toggleLocationArchiveStatusAdmin(locationId: $locationId, isArchive: $isArchive) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ToggleLocationArchiveStatusAdminMutationMutationFn = Apollo.MutationFunction<ToggleLocationArchiveStatusAdminMutationMutation, ToggleLocationArchiveStatusAdminMutationMutationVariables>;

/**
 * __useToggleLocationArchiveStatusAdminMutationMutation__
 *
 * To run a mutation, you first call `useToggleLocationArchiveStatusAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLocationArchiveStatusAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLocationArchiveStatusAdminMutationMutation, { data, loading, error }] = useToggleLocationArchiveStatusAdminMutationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isArchive: // value for 'isArchive'
 *   },
 * });
 */
export function useToggleLocationArchiveStatusAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLocationArchiveStatusAdminMutationMutation, ToggleLocationArchiveStatusAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLocationArchiveStatusAdminMutationMutation, ToggleLocationArchiveStatusAdminMutationMutationVariables>(ToggleLocationArchiveStatusAdminMutationDocument, options);
      }
export type ToggleLocationArchiveStatusAdminMutationMutationHookResult = ReturnType<typeof useToggleLocationArchiveStatusAdminMutationMutation>;
export type ToggleLocationArchiveStatusAdminMutationMutationResult = Apollo.MutationResult<ToggleLocationArchiveStatusAdminMutationMutation>;
export type ToggleLocationArchiveStatusAdminMutationMutationOptions = Apollo.BaseMutationOptions<ToggleLocationArchiveStatusAdminMutationMutation, ToggleLocationArchiveStatusAdminMutationMutationVariables>;
export const FindAllMerchantOffersAdminQueryDocument = gql`
    query FindAllMerchantOffersAdminQuery($page: Int!, $pageSize: Int!, $id: String!, $statusFilter: String, $typeFilter: String, $searchText: String) {
  findAllMerchantOffersAdmin(
    page: $page
    pageSize: $pageSize
    id: $id
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
  ) {
    data {
      id
      title
      offerType
      redemptions
      startDate
      endDate
      status
      createdAt
      createdBy {
        admin {
          id
          merchantProfile {
            id
            companyName
          }
        }
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllMerchantOffersAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllMerchantOffersAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMerchantOffersAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMerchantOffersAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      id: // value for 'id'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindAllMerchantOffersAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables> & ({ variables: FindAllMerchantOffersAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>(FindAllMerchantOffersAdminQueryDocument, options);
      }
export function useFindAllMerchantOffersAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>(FindAllMerchantOffersAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllMerchantOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>;
export function useFindAllMerchantOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantOffersAdminQueryQuery | undefined, FindAllMerchantOffersAdminQueryQueryVariables>;
export function useFindAllMerchantOffersAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>(FindAllMerchantOffersAdminQueryDocument, options);
        }
export type FindAllMerchantOffersAdminQueryQueryHookResult = ReturnType<typeof useFindAllMerchantOffersAdminQueryQuery>;
export type FindAllMerchantOffersAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllMerchantOffersAdminQueryLazyQuery>;
export type FindAllMerchantOffersAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllMerchantOffersAdminQuerySuspenseQuery>;
export type FindAllMerchantOffersAdminQueryQueryResult = Apollo.QueryResult<FindAllMerchantOffersAdminQueryQuery, FindAllMerchantOffersAdminQueryQueryVariables>;
export const FindAllMerchantsSpendAdminQueryDocument = gql`
    query FindAllMerchantsSpendAdminQuery($page: Int!, $pageSize: Int!, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllMerchantsSpendAdmin(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      userId
      userIsDeactivated
      adminId
      adminEmail
      merchantId
      username
      companyName
      businessName
      totalReceived
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllMerchantsSpendAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllMerchantsSpendAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMerchantsSpendAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMerchantsSpendAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllMerchantsSpendAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables> & ({ variables: FindAllMerchantsSpendAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>(FindAllMerchantsSpendAdminQueryDocument, options);
      }
export function useFindAllMerchantsSpendAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>(FindAllMerchantsSpendAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllMerchantsSpendAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>;
export function useFindAllMerchantsSpendAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantsSpendAdminQueryQuery | undefined, FindAllMerchantsSpendAdminQueryQueryVariables>;
export function useFindAllMerchantsSpendAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>(FindAllMerchantsSpendAdminQueryDocument, options);
        }
export type FindAllMerchantsSpendAdminQueryQueryHookResult = ReturnType<typeof useFindAllMerchantsSpendAdminQueryQuery>;
export type FindAllMerchantsSpendAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllMerchantsSpendAdminQueryLazyQuery>;
export type FindAllMerchantsSpendAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllMerchantsSpendAdminQuerySuspenseQuery>;
export type FindAllMerchantsSpendAdminQueryQueryResult = Apollo.QueryResult<FindAllMerchantsSpendAdminQueryQuery, FindAllMerchantsSpendAdminQueryQueryVariables>;
export const FindMerchantByIdAdminQueryDocument = gql`
    query FindMerchantByIdAdminQuery($id: String!) {
  findMerchantByIdAdmin(id: $id) {
    id
    admin {
      id
      shortId
      firstname
      lastname
      email
      phone
      level
      merchantProfile {
        id
        businessName
        businessType
        regCountry
        businessRegNumber
        taxId
        address
        addressAlt
        city
        country
        postcode
        companyName
        username
        industry {
          id
          name
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        companyLocation
        logoUrl
        bannerUrl
        description
        commissionRate
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
    kycStatus
    suspended
    isLocked
    isVerified
    isDeactivated
    forgotPasswordLocked
    onboarding {
      id
      status
      currentStep
    }
    role
    lastLoggedIn
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindMerchantByIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindMerchantByIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMerchantByIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMerchantByIdAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindMerchantByIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables> & ({ variables: FindMerchantByIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>(FindMerchantByIdAdminQueryDocument, options);
      }
export function useFindMerchantByIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>(FindMerchantByIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindMerchantByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>;
export function useFindMerchantByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantByIdAdminQueryQuery | undefined, FindMerchantByIdAdminQueryQueryVariables>;
export function useFindMerchantByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>(FindMerchantByIdAdminQueryDocument, options);
        }
export type FindMerchantByIdAdminQueryQueryHookResult = ReturnType<typeof useFindMerchantByIdAdminQueryQuery>;
export type FindMerchantByIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindMerchantByIdAdminQueryLazyQuery>;
export type FindMerchantByIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindMerchantByIdAdminQuerySuspenseQuery>;
export type FindMerchantByIdAdminQueryQueryResult = Apollo.QueryResult<FindMerchantByIdAdminQueryQuery, FindMerchantByIdAdminQueryQueryVariables>;
export const MerchantOverviewAdminQueryDocument = gql`
    query MerchantOverviewAdminQuery($id: String!) {
  merchantOverviewAdmin(id: $id) {
    redeemedOffers
    currentBalance
    amountReceived
    amountWithdrawn
  }
}
    `;

/**
 * __useMerchantOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useMerchantOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantOverviewAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables> & ({ variables: MerchantOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>(MerchantOverviewAdminQueryDocument, options);
      }
export function useMerchantOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>(MerchantOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useMerchantOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>;
export function useMerchantOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantOverviewAdminQueryQuery | undefined, MerchantOverviewAdminQueryQueryVariables>;
export function useMerchantOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>(MerchantOverviewAdminQueryDocument, options);
        }
export type MerchantOverviewAdminQueryQueryHookResult = ReturnType<typeof useMerchantOverviewAdminQueryQuery>;
export type MerchantOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useMerchantOverviewAdminQueryLazyQuery>;
export type MerchantOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useMerchantOverviewAdminQuerySuspenseQuery>;
export type MerchantOverviewAdminQueryQueryResult = Apollo.QueryResult<MerchantOverviewAdminQueryQuery, MerchantOverviewAdminQueryQueryVariables>;
export const MerchantsOverviewAdminQueryDocument = gql`
    query MerchantsOverviewAdminQuery($duration: String!) {
  merchantsOverviewAdmin(duration: $duration) {
    registeredMerchants
    activeMerchants
    inActiveMerchants
    totalCurrentBalance
    totalWithdrawals
  }
}
    `;

/**
 * __useMerchantsOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useMerchantsOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useMerchantsOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables> & ({ variables: MerchantsOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>(MerchantsOverviewAdminQueryDocument, options);
      }
export function useMerchantsOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>(MerchantsOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useMerchantsOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>;
export function useMerchantsOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsOverviewAdminQueryQuery | undefined, MerchantsOverviewAdminQueryQueryVariables>;
export function useMerchantsOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>(MerchantsOverviewAdminQueryDocument, options);
        }
export type MerchantsOverviewAdminQueryQueryHookResult = ReturnType<typeof useMerchantsOverviewAdminQueryQuery>;
export type MerchantsOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useMerchantsOverviewAdminQueryLazyQuery>;
export type MerchantsOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useMerchantsOverviewAdminQuerySuspenseQuery>;
export type MerchantsOverviewAdminQueryQueryResult = Apollo.QueryResult<MerchantsOverviewAdminQueryQuery, MerchantsOverviewAdminQueryQueryVariables>;
export const ResetMerchantBankPreferenceAdminMutationDocument = gql`
    mutation ResetMerchantBankPreferenceAdminMutation($bankPreferenceId: String!) {
  resetMerchantBankPreferenceAdmin(bankPreferenceId: $bankPreferenceId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ResetMerchantBankPreferenceAdminMutationMutationFn = Apollo.MutationFunction<ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables>;

/**
 * __useResetMerchantBankPreferenceAdminMutationMutation__
 *
 * To run a mutation, you first call `useResetMerchantBankPreferenceAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMerchantBankPreferenceAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMerchantBankPreferenceAdminMutationMutation, { data, loading, error }] = useResetMerchantBankPreferenceAdminMutationMutation({
 *   variables: {
 *      bankPreferenceId: // value for 'bankPreferenceId'
 *   },
 * });
 */
export function useResetMerchantBankPreferenceAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables>(ResetMerchantBankPreferenceAdminMutationDocument, options);
      }
export type ResetMerchantBankPreferenceAdminMutationMutationHookResult = ReturnType<typeof useResetMerchantBankPreferenceAdminMutationMutation>;
export type ResetMerchantBankPreferenceAdminMutationMutationResult = Apollo.MutationResult<ResetMerchantBankPreferenceAdminMutationMutation>;
export type ResetMerchantBankPreferenceAdminMutationMutationOptions = Apollo.BaseMutationOptions<ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables>;
export const ResetMerchantPasswordAdminMutationDocument = gql`
    mutation ResetMerchantPasswordAdminMutation($id: String!) {
  resetMerchantPasswordAdmin(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ResetMerchantPasswordAdminMutationMutationFn = Apollo.MutationFunction<ResetMerchantPasswordAdminMutationMutation, ResetMerchantPasswordAdminMutationMutationVariables>;

/**
 * __useResetMerchantPasswordAdminMutationMutation__
 *
 * To run a mutation, you first call `useResetMerchantPasswordAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMerchantPasswordAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMerchantPasswordAdminMutationMutation, { data, loading, error }] = useResetMerchantPasswordAdminMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetMerchantPasswordAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResetMerchantPasswordAdminMutationMutation, ResetMerchantPasswordAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMerchantPasswordAdminMutationMutation, ResetMerchantPasswordAdminMutationMutationVariables>(ResetMerchantPasswordAdminMutationDocument, options);
      }
export type ResetMerchantPasswordAdminMutationMutationHookResult = ReturnType<typeof useResetMerchantPasswordAdminMutationMutation>;
export type ResetMerchantPasswordAdminMutationMutationResult = Apollo.MutationResult<ResetMerchantPasswordAdminMutationMutation>;
export type ResetMerchantPasswordAdminMutationMutationOptions = Apollo.BaseMutationOptions<ResetMerchantPasswordAdminMutationMutation, ResetMerchantPasswordAdminMutationMutationVariables>;
export const UpdateMerchantAdminMutationDocument = gql`
    mutation UpdateMerchantAdminMutation($id: String!, $input: UpdateBusinessInfoInput!) {
  updateMerchantAdmin(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
    logoUrl
    bannerUrl
  }
}
    `;
export type UpdateMerchantAdminMutationMutationFn = Apollo.MutationFunction<UpdateMerchantAdminMutationMutation, UpdateMerchantAdminMutationMutationVariables>;

/**
 * __useUpdateMerchantAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantAdminMutationMutation, { data, loading, error }] = useUpdateMerchantAdminMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMerchantAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantAdminMutationMutation, UpdateMerchantAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantAdminMutationMutation, UpdateMerchantAdminMutationMutationVariables>(UpdateMerchantAdminMutationDocument, options);
      }
export type UpdateMerchantAdminMutationMutationHookResult = ReturnType<typeof useUpdateMerchantAdminMutationMutation>;
export type UpdateMerchantAdminMutationMutationResult = Apollo.MutationResult<UpdateMerchantAdminMutationMutation>;
export type UpdateMerchantAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantAdminMutationMutation, UpdateMerchantAdminMutationMutationVariables>;
export const UpdateMerchantAdminDataAdminMutationDocument = gql`
    mutation UpdateMerchantAdminDataAdminMutation($id: String!, $input: UpdateAdminInput!) {
  updateMerchantAdminDataAdmin(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateMerchantAdminDataAdminMutationMutationFn = Apollo.MutationFunction<UpdateMerchantAdminDataAdminMutationMutation, UpdateMerchantAdminDataAdminMutationMutationVariables>;

/**
 * __useUpdateMerchantAdminDataAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantAdminDataAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantAdminDataAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantAdminDataAdminMutationMutation, { data, loading, error }] = useUpdateMerchantAdminDataAdminMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMerchantAdminDataAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantAdminDataAdminMutationMutation, UpdateMerchantAdminDataAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantAdminDataAdminMutationMutation, UpdateMerchantAdminDataAdminMutationMutationVariables>(UpdateMerchantAdminDataAdminMutationDocument, options);
      }
export type UpdateMerchantAdminDataAdminMutationMutationHookResult = ReturnType<typeof useUpdateMerchantAdminDataAdminMutationMutation>;
export type UpdateMerchantAdminDataAdminMutationMutationResult = Apollo.MutationResult<UpdateMerchantAdminDataAdminMutationMutation>;
export type UpdateMerchantAdminDataAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantAdminDataAdminMutationMutation, UpdateMerchantAdminDataAdminMutationMutationVariables>;
export const CreateOfferPointsDeductionMutationDocument = gql`
    mutation CreateOfferPointsDeductionMutation($offerId: String!, $point: Int!) {
  createOfferPointsDeduction(offerId: $offerId, point: $point) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateOfferPointsDeductionMutationMutationFn = Apollo.MutationFunction<CreateOfferPointsDeductionMutationMutation, CreateOfferPointsDeductionMutationMutationVariables>;

/**
 * __useCreateOfferPointsDeductionMutationMutation__
 *
 * To run a mutation, you first call `useCreateOfferPointsDeductionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferPointsDeductionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferPointsDeductionMutationMutation, { data, loading, error }] = useCreateOfferPointsDeductionMutationMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      point: // value for 'point'
 *   },
 * });
 */
export function useCreateOfferPointsDeductionMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferPointsDeductionMutationMutation, CreateOfferPointsDeductionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferPointsDeductionMutationMutation, CreateOfferPointsDeductionMutationMutationVariables>(CreateOfferPointsDeductionMutationDocument, options);
      }
export type CreateOfferPointsDeductionMutationMutationHookResult = ReturnType<typeof useCreateOfferPointsDeductionMutationMutation>;
export type CreateOfferPointsDeductionMutationMutationResult = Apollo.MutationResult<CreateOfferPointsDeductionMutationMutation>;
export type CreateOfferPointsDeductionMutationMutationOptions = Apollo.BaseMutationOptions<CreateOfferPointsDeductionMutationMutation, CreateOfferPointsDeductionMutationMutationVariables>;
export const DeleteOfferPointsDeductionMutationDocument = gql`
    mutation DeleteOfferPointsDeductionMutation($id: String!) {
  deleteOfferPointsDeduction(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteOfferPointsDeductionMutationMutationFn = Apollo.MutationFunction<DeleteOfferPointsDeductionMutationMutation, DeleteOfferPointsDeductionMutationMutationVariables>;

/**
 * __useDeleteOfferPointsDeductionMutationMutation__
 *
 * To run a mutation, you first call `useDeleteOfferPointsDeductionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferPointsDeductionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferPointsDeductionMutationMutation, { data, loading, error }] = useDeleteOfferPointsDeductionMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferPointsDeductionMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferPointsDeductionMutationMutation, DeleteOfferPointsDeductionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferPointsDeductionMutationMutation, DeleteOfferPointsDeductionMutationMutationVariables>(DeleteOfferPointsDeductionMutationDocument, options);
      }
export type DeleteOfferPointsDeductionMutationMutationHookResult = ReturnType<typeof useDeleteOfferPointsDeductionMutationMutation>;
export type DeleteOfferPointsDeductionMutationMutationResult = Apollo.MutationResult<DeleteOfferPointsDeductionMutationMutation>;
export type DeleteOfferPointsDeductionMutationMutationOptions = Apollo.BaseMutationOptions<DeleteOfferPointsDeductionMutationMutation, DeleteOfferPointsDeductionMutationMutationVariables>;
export const FindAllOfferPointsDeductionsQueryDocument = gql`
    query FindAllOfferPointsDeductionsQuery($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllOfferPointsDeductions(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      offerId
      offerTitle
      offerStatus
      partnerName
      point
      createdAt
      updatedAt
      adminName
      adminLevel
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllOfferPointsDeductionsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllOfferPointsDeductionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOfferPointsDeductionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOfferPointsDeductionsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllOfferPointsDeductionsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables> & ({ variables: FindAllOfferPointsDeductionsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>(FindAllOfferPointsDeductionsQueryDocument, options);
      }
export function useFindAllOfferPointsDeductionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>(FindAllOfferPointsDeductionsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllOfferPointsDeductionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>;
export function useFindAllOfferPointsDeductionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllOfferPointsDeductionsQueryQuery | undefined, FindAllOfferPointsDeductionsQueryQueryVariables>;
export function useFindAllOfferPointsDeductionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>(FindAllOfferPointsDeductionsQueryDocument, options);
        }
export type FindAllOfferPointsDeductionsQueryQueryHookResult = ReturnType<typeof useFindAllOfferPointsDeductionsQueryQuery>;
export type FindAllOfferPointsDeductionsQueryLazyQueryHookResult = ReturnType<typeof useFindAllOfferPointsDeductionsQueryLazyQuery>;
export type FindAllOfferPointsDeductionsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllOfferPointsDeductionsQuerySuspenseQuery>;
export type FindAllOfferPointsDeductionsQueryQueryResult = Apollo.QueryResult<FindAllOfferPointsDeductionsQueryQuery, FindAllOfferPointsDeductionsQueryQueryVariables>;
export const FindOfferPointsDeductionByIdQueryDocument = gql`
    query FindOfferPointsDeductionByIdQuery($id: String!) {
  findOfferPointsDeductionById(id: $id) {
    id
    offerId
    offerTitle
    offerStatus
    partnerName
    point
    createdAt
    updatedAt
    adminName
    adminLevel
  }
}
    `;

/**
 * __useFindOfferPointsDeductionByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindOfferPointsDeductionByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOfferPointsDeductionByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOfferPointsDeductionByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindOfferPointsDeductionByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables> & ({ variables: FindOfferPointsDeductionByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>(FindOfferPointsDeductionByIdQueryDocument, options);
      }
export function useFindOfferPointsDeductionByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>(FindOfferPointsDeductionByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindOfferPointsDeductionByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>;
export function useFindOfferPointsDeductionByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOfferPointsDeductionByIdQueryQuery | undefined, FindOfferPointsDeductionByIdQueryQueryVariables>;
export function useFindOfferPointsDeductionByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>(FindOfferPointsDeductionByIdQueryDocument, options);
        }
export type FindOfferPointsDeductionByIdQueryQueryHookResult = ReturnType<typeof useFindOfferPointsDeductionByIdQueryQuery>;
export type FindOfferPointsDeductionByIdQueryLazyQueryHookResult = ReturnType<typeof useFindOfferPointsDeductionByIdQueryLazyQuery>;
export type FindOfferPointsDeductionByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindOfferPointsDeductionByIdQuerySuspenseQuery>;
export type FindOfferPointsDeductionByIdQueryQueryResult = Apollo.QueryResult<FindOfferPointsDeductionByIdQueryQuery, FindOfferPointsDeductionByIdQueryQueryVariables>;
export const UpdateOfferPointsDeductionMutationDocument = gql`
    mutation UpdateOfferPointsDeductionMutation($id: String!, $point: Int!) {
  updateOfferPointsDeduction(id: $id, point: $point) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateOfferPointsDeductionMutationMutationFn = Apollo.MutationFunction<UpdateOfferPointsDeductionMutationMutation, UpdateOfferPointsDeductionMutationMutationVariables>;

/**
 * __useUpdateOfferPointsDeductionMutationMutation__
 *
 * To run a mutation, you first call `useUpdateOfferPointsDeductionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferPointsDeductionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferPointsDeductionMutationMutation, { data, loading, error }] = useUpdateOfferPointsDeductionMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      point: // value for 'point'
 *   },
 * });
 */
export function useUpdateOfferPointsDeductionMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferPointsDeductionMutationMutation, UpdateOfferPointsDeductionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferPointsDeductionMutationMutation, UpdateOfferPointsDeductionMutationMutationVariables>(UpdateOfferPointsDeductionMutationDocument, options);
      }
export type UpdateOfferPointsDeductionMutationMutationHookResult = ReturnType<typeof useUpdateOfferPointsDeductionMutationMutation>;
export type UpdateOfferPointsDeductionMutationMutationResult = Apollo.MutationResult<UpdateOfferPointsDeductionMutationMutation>;
export type UpdateOfferPointsDeductionMutationMutationOptions = Apollo.BaseMutationOptions<UpdateOfferPointsDeductionMutationMutation, UpdateOfferPointsDeductionMutationMutationVariables>;
export const FindAllOffersAdminDocument = gql`
    query FindAllOffersAdmin($page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllOffersAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      title
      offerType
      redemptions
      startDate
      endDate
      status
      createdAt
      createdBy {
        admin {
          id
          merchantProfile {
            id
            companyName
          }
        }
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllOffersAdminQuery__
 *
 * To run a query within a React component, call `useFindAllOffersAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllOffersAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllOffersAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllOffersAdminQuery(baseOptions: Apollo.QueryHookOptions<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables> & ({ variables: FindAllOffersAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>(FindAllOffersAdminDocument, options);
      }
export function useFindAllOffersAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>(FindAllOffersAdminDocument, options);
        }
// @ts-ignore
export function useFindAllOffersAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>;
export function useFindAllOffersAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllOffersAdminQuery | undefined, FindAllOffersAdminQueryVariables>;
export function useFindAllOffersAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>(FindAllOffersAdminDocument, options);
        }
export type FindAllOffersAdminQueryHookResult = ReturnType<typeof useFindAllOffersAdminQuery>;
export type FindAllOffersAdminLazyQueryHookResult = ReturnType<typeof useFindAllOffersAdminLazyQuery>;
export type FindAllOffersAdminSuspenseQueryHookResult = ReturnType<typeof useFindAllOffersAdminSuspenseQuery>;
export type FindAllOffersAdminQueryResult = Apollo.QueryResult<FindAllOffersAdminQuery, FindAllOffersAdminQueryVariables>;
export const FindRedemptionsByOfferIdAdminDocument = gql`
    query FindRedemptionsByOfferIdAdmin($offerId: String!, $page: Int!, $pageSize: Int!, $duration: String!) {
  findRedemptionsByOfferIdAdmin(
    offerId: $offerId
    page: $page
    pageSize: $pageSize
    duration: $duration
  ) {
    data {
      createdAt
      wallet {
        id
      }
      user {
        customer {
          firstname
          lastname
          community {
            id
            alias
          }
        }
      }
      redeemedCode
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindRedemptionsByOfferIdAdminQuery__
 *
 * To run a query within a React component, call `useFindRedemptionsByOfferIdAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRedemptionsByOfferIdAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRedemptionsByOfferIdAdminQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useFindRedemptionsByOfferIdAdminQuery(baseOptions: Apollo.QueryHookOptions<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables> & ({ variables: FindRedemptionsByOfferIdAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>(FindRedemptionsByOfferIdAdminDocument, options);
      }
export function useFindRedemptionsByOfferIdAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>(FindRedemptionsByOfferIdAdminDocument, options);
        }
// @ts-ignore
export function useFindRedemptionsByOfferIdAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>;
export function useFindRedemptionsByOfferIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindRedemptionsByOfferIdAdminQuery | undefined, FindRedemptionsByOfferIdAdminQueryVariables>;
export function useFindRedemptionsByOfferIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>(FindRedemptionsByOfferIdAdminDocument, options);
        }
export type FindRedemptionsByOfferIdAdminQueryHookResult = ReturnType<typeof useFindRedemptionsByOfferIdAdminQuery>;
export type FindRedemptionsByOfferIdAdminLazyQueryHookResult = ReturnType<typeof useFindRedemptionsByOfferIdAdminLazyQuery>;
export type FindRedemptionsByOfferIdAdminSuspenseQueryHookResult = ReturnType<typeof useFindRedemptionsByOfferIdAdminSuspenseQuery>;
export type FindRedemptionsByOfferIdAdminQueryResult = Apollo.QueryResult<FindRedemptionsByOfferIdAdminQuery, FindRedemptionsByOfferIdAdminQueryVariables>;
export const OffersOverviewAdminQueryDocument = gql`
    query OffersOverviewAdminQuery($duration: String!) {
  offersOverviewAdmin(duration: $duration) {
    totalRedeemedOffers
    totalPublishedOffers
    totalExpiredOffers
    totalDraftOffers
    totalScheduledOffers
    totalImpressions
    totalOffersClick
  }
}
    `;

/**
 * __useOffersOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useOffersOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useOffersOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables> & ({ variables: OffersOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>(OffersOverviewAdminQueryDocument, options);
      }
export function useOffersOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>(OffersOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>;
export function useOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<OffersOverviewAdminQueryQuery | undefined, OffersOverviewAdminQueryQueryVariables>;
export function useOffersOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>(OffersOverviewAdminQueryDocument, options);
        }
export type OffersOverviewAdminQueryQueryHookResult = ReturnType<typeof useOffersOverviewAdminQueryQuery>;
export type OffersOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useOffersOverviewAdminQueryLazyQuery>;
export type OffersOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useOffersOverviewAdminQuerySuspenseQuery>;
export type OffersOverviewAdminQueryQueryResult = Apollo.QueryResult<OffersOverviewAdminQueryQuery, OffersOverviewAdminQueryQueryVariables>;
export const CreatePartnerExchangeRateMutationDocument = gql`
    mutation CreatePartnerExchangeRateMutation($communityId: String!, $rate: Float!) {
  createPartnerExchangeRate(communityId: $communityId, rate: $rate) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreatePartnerExchangeRateMutationMutationFn = Apollo.MutationFunction<CreatePartnerExchangeRateMutationMutation, CreatePartnerExchangeRateMutationMutationVariables>;

/**
 * __useCreatePartnerExchangeRateMutationMutation__
 *
 * To run a mutation, you first call `useCreatePartnerExchangeRateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerExchangeRateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerExchangeRateMutationMutation, { data, loading, error }] = useCreatePartnerExchangeRateMutationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useCreatePartnerExchangeRateMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerExchangeRateMutationMutation, CreatePartnerExchangeRateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerExchangeRateMutationMutation, CreatePartnerExchangeRateMutationMutationVariables>(CreatePartnerExchangeRateMutationDocument, options);
      }
export type CreatePartnerExchangeRateMutationMutationHookResult = ReturnType<typeof useCreatePartnerExchangeRateMutationMutation>;
export type CreatePartnerExchangeRateMutationMutationResult = Apollo.MutationResult<CreatePartnerExchangeRateMutationMutation>;
export type CreatePartnerExchangeRateMutationMutationOptions = Apollo.BaseMutationOptions<CreatePartnerExchangeRateMutationMutation, CreatePartnerExchangeRateMutationMutationVariables>;
export const DeletePartnerExchangeRateMutationDocument = gql`
    mutation DeletePartnerExchangeRateMutation($id: String!) {
  deletePartnerExchangeRate(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeletePartnerExchangeRateMutationMutationFn = Apollo.MutationFunction<DeletePartnerExchangeRateMutationMutation, DeletePartnerExchangeRateMutationMutationVariables>;

/**
 * __useDeletePartnerExchangeRateMutationMutation__
 *
 * To run a mutation, you first call `useDeletePartnerExchangeRateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerExchangeRateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerExchangeRateMutationMutation, { data, loading, error }] = useDeletePartnerExchangeRateMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartnerExchangeRateMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerExchangeRateMutationMutation, DeletePartnerExchangeRateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerExchangeRateMutationMutation, DeletePartnerExchangeRateMutationMutationVariables>(DeletePartnerExchangeRateMutationDocument, options);
      }
export type DeletePartnerExchangeRateMutationMutationHookResult = ReturnType<typeof useDeletePartnerExchangeRateMutationMutation>;
export type DeletePartnerExchangeRateMutationMutationResult = Apollo.MutationResult<DeletePartnerExchangeRateMutationMutation>;
export type DeletePartnerExchangeRateMutationMutationOptions = Apollo.BaseMutationOptions<DeletePartnerExchangeRateMutationMutation, DeletePartnerExchangeRateMutationMutationVariables>;
export const FindAllPartnerExchangeRatesQueryDocument = gql`
    query FindAllPartnerExchangeRatesQuery($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllPartnerExchangeRates(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      communityId
      communityName
      communityAlias
      rate
      createdAt
      updatedAt
      adminName
      adminLevel
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllPartnerExchangeRatesQueryQuery__
 *
 * To run a query within a React component, call `useFindAllPartnerExchangeRatesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllPartnerExchangeRatesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllPartnerExchangeRatesQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllPartnerExchangeRatesQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables> & ({ variables: FindAllPartnerExchangeRatesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>(FindAllPartnerExchangeRatesQueryDocument, options);
      }
export function useFindAllPartnerExchangeRatesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>(FindAllPartnerExchangeRatesQueryDocument, options);
        }
// @ts-ignore
export function useFindAllPartnerExchangeRatesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>;
export function useFindAllPartnerExchangeRatesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllPartnerExchangeRatesQueryQuery | undefined, FindAllPartnerExchangeRatesQueryQueryVariables>;
export function useFindAllPartnerExchangeRatesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>(FindAllPartnerExchangeRatesQueryDocument, options);
        }
export type FindAllPartnerExchangeRatesQueryQueryHookResult = ReturnType<typeof useFindAllPartnerExchangeRatesQueryQuery>;
export type FindAllPartnerExchangeRatesQueryLazyQueryHookResult = ReturnType<typeof useFindAllPartnerExchangeRatesQueryLazyQuery>;
export type FindAllPartnerExchangeRatesQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllPartnerExchangeRatesQuerySuspenseQuery>;
export type FindAllPartnerExchangeRatesQueryQueryResult = Apollo.QueryResult<FindAllPartnerExchangeRatesQueryQuery, FindAllPartnerExchangeRatesQueryQueryVariables>;
export const FindPartnerExchangeRateByIdQueryDocument = gql`
    query FindPartnerExchangeRateByIdQuery($id: String!) {
  findPartnerExchangeRateById(id: $id) {
    id
    communityId
    communityName
    communityAlias
    rate
    createdAt
    updatedAt
    adminName
    adminLevel
  }
}
    `;

/**
 * __useFindPartnerExchangeRateByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindPartnerExchangeRateByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPartnerExchangeRateByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPartnerExchangeRateByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindPartnerExchangeRateByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables> & ({ variables: FindPartnerExchangeRateByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>(FindPartnerExchangeRateByIdQueryDocument, options);
      }
export function useFindPartnerExchangeRateByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>(FindPartnerExchangeRateByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindPartnerExchangeRateByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>;
export function useFindPartnerExchangeRateByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindPartnerExchangeRateByIdQueryQuery | undefined, FindPartnerExchangeRateByIdQueryQueryVariables>;
export function useFindPartnerExchangeRateByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>(FindPartnerExchangeRateByIdQueryDocument, options);
        }
export type FindPartnerExchangeRateByIdQueryQueryHookResult = ReturnType<typeof useFindPartnerExchangeRateByIdQueryQuery>;
export type FindPartnerExchangeRateByIdQueryLazyQueryHookResult = ReturnType<typeof useFindPartnerExchangeRateByIdQueryLazyQuery>;
export type FindPartnerExchangeRateByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindPartnerExchangeRateByIdQuerySuspenseQuery>;
export type FindPartnerExchangeRateByIdQueryQueryResult = Apollo.QueryResult<FindPartnerExchangeRateByIdQueryQuery, FindPartnerExchangeRateByIdQueryQueryVariables>;
export const UpdatePartnerExchangeRateMutationDocument = gql`
    mutation UpdatePartnerExchangeRateMutation($id: String!, $rate: Float!) {
  updatePartnerExchangeRate(id: $id, rate: $rate) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdatePartnerExchangeRateMutationMutationFn = Apollo.MutationFunction<UpdatePartnerExchangeRateMutationMutation, UpdatePartnerExchangeRateMutationMutationVariables>;

/**
 * __useUpdatePartnerExchangeRateMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerExchangeRateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerExchangeRateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerExchangeRateMutationMutation, { data, loading, error }] = useUpdatePartnerExchangeRateMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useUpdatePartnerExchangeRateMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerExchangeRateMutationMutation, UpdatePartnerExchangeRateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerExchangeRateMutationMutation, UpdatePartnerExchangeRateMutationMutationVariables>(UpdatePartnerExchangeRateMutationDocument, options);
      }
export type UpdatePartnerExchangeRateMutationMutationHookResult = ReturnType<typeof useUpdatePartnerExchangeRateMutationMutation>;
export type UpdatePartnerExchangeRateMutationMutationResult = Apollo.MutationResult<UpdatePartnerExchangeRateMutationMutation>;
export type UpdatePartnerExchangeRateMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerExchangeRateMutationMutation, UpdatePartnerExchangeRateMutationMutationVariables>;
export const CreateCustomerTierMutationDocument = gql`
    mutation CreateCustomerTierMutation($name: String!, $multiplier: Int!, $threshold: Int!) {
  createCustomerTier(name: $name, multiplier: $multiplier, threshold: $threshold) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateCustomerTierMutationMutationFn = Apollo.MutationFunction<CreateCustomerTierMutationMutation, CreateCustomerTierMutationMutationVariables>;

/**
 * __useCreateCustomerTierMutationMutation__
 *
 * To run a mutation, you first call `useCreateCustomerTierMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerTierMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerTierMutationMutation, { data, loading, error }] = useCreateCustomerTierMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      multiplier: // value for 'multiplier'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useCreateCustomerTierMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerTierMutationMutation, CreateCustomerTierMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerTierMutationMutation, CreateCustomerTierMutationMutationVariables>(CreateCustomerTierMutationDocument, options);
      }
export type CreateCustomerTierMutationMutationHookResult = ReturnType<typeof useCreateCustomerTierMutationMutation>;
export type CreateCustomerTierMutationMutationResult = Apollo.MutationResult<CreateCustomerTierMutationMutation>;
export type CreateCustomerTierMutationMutationOptions = Apollo.BaseMutationOptions<CreateCustomerTierMutationMutation, CreateCustomerTierMutationMutationVariables>;
export const FindAllCustomerTiersQueryDocument = gql`
    query FindAllCustomerTiersQuery($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllCustomerTiers(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      multiplier
      threshold
      createdAt
      customerCount
      isArchive
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCustomerTiersQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCustomerTiersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomerTiersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomerTiersQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCustomerTiersQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables> & ({ variables: FindAllCustomerTiersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>(FindAllCustomerTiersQueryDocument, options);
      }
export function useFindAllCustomerTiersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>(FindAllCustomerTiersQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCustomerTiersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>;
export function useFindAllCustomerTiersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomerTiersQueryQuery | undefined, FindAllCustomerTiersQueryQueryVariables>;
export function useFindAllCustomerTiersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>(FindAllCustomerTiersQueryDocument, options);
        }
export type FindAllCustomerTiersQueryQueryHookResult = ReturnType<typeof useFindAllCustomerTiersQueryQuery>;
export type FindAllCustomerTiersQueryLazyQueryHookResult = ReturnType<typeof useFindAllCustomerTiersQueryLazyQuery>;
export type FindAllCustomerTiersQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCustomerTiersQuerySuspenseQuery>;
export type FindAllCustomerTiersQueryQueryResult = Apollo.QueryResult<FindAllCustomerTiersQueryQuery, FindAllCustomerTiersQueryQueryVariables>;
export const FindCustomerTierByIdQueryDocument = gql`
    query FindCustomerTierByIdQuery($id: String!) {
  findCustomerTierById(id: $id) {
    id
    name
    multiplier
    threshold
    createdAt
    customerCount
    isArchive
  }
}
    `;

/**
 * __useFindCustomerTierByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindCustomerTierByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCustomerTierByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCustomerTierByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCustomerTierByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables> & ({ variables: FindCustomerTierByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>(FindCustomerTierByIdQueryDocument, options);
      }
export function useFindCustomerTierByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>(FindCustomerTierByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindCustomerTierByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>;
export function useFindCustomerTierByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomerTierByIdQueryQuery | undefined, FindCustomerTierByIdQueryQueryVariables>;
export function useFindCustomerTierByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>(FindCustomerTierByIdQueryDocument, options);
        }
export type FindCustomerTierByIdQueryQueryHookResult = ReturnType<typeof useFindCustomerTierByIdQueryQuery>;
export type FindCustomerTierByIdQueryLazyQueryHookResult = ReturnType<typeof useFindCustomerTierByIdQueryLazyQuery>;
export type FindCustomerTierByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindCustomerTierByIdQuerySuspenseQuery>;
export type FindCustomerTierByIdQueryQueryResult = Apollo.QueryResult<FindCustomerTierByIdQueryQuery, FindCustomerTierByIdQueryQueryVariables>;
export const UpdateCustomerTierMutationDocument = gql`
    mutation UpdateCustomerTierMutation($id: String!, $input: UpdateCustomerTierInput!) {
  updateCustomerTier(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCustomerTierMutationMutationFn = Apollo.MutationFunction<UpdateCustomerTierMutationMutation, UpdateCustomerTierMutationMutationVariables>;

/**
 * __useUpdateCustomerTierMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerTierMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerTierMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerTierMutationMutation, { data, loading, error }] = useUpdateCustomerTierMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerTierMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerTierMutationMutation, UpdateCustomerTierMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerTierMutationMutation, UpdateCustomerTierMutationMutationVariables>(UpdateCustomerTierMutationDocument, options);
      }
export type UpdateCustomerTierMutationMutationHookResult = ReturnType<typeof useUpdateCustomerTierMutationMutation>;
export type UpdateCustomerTierMutationMutationResult = Apollo.MutationResult<UpdateCustomerTierMutationMutation>;
export type UpdateCustomerTierMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerTierMutationMutation, UpdateCustomerTierMutationMutationVariables>;
export const CreateRefundAdminMutationDocument = gql`
    mutation CreateRefundAdminMutation($input: CreateRefundInputAdmin!) {
  createRefundAdmin(input: $input) {
    errors {
      path
      message
    }
    message
    data {
      id
      account_number
      bank_code
      full_name
      currency
      debit_currency
      amount
      fee
      status
      reference
      narration
      complete_message
      requires_approval
      is_approved
      bank_name
    }
  }
}
    `;
export type CreateRefundAdminMutationMutationFn = Apollo.MutationFunction<CreateRefundAdminMutationMutation, CreateRefundAdminMutationMutationVariables>;

/**
 * __useCreateRefundAdminMutationMutation__
 *
 * To run a mutation, you first call `useCreateRefundAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundAdminMutationMutation, { data, loading, error }] = useCreateRefundAdminMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRefundAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRefundAdminMutationMutation, CreateRefundAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRefundAdminMutationMutation, CreateRefundAdminMutationMutationVariables>(CreateRefundAdminMutationDocument, options);
      }
export type CreateRefundAdminMutationMutationHookResult = ReturnType<typeof useCreateRefundAdminMutationMutation>;
export type CreateRefundAdminMutationMutationResult = Apollo.MutationResult<CreateRefundAdminMutationMutation>;
export type CreateRefundAdminMutationMutationOptions = Apollo.BaseMutationOptions<CreateRefundAdminMutationMutation, CreateRefundAdminMutationMutationVariables>;
export const FindAllRefundsAdminQueryDocument = gql`
    query FindAllRefundsAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllRefundsAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    refund {
      id
      amount
      reasonForRefund
      description
      customerName
      transactionId
      createdAt
      reference
      status
      currency
      userId
      createdBy {
        id
        admin {
          id
          merchantProfile {
            companyName
            businessName
          }
        }
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllRefundsAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllRefundsAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllRefundsAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllRefundsAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllRefundsAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables> & ({ variables: FindAllRefundsAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>(FindAllRefundsAdminQueryDocument, options);
      }
export function useFindAllRefundsAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>(FindAllRefundsAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllRefundsAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>;
export function useFindAllRefundsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllRefundsAdminQueryQuery | undefined, FindAllRefundsAdminQueryQueryVariables>;
export function useFindAllRefundsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>(FindAllRefundsAdminQueryDocument, options);
        }
export type FindAllRefundsAdminQueryQueryHookResult = ReturnType<typeof useFindAllRefundsAdminQueryQuery>;
export type FindAllRefundsAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllRefundsAdminQueryLazyQuery>;
export type FindAllRefundsAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllRefundsAdminQuerySuspenseQuery>;
export type FindAllRefundsAdminQueryQueryResult = Apollo.QueryResult<FindAllRefundsAdminQueryQuery, FindAllRefundsAdminQueryQueryVariables>;
export const FindRefundByIdAdminQueryDocument = gql`
    query FindRefundByIdAdminQuery($id: String!) {
  findRefundByIdAdmin(id: $id) {
    id
    amount
    reasonForRefund
    description
    customerName
    transactionId
    transaction {
      id
      offer {
        id
        title
        offerType
      }
    }
    createdAt
    reference
    status
    currency
    userId
    user {
      id
      admin {
        id
        merchantProfile {
          companyName
          businessName
        }
      }
    }
    admin {
      id
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useFindRefundByIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindRefundByIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRefundByIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRefundByIdAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindRefundByIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables> & ({ variables: FindRefundByIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>(FindRefundByIdAdminQueryDocument, options);
      }
export function useFindRefundByIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>(FindRefundByIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindRefundByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>;
export function useFindRefundByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRefundByIdAdminQueryQuery | undefined, FindRefundByIdAdminQueryQueryVariables>;
export function useFindRefundByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>(FindRefundByIdAdminQueryDocument, options);
        }
export type FindRefundByIdAdminQueryQueryHookResult = ReturnType<typeof useFindRefundByIdAdminQueryQuery>;
export type FindRefundByIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindRefundByIdAdminQueryLazyQuery>;
export type FindRefundByIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindRefundByIdAdminQuerySuspenseQuery>;
export type FindRefundByIdAdminQueryQueryResult = Apollo.QueryResult<FindRefundByIdAdminQueryQuery, FindRefundByIdAdminQueryQueryVariables>;
export const RefundOverviewAdminQueryDocument = gql`
    query RefundOverviewAdminQuery($duration: String!) {
  refundOverviewAdmin(duration: $duration) {
    totalRefunds
    pendingRefunds
    totalPendingRefundValue
  }
}
    `;

/**
 * __useRefundOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useRefundOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useRefundOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables> & ({ variables: RefundOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>(RefundOverviewAdminQueryDocument, options);
      }
export function useRefundOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>(RefundOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useRefundOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>;
export function useRefundOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RefundOverviewAdminQueryQuery | undefined, RefundOverviewAdminQueryQueryVariables>;
export function useRefundOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>(RefundOverviewAdminQueryDocument, options);
        }
export type RefundOverviewAdminQueryQueryHookResult = ReturnType<typeof useRefundOverviewAdminQueryQuery>;
export type RefundOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useRefundOverviewAdminQueryLazyQuery>;
export type RefundOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useRefundOverviewAdminQuerySuspenseQuery>;
export type RefundOverviewAdminQueryQueryResult = Apollo.QueryResult<RefundOverviewAdminQueryQuery, RefundOverviewAdminQueryQueryVariables>;
export const CreateWithdrawalAdminMutationDocument = gql`
    mutation CreateWithdrawalAdminMutation($input: CreateWithdrawalInputAdmin!) {
  createWithdrawalAdmin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateWithdrawalAdminMutationMutationFn = Apollo.MutationFunction<CreateWithdrawalAdminMutationMutation, CreateWithdrawalAdminMutationMutationVariables>;

/**
 * __useCreateWithdrawalAdminMutationMutation__
 *
 * To run a mutation, you first call `useCreateWithdrawalAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWithdrawalAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWithdrawalAdminMutationMutation, { data, loading, error }] = useCreateWithdrawalAdminMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWithdrawalAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWithdrawalAdminMutationMutation, CreateWithdrawalAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWithdrawalAdminMutationMutation, CreateWithdrawalAdminMutationMutationVariables>(CreateWithdrawalAdminMutationDocument, options);
      }
export type CreateWithdrawalAdminMutationMutationHookResult = ReturnType<typeof useCreateWithdrawalAdminMutationMutation>;
export type CreateWithdrawalAdminMutationMutationResult = Apollo.MutationResult<CreateWithdrawalAdminMutationMutation>;
export type CreateWithdrawalAdminMutationMutationOptions = Apollo.BaseMutationOptions<CreateWithdrawalAdminMutationMutation, CreateWithdrawalAdminMutationMutationVariables>;
export const FindAllWithdrawalsAdminQueryDocument = gql`
    query FindAllWithdrawalsAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $duration: String) {
  findAllWithdrawalsAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    duration: $duration
  ) {
    withdrawals {
      id
      transaction {
        id
        amount
        status
        wallet {
          id
          flAccountReference
          barterId
          balance
        }
        user {
          id
          admin {
            id
            merchantProfile {
              companyName
              businessName
            }
          }
        }
        status
        currency
      }
      bankPreference {
        id
        bank {
          id
          bank
          bankCode
        }
        accountNo
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllWithdrawalsAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllWithdrawalsAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllWithdrawalsAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllWithdrawalsAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useFindAllWithdrawalsAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables> & ({ variables: FindAllWithdrawalsAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>(FindAllWithdrawalsAdminQueryDocument, options);
      }
export function useFindAllWithdrawalsAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>(FindAllWithdrawalsAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllWithdrawalsAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>;
export function useFindAllWithdrawalsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllWithdrawalsAdminQueryQuery | undefined, FindAllWithdrawalsAdminQueryQueryVariables>;
export function useFindAllWithdrawalsAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>(FindAllWithdrawalsAdminQueryDocument, options);
        }
export type FindAllWithdrawalsAdminQueryQueryHookResult = ReturnType<typeof useFindAllWithdrawalsAdminQueryQuery>;
export type FindAllWithdrawalsAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllWithdrawalsAdminQueryLazyQuery>;
export type FindAllWithdrawalsAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllWithdrawalsAdminQuerySuspenseQuery>;
export type FindAllWithdrawalsAdminQueryQueryResult = Apollo.QueryResult<FindAllWithdrawalsAdminQueryQuery, FindAllWithdrawalsAdminQueryQueryVariables>;
export const FindWithdrawalByIdAdminQueryDocument = gql`
    query FindWithdrawalByIdAdminQuery($id: String!) {
  findWithdrawalByIdAdmin(id: $id) {
    id
    transaction {
      id
      amount
      status
      wallet {
        id
        flAccountReference
        barterId
        balance
      }
      user {
        id
        admin {
          id
          merchantProfile {
            companyName
            businessName
          }
        }
      }
      status
      currency
    }
    bankPreference {
      id
      bank {
        id
        bank
        bankCode
      }
      accountNo
    }
    createdAt
  }
}
    `;

/**
 * __useFindWithdrawalByIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindWithdrawalByIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindWithdrawalByIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindWithdrawalByIdAdminQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindWithdrawalByIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables> & ({ variables: FindWithdrawalByIdAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>(FindWithdrawalByIdAdminQueryDocument, options);
      }
export function useFindWithdrawalByIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>(FindWithdrawalByIdAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindWithdrawalByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>;
export function useFindWithdrawalByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindWithdrawalByIdAdminQueryQuery | undefined, FindWithdrawalByIdAdminQueryQueryVariables>;
export function useFindWithdrawalByIdAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>(FindWithdrawalByIdAdminQueryDocument, options);
        }
export type FindWithdrawalByIdAdminQueryQueryHookResult = ReturnType<typeof useFindWithdrawalByIdAdminQueryQuery>;
export type FindWithdrawalByIdAdminQueryLazyQueryHookResult = ReturnType<typeof useFindWithdrawalByIdAdminQueryLazyQuery>;
export type FindWithdrawalByIdAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindWithdrawalByIdAdminQuerySuspenseQuery>;
export type FindWithdrawalByIdAdminQueryQueryResult = Apollo.QueryResult<FindWithdrawalByIdAdminQueryQuery, FindWithdrawalByIdAdminQueryQueryVariables>;
export const WithdrawalOverviewAdminQueryDocument = gql`
    query WithdrawalOverviewAdminQuery($duration: String!) {
  withdrawalOverviewAdmin(duration: $duration) {
    totalWithdrawals
    pendingWithdrawals
  }
}
    `;

/**
 * __useWithdrawalOverviewAdminQueryQuery__
 *
 * To run a query within a React component, call `useWithdrawalOverviewAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalOverviewAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalOverviewAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useWithdrawalOverviewAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables> & ({ variables: WithdrawalOverviewAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>(WithdrawalOverviewAdminQueryDocument, options);
      }
export function useWithdrawalOverviewAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>(WithdrawalOverviewAdminQueryDocument, options);
        }
// @ts-ignore
export function useWithdrawalOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>;
export function useWithdrawalOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<WithdrawalOverviewAdminQueryQuery | undefined, WithdrawalOverviewAdminQueryQueryVariables>;
export function useWithdrawalOverviewAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>(WithdrawalOverviewAdminQueryDocument, options);
        }
export type WithdrawalOverviewAdminQueryQueryHookResult = ReturnType<typeof useWithdrawalOverviewAdminQueryQuery>;
export type WithdrawalOverviewAdminQueryLazyQueryHookResult = ReturnType<typeof useWithdrawalOverviewAdminQueryLazyQuery>;
export type WithdrawalOverviewAdminQuerySuspenseQueryHookResult = ReturnType<typeof useWithdrawalOverviewAdminQuerySuspenseQuery>;
export type WithdrawalOverviewAdminQueryQueryResult = Apollo.QueryResult<WithdrawalOverviewAdminQueryQuery, WithdrawalOverviewAdminQueryQueryVariables>;
export const CampaignClickThroughsQueryDocument = gql`
    query CampaignClickThroughsQuery($id: String!, $page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  campaignClickThroughs(
    id: $id
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      createdAt
      customer
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useCampaignClickThroughsQueryQuery__
 *
 * To run a query within a React component, call `useCampaignClickThroughsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignClickThroughsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignClickThroughsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCampaignClickThroughsQueryQuery(baseOptions: Apollo.QueryHookOptions<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables> & ({ variables: CampaignClickThroughsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>(CampaignClickThroughsQueryDocument, options);
      }
export function useCampaignClickThroughsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>(CampaignClickThroughsQueryDocument, options);
        }
// @ts-ignore
export function useCampaignClickThroughsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>;
export function useCampaignClickThroughsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignClickThroughsQueryQuery | undefined, CampaignClickThroughsQueryQueryVariables>;
export function useCampaignClickThroughsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>(CampaignClickThroughsQueryDocument, options);
        }
export type CampaignClickThroughsQueryQueryHookResult = ReturnType<typeof useCampaignClickThroughsQueryQuery>;
export type CampaignClickThroughsQueryLazyQueryHookResult = ReturnType<typeof useCampaignClickThroughsQueryLazyQuery>;
export type CampaignClickThroughsQuerySuspenseQueryHookResult = ReturnType<typeof useCampaignClickThroughsQuerySuspenseQuery>;
export type CampaignClickThroughsQueryQueryResult = Apollo.QueryResult<CampaignClickThroughsQueryQuery, CampaignClickThroughsQueryQueryVariables>;
export const CampaignOverviewQueryDocument = gql`
    query CampaignOverviewQuery($duration: String!, $typeFilter: String) {
  campaignOverview(duration: $duration, typeFilter: $typeFilter) {
    totalCampaigns
    totalImpressions
    totalClicks
    activeCampaigns
    expiredCampaigns
  }
}
    `;

/**
 * __useCampaignOverviewQueryQuery__
 *
 * To run a query within a React component, call `useCampaignOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignOverviewQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *      typeFilter: // value for 'typeFilter'
 *   },
 * });
 */
export function useCampaignOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables> & ({ variables: CampaignOverviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>(CampaignOverviewQueryDocument, options);
      }
export function useCampaignOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>(CampaignOverviewQueryDocument, options);
        }
// @ts-ignore
export function useCampaignOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>;
export function useCampaignOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignOverviewQueryQuery | undefined, CampaignOverviewQueryQueryVariables>;
export function useCampaignOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>(CampaignOverviewQueryDocument, options);
        }
export type CampaignOverviewQueryQueryHookResult = ReturnType<typeof useCampaignOverviewQueryQuery>;
export type CampaignOverviewQueryLazyQueryHookResult = ReturnType<typeof useCampaignOverviewQueryLazyQuery>;
export type CampaignOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useCampaignOverviewQuerySuspenseQuery>;
export type CampaignOverviewQueryQueryResult = Apollo.QueryResult<CampaignOverviewQueryQuery, CampaignOverviewQueryQueryVariables>;
export const CampaignSubmissionsQueryDocument = gql`
    query CampaignSubmissionsQuery($id: String!, $page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  campaignSubmissions(
    id: $id
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      createdAt
      customer
      response
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useCampaignSubmissionsQueryQuery__
 *
 * To run a query within a React component, call `useCampaignSubmissionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSubmissionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSubmissionsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useCampaignSubmissionsQueryQuery(baseOptions: Apollo.QueryHookOptions<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables> & ({ variables: CampaignSubmissionsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>(CampaignSubmissionsQueryDocument, options);
      }
export function useCampaignSubmissionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>(CampaignSubmissionsQueryDocument, options);
        }
// @ts-ignore
export function useCampaignSubmissionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>;
export function useCampaignSubmissionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignSubmissionsQueryQuery | undefined, CampaignSubmissionsQueryQueryVariables>;
export function useCampaignSubmissionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>(CampaignSubmissionsQueryDocument, options);
        }
export type CampaignSubmissionsQueryQueryHookResult = ReturnType<typeof useCampaignSubmissionsQueryQuery>;
export type CampaignSubmissionsQueryLazyQueryHookResult = ReturnType<typeof useCampaignSubmissionsQueryLazyQuery>;
export type CampaignSubmissionsQuerySuspenseQueryHookResult = ReturnType<typeof useCampaignSubmissionsQuerySuspenseQuery>;
export type CampaignSubmissionsQueryQueryResult = Apollo.QueryResult<CampaignSubmissionsQueryQuery, CampaignSubmissionsQueryQueryVariables>;
export const CreateCampaignMutationDocument = gql`
    mutation CreateCampaignMutation($title: String, $description: String, $question: String, $active: Boolean!, $bannerUrl: String, $locationId: [String!]!, $communityId: [String!]!, $campaignType: String!, $pollOptions: [String], $campaignLink: String, $startDate: String!, $endDate: String!, $colorCode: String) {
  createCampaign(
    title: $title
    description: $description
    question: $question
    active: $active
    bannerUrl: $bannerUrl
    locationId: $locationId
    communityId: $communityId
    campaignType: $campaignType
    pollOptions: $pollOptions
    campaignLink: $campaignLink
    startDate: $startDate
    endDate: $endDate
    colorCode: $colorCode
  ) {
    errors {
      path
      message
    }
    message
    bannerUrl
  }
}
    `;
export type CreateCampaignMutationMutationFn = Apollo.MutationFunction<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>;

/**
 * __useCreateCampaignMutationMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutationMutation, { data, loading, error }] = useCreateCampaignMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      question: // value for 'question'
 *      active: // value for 'active'
 *      bannerUrl: // value for 'bannerUrl'
 *      locationId: // value for 'locationId'
 *      communityId: // value for 'communityId'
 *      campaignType: // value for 'campaignType'
 *      pollOptions: // value for 'pollOptions'
 *      campaignLink: // value for 'campaignLink'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      colorCode: // value for 'colorCode'
 *   },
 * });
 */
export function useCreateCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>(CreateCampaignMutationDocument, options);
      }
export type CreateCampaignMutationMutationHookResult = ReturnType<typeof useCreateCampaignMutationMutation>;
export type CreateCampaignMutationMutationResult = Apollo.MutationResult<CreateCampaignMutationMutation>;
export type CreateCampaignMutationMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>;
export const DeleteCampaignByIdMutationDocument = gql`
    mutation DeleteCampaignByIdMutation($id: String!) {
  deleteCampaignById(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteCampaignByIdMutationMutationFn = Apollo.MutationFunction<DeleteCampaignByIdMutationMutation, DeleteCampaignByIdMutationMutationVariables>;

/**
 * __useDeleteCampaignByIdMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignByIdMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignByIdMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignByIdMutationMutation, { data, loading, error }] = useDeleteCampaignByIdMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignByIdMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignByIdMutationMutation, DeleteCampaignByIdMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignByIdMutationMutation, DeleteCampaignByIdMutationMutationVariables>(DeleteCampaignByIdMutationDocument, options);
      }
export type DeleteCampaignByIdMutationMutationHookResult = ReturnType<typeof useDeleteCampaignByIdMutationMutation>;
export type DeleteCampaignByIdMutationMutationResult = Apollo.MutationResult<DeleteCampaignByIdMutationMutation>;
export type DeleteCampaignByIdMutationMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignByIdMutationMutation, DeleteCampaignByIdMutationMutationVariables>;
export const FindAllCampaignsQueryDocument = gql`
    query FindAllCampaignsQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $locationFilter: String, $communityFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllCampaigns(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    locationFilter: $locationFilter
    communityFilter: $communityFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      title
      description
      question
      active
      bannerUrl
      location
      community
      campaignType
      pollOptions
      campaignLink
      startDate
      endDate
      colorCode
      views
      clickThrough
      createdAt
      adminName
      adminLevel
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCampaignsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCampaignsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCampaignsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCampaignsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      locationFilter: // value for 'locationFilter'
 *      communityFilter: // value for 'communityFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCampaignsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables> & ({ variables: FindAllCampaignsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>(FindAllCampaignsQueryDocument, options);
      }
export function useFindAllCampaignsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>(FindAllCampaignsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCampaignsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>;
export function useFindAllCampaignsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCampaignsQueryQuery | undefined, FindAllCampaignsQueryQueryVariables>;
export function useFindAllCampaignsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>(FindAllCampaignsQueryDocument, options);
        }
export type FindAllCampaignsQueryQueryHookResult = ReturnType<typeof useFindAllCampaignsQueryQuery>;
export type FindAllCampaignsQueryLazyQueryHookResult = ReturnType<typeof useFindAllCampaignsQueryLazyQuery>;
export type FindAllCampaignsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCampaignsQuerySuspenseQuery>;
export type FindAllCampaignsQueryQueryResult = Apollo.QueryResult<FindAllCampaignsQueryQuery, FindAllCampaignsQueryQueryVariables>;
export const FindCampaignByIdQueryDocument = gql`
    query FindCampaignByIdQuery($id: String!) {
  findCampaignById(id: $id) {
    id
    title
    description
    question
    active
    bannerUrl
    location
    community
    campaignType
    pollOptions
    campaignLink
    startDate
    endDate
    colorCode
    views
    clickThrough
    createdAt
    adminName
    adminLevel
  }
}
    `;

/**
 * __useFindCampaignByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindCampaignByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCampaignByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCampaignByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCampaignByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables> & ({ variables: FindCampaignByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>(FindCampaignByIdQueryDocument, options);
      }
export function useFindCampaignByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>(FindCampaignByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindCampaignByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>;
export function useFindCampaignByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindCampaignByIdQueryQuery | undefined, FindCampaignByIdQueryQueryVariables>;
export function useFindCampaignByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>(FindCampaignByIdQueryDocument, options);
        }
export type FindCampaignByIdQueryQueryHookResult = ReturnType<typeof useFindCampaignByIdQueryQuery>;
export type FindCampaignByIdQueryLazyQueryHookResult = ReturnType<typeof useFindCampaignByIdQueryLazyQuery>;
export type FindCampaignByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindCampaignByIdQuerySuspenseQuery>;
export type FindCampaignByIdQueryQueryResult = Apollo.QueryResult<FindCampaignByIdQueryQuery, FindCampaignByIdQueryQueryVariables>;
export const FindCommunitiesFromCampaignsDocument = gql`
    query FindCommunitiesFromCampaigns {
  findCommunitiesFromCampaigns {
    id
    name
    alias
  }
}
    `;

/**
 * __useFindCommunitiesFromCampaignsQuery__
 *
 * To run a query within a React component, call `useFindCommunitiesFromCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommunitiesFromCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommunitiesFromCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindCommunitiesFromCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>(FindCommunitiesFromCampaignsDocument, options);
      }
export function useFindCommunitiesFromCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>(FindCommunitiesFromCampaignsDocument, options);
        }
// @ts-ignore
export function useFindCommunitiesFromCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>;
export function useFindCommunitiesFromCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<FindCommunitiesFromCampaignsQuery | undefined, FindCommunitiesFromCampaignsQueryVariables>;
export function useFindCommunitiesFromCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>(FindCommunitiesFromCampaignsDocument, options);
        }
export type FindCommunitiesFromCampaignsQueryHookResult = ReturnType<typeof useFindCommunitiesFromCampaignsQuery>;
export type FindCommunitiesFromCampaignsLazyQueryHookResult = ReturnType<typeof useFindCommunitiesFromCampaignsLazyQuery>;
export type FindCommunitiesFromCampaignsSuspenseQueryHookResult = ReturnType<typeof useFindCommunitiesFromCampaignsSuspenseQuery>;
export type FindCommunitiesFromCampaignsQueryResult = Apollo.QueryResult<FindCommunitiesFromCampaignsQuery, FindCommunitiesFromCampaignsQueryVariables>;
export const NewCampaignSubscriptionDocument = gql`
    subscription NewCampaignSubscription {
  newCampaign {
    id
    title
    location
    community
  }
}
    `;

/**
 * __useNewCampaignSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewCampaignSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCampaignSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCampaignSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewCampaignSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewCampaignSubscriptionSubscription, NewCampaignSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCampaignSubscriptionSubscription, NewCampaignSubscriptionSubscriptionVariables>(NewCampaignSubscriptionDocument, options);
      }
export type NewCampaignSubscriptionSubscriptionHookResult = ReturnType<typeof useNewCampaignSubscriptionSubscription>;
export type NewCampaignSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewCampaignSubscriptionSubscription>;
export const FindLocationsFromCampaignsDocument = gql`
    query FindLocationsFromCampaigns {
  findLocationsFromCampaigns {
    id
    city
  }
}
    `;

/**
 * __useFindLocationsFromCampaignsQuery__
 *
 * To run a query within a React component, call `useFindLocationsFromCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLocationsFromCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLocationsFromCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindLocationsFromCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>(FindLocationsFromCampaignsDocument, options);
      }
export function useFindLocationsFromCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>(FindLocationsFromCampaignsDocument, options);
        }
// @ts-ignore
export function useFindLocationsFromCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>;
export function useFindLocationsFromCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>): Apollo.UseSuspenseQueryResult<FindLocationsFromCampaignsQuery | undefined, FindLocationsFromCampaignsQueryVariables>;
export function useFindLocationsFromCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>(FindLocationsFromCampaignsDocument, options);
        }
export type FindLocationsFromCampaignsQueryHookResult = ReturnType<typeof useFindLocationsFromCampaignsQuery>;
export type FindLocationsFromCampaignsLazyQueryHookResult = ReturnType<typeof useFindLocationsFromCampaignsLazyQuery>;
export type FindLocationsFromCampaignsSuspenseQueryHookResult = ReturnType<typeof useFindLocationsFromCampaignsSuspenseQuery>;
export type FindLocationsFromCampaignsQueryResult = Apollo.QueryResult<FindLocationsFromCampaignsQuery, FindLocationsFromCampaignsQueryVariables>;
export const GetCampaignQueryDocument = gql`
    query GetCampaignQuery {
  getCampaign {
    id
    title
    description
    question
    bannerUrl
    campaignType
    pollOptions
    location
    community
    campaignLink
    colorCode
  }
}
    `;

/**
 * __useGetCampaignQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>(GetCampaignQueryDocument, options);
      }
export function useGetCampaignQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>(GetCampaignQueryDocument, options);
        }
// @ts-ignore
export function useGetCampaignQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>;
export function useGetCampaignQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCampaignQueryQuery | undefined, GetCampaignQueryQueryVariables>;
export function useGetCampaignQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>(GetCampaignQueryDocument, options);
        }
export type GetCampaignQueryQueryHookResult = ReturnType<typeof useGetCampaignQueryQuery>;
export type GetCampaignQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignQueryLazyQuery>;
export type GetCampaignQuerySuspenseQueryHookResult = ReturnType<typeof useGetCampaignQuerySuspenseQuery>;
export type GetCampaignQueryQueryResult = Apollo.QueryResult<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>;
export const MarkCampaignMutationDocument = gql`
    mutation MarkCampaignMutation($id: String!, $option: String, $close: Boolean) {
  markCampaign(id: $id, option: $option, close: $close) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type MarkCampaignMutationMutationFn = Apollo.MutationFunction<MarkCampaignMutationMutation, MarkCampaignMutationMutationVariables>;

/**
 * __useMarkCampaignMutationMutation__
 *
 * To run a mutation, you first call `useMarkCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCampaignMutationMutation, { data, loading, error }] = useMarkCampaignMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *      close: // value for 'close'
 *   },
 * });
 */
export function useMarkCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarkCampaignMutationMutation, MarkCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCampaignMutationMutation, MarkCampaignMutationMutationVariables>(MarkCampaignMutationDocument, options);
      }
export type MarkCampaignMutationMutationHookResult = ReturnType<typeof useMarkCampaignMutationMutation>;
export type MarkCampaignMutationMutationResult = Apollo.MutationResult<MarkCampaignMutationMutation>;
export type MarkCampaignMutationMutationOptions = Apollo.BaseMutationOptions<MarkCampaignMutationMutation, MarkCampaignMutationMutationVariables>;
export const UpdateCampaignMutationDocument = gql`
    mutation UpdateCampaignMutation($campaignId: String!, $input: UpdateCampaignInput!) {
  updateCampaign(campaignId: $campaignId, input: $input) {
    errors {
      path
      message
    }
    message
    bannerUrl
  }
}
    `;
export type UpdateCampaignMutationMutationFn = Apollo.MutationFunction<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>;

/**
 * __useUpdateCampaignMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutationMutation, { data, loading, error }] = useUpdateCampaignMutationMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>(UpdateCampaignMutationDocument, options);
      }
export type UpdateCampaignMutationMutationHookResult = ReturnType<typeof useUpdateCampaignMutationMutation>;
export type UpdateCampaignMutationMutationResult = Apollo.MutationResult<UpdateCampaignMutationMutation>;
export type UpdateCampaignMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>;
export const FindPlatformContactsQueryDocument = gql`
    query FindPlatformContactsQuery {
  findPlatformContacts {
    id
    facebook
    x
    linkedin
    instagram
    logoUrl
    email
    website
    address
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useFindPlatformContactsQueryQuery__
 *
 * To run a query within a React component, call `useFindPlatformContactsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPlatformContactsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlatformContactsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindPlatformContactsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>(FindPlatformContactsQueryDocument, options);
      }
export function useFindPlatformContactsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>(FindPlatformContactsQueryDocument, options);
        }
// @ts-ignore
export function useFindPlatformContactsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>;
export function useFindPlatformContactsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindPlatformContactsQueryQuery | undefined, FindPlatformContactsQueryQueryVariables>;
export function useFindPlatformContactsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>(FindPlatformContactsQueryDocument, options);
        }
export type FindPlatformContactsQueryQueryHookResult = ReturnType<typeof useFindPlatformContactsQueryQuery>;
export type FindPlatformContactsQueryLazyQueryHookResult = ReturnType<typeof useFindPlatformContactsQueryLazyQuery>;
export type FindPlatformContactsQuerySuspenseQueryHookResult = ReturnType<typeof useFindPlatformContactsQuerySuspenseQuery>;
export type FindPlatformContactsQueryQueryResult = Apollo.QueryResult<FindPlatformContactsQueryQuery, FindPlatformContactsQueryQueryVariables>;
export const NewPlatformContactSubscriptionDocument = gql`
    subscription NewPlatformContactSubscription {
  newPlatformContact {
    id
    facebook
    x
    linkedin
    instagram
    logoUrl
    email
    website
    address
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useNewPlatformContactSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewPlatformContactSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewPlatformContactSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewPlatformContactSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewPlatformContactSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewPlatformContactSubscriptionSubscription, NewPlatformContactSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewPlatformContactSubscriptionSubscription, NewPlatformContactSubscriptionSubscriptionVariables>(NewPlatformContactSubscriptionDocument, options);
      }
export type NewPlatformContactSubscriptionSubscriptionHookResult = ReturnType<typeof useNewPlatformContactSubscriptionSubscription>;
export type NewPlatformContactSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewPlatformContactSubscriptionSubscription>;
export const UpdatePlatformContactMutationDocument = gql`
    mutation UpdatePlatformContactMutation($id: String!, $input: UpdatePlatformContactInput!) {
  updatePlatformContact(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
    logoUrl
  }
}
    `;
export type UpdatePlatformContactMutationMutationFn = Apollo.MutationFunction<UpdatePlatformContactMutationMutation, UpdatePlatformContactMutationMutationVariables>;

/**
 * __useUpdatePlatformContactMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformContactMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformContactMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformContactMutationMutation, { data, loading, error }] = useUpdatePlatformContactMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformContactMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformContactMutationMutation, UpdatePlatformContactMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformContactMutationMutation, UpdatePlatformContactMutationMutationVariables>(UpdatePlatformContactMutationDocument, options);
      }
export type UpdatePlatformContactMutationMutationHookResult = ReturnType<typeof useUpdatePlatformContactMutationMutation>;
export type UpdatePlatformContactMutationMutationResult = Apollo.MutationResult<UpdatePlatformContactMutationMutation>;
export type UpdatePlatformContactMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformContactMutationMutation, UpdatePlatformContactMutationMutationVariables>;
export const ViewPlatformContactQueryDocument = gql`
    query ViewPlatformContactQuery($id: String!) {
  viewPlatformContact(id: $id) {
    id
    facebook
    x
    linkedin
    instagram
    logoUrl
    email
    website
    address
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useViewPlatformContactQueryQuery__
 *
 * To run a query within a React component, call `useViewPlatformContactQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPlatformContactQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPlatformContactQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewPlatformContactQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables> & ({ variables: ViewPlatformContactQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>(ViewPlatformContactQueryDocument, options);
      }
export function useViewPlatformContactQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>(ViewPlatformContactQueryDocument, options);
        }
// @ts-ignore
export function useViewPlatformContactQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>;
export function useViewPlatformContactQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewPlatformContactQueryQuery | undefined, ViewPlatformContactQueryQueryVariables>;
export function useViewPlatformContactQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>(ViewPlatformContactQueryDocument, options);
        }
export type ViewPlatformContactQueryQueryHookResult = ReturnType<typeof useViewPlatformContactQueryQuery>;
export type ViewPlatformContactQueryLazyQueryHookResult = ReturnType<typeof useViewPlatformContactQueryLazyQuery>;
export type ViewPlatformContactQuerySuspenseQueryHookResult = ReturnType<typeof useViewPlatformContactQuerySuspenseQuery>;
export type ViewPlatformContactQueryQueryResult = Apollo.QueryResult<ViewPlatformContactQueryQuery, ViewPlatformContactQueryQueryVariables>;
export const CreateRepContactMutationDocument = gql`
    mutation CreateRepContactMutation($adminId: String!, $role: String!) {
  createRepContact(adminId: $adminId, role: $role) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateRepContactMutationMutationFn = Apollo.MutationFunction<CreateRepContactMutationMutation, CreateRepContactMutationMutationVariables>;

/**
 * __useCreateRepContactMutationMutation__
 *
 * To run a mutation, you first call `useCreateRepContactMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRepContactMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRepContactMutationMutation, { data, loading, error }] = useCreateRepContactMutationMutation({
 *   variables: {
 *      adminId: // value for 'adminId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateRepContactMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRepContactMutationMutation, CreateRepContactMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRepContactMutationMutation, CreateRepContactMutationMutationVariables>(CreateRepContactMutationDocument, options);
      }
export type CreateRepContactMutationMutationHookResult = ReturnType<typeof useCreateRepContactMutationMutation>;
export type CreateRepContactMutationMutationResult = Apollo.MutationResult<CreateRepContactMutationMutation>;
export type CreateRepContactMutationMutationOptions = Apollo.BaseMutationOptions<CreateRepContactMutationMutation, CreateRepContactMutationMutationVariables>;
export const DeleteRepContactMutationDocument = gql`
    mutation DeleteRepContactMutation($id: String!) {
  deleteRepContact(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteRepContactMutationMutationFn = Apollo.MutationFunction<DeleteRepContactMutationMutation, DeleteRepContactMutationMutationVariables>;

/**
 * __useDeleteRepContactMutationMutation__
 *
 * To run a mutation, you first call `useDeleteRepContactMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRepContactMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRepContactMutationMutation, { data, loading, error }] = useDeleteRepContactMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRepContactMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRepContactMutationMutation, DeleteRepContactMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRepContactMutationMutation, DeleteRepContactMutationMutationVariables>(DeleteRepContactMutationDocument, options);
      }
export type DeleteRepContactMutationMutationHookResult = ReturnType<typeof useDeleteRepContactMutationMutation>;
export type DeleteRepContactMutationMutationResult = Apollo.MutationResult<DeleteRepContactMutationMutation>;
export type DeleteRepContactMutationMutationOptions = Apollo.BaseMutationOptions<DeleteRepContactMutationMutation, DeleteRepContactMutationMutationVariables>;
export const FindRepContactsQueryDocument = gql`
    query FindRepContactsQuery {
  findRepContacts {
    id
    role
    admin {
      id
      firstname
      lastname
      email
      phone
      createdAt
      updatedAt
    }
    user {
      id
      admin {
        firstname
        lastname
        email
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindRepContactsQueryQuery__
 *
 * To run a query within a React component, call `useFindRepContactsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRepContactsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRepContactsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindRepContactsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>(FindRepContactsQueryDocument, options);
      }
export function useFindRepContactsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>(FindRepContactsQueryDocument, options);
        }
// @ts-ignore
export function useFindRepContactsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>;
export function useFindRepContactsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRepContactsQueryQuery | undefined, FindRepContactsQueryQueryVariables>;
export function useFindRepContactsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>(FindRepContactsQueryDocument, options);
        }
export type FindRepContactsQueryQueryHookResult = ReturnType<typeof useFindRepContactsQueryQuery>;
export type FindRepContactsQueryLazyQueryHookResult = ReturnType<typeof useFindRepContactsQueryLazyQuery>;
export type FindRepContactsQuerySuspenseQueryHookResult = ReturnType<typeof useFindRepContactsQuerySuspenseQuery>;
export type FindRepContactsQueryQueryResult = Apollo.QueryResult<FindRepContactsQueryQuery, FindRepContactsQueryQueryVariables>;
export const NewRepContactSubscriptionDocument = gql`
    subscription NewRepContactSubscription {
  newRepContact {
    id
    role
    admin {
      id
      firstname
      lastname
      email
      phone
      createdAt
      updatedAt
    }
    user {
      id
      admin {
        firstname
        lastname
        email
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewRepContactSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewRepContactSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewRepContactSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewRepContactSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewRepContactSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewRepContactSubscriptionSubscription, NewRepContactSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewRepContactSubscriptionSubscription, NewRepContactSubscriptionSubscriptionVariables>(NewRepContactSubscriptionDocument, options);
      }
export type NewRepContactSubscriptionSubscriptionHookResult = ReturnType<typeof useNewRepContactSubscriptionSubscription>;
export type NewRepContactSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewRepContactSubscriptionSubscription>;
export const UpdateRepContactMutationDocument = gql`
    mutation UpdateRepContactMutation($id: String!, $input: UpdateRepContactInput!) {
  updateRepContact(id: $id, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateRepContactMutationMutationFn = Apollo.MutationFunction<UpdateRepContactMutationMutation, UpdateRepContactMutationMutationVariables>;

/**
 * __useUpdateRepContactMutationMutation__
 *
 * To run a mutation, you first call `useUpdateRepContactMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRepContactMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRepContactMutationMutation, { data, loading, error }] = useUpdateRepContactMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRepContactMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRepContactMutationMutation, UpdateRepContactMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRepContactMutationMutation, UpdateRepContactMutationMutationVariables>(UpdateRepContactMutationDocument, options);
      }
export type UpdateRepContactMutationMutationHookResult = ReturnType<typeof useUpdateRepContactMutationMutation>;
export type UpdateRepContactMutationMutationResult = Apollo.MutationResult<UpdateRepContactMutationMutation>;
export type UpdateRepContactMutationMutationOptions = Apollo.BaseMutationOptions<UpdateRepContactMutationMutation, UpdateRepContactMutationMutationVariables>;
export const ViewRepContactQueryDocument = gql`
    query ViewRepContactQuery($id: String!) {
  viewRepContact(id: $id) {
    id
    role
    admin {
      id
      firstname
      lastname
      email
      phone
      createdAt
      updatedAt
    }
    user {
      id
      admin {
        firstname
        lastname
        email
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewRepContactQueryQuery__
 *
 * To run a query within a React component, call `useViewRepContactQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewRepContactQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewRepContactQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewRepContactQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables> & ({ variables: ViewRepContactQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>(ViewRepContactQueryDocument, options);
      }
export function useViewRepContactQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>(ViewRepContactQueryDocument, options);
        }
// @ts-ignore
export function useViewRepContactQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>;
export function useViewRepContactQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewRepContactQueryQuery | undefined, ViewRepContactQueryQueryVariables>;
export function useViewRepContactQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>(ViewRepContactQueryDocument, options);
        }
export type ViewRepContactQueryQueryHookResult = ReturnType<typeof useViewRepContactQueryQuery>;
export type ViewRepContactQueryLazyQueryHookResult = ReturnType<typeof useViewRepContactQueryLazyQuery>;
export type ViewRepContactQuerySuspenseQueryHookResult = ReturnType<typeof useViewRepContactQuerySuspenseQuery>;
export type ViewRepContactQueryQueryResult = Apollo.QueryResult<ViewRepContactQueryQuery, ViewRepContactQueryQueryVariables>;
export const FindAdminAdminsQueryDocument = gql`
    query FindAdminAdminsQuery {
  findAdminAdmins {
    id
    firstname
    lastname
    email
    phone
    shortId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindAdminAdminsQueryQuery__
 *
 * To run a query within a React component, call `useFindAdminAdminsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAdminAdminsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAdminAdminsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAdminAdminsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>(FindAdminAdminsQueryDocument, options);
      }
export function useFindAdminAdminsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>(FindAdminAdminsQueryDocument, options);
        }
// @ts-ignore
export function useFindAdminAdminsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>;
export function useFindAdminAdminsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminAdminsQueryQuery | undefined, FindAdminAdminsQueryQueryVariables>;
export function useFindAdminAdminsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>(FindAdminAdminsQueryDocument, options);
        }
export type FindAdminAdminsQueryQueryHookResult = ReturnType<typeof useFindAdminAdminsQueryQuery>;
export type FindAdminAdminsQueryLazyQueryHookResult = ReturnType<typeof useFindAdminAdminsQueryLazyQuery>;
export type FindAdminAdminsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAdminAdminsQuerySuspenseQuery>;
export type FindAdminAdminsQueryQueryResult = Apollo.QueryResult<FindAdminAdminsQueryQuery, FindAdminAdminsQueryQueryVariables>;
export const FindAdminMerchantsQueryDocument = gql`
    query FindAdminMerchantsQuery {
  findAdminMerchants {
    id
    businessName
    businessType
    businessRegNumber
    companyName
    username
    logoUrl
    createdAt
    adminId
    userId
  }
}
    `;

/**
 * __useFindAdminMerchantsQueryQuery__
 *
 * To run a query within a React component, call `useFindAdminMerchantsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAdminMerchantsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAdminMerchantsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAdminMerchantsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>(FindAdminMerchantsQueryDocument, options);
      }
export function useFindAdminMerchantsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>(FindAdminMerchantsQueryDocument, options);
        }
// @ts-ignore
export function useFindAdminMerchantsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>;
export function useFindAdminMerchantsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminMerchantsQueryQuery | undefined, FindAdminMerchantsQueryQueryVariables>;
export function useFindAdminMerchantsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>(FindAdminMerchantsQueryDocument, options);
        }
export type FindAdminMerchantsQueryQueryHookResult = ReturnType<typeof useFindAdminMerchantsQueryQuery>;
export type FindAdminMerchantsQueryLazyQueryHookResult = ReturnType<typeof useFindAdminMerchantsQueryLazyQuery>;
export type FindAdminMerchantsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAdminMerchantsQuerySuspenseQuery>;
export type FindAdminMerchantsQueryQueryResult = Apollo.QueryResult<FindAdminMerchantsQueryQuery, FindAdminMerchantsQueryQueryVariables>;
export const FindAllInterestsQueryDocument = gql`
    query FindAllInterestsQuery($page: Int!, $pageSize: Int!, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllInterests(
    page: $page
    pageSize: $pageSize
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      partner
      numberOfCustomers
      totalReceived
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllInterestsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllInterestsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllInterestsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllInterestsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllInterestsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables> & ({ variables: FindAllInterestsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>(FindAllInterestsQueryDocument, options);
      }
export function useFindAllInterestsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>(FindAllInterestsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllInterestsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>;
export function useFindAllInterestsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllInterestsQueryQuery | undefined, FindAllInterestsQueryQueryVariables>;
export function useFindAllInterestsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>(FindAllInterestsQueryDocument, options);
        }
export type FindAllInterestsQueryQueryHookResult = ReturnType<typeof useFindAllInterestsQueryQuery>;
export type FindAllInterestsQueryLazyQueryHookResult = ReturnType<typeof useFindAllInterestsQueryLazyQuery>;
export type FindAllInterestsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllInterestsQuerySuspenseQuery>;
export type FindAllInterestsQueryQueryResult = Apollo.QueryResult<FindAllInterestsQueryQuery, FindAllInterestsQueryQueryVariables>;
export const FindMerchantInterestsQueryDocument = gql`
    query FindMerchantInterestsQuery($page: Int!, $pageSize: Int!, $id: String!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findMerchantInterests(
    page: $page
    pageSize: $pageSize
    id: $id
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    companyName
    username
    shortId
    totalInterests
    data {
      customerName
      customerUsername
      location
      totalSpend
      community {
        id
        name
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindMerchantInterestsQueryQuery__
 *
 * To run a query within a React component, call `useFindMerchantInterestsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMerchantInterestsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMerchantInterestsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      id: // value for 'id'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindMerchantInterestsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables> & ({ variables: FindMerchantInterestsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>(FindMerchantInterestsQueryDocument, options);
      }
export function useFindMerchantInterestsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>(FindMerchantInterestsQueryDocument, options);
        }
// @ts-ignore
export function useFindMerchantInterestsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>;
export function useFindMerchantInterestsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantInterestsQueryQuery | undefined, FindMerchantInterestsQueryQueryVariables>;
export function useFindMerchantInterestsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>(FindMerchantInterestsQueryDocument, options);
        }
export type FindMerchantInterestsQueryQueryHookResult = ReturnType<typeof useFindMerchantInterestsQueryQuery>;
export type FindMerchantInterestsQueryLazyQueryHookResult = ReturnType<typeof useFindMerchantInterestsQueryLazyQuery>;
export type FindMerchantInterestsQuerySuspenseQueryHookResult = ReturnType<typeof useFindMerchantInterestsQuerySuspenseQuery>;
export type FindMerchantInterestsQueryQueryResult = Apollo.QueryResult<FindMerchantInterestsQueryQuery, FindMerchantInterestsQueryQueryVariables>;
export const InterestOverviewQueryDocument = gql`
    query InterestOverviewQuery($duration: String!) {
  interestOverview(duration: $duration) {
    partnersWithInterest
    customersWithInterest
  }
}
    `;

/**
 * __useInterestOverviewQueryQuery__
 *
 * To run a query within a React component, call `useInterestOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterestOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterestOverviewQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useInterestOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables> & ({ variables: InterestOverviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>(InterestOverviewQueryDocument, options);
      }
export function useInterestOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>(InterestOverviewQueryDocument, options);
        }
// @ts-ignore
export function useInterestOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>;
export function useInterestOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<InterestOverviewQueryQuery | undefined, InterestOverviewQueryQueryVariables>;
export function useInterestOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>(InterestOverviewQueryDocument, options);
        }
export type InterestOverviewQueryQueryHookResult = ReturnType<typeof useInterestOverviewQueryQuery>;
export type InterestOverviewQueryLazyQueryHookResult = ReturnType<typeof useInterestOverviewQueryLazyQuery>;
export type InterestOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useInterestOverviewQuerySuspenseQuery>;
export type InterestOverviewQueryQueryResult = Apollo.QueryResult<InterestOverviewQueryQuery, InterestOverviewQueryQueryVariables>;
export const CustomersOverviewOnboardingAdminQueryDocument = gql`
    query CustomersOverviewOnboardingAdminQuery($duration: String!) {
  customersOverviewOnboardingAdmin(duration: $duration) {
    accountsCreated
    accountsVerified
    onboarded
    idsConnected
  }
}
    `;

/**
 * __useCustomersOverviewOnboardingAdminQueryQuery__
 *
 * To run a query within a React component, call `useCustomersOverviewOnboardingAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersOverviewOnboardingAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersOverviewOnboardingAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCustomersOverviewOnboardingAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables> & ({ variables: CustomersOverviewOnboardingAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>(CustomersOverviewOnboardingAdminQueryDocument, options);
      }
export function useCustomersOverviewOnboardingAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>(CustomersOverviewOnboardingAdminQueryDocument, options);
        }
// @ts-ignore
export function useCustomersOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>;
export function useCustomersOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomersOverviewOnboardingAdminQueryQuery | undefined, CustomersOverviewOnboardingAdminQueryQueryVariables>;
export function useCustomersOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>(CustomersOverviewOnboardingAdminQueryDocument, options);
        }
export type CustomersOverviewOnboardingAdminQueryQueryHookResult = ReturnType<typeof useCustomersOverviewOnboardingAdminQueryQuery>;
export type CustomersOverviewOnboardingAdminQueryLazyQueryHookResult = ReturnType<typeof useCustomersOverviewOnboardingAdminQueryLazyQuery>;
export type CustomersOverviewOnboardingAdminQuerySuspenseQueryHookResult = ReturnType<typeof useCustomersOverviewOnboardingAdminQuerySuspenseQuery>;
export type CustomersOverviewOnboardingAdminQueryQueryResult = Apollo.QueryResult<CustomersOverviewOnboardingAdminQueryQuery, CustomersOverviewOnboardingAdminQueryQueryVariables>;
export const FindAllCustomersOnboardingAdminQueryDocument = gql`
    query FindAllCustomersOnboardingAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllCustomersOnboardingAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      firstname
      lastname
      stage
      status
      email
      phone
      createdAt
      updatedAt
      referrer {
        userId
        id
        firstname
        lastname
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCustomersOnboardingAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCustomersOnboardingAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomersOnboardingAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomersOnboardingAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCustomersOnboardingAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables> & ({ variables: FindAllCustomersOnboardingAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>(FindAllCustomersOnboardingAdminQueryDocument, options);
      }
export function useFindAllCustomersOnboardingAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>(FindAllCustomersOnboardingAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCustomersOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>;
export function useFindAllCustomersOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersOnboardingAdminQueryQuery | undefined, FindAllCustomersOnboardingAdminQueryQueryVariables>;
export function useFindAllCustomersOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>(FindAllCustomersOnboardingAdminQueryDocument, options);
        }
export type FindAllCustomersOnboardingAdminQueryQueryHookResult = ReturnType<typeof useFindAllCustomersOnboardingAdminQueryQuery>;
export type FindAllCustomersOnboardingAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllCustomersOnboardingAdminQueryLazyQuery>;
export type FindAllCustomersOnboardingAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCustomersOnboardingAdminQuerySuspenseQuery>;
export type FindAllCustomersOnboardingAdminQueryQueryResult = Apollo.QueryResult<FindAllCustomersOnboardingAdminQueryQuery, FindAllCustomersOnboardingAdminQueryQueryVariables>;
export const FindAllMerchantsOnboardingAdminQueryDocument = gql`
    query FindAllMerchantsOnboardingAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllMerchantsOnboardingAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      adminId
      merchantId
      firstname
      lastname
      companyName
      currentStep
      status
      isVerified
      websiteOrSocials
      email
      phone
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllMerchantsOnboardingAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllMerchantsOnboardingAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMerchantsOnboardingAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMerchantsOnboardingAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllMerchantsOnboardingAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables> & ({ variables: FindAllMerchantsOnboardingAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>(FindAllMerchantsOnboardingAdminQueryDocument, options);
      }
export function useFindAllMerchantsOnboardingAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>(FindAllMerchantsOnboardingAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllMerchantsOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>;
export function useFindAllMerchantsOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMerchantsOnboardingAdminQueryQuery | undefined, FindAllMerchantsOnboardingAdminQueryQueryVariables>;
export function useFindAllMerchantsOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>(FindAllMerchantsOnboardingAdminQueryDocument, options);
        }
export type FindAllMerchantsOnboardingAdminQueryQueryHookResult = ReturnType<typeof useFindAllMerchantsOnboardingAdminQueryQuery>;
export type FindAllMerchantsOnboardingAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllMerchantsOnboardingAdminQueryLazyQuery>;
export type FindAllMerchantsOnboardingAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllMerchantsOnboardingAdminQuerySuspenseQuery>;
export type FindAllMerchantsOnboardingAdminQueryQueryResult = Apollo.QueryResult<FindAllMerchantsOnboardingAdminQueryQuery, FindAllMerchantsOnboardingAdminQueryQueryVariables>;
export const MerchantsOverviewOnboardingAdminQueryDocument = gql`
    query MerchantsOverviewOnboardingAdminQuery($duration: String!) {
  merchantsOverviewOnboardingAdmin(duration: $duration) {
    accountsCreated
    accountsVerified
    onboarded1
    onboarded2
  }
}
    `;

/**
 * __useMerchantsOverviewOnboardingAdminQueryQuery__
 *
 * To run a query within a React component, call `useMerchantsOverviewOnboardingAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsOverviewOnboardingAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsOverviewOnboardingAdminQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useMerchantsOverviewOnboardingAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables> & ({ variables: MerchantsOverviewOnboardingAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>(MerchantsOverviewOnboardingAdminQueryDocument, options);
      }
export function useMerchantsOverviewOnboardingAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>(MerchantsOverviewOnboardingAdminQueryDocument, options);
        }
// @ts-ignore
export function useMerchantsOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>;
export function useMerchantsOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsOverviewOnboardingAdminQueryQuery | undefined, MerchantsOverviewOnboardingAdminQueryQueryVariables>;
export function useMerchantsOverviewOnboardingAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>(MerchantsOverviewOnboardingAdminQueryDocument, options);
        }
export type MerchantsOverviewOnboardingAdminQueryQueryHookResult = ReturnType<typeof useMerchantsOverviewOnboardingAdminQueryQuery>;
export type MerchantsOverviewOnboardingAdminQueryLazyQueryHookResult = ReturnType<typeof useMerchantsOverviewOnboardingAdminQueryLazyQuery>;
export type MerchantsOverviewOnboardingAdminQuerySuspenseQueryHookResult = ReturnType<typeof useMerchantsOverviewOnboardingAdminQuerySuspenseQuery>;
export type MerchantsOverviewOnboardingAdminQueryQueryResult = Apollo.QueryResult<MerchantsOverviewOnboardingAdminQueryQuery, MerchantsOverviewOnboardingAdminQueryQueryVariables>;
export const TenantsQueryDocument = gql`
    query TenantsQuery {
  tenants {
    id
    name
    slug
    status
    isDefault
  }
}
    `;

/**
 * __useTenantsQueryQuery__
 *
 * To run a query within a React component, call `useTenantsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantsQueryQuery(baseOptions?: Apollo.QueryHookOptions<TenantsQueryQuery, TenantsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantsQueryQuery, TenantsQueryQueryVariables>(TenantsQueryDocument, options);
      }
export function useTenantsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantsQueryQuery, TenantsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantsQueryQuery, TenantsQueryQueryVariables>(TenantsQueryDocument, options);
        }
// @ts-ignore
export function useTenantsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenantsQueryQuery, TenantsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<TenantsQueryQuery, TenantsQueryQueryVariables>;
export function useTenantsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TenantsQueryQuery, TenantsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<TenantsQueryQuery | undefined, TenantsQueryQueryVariables>;
export function useTenantsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TenantsQueryQuery, TenantsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenantsQueryQuery, TenantsQueryQueryVariables>(TenantsQueryDocument, options);
        }
export type TenantsQueryQueryHookResult = ReturnType<typeof useTenantsQueryQuery>;
export type TenantsQueryLazyQueryHookResult = ReturnType<typeof useTenantsQueryLazyQuery>;
export type TenantsQuerySuspenseQueryHookResult = ReturnType<typeof useTenantsQuerySuspenseQuery>;
export type TenantsQueryQueryResult = Apollo.QueryResult<TenantsQueryQuery, TenantsQueryQueryVariables>;
export const FindAllTransactionsAdminDocument = gql`
    query FindAllTransactionsAdmin($page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $duration: String, $sortBy: String, $sortOrder: String) {
  findAllTransactionsAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    duration: $duration
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      wallet {
        id
        balance
        owner {
          id
          customer {
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      recipientWallet {
        id
        balance
        currency
        owner {
          admin {
            merchantProfile {
              companyName
            }
          }
        }
        createdAt
        updatedAt
      }
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community {
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy {
          id
          role
          admin {
            id
            shortId
            firstname
            lastname
            email
            phone
            merchantProfile {
              id
              businessName
              businessType
              regCountry
              businessRegNumber
              taxId
              address
              addressAlt
              city
              country
              postcode
              companyName
              username
              industry {
                id
                name
                createdBy {
                  id
                  role
                }
                createdAt
                updatedAt
              }
              companyLocation
              logoUrl
              bannerUrl
              description
              commissionRate
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
        customer {
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllTransactionsAdminQuery__
 *
 * To run a query within a React component, call `useFindAllTransactionsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTransactionsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTransactionsAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllTransactionsAdminQuery(baseOptions: Apollo.QueryHookOptions<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables> & ({ variables: FindAllTransactionsAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>(FindAllTransactionsAdminDocument, options);
      }
export function useFindAllTransactionsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>(FindAllTransactionsAdminDocument, options);
        }
// @ts-ignore
export function useFindAllTransactionsAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>;
export function useFindAllTransactionsAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllTransactionsAdminQuery | undefined, FindAllTransactionsAdminQueryVariables>;
export function useFindAllTransactionsAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>(FindAllTransactionsAdminDocument, options);
        }
export type FindAllTransactionsAdminQueryHookResult = ReturnType<typeof useFindAllTransactionsAdminQuery>;
export type FindAllTransactionsAdminLazyQueryHookResult = ReturnType<typeof useFindAllTransactionsAdminLazyQuery>;
export type FindAllTransactionsAdminSuspenseQueryHookResult = ReturnType<typeof useFindAllTransactionsAdminSuspenseQuery>;
export type FindAllTransactionsAdminQueryResult = Apollo.QueryResult<FindAllTransactionsAdminQuery, FindAllTransactionsAdminQueryVariables>;
export const FindTransactionsByUserIdAdminDocument = gql`
    query FindTransactionsByUserIdAdmin($userId: String!, $page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findTransactionsByUserIdAdmin(
    userId: $userId
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      wallet {
        id
        balance
        owner {
          id
          admin {
            id
            merchantProfile {
              id
              companyName
              businessName
            }
          }
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      recipientWallet {
        id
        balance
        currency
        owner {
          id
          admin {
            id
            merchantProfile {
              id
              companyName
              businessName
            }
          }
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        category {
          name
        }
      }
      njoyCode
      partnerVoucher
      user {
        id
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindTransactionsByUserIdAdminQuery__
 *
 * To run a query within a React component, call `useFindTransactionsByUserIdAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsByUserIdAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsByUserIdAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindTransactionsByUserIdAdminQuery(baseOptions: Apollo.QueryHookOptions<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables> & ({ variables: FindTransactionsByUserIdAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>(FindTransactionsByUserIdAdminDocument, options);
      }
export function useFindTransactionsByUserIdAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>(FindTransactionsByUserIdAdminDocument, options);
        }
// @ts-ignore
export function useFindTransactionsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>;
export function useFindTransactionsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByUserIdAdminQuery | undefined, FindTransactionsByUserIdAdminQueryVariables>;
export function useFindTransactionsByUserIdAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>(FindTransactionsByUserIdAdminDocument, options);
        }
export type FindTransactionsByUserIdAdminQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdAdminQuery>;
export type FindTransactionsByUserIdAdminLazyQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdAdminLazyQuery>;
export type FindTransactionsByUserIdAdminSuspenseQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdAdminSuspenseQuery>;
export type FindTransactionsByUserIdAdminQueryResult = Apollo.QueryResult<FindTransactionsByUserIdAdminQuery, FindTransactionsByUserIdAdminQueryVariables>;
export const AlertOverviewQueryDocument = gql`
    query AlertOverviewQuery($duration: String) {
  alertOverview(duration: $duration) {
    totalPushNotifications
    totalSubscribedUsers
    totalAlerts
  }
}
    `;

/**
 * __useAlertOverviewQueryQuery__
 *
 * To run a query within a React component, call `useAlertOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertOverviewQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAlertOverviewQueryQuery(baseOptions?: Apollo.QueryHookOptions<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>(AlertOverviewQueryDocument, options);
      }
export function useAlertOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>(AlertOverviewQueryDocument, options);
        }
// @ts-ignore
export function useAlertOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>;
export function useAlertOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<AlertOverviewQueryQuery | undefined, AlertOverviewQueryQueryVariables>;
export function useAlertOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>(AlertOverviewQueryDocument, options);
        }
export type AlertOverviewQueryQueryHookResult = ReturnType<typeof useAlertOverviewQueryQuery>;
export type AlertOverviewQueryLazyQueryHookResult = ReturnType<typeof useAlertOverviewQueryLazyQuery>;
export type AlertOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useAlertOverviewQuerySuspenseQuery>;
export type AlertOverviewQueryQueryResult = Apollo.QueryResult<AlertOverviewQueryQuery, AlertOverviewQueryQueryVariables>;
export const AlertOverviewByAlertIdQueryDocument = gql`
    query AlertOverviewByAlertIdQuery($alertId: String!) {
  alertOverviewByAlertId(alertId: $alertId) {
    items {
      totalNotificationsSent
      totalNotificationsQueued
      totalClicks
      totalRead
      totalUnread
    }
  }
}
    `;

/**
 * __useAlertOverviewByAlertIdQueryQuery__
 *
 * To run a query within a React component, call `useAlertOverviewByAlertIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertOverviewByAlertIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertOverviewByAlertIdQueryQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useAlertOverviewByAlertIdQueryQuery(baseOptions: Apollo.QueryHookOptions<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables> & ({ variables: AlertOverviewByAlertIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>(AlertOverviewByAlertIdQueryDocument, options);
      }
export function useAlertOverviewByAlertIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>(AlertOverviewByAlertIdQueryDocument, options);
        }
// @ts-ignore
export function useAlertOverviewByAlertIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>;
export function useAlertOverviewByAlertIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<AlertOverviewByAlertIdQueryQuery | undefined, AlertOverviewByAlertIdQueryQueryVariables>;
export function useAlertOverviewByAlertIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>(AlertOverviewByAlertIdQueryDocument, options);
        }
export type AlertOverviewByAlertIdQueryQueryHookResult = ReturnType<typeof useAlertOverviewByAlertIdQueryQuery>;
export type AlertOverviewByAlertIdQueryLazyQueryHookResult = ReturnType<typeof useAlertOverviewByAlertIdQueryLazyQuery>;
export type AlertOverviewByAlertIdQuerySuspenseQueryHookResult = ReturnType<typeof useAlertOverviewByAlertIdQuerySuspenseQuery>;
export type AlertOverviewByAlertIdQueryQueryResult = Apollo.QueryResult<AlertOverviewByAlertIdQueryQuery, AlertOverviewByAlertIdQueryQueryVariables>;
export const CreateAlertMutationDocument = gql`
    mutation CreateAlertMutation($title: String!, $update: String!, $scheduledAt: String, $target: String, $userIds: [String!], $roleTargets: [String!], $locationIds: [String!], $communityIds: [String!], $deliveryMode: String) {
  createAlert(
    title: $title
    update: $update
    scheduledAt: $scheduledAt
    target: $target
    userIds: $userIds
    roleTargets: $roleTargets
    locationIds: $locationIds
    communityIds: $communityIds
    deliveryMode: $deliveryMode
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateAlertMutationMutationFn = Apollo.MutationFunction<CreateAlertMutationMutation, CreateAlertMutationMutationVariables>;

/**
 * __useCreateAlertMutationMutation__
 *
 * To run a mutation, you first call `useCreateAlertMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertMutationMutation, { data, loading, error }] = useCreateAlertMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      update: // value for 'update'
 *      scheduledAt: // value for 'scheduledAt'
 *      target: // value for 'target'
 *      userIds: // value for 'userIds'
 *      roleTargets: // value for 'roleTargets'
 *      locationIds: // value for 'locationIds'
 *      communityIds: // value for 'communityIds'
 *      deliveryMode: // value for 'deliveryMode'
 *   },
 * });
 */
export function useCreateAlertMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertMutationMutation, CreateAlertMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertMutationMutation, CreateAlertMutationMutationVariables>(CreateAlertMutationDocument, options);
      }
export type CreateAlertMutationMutationHookResult = ReturnType<typeof useCreateAlertMutationMutation>;
export type CreateAlertMutationMutationResult = Apollo.MutationResult<CreateAlertMutationMutation>;
export type CreateAlertMutationMutationOptions = Apollo.BaseMutationOptions<CreateAlertMutationMutation, CreateAlertMutationMutationVariables>;
export const DeleteAlertMutationDocument = gql`
    mutation DeleteAlertMutation($id: String!) {
  deleteAlert(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteAlertMutationMutationFn = Apollo.MutationFunction<DeleteAlertMutationMutation, DeleteAlertMutationMutationVariables>;

/**
 * __useDeleteAlertMutationMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutationMutation, { data, loading, error }] = useDeleteAlertMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertMutationMutation, DeleteAlertMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertMutationMutation, DeleteAlertMutationMutationVariables>(DeleteAlertMutationDocument, options);
      }
export type DeleteAlertMutationMutationHookResult = ReturnType<typeof useDeleteAlertMutationMutation>;
export type DeleteAlertMutationMutationResult = Apollo.MutationResult<DeleteAlertMutationMutation>;
export type DeleteAlertMutationMutationOptions = Apollo.BaseMutationOptions<DeleteAlertMutationMutation, DeleteAlertMutationMutationVariables>;
export const FindAllAlertsQueryDocument = gql`
    query FindAllAlertsQuery($page: Int!, $pageSize: Int!, $deliveryModes: [String!], $communityIds: [String!], $locationIds: [String!], $targets: [String!], $searchText: String) {
  findAllAlerts(
    page: $page
    pageSize: $pageSize
    deliveryModes: $deliveryModes
    communityIds: $communityIds
    locationIds: $locationIds
    targets: $targets
    searchText: $searchText
  ) {
    data {
      id
      title
      update
      isSeen
      broadcast
      targetMode
      deliveryMode
      locationIds
      locationScopeAll
      communityIds
      communityScopeAll
      targetUserCount
      receivedCount
      queuedCount
      clickCount
      readCount
      unreadCount
      createdBy {
        id
        admin {
          firstname
          lastname
          email
        }
      }
      type
      typeId
      scheduledAt
      dispatchedAt
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllAlertsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllAlertsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAlertsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAlertsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      deliveryModes: // value for 'deliveryModes'
 *      communityIds: // value for 'communityIds'
 *      locationIds: // value for 'locationIds'
 *      targets: // value for 'targets'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindAllAlertsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables> & ({ variables: FindAllAlertsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>(FindAllAlertsQueryDocument, options);
      }
export function useFindAllAlertsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>(FindAllAlertsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllAlertsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>;
export function useFindAllAlertsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAlertsQueryQuery | undefined, FindAllAlertsQueryQueryVariables>;
export function useFindAllAlertsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>(FindAllAlertsQueryDocument, options);
        }
export type FindAllAlertsQueryQueryHookResult = ReturnType<typeof useFindAllAlertsQueryQuery>;
export type FindAllAlertsQueryLazyQueryHookResult = ReturnType<typeof useFindAllAlertsQueryLazyQuery>;
export type FindAllAlertsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllAlertsQuerySuspenseQuery>;
export type FindAllAlertsQueryQueryResult = Apollo.QueryResult<FindAllAlertsQueryQuery, FindAllAlertsQueryQueryVariables>;
export const FindSubscribedAlertUsersQueryDocument = gql`
    query FindSubscribedAlertUsersQuery($page: Int!, $pageSize: Int!, $searchText: String) {
  findSubscribedAlertUsers(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
  ) {
    data {
      userId
      username
      firstname
      lastname
      isAmbassador
      communityId
      community {
        id
        name
        alias
      }
      location
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindSubscribedAlertUsersQueryQuery__
 *
 * To run a query within a React component, call `useFindSubscribedAlertUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSubscribedAlertUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSubscribedAlertUsersQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindSubscribedAlertUsersQueryQuery(baseOptions: Apollo.QueryHookOptions<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables> & ({ variables: FindSubscribedAlertUsersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>(FindSubscribedAlertUsersQueryDocument, options);
      }
export function useFindSubscribedAlertUsersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>(FindSubscribedAlertUsersQueryDocument, options);
        }
// @ts-ignore
export function useFindSubscribedAlertUsersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>;
export function useFindSubscribedAlertUsersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindSubscribedAlertUsersQueryQuery | undefined, FindSubscribedAlertUsersQueryQueryVariables>;
export function useFindSubscribedAlertUsersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>(FindSubscribedAlertUsersQueryDocument, options);
        }
export type FindSubscribedAlertUsersQueryQueryHookResult = ReturnType<typeof useFindSubscribedAlertUsersQueryQuery>;
export type FindSubscribedAlertUsersQueryLazyQueryHookResult = ReturnType<typeof useFindSubscribedAlertUsersQueryLazyQuery>;
export type FindSubscribedAlertUsersQuerySuspenseQueryHookResult = ReturnType<typeof useFindSubscribedAlertUsersQuerySuspenseQuery>;
export type FindSubscribedAlertUsersQueryQueryResult = Apollo.QueryResult<FindSubscribedAlertUsersQueryQuery, FindSubscribedAlertUsersQueryQueryVariables>;
export const MyAlertQueryDocument = gql`
    query MyAlertQuery($offset: Int!, $limit: Int!) {
  myAlert(offset: $offset, limit: $limit) {
    id
    title
    update
    isSeen
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyAlertQueryQuery__
 *
 * To run a query within a React component, call `useMyAlertQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAlertQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAlertQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyAlertQueryQuery(baseOptions: Apollo.QueryHookOptions<MyAlertQueryQuery, MyAlertQueryQueryVariables> & ({ variables: MyAlertQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAlertQueryQuery, MyAlertQueryQueryVariables>(MyAlertQueryDocument, options);
      }
export function useMyAlertQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAlertQueryQuery, MyAlertQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAlertQueryQuery, MyAlertQueryQueryVariables>(MyAlertQueryDocument, options);
        }
// @ts-ignore
export function useMyAlertQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAlertQueryQuery, MyAlertQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyAlertQueryQuery, MyAlertQueryQueryVariables>;
export function useMyAlertQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAlertQueryQuery, MyAlertQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyAlertQueryQuery | undefined, MyAlertQueryQueryVariables>;
export function useMyAlertQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAlertQueryQuery, MyAlertQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAlertQueryQuery, MyAlertQueryQueryVariables>(MyAlertQueryDocument, options);
        }
export type MyAlertQueryQueryHookResult = ReturnType<typeof useMyAlertQueryQuery>;
export type MyAlertQueryLazyQueryHookResult = ReturnType<typeof useMyAlertQueryLazyQuery>;
export type MyAlertQuerySuspenseQueryHookResult = ReturnType<typeof useMyAlertQuerySuspenseQuery>;
export type MyAlertQueryQueryResult = Apollo.QueryResult<MyAlertQueryQuery, MyAlertQueryQueryVariables>;
export const NewAlertSubscriptionDocument = gql`
    subscription NewAlertSubscription {
  newAlert {
    id
    title
    update
    isSeen
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewAlertSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewAlertSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewAlertSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewAlertSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewAlertSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewAlertSubscriptionSubscription, NewAlertSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewAlertSubscriptionSubscription, NewAlertSubscriptionSubscriptionVariables>(NewAlertSubscriptionDocument, options);
      }
export type NewAlertSubscriptionSubscriptionHookResult = ReturnType<typeof useNewAlertSubscriptionSubscription>;
export type NewAlertSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewAlertSubscriptionSubscription>;
export const PushProviderEventBreakdownQueryDocument = gql`
    query PushProviderEventBreakdownQuery($windowHours: Int) {
  pushProviderEventBreakdown(windowHours: $windowHours) {
    errors {
      path
      message
    }
    message
    windowHours
    providers {
      provider
      received
      clicked
      read
      failed
      total
    }
  }
}
    `;

/**
 * __usePushProviderEventBreakdownQueryQuery__
 *
 * To run a query within a React component, call `usePushProviderEventBreakdownQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushProviderEventBreakdownQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushProviderEventBreakdownQueryQuery({
 *   variables: {
 *      windowHours: // value for 'windowHours'
 *   },
 * });
 */
export function usePushProviderEventBreakdownQueryQuery(baseOptions?: Apollo.QueryHookOptions<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>(PushProviderEventBreakdownQueryDocument, options);
      }
export function usePushProviderEventBreakdownQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>(PushProviderEventBreakdownQueryDocument, options);
        }
// @ts-ignore
export function usePushProviderEventBreakdownQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>;
export function usePushProviderEventBreakdownQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PushProviderEventBreakdownQueryQuery | undefined, PushProviderEventBreakdownQueryQueryVariables>;
export function usePushProviderEventBreakdownQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>(PushProviderEventBreakdownQueryDocument, options);
        }
export type PushProviderEventBreakdownQueryQueryHookResult = ReturnType<typeof usePushProviderEventBreakdownQueryQuery>;
export type PushProviderEventBreakdownQueryLazyQueryHookResult = ReturnType<typeof usePushProviderEventBreakdownQueryLazyQuery>;
export type PushProviderEventBreakdownQuerySuspenseQueryHookResult = ReturnType<typeof usePushProviderEventBreakdownQuerySuspenseQuery>;
export type PushProviderEventBreakdownQueryQueryResult = Apollo.QueryResult<PushProviderEventBreakdownQueryQuery, PushProviderEventBreakdownQueryQueryVariables>;
export const PushProviderEventMetricsQueryDocument = gql`
    query PushProviderEventMetricsQuery {
  pushProviderEventMetrics {
    errors {
      path
      message
    }
    message
    processed
    updated
    duplicate
    invalid
    missingAlert
    received
    clicked
    read
    failed
  }
}
    `;

/**
 * __usePushProviderEventMetricsQueryQuery__
 *
 * To run a query within a React component, call `usePushProviderEventMetricsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushProviderEventMetricsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushProviderEventMetricsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePushProviderEventMetricsQueryQuery(baseOptions?: Apollo.QueryHookOptions<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>(PushProviderEventMetricsQueryDocument, options);
      }
export function usePushProviderEventMetricsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>(PushProviderEventMetricsQueryDocument, options);
        }
// @ts-ignore
export function usePushProviderEventMetricsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>;
export function usePushProviderEventMetricsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PushProviderEventMetricsQueryQuery | undefined, PushProviderEventMetricsQueryQueryVariables>;
export function usePushProviderEventMetricsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>(PushProviderEventMetricsQueryDocument, options);
        }
export type PushProviderEventMetricsQueryQueryHookResult = ReturnType<typeof usePushProviderEventMetricsQueryQuery>;
export type PushProviderEventMetricsQueryLazyQueryHookResult = ReturnType<typeof usePushProviderEventMetricsQueryLazyQuery>;
export type PushProviderEventMetricsQuerySuspenseQueryHookResult = ReturnType<typeof usePushProviderEventMetricsQuerySuspenseQuery>;
export type PushProviderEventMetricsQueryQueryResult = Apollo.QueryResult<PushProviderEventMetricsQueryQuery, PushProviderEventMetricsQueryQueryVariables>;
export const UpdateAlertMutationDocument = gql`
    mutation UpdateAlertMutation($alertId: String!, $input: UpdateAlertInput!) {
  updateAlert(alertId: $alertId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateAlertMutationMutationFn = Apollo.MutationFunction<UpdateAlertMutationMutation, UpdateAlertMutationMutationVariables>;

/**
 * __useUpdateAlertMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAlertMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertMutationMutation, { data, loading, error }] = useUpdateAlertMutationMutation({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertMutationMutation, UpdateAlertMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertMutationMutation, UpdateAlertMutationMutationVariables>(UpdateAlertMutationDocument, options);
      }
export type UpdateAlertMutationMutationHookResult = ReturnType<typeof useUpdateAlertMutationMutation>;
export type UpdateAlertMutationMutationResult = Apollo.MutationResult<UpdateAlertMutationMutation>;
export type UpdateAlertMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAlertMutationMutation, UpdateAlertMutationMutationVariables>;
export const ViewAlertQueryDocument = gql`
    query ViewAlertQuery($alertId: String!) {
  viewAlert(alertId: $alertId) {
    id
    title
    update
    isSeen
    broadcast
    targetMode
    deliveryMode
    locationIds
    locationScopeAll
    communityIds
    communityScopeAll
    targetUserCount
    receivedCount
    queuedCount
    clickCount
    readCount
    unreadCount
    createdBy {
      id
      admin {
        firstname
        lastname
        email
      }
    }
    type
    typeId
    scheduledAt
    dispatchedAt
    selectionSummary {
      targetMode
      userCount
      roles
      userIds
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewAlertQueryQuery__
 *
 * To run a query within a React component, call `useViewAlertQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewAlertQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewAlertQueryQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useViewAlertQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewAlertQueryQuery, ViewAlertQueryQueryVariables> & ({ variables: ViewAlertQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>(ViewAlertQueryDocument, options);
      }
export function useViewAlertQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>(ViewAlertQueryDocument, options);
        }
// @ts-ignore
export function useViewAlertQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>;
export function useViewAlertQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAlertQueryQuery | undefined, ViewAlertQueryQueryVariables>;
export function useViewAlertQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>(ViewAlertQueryDocument, options);
        }
export type ViewAlertQueryQueryHookResult = ReturnType<typeof useViewAlertQueryQuery>;
export type ViewAlertQueryLazyQueryHookResult = ReturnType<typeof useViewAlertQueryLazyQuery>;
export type ViewAlertQuerySuspenseQueryHookResult = ReturnType<typeof useViewAlertQuerySuspenseQuery>;
export type ViewAlertQueryQueryResult = Apollo.QueryResult<ViewAlertQueryQuery, ViewAlertQueryQueryVariables>;
export const FindAllAuditLogsQueryDocument = gql`
    query FindAllAuditLogsQuery($duration: String, $searchText: String, $page: Int!, $pageSize: Int!, $sortBy: String, $sortOrder: String) {
  findAllAuditLogs(
    duration: $duration
    searchText: $searchText
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      entity
      action
      entityId
      ipAddress
      userAgent
      createdAt
    }
    uniqueEntities
    totalLogs
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllAuditLogsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllAuditLogsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAuditLogsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAuditLogsQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *      searchText: // value for 'searchText'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllAuditLogsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables> & ({ variables: FindAllAuditLogsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>(FindAllAuditLogsQueryDocument, options);
      }
export function useFindAllAuditLogsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>(FindAllAuditLogsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllAuditLogsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>;
export function useFindAllAuditLogsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllAuditLogsQueryQuery | undefined, FindAllAuditLogsQueryQueryVariables>;
export function useFindAllAuditLogsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>(FindAllAuditLogsQueryDocument, options);
        }
export type FindAllAuditLogsQueryQueryHookResult = ReturnType<typeof useFindAllAuditLogsQueryQuery>;
export type FindAllAuditLogsQueryLazyQueryHookResult = ReturnType<typeof useFindAllAuditLogsQueryLazyQuery>;
export type FindAllAuditLogsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllAuditLogsQuerySuspenseQuery>;
export type FindAllAuditLogsQueryQueryResult = Apollo.QueryResult<FindAllAuditLogsQueryQuery, FindAllAuditLogsQueryQueryVariables>;
export const ViewAuditLogQueryDocument = gql`
    query ViewAuditLogQuery($id: String!) {
  viewAuditLog(id: $id) {
    id
    entity
    action
    entityId
    ipAddress
    userAgent
    createdAt
  }
}
    `;

/**
 * __useViewAuditLogQueryQuery__
 *
 * To run a query within a React component, call `useViewAuditLogQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewAuditLogQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewAuditLogQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewAuditLogQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables> & ({ variables: ViewAuditLogQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>(ViewAuditLogQueryDocument, options);
      }
export function useViewAuditLogQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>(ViewAuditLogQueryDocument, options);
        }
// @ts-ignore
export function useViewAuditLogQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>;
export function useViewAuditLogQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewAuditLogQueryQuery | undefined, ViewAuditLogQueryQueryVariables>;
export function useViewAuditLogQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>(ViewAuditLogQueryDocument, options);
        }
export type ViewAuditLogQueryQueryHookResult = ReturnType<typeof useViewAuditLogQueryQuery>;
export type ViewAuditLogQueryLazyQueryHookResult = ReturnType<typeof useViewAuditLogQueryLazyQuery>;
export type ViewAuditLogQuerySuspenseQueryHookResult = ReturnType<typeof useViewAuditLogQuerySuspenseQuery>;
export type ViewAuditLogQueryQueryResult = Apollo.QueryResult<ViewAuditLogQueryQuery, ViewAuditLogQueryQueryVariables>;
export const ForgotPasswordChangeAdminMutationDocument = gql`
    mutation ForgotPasswordChangeAdminMutation($newPassword: String!, $confirmNewPassword: String!, $key: String!) {
  forgotPasswordChangeAdmin(
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
    key: $key
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ForgotPasswordChangeAdminMutationMutationFn = Apollo.MutationFunction<ForgotPasswordChangeAdminMutationMutation, ForgotPasswordChangeAdminMutationMutationVariables>;

/**
 * __useForgotPasswordChangeAdminMutationMutation__
 *
 * To run a mutation, you first call `useForgotPasswordChangeAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordChangeAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordChangeAdminMutationMutation, { data, loading, error }] = useForgotPasswordChangeAdminMutationMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      confirmNewPassword: // value for 'confirmNewPassword'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useForgotPasswordChangeAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordChangeAdminMutationMutation, ForgotPasswordChangeAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordChangeAdminMutationMutation, ForgotPasswordChangeAdminMutationMutationVariables>(ForgotPasswordChangeAdminMutationDocument, options);
      }
export type ForgotPasswordChangeAdminMutationMutationHookResult = ReturnType<typeof useForgotPasswordChangeAdminMutationMutation>;
export type ForgotPasswordChangeAdminMutationMutationResult = Apollo.MutationResult<ForgotPasswordChangeAdminMutationMutation>;
export type ForgotPasswordChangeAdminMutationMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordChangeAdminMutationMutation, ForgotPasswordChangeAdminMutationMutationVariables>;
export const SendForgotPasswordEmailAdminMutationDocument = gql`
    mutation SendForgotPasswordEmailAdminMutation($email: String!) {
  sendForgotPasswordEmailAdmin(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type SendForgotPasswordEmailAdminMutationMutationFn = Apollo.MutationFunction<SendForgotPasswordEmailAdminMutationMutation, SendForgotPasswordEmailAdminMutationMutationVariables>;

/**
 * __useSendForgotPasswordEmailAdminMutationMutation__
 *
 * To run a mutation, you first call `useSendForgotPasswordEmailAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForgotPasswordEmailAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForgotPasswordEmailAdminMutationMutation, { data, loading, error }] = useSendForgotPasswordEmailAdminMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendForgotPasswordEmailAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendForgotPasswordEmailAdminMutationMutation, SendForgotPasswordEmailAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendForgotPasswordEmailAdminMutationMutation, SendForgotPasswordEmailAdminMutationMutationVariables>(SendForgotPasswordEmailAdminMutationDocument, options);
      }
export type SendForgotPasswordEmailAdminMutationMutationHookResult = ReturnType<typeof useSendForgotPasswordEmailAdminMutationMutation>;
export type SendForgotPasswordEmailAdminMutationMutationResult = Apollo.MutationResult<SendForgotPasswordEmailAdminMutationMutation>;
export type SendForgotPasswordEmailAdminMutationMutationOptions = Apollo.BaseMutationOptions<SendForgotPasswordEmailAdminMutationMutation, SendForgotPasswordEmailAdminMutationMutationVariables>;
export const LoginAdminMutationDocument = gql`
    mutation LoginAdminMutation($adminId: String!, $password: String!) {
  loginAdmin(adminId: $adminId, password: $password) {
    errors {
      path
      message
    }
    sessionId
    sessionRole
  }
}
    `;
export type LoginAdminMutationMutationFn = Apollo.MutationFunction<LoginAdminMutationMutation, LoginAdminMutationMutationVariables>;

/**
 * __useLoginAdminMutationMutation__
 *
 * To run a mutation, you first call `useLoginAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAdminMutationMutation, { data, loading, error }] = useLoginAdminMutationMutation({
 *   variables: {
 *      adminId: // value for 'adminId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginAdminMutationMutation, LoginAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAdminMutationMutation, LoginAdminMutationMutationVariables>(LoginAdminMutationDocument, options);
      }
export type LoginAdminMutationMutationHookResult = ReturnType<typeof useLoginAdminMutationMutation>;
export type LoginAdminMutationMutationResult = Apollo.MutationResult<LoginAdminMutationMutation>;
export type LoginAdminMutationMutationOptions = Apollo.BaseMutationOptions<LoginAdminMutationMutation, LoginAdminMutationMutationVariables>;
export const OtpValidateAdminMutationDocument = gql`
    mutation OtpValidateAdminMutation($verificationCode: String!, $email: String!) {
  otpValidateAdmin(verificationCode: $verificationCode, email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type OtpValidateAdminMutationMutationFn = Apollo.MutationFunction<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>;

/**
 * __useOtpValidateAdminMutationMutation__
 *
 * To run a mutation, you first call `useOtpValidateAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpValidateAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpValidateAdminMutationMutation, { data, loading, error }] = useOtpValidateAdminMutationMutation({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useOtpValidateAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>(OtpValidateAdminMutationDocument, options);
      }
export type OtpValidateAdminMutationMutationHookResult = ReturnType<typeof useOtpValidateAdminMutationMutation>;
export type OtpValidateAdminMutationMutationResult = Apollo.MutationResult<OtpValidateAdminMutationMutation>;
export type OtpValidateAdminMutationMutationOptions = Apollo.BaseMutationOptions<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>;
export const ResendOtpAdminMutationDocument = gql`
    mutation ResendOtpAdminMutation($email: String!) {
  resendOtpAdmin(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ResendOtpAdminMutationMutationFn = Apollo.MutationFunction<ResendOtpAdminMutationMutation, ResendOtpAdminMutationMutationVariables>;

/**
 * __useResendOtpAdminMutationMutation__
 *
 * To run a mutation, you first call `useResendOtpAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOtpAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOtpAdminMutationMutation, { data, loading, error }] = useResendOtpAdminMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendOtpAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResendOtpAdminMutationMutation, ResendOtpAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOtpAdminMutationMutation, ResendOtpAdminMutationMutationVariables>(ResendOtpAdminMutationDocument, options);
      }
export type ResendOtpAdminMutationMutationHookResult = ReturnType<typeof useResendOtpAdminMutationMutation>;
export type ResendOtpAdminMutationMutationResult = Apollo.MutationResult<ResendOtpAdminMutationMutation>;
export type ResendOtpAdminMutationMutationOptions = Apollo.BaseMutationOptions<ResendOtpAdminMutationMutation, ResendOtpAdminMutationMutationVariables>;
export const UpdatePasswordChangeAdminMutationDocument = gql`
    mutation UpdatePasswordChangeAdminMutation($oldPassword: String!, $newPassword: String!, $confirmNewPassword: String!) {
  updatePasswordChangeAdmin(
    oldPassword: $oldPassword
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
  ) {
    path
    message
  }
}
    `;
export type UpdatePasswordChangeAdminMutationMutationFn = Apollo.MutationFunction<UpdatePasswordChangeAdminMutationMutation, UpdatePasswordChangeAdminMutationMutationVariables>;

/**
 * __useUpdatePasswordChangeAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordChangeAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordChangeAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordChangeAdminMutationMutation, { data, loading, error }] = useUpdatePasswordChangeAdminMutationMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *      confirmNewPassword: // value for 'confirmNewPassword'
 *   },
 * });
 */
export function useUpdatePasswordChangeAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordChangeAdminMutationMutation, UpdatePasswordChangeAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordChangeAdminMutationMutation, UpdatePasswordChangeAdminMutationMutationVariables>(UpdatePasswordChangeAdminMutationDocument, options);
      }
export type UpdatePasswordChangeAdminMutationMutationHookResult = ReturnType<typeof useUpdatePasswordChangeAdminMutationMutation>;
export type UpdatePasswordChangeAdminMutationMutationResult = Apollo.MutationResult<UpdatePasswordChangeAdminMutationMutation>;
export type UpdatePasswordChangeAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordChangeAdminMutationMutation, UpdatePasswordChangeAdminMutationMutationVariables>;
export const CreateCommunityMutationDocument = gql`
    mutation CreateCommunityMutation($name: String!, $alias: String!, $logoUrl: String, $colorCode: String) {
  createCommunity(
    name: $name
    alias: $alias
    logoUrl: $logoUrl
    colorCode: $colorCode
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateCommunityMutationMutationFn = Apollo.MutationFunction<CreateCommunityMutationMutation, CreateCommunityMutationMutationVariables>;

/**
 * __useCreateCommunityMutationMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMutationMutation, { data, loading, error }] = useCreateCommunityMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      alias: // value for 'alias'
 *      logoUrl: // value for 'logoUrl'
 *      colorCode: // value for 'colorCode'
 *   },
 * });
 */
export function useCreateCommunityMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMutationMutation, CreateCommunityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMutationMutation, CreateCommunityMutationMutationVariables>(CreateCommunityMutationDocument, options);
      }
export type CreateCommunityMutationMutationHookResult = ReturnType<typeof useCreateCommunityMutationMutation>;
export type CreateCommunityMutationMutationResult = Apollo.MutationResult<CreateCommunityMutationMutation>;
export type CreateCommunityMutationMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMutationMutation, CreateCommunityMutationMutationVariables>;
export const FindAllCommunitiesQueryDocument = gql`
    query FindAllCommunitiesQuery {
  findAllCommunities {
    id
    name
    alias
    logoUrl
    colorCode
    isArchive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindAllCommunitiesQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCommunitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCommunitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCommunitiesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCommunitiesQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>(FindAllCommunitiesQueryDocument, options);
      }
export function useFindAllCommunitiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>(FindAllCommunitiesQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCommunitiesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>;
export function useFindAllCommunitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunitiesQueryQuery | undefined, FindAllCommunitiesQueryQueryVariables>;
export function useFindAllCommunitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>(FindAllCommunitiesQueryDocument, options);
        }
export type FindAllCommunitiesQueryQueryHookResult = ReturnType<typeof useFindAllCommunitiesQueryQuery>;
export type FindAllCommunitiesQueryLazyQueryHookResult = ReturnType<typeof useFindAllCommunitiesQueryLazyQuery>;
export type FindAllCommunitiesQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCommunitiesQuerySuspenseQuery>;
export type FindAllCommunitiesQueryQueryResult = Apollo.QueryResult<FindAllCommunitiesQueryQuery, FindAllCommunitiesQueryQueryVariables>;
export const NewCommunitySubscriptionDocument = gql`
    subscription NewCommunitySubscription {
  newCommunity {
    id
    name
    alias
    logoUrl
    colorCode
    isArchive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewCommunitySubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewCommunitySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCommunitySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCommunitySubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewCommunitySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewCommunitySubscriptionSubscription, NewCommunitySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCommunitySubscriptionSubscription, NewCommunitySubscriptionSubscriptionVariables>(NewCommunitySubscriptionDocument, options);
      }
export type NewCommunitySubscriptionSubscriptionHookResult = ReturnType<typeof useNewCommunitySubscriptionSubscription>;
export type NewCommunitySubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewCommunitySubscriptionSubscription>;
export const FindAllCommunitySpendDocument = gql`
    query FindAllCommunitySpend($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllCommunitySpend(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      community {
        id
        name
        alias
        logoUrl
        isArchive
        createdBy {
          id
          admin {
            id
            level
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      totalSpend
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCommunitySpendQuery__
 *
 * To run a query within a React component, call `useFindAllCommunitySpendQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCommunitySpendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCommunitySpendQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCommunitySpendQuery(baseOptions: Apollo.QueryHookOptions<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables> & ({ variables: FindAllCommunitySpendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>(FindAllCommunitySpendDocument, options);
      }
export function useFindAllCommunitySpendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>(FindAllCommunitySpendDocument, options);
        }
// @ts-ignore
export function useFindAllCommunitySpendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>;
export function useFindAllCommunitySpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunitySpendQuery | undefined, FindAllCommunitySpendQueryVariables>;
export function useFindAllCommunitySpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>(FindAllCommunitySpendDocument, options);
        }
export type FindAllCommunitySpendQueryHookResult = ReturnType<typeof useFindAllCommunitySpendQuery>;
export type FindAllCommunitySpendLazyQueryHookResult = ReturnType<typeof useFindAllCommunitySpendLazyQuery>;
export type FindAllCommunitySpendSuspenseQueryHookResult = ReturnType<typeof useFindAllCommunitySpendSuspenseQuery>;
export type FindAllCommunitySpendQueryResult = Apollo.QueryResult<FindAllCommunitySpendQuery, FindAllCommunitySpendQueryVariables>;
export const ToggleCommunityArchiveStatusMutationDocument = gql`
    mutation ToggleCommunityArchiveStatusMutation($communityId: String!, $isArchive: Boolean!) {
  toggleCommunityArchiveStatus(communityId: $communityId, isArchive: $isArchive) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ToggleCommunityArchiveStatusMutationMutationFn = Apollo.MutationFunction<ToggleCommunityArchiveStatusMutationMutation, ToggleCommunityArchiveStatusMutationMutationVariables>;

/**
 * __useToggleCommunityArchiveStatusMutationMutation__
 *
 * To run a mutation, you first call `useToggleCommunityArchiveStatusMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCommunityArchiveStatusMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCommunityArchiveStatusMutationMutation, { data, loading, error }] = useToggleCommunityArchiveStatusMutationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      isArchive: // value for 'isArchive'
 *   },
 * });
 */
export function useToggleCommunityArchiveStatusMutationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCommunityArchiveStatusMutationMutation, ToggleCommunityArchiveStatusMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCommunityArchiveStatusMutationMutation, ToggleCommunityArchiveStatusMutationMutationVariables>(ToggleCommunityArchiveStatusMutationDocument, options);
      }
export type ToggleCommunityArchiveStatusMutationMutationHookResult = ReturnType<typeof useToggleCommunityArchiveStatusMutationMutation>;
export type ToggleCommunityArchiveStatusMutationMutationResult = Apollo.MutationResult<ToggleCommunityArchiveStatusMutationMutation>;
export type ToggleCommunityArchiveStatusMutationMutationOptions = Apollo.BaseMutationOptions<ToggleCommunityArchiveStatusMutationMutation, ToggleCommunityArchiveStatusMutationMutationVariables>;
export const UpdateCommunityMutationDocument = gql`
    mutation UpdateCommunityMutation($communityId: String!, $input: UpdateCommunityInput!) {
  updateCommunity(communityId: $communityId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCommunityMutationMutationFn = Apollo.MutationFunction<UpdateCommunityMutationMutation, UpdateCommunityMutationMutationVariables>;

/**
 * __useUpdateCommunityMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityMutationMutation, { data, loading, error }] = useUpdateCommunityMutationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityMutationMutation, UpdateCommunityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityMutationMutation, UpdateCommunityMutationMutationVariables>(UpdateCommunityMutationDocument, options);
      }
export type UpdateCommunityMutationMutationHookResult = ReturnType<typeof useUpdateCommunityMutationMutation>;
export type UpdateCommunityMutationMutationResult = Apollo.MutationResult<UpdateCommunityMutationMutation>;
export type UpdateCommunityMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityMutationMutation, UpdateCommunityMutationMutationVariables>;
export const CreateCommunityEntityMutationDocument = gql`
    mutation CreateCommunityEntityMutation($input: CreateCommunityEntityInput!) {
  createCommunityEntity(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateCommunityEntityMutationMutationFn = Apollo.MutationFunction<CreateCommunityEntityMutationMutation, CreateCommunityEntityMutationMutationVariables>;

/**
 * __useCreateCommunityEntityMutationMutation__
 *
 * To run a mutation, you first call `useCreateCommunityEntityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityEntityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityEntityMutationMutation, { data, loading, error }] = useCreateCommunityEntityMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityEntityMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityEntityMutationMutation, CreateCommunityEntityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityEntityMutationMutation, CreateCommunityEntityMutationMutationVariables>(CreateCommunityEntityMutationDocument, options);
      }
export type CreateCommunityEntityMutationMutationHookResult = ReturnType<typeof useCreateCommunityEntityMutationMutation>;
export type CreateCommunityEntityMutationMutationResult = Apollo.MutationResult<CreateCommunityEntityMutationMutation>;
export type CreateCommunityEntityMutationMutationOptions = Apollo.BaseMutationOptions<CreateCommunityEntityMutationMutation, CreateCommunityEntityMutationMutationVariables>;
export const DeleteCommunityEntityMutationDocument = gql`
    mutation DeleteCommunityEntityMutation($id: String!) {
  deleteCommunityEntity(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteCommunityEntityMutationMutationFn = Apollo.MutationFunction<DeleteCommunityEntityMutationMutation, DeleteCommunityEntityMutationMutationVariables>;

/**
 * __useDeleteCommunityEntityMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityEntityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityEntityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityEntityMutationMutation, { data, loading, error }] = useDeleteCommunityEntityMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommunityEntityMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityEntityMutationMutation, DeleteCommunityEntityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityEntityMutationMutation, DeleteCommunityEntityMutationMutationVariables>(DeleteCommunityEntityMutationDocument, options);
      }
export type DeleteCommunityEntityMutationMutationHookResult = ReturnType<typeof useDeleteCommunityEntityMutationMutation>;
export type DeleteCommunityEntityMutationMutationResult = Apollo.MutationResult<DeleteCommunityEntityMutationMutation>;
export type DeleteCommunityEntityMutationMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityEntityMutationMutation, DeleteCommunityEntityMutationMutationVariables>;
export const FindAllCommunityEntitiesQueryDocument = gql`
    query FindAllCommunityEntitiesQuery {
  findAllCommunityEntities {
    id
    name
    shortName
    entityType
  }
}
    `;

/**
 * __useFindAllCommunityEntitiesQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCommunityEntitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCommunityEntitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCommunityEntitiesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCommunityEntitiesQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>(FindAllCommunityEntitiesQueryDocument, options);
      }
export function useFindAllCommunityEntitiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>(FindAllCommunityEntitiesQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCommunityEntitiesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>;
export function useFindAllCommunityEntitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunityEntitiesQueryQuery | undefined, FindAllCommunityEntitiesQueryQueryVariables>;
export function useFindAllCommunityEntitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>(FindAllCommunityEntitiesQueryDocument, options);
        }
export type FindAllCommunityEntitiesQueryQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesQueryQuery>;
export type FindAllCommunityEntitiesQueryLazyQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesQueryLazyQuery>;
export type FindAllCommunityEntitiesQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesQuerySuspenseQuery>;
export type FindAllCommunityEntitiesQueryQueryResult = Apollo.QueryResult<FindAllCommunityEntitiesQueryQuery, FindAllCommunityEntitiesQueryQueryVariables>;
export const NewCommunityEntitySubscriptionDocument = gql`
    subscription NewCommunityEntitySubscription {
  newCommunityEntity {
    id
    name
    shortName
    entityType
    createdBy {
      id
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewCommunityEntitySubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewCommunityEntitySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCommunityEntitySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCommunityEntitySubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewCommunityEntitySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewCommunityEntitySubscriptionSubscription, NewCommunityEntitySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCommunityEntitySubscriptionSubscription, NewCommunityEntitySubscriptionSubscriptionVariables>(NewCommunityEntitySubscriptionDocument, options);
      }
export type NewCommunityEntitySubscriptionSubscriptionHookResult = ReturnType<typeof useNewCommunityEntitySubscriptionSubscription>;
export type NewCommunityEntitySubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewCommunityEntitySubscriptionSubscription>;
export const FindAllCommunityEntitiesAdminDocument = gql`
    query FindAllCommunityEntitiesAdmin($page: Int!, $pageSize: Int!, $entityTypeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllCommunityEntitiesAdmin(
    page: $page
    pageSize: $pageSize
    entityTypeFilter: $entityTypeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      shortName
      entityType
      createdBy {
        id
        admin {
          id
          firstname
          lastname
          email
          level
        }
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCommunityEntitiesAdminQuery__
 *
 * To run a query within a React component, call `useFindAllCommunityEntitiesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCommunityEntitiesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCommunityEntitiesAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      entityTypeFilter: // value for 'entityTypeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCommunityEntitiesAdminQuery(baseOptions: Apollo.QueryHookOptions<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables> & ({ variables: FindAllCommunityEntitiesAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>(FindAllCommunityEntitiesAdminDocument, options);
      }
export function useFindAllCommunityEntitiesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>(FindAllCommunityEntitiesAdminDocument, options);
        }
// @ts-ignore
export function useFindAllCommunityEntitiesAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>;
export function useFindAllCommunityEntitiesAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCommunityEntitiesAdminQuery | undefined, FindAllCommunityEntitiesAdminQueryVariables>;
export function useFindAllCommunityEntitiesAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>(FindAllCommunityEntitiesAdminDocument, options);
        }
export type FindAllCommunityEntitiesAdminQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesAdminQuery>;
export type FindAllCommunityEntitiesAdminLazyQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesAdminLazyQuery>;
export type FindAllCommunityEntitiesAdminSuspenseQueryHookResult = ReturnType<typeof useFindAllCommunityEntitiesAdminSuspenseQuery>;
export type FindAllCommunityEntitiesAdminQueryResult = Apollo.QueryResult<FindAllCommunityEntitiesAdminQuery, FindAllCommunityEntitiesAdminQueryVariables>;
export const FindByEntityTypeQueryDocument = gql`
    query FindByEntityTypeQuery($entityType: String!) {
  findByEntityType(entityType: $entityType) {
    id
    name
    shortName
    entityType
  }
}
    `;

/**
 * __useFindByEntityTypeQueryQuery__
 *
 * To run a query within a React component, call `useFindByEntityTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindByEntityTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindByEntityTypeQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useFindByEntityTypeQueryQuery(baseOptions: Apollo.QueryHookOptions<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables> & ({ variables: FindByEntityTypeQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>(FindByEntityTypeQueryDocument, options);
      }
export function useFindByEntityTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>(FindByEntityTypeQueryDocument, options);
        }
// @ts-ignore
export function useFindByEntityTypeQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>;
export function useFindByEntityTypeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindByEntityTypeQueryQuery | undefined, FindByEntityTypeQueryQueryVariables>;
export function useFindByEntityTypeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>(FindByEntityTypeQueryDocument, options);
        }
export type FindByEntityTypeQueryQueryHookResult = ReturnType<typeof useFindByEntityTypeQueryQuery>;
export type FindByEntityTypeQueryLazyQueryHookResult = ReturnType<typeof useFindByEntityTypeQueryLazyQuery>;
export type FindByEntityTypeQuerySuspenseQueryHookResult = ReturnType<typeof useFindByEntityTypeQuerySuspenseQuery>;
export type FindByEntityTypeQueryQueryResult = Apollo.QueryResult<FindByEntityTypeQueryQuery, FindByEntityTypeQueryQueryVariables>;
export const UpdateCommunityEntityMutationDocument = gql`
    mutation UpdateCommunityEntityMutation($communityEntityId: String!, $input: UpdateCommunityEntityInput!) {
  updateCommunityEntity(communityEntityId: $communityEntityId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCommunityEntityMutationMutationFn = Apollo.MutationFunction<UpdateCommunityEntityMutationMutation, UpdateCommunityEntityMutationMutationVariables>;

/**
 * __useUpdateCommunityEntityMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityEntityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityEntityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityEntityMutationMutation, { data, loading, error }] = useUpdateCommunityEntityMutationMutation({
 *   variables: {
 *      communityEntityId: // value for 'communityEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityEntityMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityEntityMutationMutation, UpdateCommunityEntityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityEntityMutationMutation, UpdateCommunityEntityMutationMutationVariables>(UpdateCommunityEntityMutationDocument, options);
      }
export type UpdateCommunityEntityMutationMutationHookResult = ReturnType<typeof useUpdateCommunityEntityMutationMutation>;
export type UpdateCommunityEntityMutationMutationResult = Apollo.MutationResult<UpdateCommunityEntityMutationMutation>;
export type UpdateCommunityEntityMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityEntityMutationMutation, UpdateCommunityEntityMutationMutationVariables>;
export const ViewCommunityEntityByIdQueryDocument = gql`
    query ViewCommunityEntityByIdQuery($communityEntityId: String!) {
  viewCommunityEntityById(communityEntityId: $communityEntityId) {
    id
    name
    shortName
    entityType
    createdBy {
      id
      admin {
        id
        firstname
        lastname
        email
        level
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewCommunityEntityByIdQueryQuery__
 *
 * To run a query within a React component, call `useViewCommunityEntityByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCommunityEntityByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCommunityEntityByIdQueryQuery({
 *   variables: {
 *      communityEntityId: // value for 'communityEntityId'
 *   },
 * });
 */
export function useViewCommunityEntityByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables> & ({ variables: ViewCommunityEntityByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>(ViewCommunityEntityByIdQueryDocument, options);
      }
export function useViewCommunityEntityByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>(ViewCommunityEntityByIdQueryDocument, options);
        }
// @ts-ignore
export function useViewCommunityEntityByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>;
export function useViewCommunityEntityByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCommunityEntityByIdQueryQuery | undefined, ViewCommunityEntityByIdQueryQueryVariables>;
export function useViewCommunityEntityByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>(ViewCommunityEntityByIdQueryDocument, options);
        }
export type ViewCommunityEntityByIdQueryQueryHookResult = ReturnType<typeof useViewCommunityEntityByIdQueryQuery>;
export type ViewCommunityEntityByIdQueryLazyQueryHookResult = ReturnType<typeof useViewCommunityEntityByIdQueryLazyQuery>;
export type ViewCommunityEntityByIdQuerySuspenseQueryHookResult = ReturnType<typeof useViewCommunityEntityByIdQuerySuspenseQuery>;
export type ViewCommunityEntityByIdQueryQueryResult = Apollo.QueryResult<ViewCommunityEntityByIdQueryQuery, ViewCommunityEntityByIdQueryQueryVariables>;
export const DeactivateAdminMutationDocument = gql`
    mutation DeactivateAdminMutation($input: DeactivateAdminInput!) {
  deactivateAdmin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeactivateAdminMutationMutationFn = Apollo.MutationFunction<DeactivateAdminMutationMutation, DeactivateAdminMutationMutationVariables>;

/**
 * __useDeactivateAdminMutationMutation__
 *
 * To run a mutation, you first call `useDeactivateAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdminMutationMutation, { data, loading, error }] = useDeactivateAdminMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAdminMutationMutation, DeactivateAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAdminMutationMutation, DeactivateAdminMutationMutationVariables>(DeactivateAdminMutationDocument, options);
      }
export type DeactivateAdminMutationMutationHookResult = ReturnType<typeof useDeactivateAdminMutationMutation>;
export type DeactivateAdminMutationMutationResult = Apollo.MutationResult<DeactivateAdminMutationMutation>;
export type DeactivateAdminMutationMutationOptions = Apollo.BaseMutationOptions<DeactivateAdminMutationMutation, DeactivateAdminMutationMutationVariables>;
export const ReactivateAdminMutationDocument = gql`
    mutation ReactivateAdminMutation($email: String!) {
  reactivateAdmin(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ReactivateAdminMutationMutationFn = Apollo.MutationFunction<ReactivateAdminMutationMutation, ReactivateAdminMutationMutationVariables>;

/**
 * __useReactivateAdminMutationMutation__
 *
 * To run a mutation, you first call `useReactivateAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateAdminMutationMutation, { data, loading, error }] = useReactivateAdminMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReactivateAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateAdminMutationMutation, ReactivateAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateAdminMutationMutation, ReactivateAdminMutationMutationVariables>(ReactivateAdminMutationDocument, options);
      }
export type ReactivateAdminMutationMutationHookResult = ReturnType<typeof useReactivateAdminMutationMutation>;
export type ReactivateAdminMutationMutationResult = Apollo.MutationResult<ReactivateAdminMutationMutation>;
export type ReactivateAdminMutationMutationOptions = Apollo.BaseMutationOptions<ReactivateAdminMutationMutation, ReactivateAdminMutationMutationVariables>;
export const DeactivateCustomerAdminDocument = gql`
    mutation DeactivateCustomerAdmin($input: DeactivateCustomerAdminInput!) {
  deactivateCustomerAdmin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeactivateCustomerAdminMutationFn = Apollo.MutationFunction<DeactivateCustomerAdminMutation, DeactivateCustomerAdminMutationVariables>;

/**
 * __useDeactivateCustomerAdminMutation__
 *
 * To run a mutation, you first call `useDeactivateCustomerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCustomerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCustomerAdminMutation, { data, loading, error }] = useDeactivateCustomerAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateCustomerAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCustomerAdminMutation, DeactivateCustomerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCustomerAdminMutation, DeactivateCustomerAdminMutationVariables>(DeactivateCustomerAdminDocument, options);
      }
export type DeactivateCustomerAdminMutationHookResult = ReturnType<typeof useDeactivateCustomerAdminMutation>;
export type DeactivateCustomerAdminMutationResult = Apollo.MutationResult<DeactivateCustomerAdminMutation>;
export type DeactivateCustomerAdminMutationOptions = Apollo.BaseMutationOptions<DeactivateCustomerAdminMutation, DeactivateCustomerAdminMutationVariables>;
export const ReactivateCustomerAdminDocument = gql`
    mutation ReactivateCustomerAdmin($email: String!) {
  reactivateCustomerAdmin(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ReactivateCustomerAdminMutationFn = Apollo.MutationFunction<ReactivateCustomerAdminMutation, ReactivateCustomerAdminMutationVariables>;

/**
 * __useReactivateCustomerAdminMutation__
 *
 * To run a mutation, you first call `useReactivateCustomerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCustomerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateCustomerAdminMutation, { data, loading, error }] = useReactivateCustomerAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReactivateCustomerAdminMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateCustomerAdminMutation, ReactivateCustomerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateCustomerAdminMutation, ReactivateCustomerAdminMutationVariables>(ReactivateCustomerAdminDocument, options);
      }
export type ReactivateCustomerAdminMutationHookResult = ReturnType<typeof useReactivateCustomerAdminMutation>;
export type ReactivateCustomerAdminMutationResult = Apollo.MutationResult<ReactivateCustomerAdminMutation>;
export type ReactivateCustomerAdminMutationOptions = Apollo.BaseMutationOptions<ReactivateCustomerAdminMutation, ReactivateCustomerAdminMutationVariables>;
export const FindAllCategoriesQueryDocument = gql`
    query FindAllCategoriesQuery {
  findAllCategories {
    id
    name
    imgSrc
    createdAt
  }
}
    `;

/**
 * __useFindAllCategoriesQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCategoriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCategoriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCategoriesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCategoriesQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>(FindAllCategoriesQueryDocument, options);
      }
export function useFindAllCategoriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>(FindAllCategoriesQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCategoriesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>;
export function useFindAllCategoriesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCategoriesQueryQuery | undefined, FindAllCategoriesQueryQueryVariables>;
export function useFindAllCategoriesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>(FindAllCategoriesQueryDocument, options);
        }
export type FindAllCategoriesQueryQueryHookResult = ReturnType<typeof useFindAllCategoriesQueryQuery>;
export type FindAllCategoriesQueryLazyQueryHookResult = ReturnType<typeof useFindAllCategoriesQueryLazyQuery>;
export type FindAllCategoriesQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCategoriesQuerySuspenseQuery>;
export type FindAllCategoriesQueryQueryResult = Apollo.QueryResult<FindAllCategoriesQueryQuery, FindAllCategoriesQueryQueryVariables>;
export const NewCategorySubscriptionDocument = gql`
    subscription NewCategorySubscription {
  newCategory {
    id
    name
    imgSrc
    isArchive
    createdBy {
      id
      role
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewCategorySubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewCategorySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCategorySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCategorySubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewCategorySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewCategorySubscriptionSubscription, NewCategorySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCategorySubscriptionSubscription, NewCategorySubscriptionSubscriptionVariables>(NewCategorySubscriptionDocument, options);
      }
export type NewCategorySubscriptionSubscriptionHookResult = ReturnType<typeof useNewCategorySubscriptionSubscription>;
export type NewCategorySubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewCategorySubscriptionSubscription>;
export const FindCustomersWhoRedeemedOffersDocument = gql`
    query FindCustomersWhoRedeemedOffers($page: Int!, $pageSize: Int!, $communityFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findCustomersWhoRedeemedOffers(
    page: $page
    pageSize: $pageSize
    communityFilter: $communityFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      customer {
        id
        avatarUrl
        firstname
        lastname
        email
        username
        phone
        community {
          id
          name
          alias
        }
        createdAt
        updatedAt
        address
        gender
        dob
        nin
      }
      totalSpent
      location
    }
    pageSize
    page
    total
    totalPages
  }
}
    `;

/**
 * __useFindCustomersWhoRedeemedOffersQuery__
 *
 * To run a query within a React component, call `useFindCustomersWhoRedeemedOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCustomersWhoRedeemedOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCustomersWhoRedeemedOffersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      communityFilter: // value for 'communityFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindCustomersWhoRedeemedOffersQuery(baseOptions: Apollo.QueryHookOptions<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables> & ({ variables: FindCustomersWhoRedeemedOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>(FindCustomersWhoRedeemedOffersDocument, options);
      }
export function useFindCustomersWhoRedeemedOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>(FindCustomersWhoRedeemedOffersDocument, options);
        }
// @ts-ignore
export function useFindCustomersWhoRedeemedOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>;
export function useFindCustomersWhoRedeemedOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindCustomersWhoRedeemedOffersQuery | undefined, FindCustomersWhoRedeemedOffersQueryVariables>;
export function useFindCustomersWhoRedeemedOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>(FindCustomersWhoRedeemedOffersDocument, options);
        }
export type FindCustomersWhoRedeemedOffersQueryHookResult = ReturnType<typeof useFindCustomersWhoRedeemedOffersQuery>;
export type FindCustomersWhoRedeemedOffersLazyQueryHookResult = ReturnType<typeof useFindCustomersWhoRedeemedOffersLazyQuery>;
export type FindCustomersWhoRedeemedOffersSuspenseQueryHookResult = ReturnType<typeof useFindCustomersWhoRedeemedOffersSuspenseQuery>;
export type FindCustomersWhoRedeemedOffersQueryResult = Apollo.QueryResult<FindCustomersWhoRedeemedOffersQuery, FindCustomersWhoRedeemedOffersQueryVariables>;
export const CreateIndustryMutationDocument = gql`
    mutation CreateIndustryMutation($name: String!) {
  createIndustry(name: $name) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateIndustryMutationMutationFn = Apollo.MutationFunction<CreateIndustryMutationMutation, CreateIndustryMutationMutationVariables>;

/**
 * __useCreateIndustryMutationMutation__
 *
 * To run a mutation, you first call `useCreateIndustryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndustryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndustryMutationMutation, { data, loading, error }] = useCreateIndustryMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateIndustryMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndustryMutationMutation, CreateIndustryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndustryMutationMutation, CreateIndustryMutationMutationVariables>(CreateIndustryMutationDocument, options);
      }
export type CreateIndustryMutationMutationHookResult = ReturnType<typeof useCreateIndustryMutationMutation>;
export type CreateIndustryMutationMutationResult = Apollo.MutationResult<CreateIndustryMutationMutation>;
export type CreateIndustryMutationMutationOptions = Apollo.BaseMutationOptions<CreateIndustryMutationMutation, CreateIndustryMutationMutationVariables>;
export const DeleteIndustryMutationDocument = gql`
    mutation DeleteIndustryMutation($id: String!) {
  deleteIndustry(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteIndustryMutationMutationFn = Apollo.MutationFunction<DeleteIndustryMutationMutation, DeleteIndustryMutationMutationVariables>;

/**
 * __useDeleteIndustryMutationMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryMutationMutation, { data, loading, error }] = useDeleteIndustryMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndustryMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryMutationMutation, DeleteIndustryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryMutationMutation, DeleteIndustryMutationMutationVariables>(DeleteIndustryMutationDocument, options);
      }
export type DeleteIndustryMutationMutationHookResult = ReturnType<typeof useDeleteIndustryMutationMutation>;
export type DeleteIndustryMutationMutationResult = Apollo.MutationResult<DeleteIndustryMutationMutation>;
export type DeleteIndustryMutationMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryMutationMutation, DeleteIndustryMutationMutationVariables>;
export const FindAllIndustriesQueryDocument = gql`
    query FindAllIndustriesQuery {
  findAllIndustries {
    id
    name
    createdAt
    updatedAt
    isArchive
    createdBy {
      id
      admin {
        firstname
        lastname
        email
        level
      }
    }
  }
}
    `;

/**
 * __useFindAllIndustriesQueryQuery__
 *
 * To run a query within a React component, call `useFindAllIndustriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllIndustriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllIndustriesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllIndustriesQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>(FindAllIndustriesQueryDocument, options);
      }
export function useFindAllIndustriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>(FindAllIndustriesQueryDocument, options);
        }
// @ts-ignore
export function useFindAllIndustriesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>;
export function useFindAllIndustriesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllIndustriesQueryQuery | undefined, FindAllIndustriesQueryQueryVariables>;
export function useFindAllIndustriesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>(FindAllIndustriesQueryDocument, options);
        }
export type FindAllIndustriesQueryQueryHookResult = ReturnType<typeof useFindAllIndustriesQueryQuery>;
export type FindAllIndustriesQueryLazyQueryHookResult = ReturnType<typeof useFindAllIndustriesQueryLazyQuery>;
export type FindAllIndustriesQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllIndustriesQuerySuspenseQuery>;
export type FindAllIndustriesQueryQueryResult = Apollo.QueryResult<FindAllIndustriesQueryQuery, FindAllIndustriesQueryQueryVariables>;
export const NewIndustrySubscriptionDocument = gql`
    subscription NewIndustrySubscription {
  newIndustry {
    id
    name
    createdAt
    updatedAt
    createdBy {
      id
      admin {
        firstname
        lastname
        email
      }
    }
  }
}
    `;

/**
 * __useNewIndustrySubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewIndustrySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewIndustrySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewIndustrySubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewIndustrySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewIndustrySubscriptionSubscription, NewIndustrySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewIndustrySubscriptionSubscription, NewIndustrySubscriptionSubscriptionVariables>(NewIndustrySubscriptionDocument, options);
      }
export type NewIndustrySubscriptionSubscriptionHookResult = ReturnType<typeof useNewIndustrySubscriptionSubscription>;
export type NewIndustrySubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewIndustrySubscriptionSubscription>;
export const FindAllIndustriesAdminQueryDocument = gql`
    query FindAllIndustriesAdminQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllIndustriesAdmin(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      createdAt
      isArchive
      partnerCount
      createdBy {
        id
        admin {
          id
          firstname
          lastname
          email
          level
        }
      }
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllIndustriesAdminQueryQuery__
 *
 * To run a query within a React component, call `useFindAllIndustriesAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllIndustriesAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllIndustriesAdminQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllIndustriesAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables> & ({ variables: FindAllIndustriesAdminQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>(FindAllIndustriesAdminQueryDocument, options);
      }
export function useFindAllIndustriesAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>(FindAllIndustriesAdminQueryDocument, options);
        }
// @ts-ignore
export function useFindAllIndustriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>;
export function useFindAllIndustriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllIndustriesAdminQueryQuery | undefined, FindAllIndustriesAdminQueryQueryVariables>;
export function useFindAllIndustriesAdminQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>(FindAllIndustriesAdminQueryDocument, options);
        }
export type FindAllIndustriesAdminQueryQueryHookResult = ReturnType<typeof useFindAllIndustriesAdminQueryQuery>;
export type FindAllIndustriesAdminQueryLazyQueryHookResult = ReturnType<typeof useFindAllIndustriesAdminQueryLazyQuery>;
export type FindAllIndustriesAdminQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllIndustriesAdminQuerySuspenseQuery>;
export type FindAllIndustriesAdminQueryQueryResult = Apollo.QueryResult<FindAllIndustriesAdminQueryQuery, FindAllIndustriesAdminQueryQueryVariables>;
export const ViewIndustryQueryDocument = gql`
    query ViewIndustryQuery($id: String!) {
  viewIndustry(id: $id) {
    id
    name
    createdAt
    updatedAt
    isArchive
    partnerCount
    createdBy {
      id
      admin {
        id
        firstname
        lastname
        email
        level
      }
    }
  }
}
    `;

/**
 * __useViewIndustryQueryQuery__
 *
 * To run a query within a React component, call `useViewIndustryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewIndustryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewIndustryQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewIndustryQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables> & ({ variables: ViewIndustryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>(ViewIndustryQueryDocument, options);
      }
export function useViewIndustryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>(ViewIndustryQueryDocument, options);
        }
// @ts-ignore
export function useViewIndustryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>;
export function useViewIndustryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewIndustryQueryQuery | undefined, ViewIndustryQueryQueryVariables>;
export function useViewIndustryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>(ViewIndustryQueryDocument, options);
        }
export type ViewIndustryQueryQueryHookResult = ReturnType<typeof useViewIndustryQueryQuery>;
export type ViewIndustryQueryLazyQueryHookResult = ReturnType<typeof useViewIndustryQueryLazyQuery>;
export type ViewIndustryQuerySuspenseQueryHookResult = ReturnType<typeof useViewIndustryQuerySuspenseQuery>;
export type ViewIndustryQueryQueryResult = Apollo.QueryResult<ViewIndustryQueryQuery, ViewIndustryQueryQueryVariables>;
export const UpdateIndustryMutationDocument = gql`
    mutation UpdateIndustryMutation($industryId: String!, $input: UpdateIndustryInput!) {
  updateIndustry(industryId: $industryId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateIndustryMutationMutationFn = Apollo.MutationFunction<UpdateIndustryMutationMutation, UpdateIndustryMutationMutationVariables>;

/**
 * __useUpdateIndustryMutationMutation__
 *
 * To run a mutation, you first call `useUpdateIndustryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndustryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndustryMutationMutation, { data, loading, error }] = useUpdateIndustryMutationMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndustryMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndustryMutationMutation, UpdateIndustryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndustryMutationMutation, UpdateIndustryMutationMutationVariables>(UpdateIndustryMutationDocument, options);
      }
export type UpdateIndustryMutationMutationHookResult = ReturnType<typeof useUpdateIndustryMutationMutation>;
export type UpdateIndustryMutationMutationResult = Apollo.MutationResult<UpdateIndustryMutationMutation>;
export type UpdateIndustryMutationMutationOptions = Apollo.BaseMutationOptions<UpdateIndustryMutationMutation, UpdateIndustryMutationMutationVariables>;
export const BusinessOnboardingStepOneMutationDocument = gql`
    mutation BusinessOnboardingStepOneMutation($businessName: String!, $businessType: String!, $regCountry: String!, $businessRegNumber: String!, $taxId: String, $address: String!, $addressAlt: String, $city: String!, $country: String!, $postcode: String) {
  businessOnboardingStepOne(
    businessName: $businessName
    businessType: $businessType
    regCountry: $regCountry
    businessRegNumber: $businessRegNumber
    taxId: $taxId
    address: $address
    addressAlt: $addressAlt
    city: $city
    country: $country
    postcode: $postcode
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type BusinessOnboardingStepOneMutationMutationFn = Apollo.MutationFunction<BusinessOnboardingStepOneMutationMutation, BusinessOnboardingStepOneMutationMutationVariables>;

/**
 * __useBusinessOnboardingStepOneMutationMutation__
 *
 * To run a mutation, you first call `useBusinessOnboardingStepOneMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessOnboardingStepOneMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessOnboardingStepOneMutationMutation, { data, loading, error }] = useBusinessOnboardingStepOneMutationMutation({
 *   variables: {
 *      businessName: // value for 'businessName'
 *      businessType: // value for 'businessType'
 *      regCountry: // value for 'regCountry'
 *      businessRegNumber: // value for 'businessRegNumber'
 *      taxId: // value for 'taxId'
 *      address: // value for 'address'
 *      addressAlt: // value for 'addressAlt'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useBusinessOnboardingStepOneMutationMutation(baseOptions?: Apollo.MutationHookOptions<BusinessOnboardingStepOneMutationMutation, BusinessOnboardingStepOneMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessOnboardingStepOneMutationMutation, BusinessOnboardingStepOneMutationMutationVariables>(BusinessOnboardingStepOneMutationDocument, options);
      }
export type BusinessOnboardingStepOneMutationMutationHookResult = ReturnType<typeof useBusinessOnboardingStepOneMutationMutation>;
export type BusinessOnboardingStepOneMutationMutationResult = Apollo.MutationResult<BusinessOnboardingStepOneMutationMutation>;
export type BusinessOnboardingStepOneMutationMutationOptions = Apollo.BaseMutationOptions<BusinessOnboardingStepOneMutationMutation, BusinessOnboardingStepOneMutationMutationVariables>;
export const BusinessOnboardingStepTwoMutationDocument = gql`
    mutation BusinessOnboardingStepTwoMutation($username: String!, $industryId: String!, $companyLocation: String!, $logoUrl: String!, $bannerUrl: String!, $description: String!) {
  businessOnboardingStepTwo(
    username: $username
    industryId: $industryId
    companyLocation: $companyLocation
    logoUrl: $logoUrl
    bannerUrl: $bannerUrl
    description: $description
  ) {
    errors {
      path
      message
    }
    message
    logoUrl
    bannerUrl
  }
}
    `;
export type BusinessOnboardingStepTwoMutationMutationFn = Apollo.MutationFunction<BusinessOnboardingStepTwoMutationMutation, BusinessOnboardingStepTwoMutationMutationVariables>;

/**
 * __useBusinessOnboardingStepTwoMutationMutation__
 *
 * To run a mutation, you first call `useBusinessOnboardingStepTwoMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessOnboardingStepTwoMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessOnboardingStepTwoMutationMutation, { data, loading, error }] = useBusinessOnboardingStepTwoMutationMutation({
 *   variables: {
 *      username: // value for 'username'
 *      industryId: // value for 'industryId'
 *      companyLocation: // value for 'companyLocation'
 *      logoUrl: // value for 'logoUrl'
 *      bannerUrl: // value for 'bannerUrl'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useBusinessOnboardingStepTwoMutationMutation(baseOptions?: Apollo.MutationHookOptions<BusinessOnboardingStepTwoMutationMutation, BusinessOnboardingStepTwoMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessOnboardingStepTwoMutationMutation, BusinessOnboardingStepTwoMutationMutationVariables>(BusinessOnboardingStepTwoMutationDocument, options);
      }
export type BusinessOnboardingStepTwoMutationMutationHookResult = ReturnType<typeof useBusinessOnboardingStepTwoMutationMutation>;
export type BusinessOnboardingStepTwoMutationMutationResult = Apollo.MutationResult<BusinessOnboardingStepTwoMutationMutation>;
export type BusinessOnboardingStepTwoMutationMutationOptions = Apollo.BaseMutationOptions<BusinessOnboardingStepTwoMutationMutation, BusinessOnboardingStepTwoMutationMutationVariables>;
export const BestPerformingOffersQueryDocument = gql`
    query BestPerformingOffersQuery {
  bestPerformingOffers {
    id
    title
    offerType
    redemptions
  }
}
    `;

/**
 * __useBestPerformingOffersQueryQuery__
 *
 * To run a query within a React component, call `useBestPerformingOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBestPerformingOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBestPerformingOffersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBestPerformingOffersQueryQuery(baseOptions?: Apollo.QueryHookOptions<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>(BestPerformingOffersQueryDocument, options);
      }
export function useBestPerformingOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>(BestPerformingOffersQueryDocument, options);
        }
// @ts-ignore
export function useBestPerformingOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>;
export function useBestPerformingOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BestPerformingOffersQueryQuery | undefined, BestPerformingOffersQueryQueryVariables>;
export function useBestPerformingOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>(BestPerformingOffersQueryDocument, options);
        }
export type BestPerformingOffersQueryQueryHookResult = ReturnType<typeof useBestPerformingOffersQueryQuery>;
export type BestPerformingOffersQueryLazyQueryHookResult = ReturnType<typeof useBestPerformingOffersQueryLazyQuery>;
export type BestPerformingOffersQuerySuspenseQueryHookResult = ReturnType<typeof useBestPerformingOffersQuerySuspenseQuery>;
export type BestPerformingOffersQueryQueryResult = Apollo.QueryResult<BestPerformingOffersQueryQuery, BestPerformingOffersQueryQueryVariables>;
export const CashFlowOverviewQueryDocument = gql`
    query CashFlowOverviewQuery($duration: String!) {
  cashFlowOverview(duration: $duration) {
    totalCurrentBalance
    totalCashWithdrawn
    totalTransactionValue
  }
}
    `;

/**
 * __useCashFlowOverviewQueryQuery__
 *
 * To run a query within a React component, call `useCashFlowOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowOverviewQueryQuery({
 *   variables: {
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCashFlowOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables> & ({ variables: CashFlowOverviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>(CashFlowOverviewQueryDocument, options);
      }
export function useCashFlowOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>(CashFlowOverviewQueryDocument, options);
        }
// @ts-ignore
export function useCashFlowOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>;
export function useCashFlowOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CashFlowOverviewQueryQuery | undefined, CashFlowOverviewQueryQueryVariables>;
export function useCashFlowOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>(CashFlowOverviewQueryDocument, options);
        }
export type CashFlowOverviewQueryQueryHookResult = ReturnType<typeof useCashFlowOverviewQueryQuery>;
export type CashFlowOverviewQueryLazyQueryHookResult = ReturnType<typeof useCashFlowOverviewQueryLazyQuery>;
export type CashFlowOverviewQuerySuspenseQueryHookResult = ReturnType<typeof useCashFlowOverviewQuerySuspenseQuery>;
export type CashFlowOverviewQueryQueryResult = Apollo.QueryResult<CashFlowOverviewQueryQuery, CashFlowOverviewQueryQueryVariables>;
export const PublishedOffersOverviewQueryDocument = gql`
    query PublishedOffersOverviewQuery {
  publishedOffersOverview {
    offerTypes {
      offerType
      count
    }
    totalOffers
  }
}
    `;

/**
 * __usePublishedOffersOverviewQueryQuery__
 *
 * To run a query within a React component, call `usePublishedOffersOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedOffersOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedOffersOverviewQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedOffersOverviewQueryQuery(baseOptions?: Apollo.QueryHookOptions<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>(PublishedOffersOverviewQueryDocument, options);
      }
export function usePublishedOffersOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>(PublishedOffersOverviewQueryDocument, options);
        }
// @ts-ignore
export function usePublishedOffersOverviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>;
export function usePublishedOffersOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PublishedOffersOverviewQueryQuery | undefined, PublishedOffersOverviewQueryQueryVariables>;
export function usePublishedOffersOverviewQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>(PublishedOffersOverviewQueryDocument, options);
        }
export type PublishedOffersOverviewQueryQueryHookResult = ReturnType<typeof usePublishedOffersOverviewQueryQuery>;
export type PublishedOffersOverviewQueryLazyQueryHookResult = ReturnType<typeof usePublishedOffersOverviewQueryLazyQuery>;
export type PublishedOffersOverviewQuerySuspenseQueryHookResult = ReturnType<typeof usePublishedOffersOverviewQuerySuspenseQuery>;
export type PublishedOffersOverviewQueryQueryResult = Apollo.QueryResult<PublishedOffersOverviewQueryQuery, PublishedOffersOverviewQueryQueryVariables>;
export const FindAllMyCommunitySpendDocument = gql`
    query FindAllMyCommunitySpend($page: Int!, $pageSize: Int!, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllMyCommunitySpend(
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      community {
        id
        name
        alias
        logoUrl
        createdAt
        updatedAt
      }
      totalSpend
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllMyCommunitySpendQuery__
 *
 * To run a query within a React component, call `useFindAllMyCommunitySpendQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllMyCommunitySpendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllMyCommunitySpendQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllMyCommunitySpendQuery(baseOptions: Apollo.QueryHookOptions<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables> & ({ variables: FindAllMyCommunitySpendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>(FindAllMyCommunitySpendDocument, options);
      }
export function useFindAllMyCommunitySpendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>(FindAllMyCommunitySpendDocument, options);
        }
// @ts-ignore
export function useFindAllMyCommunitySpendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>;
export function useFindAllMyCommunitySpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllMyCommunitySpendQuery | undefined, FindAllMyCommunitySpendQueryVariables>;
export function useFindAllMyCommunitySpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>(FindAllMyCommunitySpendDocument, options);
        }
export type FindAllMyCommunitySpendQueryHookResult = ReturnType<typeof useFindAllMyCommunitySpendQuery>;
export type FindAllMyCommunitySpendLazyQueryHookResult = ReturnType<typeof useFindAllMyCommunitySpendLazyQuery>;
export type FindAllMyCommunitySpendSuspenseQueryHookResult = ReturnType<typeof useFindAllMyCommunitySpendSuspenseQuery>;
export type FindAllMyCommunitySpendQueryResult = Apollo.QueryResult<FindAllMyCommunitySpendQuery, FindAllMyCommunitySpendQueryVariables>;
export const FindMerchantCommunitiesFromOffersDocument = gql`
    query FindMerchantCommunitiesFromOffers {
  findMerchantCommunitiesFromOffers {
    id
    name
    alias
    logoUrl
    colorCode
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindMerchantCommunitiesFromOffersQuery__
 *
 * To run a query within a React component, call `useFindMerchantCommunitiesFromOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMerchantCommunitiesFromOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMerchantCommunitiesFromOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMerchantCommunitiesFromOffersQuery(baseOptions?: Apollo.QueryHookOptions<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>(FindMerchantCommunitiesFromOffersDocument, options);
      }
export function useFindMerchantCommunitiesFromOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>(FindMerchantCommunitiesFromOffersDocument, options);
        }
// @ts-ignore
export function useFindMerchantCommunitiesFromOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>;
export function useFindMerchantCommunitiesFromOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindMerchantCommunitiesFromOffersQuery | undefined, FindMerchantCommunitiesFromOffersQueryVariables>;
export function useFindMerchantCommunitiesFromOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>(FindMerchantCommunitiesFromOffersDocument, options);
        }
export type FindMerchantCommunitiesFromOffersQueryHookResult = ReturnType<typeof useFindMerchantCommunitiesFromOffersQuery>;
export type FindMerchantCommunitiesFromOffersLazyQueryHookResult = ReturnType<typeof useFindMerchantCommunitiesFromOffersLazyQuery>;
export type FindMerchantCommunitiesFromOffersSuspenseQueryHookResult = ReturnType<typeof useFindMerchantCommunitiesFromOffersSuspenseQuery>;
export type FindMerchantCommunitiesFromOffersQueryResult = Apollo.QueryResult<FindMerchantCommunitiesFromOffersQuery, FindMerchantCommunitiesFromOffersQueryVariables>;
export const NewMerchantApprovalDocument = gql`
    mutation NewMerchantApproval($merchantId: String!) {
  newMerchantApproval(merchantId: $merchantId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type NewMerchantApprovalMutationFn = Apollo.MutationFunction<NewMerchantApprovalMutation, NewMerchantApprovalMutationVariables>;

/**
 * __useNewMerchantApprovalMutation__
 *
 * To run a mutation, you first call `useNewMerchantApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewMerchantApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newMerchantApprovalMutation, { data, loading, error }] = useNewMerchantApprovalMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useNewMerchantApprovalMutation(baseOptions?: Apollo.MutationHookOptions<NewMerchantApprovalMutation, NewMerchantApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewMerchantApprovalMutation, NewMerchantApprovalMutationVariables>(NewMerchantApprovalDocument, options);
      }
export type NewMerchantApprovalMutationHookResult = ReturnType<typeof useNewMerchantApprovalMutation>;
export type NewMerchantApprovalMutationResult = Apollo.MutationResult<NewMerchantApprovalMutation>;
export type NewMerchantApprovalMutationOptions = Apollo.BaseMutationOptions<NewMerchantApprovalMutation, NewMerchantApprovalMutationVariables>;
export const RegisterMerchantMutationDocument = gql`
    mutation RegisterMerchantMutation($firstname: String!, $lastname: String!, $companyName: String!, $email: String!, $phone: String!, $websiteOrSocials: String, $password: String!, $confirmPassword: String!, $nda: Boolean!) {
  registerMerchant(
    firstname: $firstname
    lastname: $lastname
    companyName: $companyName
    email: $email
    phone: $phone
    websiteOrSocials: $websiteOrSocials
    password: $password
    confirmPassword: $confirmPassword
    nda: $nda
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type RegisterMerchantMutationMutationFn = Apollo.MutationFunction<RegisterMerchantMutationMutation, RegisterMerchantMutationMutationVariables>;

/**
 * __useRegisterMerchantMutationMutation__
 *
 * To run a mutation, you first call `useRegisterMerchantMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMerchantMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMerchantMutationMutation, { data, loading, error }] = useRegisterMerchantMutationMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      companyName: // value for 'companyName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      websiteOrSocials: // value for 'websiteOrSocials'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *      nda: // value for 'nda'
 *   },
 * });
 */
export function useRegisterMerchantMutationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMerchantMutationMutation, RegisterMerchantMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMerchantMutationMutation, RegisterMerchantMutationMutationVariables>(RegisterMerchantMutationDocument, options);
      }
export type RegisterMerchantMutationMutationHookResult = ReturnType<typeof useRegisterMerchantMutationMutation>;
export type RegisterMerchantMutationMutationResult = Apollo.MutationResult<RegisterMerchantMutationMutation>;
export type RegisterMerchantMutationMutationOptions = Apollo.BaseMutationOptions<RegisterMerchantMutationMutation, RegisterMerchantMutationMutationVariables>;
export const TopMerchantsDocument = gql`
    query TopMerchants($offset: Int!, $limit: Int!) {
  topMerchants(offset: $offset, limit: $limit) {
    id
    admin {
      id
      merchantProfile {
        id
        companyName
        username
        companyLocation
        logoUrl
        bannerUrl
        description
      }
    }
    isVerified
  }
}
    `;

/**
 * __useTopMerchantsQuery__
 *
 * To run a query within a React component, call `useTopMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopMerchantsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTopMerchantsQuery(baseOptions: Apollo.QueryHookOptions<TopMerchantsQuery, TopMerchantsQueryVariables> & ({ variables: TopMerchantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopMerchantsQuery, TopMerchantsQueryVariables>(TopMerchantsDocument, options);
      }
export function useTopMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopMerchantsQuery, TopMerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopMerchantsQuery, TopMerchantsQueryVariables>(TopMerchantsDocument, options);
        }
// @ts-ignore
export function useTopMerchantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopMerchantsQuery, TopMerchantsQueryVariables>): Apollo.UseSuspenseQueryResult<TopMerchantsQuery, TopMerchantsQueryVariables>;
export function useTopMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopMerchantsQuery, TopMerchantsQueryVariables>): Apollo.UseSuspenseQueryResult<TopMerchantsQuery | undefined, TopMerchantsQueryVariables>;
export function useTopMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopMerchantsQuery, TopMerchantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopMerchantsQuery, TopMerchantsQueryVariables>(TopMerchantsDocument, options);
        }
export type TopMerchantsQueryHookResult = ReturnType<typeof useTopMerchantsQuery>;
export type TopMerchantsLazyQueryHookResult = ReturnType<typeof useTopMerchantsLazyQuery>;
export type TopMerchantsSuspenseQueryHookResult = ReturnType<typeof useTopMerchantsSuspenseQuery>;
export type TopMerchantsQueryResult = Apollo.QueryResult<TopMerchantsQuery, TopMerchantsQueryVariables>;
export const MarkNjoyCodeAsUsedMutationDocument = gql`
    mutation MarkNjoyCodeAsUsedMutation($adminId: String!, $njoyCode: String!) {
  markNjoyCodeAsUsed(adminId: $adminId, njoyCode: $njoyCode) {
    errors {
      path
      message
    }
    message
    njoyCode
  }
}
    `;
export type MarkNjoyCodeAsUsedMutationMutationFn = Apollo.MutationFunction<MarkNjoyCodeAsUsedMutationMutation, MarkNjoyCodeAsUsedMutationMutationVariables>;

/**
 * __useMarkNjoyCodeAsUsedMutationMutation__
 *
 * To run a mutation, you first call `useMarkNjoyCodeAsUsedMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNjoyCodeAsUsedMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNjoyCodeAsUsedMutationMutation, { data, loading, error }] = useMarkNjoyCodeAsUsedMutationMutation({
 *   variables: {
 *      adminId: // value for 'adminId'
 *      njoyCode: // value for 'njoyCode'
 *   },
 * });
 */
export function useMarkNjoyCodeAsUsedMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarkNjoyCodeAsUsedMutationMutation, MarkNjoyCodeAsUsedMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNjoyCodeAsUsedMutationMutation, MarkNjoyCodeAsUsedMutationMutationVariables>(MarkNjoyCodeAsUsedMutationDocument, options);
      }
export type MarkNjoyCodeAsUsedMutationMutationHookResult = ReturnType<typeof useMarkNjoyCodeAsUsedMutationMutation>;
export type MarkNjoyCodeAsUsedMutationMutationResult = Apollo.MutationResult<MarkNjoyCodeAsUsedMutationMutation>;
export type MarkNjoyCodeAsUsedMutationMutationOptions = Apollo.BaseMutationOptions<MarkNjoyCodeAsUsedMutationMutation, MarkNjoyCodeAsUsedMutationMutationVariables>;
export const VerifyNjoyCodeQueryDocument = gql`
    query VerifyNjoyCodeQuery($njoyCode: String!) {
  verifyNjoyCode(njoyCode: $njoyCode) {
    errors {
      path
      message
    }
    message
    data {
      offerTitle
      offerType
      offerCode
      status
      redeemedDate
      usedDate
    }
  }
}
    `;

/**
 * __useVerifyNjoyCodeQueryQuery__
 *
 * To run a query within a React component, call `useVerifyNjoyCodeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyNjoyCodeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyNjoyCodeQueryQuery({
 *   variables: {
 *      njoyCode: // value for 'njoyCode'
 *   },
 * });
 */
export function useVerifyNjoyCodeQueryQuery(baseOptions: Apollo.QueryHookOptions<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables> & ({ variables: VerifyNjoyCodeQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>(VerifyNjoyCodeQueryDocument, options);
      }
export function useVerifyNjoyCodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>(VerifyNjoyCodeQueryDocument, options);
        }
// @ts-ignore
export function useVerifyNjoyCodeQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>;
export function useVerifyNjoyCodeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<VerifyNjoyCodeQueryQuery | undefined, VerifyNjoyCodeQueryQueryVariables>;
export function useVerifyNjoyCodeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>(VerifyNjoyCodeQueryDocument, options);
        }
export type VerifyNjoyCodeQueryQueryHookResult = ReturnType<typeof useVerifyNjoyCodeQueryQuery>;
export type VerifyNjoyCodeQueryLazyQueryHookResult = ReturnType<typeof useVerifyNjoyCodeQueryLazyQuery>;
export type VerifyNjoyCodeQuerySuspenseQueryHookResult = ReturnType<typeof useVerifyNjoyCodeQuerySuspenseQuery>;
export type VerifyNjoyCodeQueryQueryResult = Apollo.QueryResult<VerifyNjoyCodeQueryQuery, VerifyNjoyCodeQueryQueryVariables>;
export const CreateOfferMutationDocument = gql`
    mutation CreateOfferMutation($title: String!, $description: String!, $bannerUrl: String, $categoryId: String!, $offerType: String!, $discountType: String, $discountValue: Int, $amount: Float, $njoyCodeId: String, $partnerVoucher: [String], $referralUrl: String, $status: String!, $usageLimitPerUser: Int!, $totalUsageLimit: Int, $startDate: String!, $endDate: String, $communityId: [String!], $locationId: [String!], $offerTOR: String!, $merchantId: String) {
  createOffer(
    title: $title
    description: $description
    bannerUrl: $bannerUrl
    categoryId: $categoryId
    offerType: $offerType
    discountType: $discountType
    discountValue: $discountValue
    amount: $amount
    njoyCodeId: $njoyCodeId
    partnerVoucher: $partnerVoucher
    referralUrl: $referralUrl
    status: $status
    usageLimitPerUser: $usageLimitPerUser
    totalUsageLimit: $totalUsageLimit
    startDate: $startDate
    endDate: $endDate
    communityId: $communityId
    locationId: $locationId
    offerTOR: $offerTOR
    merchantId: $merchantId
  ) {
    errors {
      path
      message
    }
    message
    bannerUrl
    offerId
  }
}
    `;
export type CreateOfferMutationMutationFn = Apollo.MutationFunction<CreateOfferMutationMutation, CreateOfferMutationMutationVariables>;

/**
 * __useCreateOfferMutationMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutationMutation, { data, loading, error }] = useCreateOfferMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      bannerUrl: // value for 'bannerUrl'
 *      categoryId: // value for 'categoryId'
 *      offerType: // value for 'offerType'
 *      discountType: // value for 'discountType'
 *      discountValue: // value for 'discountValue'
 *      amount: // value for 'amount'
 *      njoyCodeId: // value for 'njoyCodeId'
 *      partnerVoucher: // value for 'partnerVoucher'
 *      referralUrl: // value for 'referralUrl'
 *      status: // value for 'status'
 *      usageLimitPerUser: // value for 'usageLimitPerUser'
 *      totalUsageLimit: // value for 'totalUsageLimit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      communityId: // value for 'communityId'
 *      locationId: // value for 'locationId'
 *      offerTOR: // value for 'offerTOR'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useCreateOfferMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferMutationMutation, CreateOfferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferMutationMutation, CreateOfferMutationMutationVariables>(CreateOfferMutationDocument, options);
      }
export type CreateOfferMutationMutationHookResult = ReturnType<typeof useCreateOfferMutationMutation>;
export type CreateOfferMutationMutationResult = Apollo.MutationResult<CreateOfferMutationMutation>;
export type CreateOfferMutationMutationOptions = Apollo.BaseMutationOptions<CreateOfferMutationMutation, CreateOfferMutationMutationVariables>;
export const DeleteOfferMutationDocument = gql`
    mutation DeleteOfferMutation($id: String!) {
  deleteOffer(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeleteOfferMutationMutationFn = Apollo.MutationFunction<DeleteOfferMutationMutation, DeleteOfferMutationMutationVariables>;

/**
 * __useDeleteOfferMutationMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferMutationMutation, { data, loading, error }] = useDeleteOfferMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferMutationMutation, DeleteOfferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferMutationMutation, DeleteOfferMutationMutationVariables>(DeleteOfferMutationDocument, options);
      }
export type DeleteOfferMutationMutationHookResult = ReturnType<typeof useDeleteOfferMutationMutation>;
export type DeleteOfferMutationMutationResult = Apollo.MutationResult<DeleteOfferMutationMutation>;
export type DeleteOfferMutationMutationOptions = Apollo.BaseMutationOptions<DeleteOfferMutationMutation, DeleteOfferMutationMutationVariables>;
export const FindAdminOffersDocument = gql`
    query FindAdminOffers($page: Int!, $pageSize: Int!, $duration: String, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAdminOffers(
    page: $page
    pageSize: $pageSize
    duration: $duration
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    pageOffers {
      data {
        id
        title
        offerType
        redemptions
        startDate
        endDate
        status
        createdAt
        createdBy {
          admin {
            id
            merchantProfile {
              id
              companyName
            }
          }
        }
      }
      total
      page
      pageSize
      totalPages
    }
    redeemedOffers
    publishedOffers
    offerViews
    offerClicks
  }
}
    `;

/**
 * __useFindAdminOffersQuery__
 *
 * To run a query within a React component, call `useFindAdminOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAdminOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAdminOffersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      duration: // value for 'duration'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAdminOffersQuery(baseOptions: Apollo.QueryHookOptions<FindAdminOffersQuery, FindAdminOffersQueryVariables> & ({ variables: FindAdminOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAdminOffersQuery, FindAdminOffersQueryVariables>(FindAdminOffersDocument, options);
      }
export function useFindAdminOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAdminOffersQuery, FindAdminOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAdminOffersQuery, FindAdminOffersQueryVariables>(FindAdminOffersDocument, options);
        }
// @ts-ignore
export function useFindAdminOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAdminOffersQuery, FindAdminOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminOffersQuery, FindAdminOffersQueryVariables>;
export function useFindAdminOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminOffersQuery, FindAdminOffersQueryVariables>): Apollo.UseSuspenseQueryResult<FindAdminOffersQuery | undefined, FindAdminOffersQueryVariables>;
export function useFindAdminOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAdminOffersQuery, FindAdminOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAdminOffersQuery, FindAdminOffersQueryVariables>(FindAdminOffersDocument, options);
        }
export type FindAdminOffersQueryHookResult = ReturnType<typeof useFindAdminOffersQuery>;
export type FindAdminOffersLazyQueryHookResult = ReturnType<typeof useFindAdminOffersLazyQuery>;
export type FindAdminOffersSuspenseQueryHookResult = ReturnType<typeof useFindAdminOffersSuspenseQuery>;
export type FindAdminOffersQueryResult = Apollo.QueryResult<FindAdminOffersQuery, FindAdminOffersQueryVariables>;
export const FindRecentOfferRedemptionsByIdDocument = gql`
    query FindRecentOfferRedemptionsById($offerId: String!, $page: Int!, $pageSize: Int!, $searchText: String, $duration: String) {
  findRecentOfferRedemptionsById(
    offerId: $offerId
    page: $page
    pageSize: $pageSize
    searchText: $searchText
    duration: $duration
  ) {
    data {
      customer {
        id
        firstname
        lastname
        username
        community {
          id
          name
          alias
        }
      }
      redeemedCode
      redemptionDate
    }
    redeemedCodes
    remainingCodes
    totalOfferViews
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindRecentOfferRedemptionsByIdQuery__
 *
 * To run a query within a React component, call `useFindRecentOfferRedemptionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRecentOfferRedemptionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRecentOfferRedemptionsByIdQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useFindRecentOfferRedemptionsByIdQuery(baseOptions: Apollo.QueryHookOptions<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables> & ({ variables: FindRecentOfferRedemptionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>(FindRecentOfferRedemptionsByIdDocument, options);
      }
export function useFindRecentOfferRedemptionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>(FindRecentOfferRedemptionsByIdDocument, options);
        }
// @ts-ignore
export function useFindRecentOfferRedemptionsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>;
export function useFindRecentOfferRedemptionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindRecentOfferRedemptionsByIdQuery | undefined, FindRecentOfferRedemptionsByIdQueryVariables>;
export function useFindRecentOfferRedemptionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>(FindRecentOfferRedemptionsByIdDocument, options);
        }
export type FindRecentOfferRedemptionsByIdQueryHookResult = ReturnType<typeof useFindRecentOfferRedemptionsByIdQuery>;
export type FindRecentOfferRedemptionsByIdLazyQueryHookResult = ReturnType<typeof useFindRecentOfferRedemptionsByIdLazyQuery>;
export type FindRecentOfferRedemptionsByIdSuspenseQueryHookResult = ReturnType<typeof useFindRecentOfferRedemptionsByIdSuspenseQuery>;
export type FindRecentOfferRedemptionsByIdQueryResult = Apollo.QueryResult<FindRecentOfferRedemptionsByIdQuery, FindRecentOfferRedemptionsByIdQueryVariables>;
export const UpdateOfferMutationDocument = gql`
    mutation UpdateOfferMutation($offerId: String!, $input: UpdateOfferInput!) {
  updateOffer(offerId: $offerId, input: $input) {
    errors {
      path
      message
    }
    message
    bannerUrl
  }
}
    `;
export type UpdateOfferMutationMutationFn = Apollo.MutationFunction<UpdateOfferMutationMutation, UpdateOfferMutationMutationVariables>;

/**
 * __useUpdateOfferMutationMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutationMutation, { data, loading, error }] = useUpdateOfferMutationMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutationMutation, UpdateOfferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutationMutation, UpdateOfferMutationMutationVariables>(UpdateOfferMutationDocument, options);
      }
export type UpdateOfferMutationMutationHookResult = ReturnType<typeof useUpdateOfferMutationMutation>;
export type UpdateOfferMutationMutationResult = Apollo.MutationResult<UpdateOfferMutationMutation>;
export type UpdateOfferMutationMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutationMutation, UpdateOfferMutationMutationVariables>;
export const CreateRefundMutationDocument = gql`
    mutation CreateRefundMutation($input: CreateRefundInput!) {
  createRefund(input: $input) {
    errors {
      path
      message
    }
    message
    data {
      id
      account_number
      bank_code
      full_name
      currency
      debit_currency
      amount
      fee
      status
      reference
      narration
      complete_message
      requires_approval
      is_approved
      bank_name
    }
  }
}
    `;
export type CreateRefundMutationMutationFn = Apollo.MutationFunction<CreateRefundMutationMutation, CreateRefundMutationMutationVariables>;

/**
 * __useCreateRefundMutationMutation__
 *
 * To run a mutation, you first call `useCreateRefundMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundMutationMutation, { data, loading, error }] = useCreateRefundMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRefundMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRefundMutationMutation, CreateRefundMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRefundMutationMutation, CreateRefundMutationMutationVariables>(CreateRefundMutationDocument, options);
      }
export type CreateRefundMutationMutationHookResult = ReturnType<typeof useCreateRefundMutationMutation>;
export type CreateRefundMutationMutationResult = Apollo.MutationResult<CreateRefundMutationMutation>;
export type CreateRefundMutationMutationOptions = Apollo.BaseMutationOptions<CreateRefundMutationMutation, CreateRefundMutationMutationVariables>;
export const FindRefundsQueryDocument = gql`
    query FindRefundsQuery($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String) {
  findRefunds(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
  ) {
    refund {
      id
      amount
      reasonForRefund
      description
      customerName
      transactionId
      createdAt
      reference
      status
      currency
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindRefundsQueryQuery__
 *
 * To run a query within a React component, call `useFindRefundsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRefundsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRefundsQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindRefundsQueryQuery(baseOptions: Apollo.QueryHookOptions<FindRefundsQueryQuery, FindRefundsQueryQueryVariables> & ({ variables: FindRefundsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>(FindRefundsQueryDocument, options);
      }
export function useFindRefundsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>(FindRefundsQueryDocument, options);
        }
// @ts-ignore
export function useFindRefundsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>;
export function useFindRefundsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindRefundsQueryQuery | undefined, FindRefundsQueryQueryVariables>;
export function useFindRefundsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>(FindRefundsQueryDocument, options);
        }
export type FindRefundsQueryQueryHookResult = ReturnType<typeof useFindRefundsQueryQuery>;
export type FindRefundsQueryLazyQueryHookResult = ReturnType<typeof useFindRefundsQueryLazyQuery>;
export type FindRefundsQuerySuspenseQueryHookResult = ReturnType<typeof useFindRefundsQuerySuspenseQuery>;
export type FindRefundsQueryQueryResult = Apollo.QueryResult<FindRefundsQueryQuery, FindRefundsQueryQueryVariables>;
export const NewRefundSubscriptionDocument = gql`
    subscription NewRefundSubscription {
  newRefund {
    id
    amount
    reasonForRefund
    description
    customerName
    transactionId
    createdAt
    reference
    status
    currency
  }
}
    `;

/**
 * __useNewRefundSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewRefundSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewRefundSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewRefundSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewRefundSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewRefundSubscriptionSubscription, NewRefundSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewRefundSubscriptionSubscription, NewRefundSubscriptionSubscriptionVariables>(NewRefundSubscriptionDocument, options);
      }
export type NewRefundSubscriptionSubscriptionHookResult = ReturnType<typeof useNewRefundSubscriptionSubscription>;
export type NewRefundSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewRefundSubscriptionSubscription>;
export const FindAllCustomerAndMerchantOfferTransactionsDocument = gql`
    query FindAllCustomerAndMerchantOfferTransactions($customerUserId: String!, $merchantUserId: String!, $page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllCustomerAndMerchantOfferTransactions(
    customerUserId: $customerUserId
    merchantUserId: $merchantUserId
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        category {
          name
        }
      }
      njoyCode
      partnerVoucher
      user {
        id
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllCustomerAndMerchantOfferTransactionsQuery__
 *
 * To run a query within a React component, call `useFindAllCustomerAndMerchantOfferTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomerAndMerchantOfferTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomerAndMerchantOfferTransactionsQuery({
 *   variables: {
 *      customerUserId: // value for 'customerUserId'
 *      merchantUserId: // value for 'merchantUserId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllCustomerAndMerchantOfferTransactionsQuery(baseOptions: Apollo.QueryHookOptions<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables> & ({ variables: FindAllCustomerAndMerchantOfferTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>(FindAllCustomerAndMerchantOfferTransactionsDocument, options);
      }
export function useFindAllCustomerAndMerchantOfferTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>(FindAllCustomerAndMerchantOfferTransactionsDocument, options);
        }
// @ts-ignore
export function useFindAllCustomerAndMerchantOfferTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>;
export function useFindAllCustomerAndMerchantOfferTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomerAndMerchantOfferTransactionsQuery | undefined, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>;
export function useFindAllCustomerAndMerchantOfferTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>(FindAllCustomerAndMerchantOfferTransactionsDocument, options);
        }
export type FindAllCustomerAndMerchantOfferTransactionsQueryHookResult = ReturnType<typeof useFindAllCustomerAndMerchantOfferTransactionsQuery>;
export type FindAllCustomerAndMerchantOfferTransactionsLazyQueryHookResult = ReturnType<typeof useFindAllCustomerAndMerchantOfferTransactionsLazyQuery>;
export type FindAllCustomerAndMerchantOfferTransactionsSuspenseQueryHookResult = ReturnType<typeof useFindAllCustomerAndMerchantOfferTransactionsSuspenseQuery>;
export type FindAllCustomerAndMerchantOfferTransactionsQueryResult = Apollo.QueryResult<FindAllCustomerAndMerchantOfferTransactionsQuery, FindAllCustomerAndMerchantOfferTransactionsQueryVariables>;
export const FindAllRedemptionsDocument = gql`
    query FindAllRedemptions($page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findAllRedemptions(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        amount
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community {
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy {
          id
          role
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
        customer {
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllRedemptionsQuery__
 *
 * To run a query within a React component, call `useFindAllRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllRedemptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllRedemptionsQuery(baseOptions: Apollo.QueryHookOptions<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables> & ({ variables: FindAllRedemptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>(FindAllRedemptionsDocument, options);
      }
export function useFindAllRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>(FindAllRedemptionsDocument, options);
        }
// @ts-ignore
export function useFindAllRedemptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>;
export function useFindAllRedemptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllRedemptionsQuery | undefined, FindAllRedemptionsQueryVariables>;
export function useFindAllRedemptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>(FindAllRedemptionsDocument, options);
        }
export type FindAllRedemptionsQueryHookResult = ReturnType<typeof useFindAllRedemptionsQuery>;
export type FindAllRedemptionsLazyQueryHookResult = ReturnType<typeof useFindAllRedemptionsLazyQuery>;
export type FindAllRedemptionsSuspenseQueryHookResult = ReturnType<typeof useFindAllRedemptionsSuspenseQuery>;
export type FindAllRedemptionsQueryResult = Apollo.QueryResult<FindAllRedemptionsQuery, FindAllRedemptionsQueryVariables>;
export const FindAllTransactionsByCommunityIdDocument = gql`
    query FindAllTransactionsByCommunityId($communityId: String!, $page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String) {
  findAllTransactionsByCommunityId(
    communityId: $communityId
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
  ) {
    data {
      transaction {
        id
        amount
        charge
        reference
        type
        status
        currency
        transferTypes
        bankPreference {
          id
        }
        offer {
          id
          title
          description
          category {
            name
          }
          createdBy {
            id
            role
          }
        }
        njoyCode
        partnerVoucher
        user {
          id
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
    }
    redeemedOffers
    totalSpend
    totalCustomers
    totalCommunitySize
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllTransactionsByCommunityIdQuery__
 *
 * To run a query within a React component, call `useFindAllTransactionsByCommunityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllTransactionsByCommunityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllTransactionsByCommunityIdQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindAllTransactionsByCommunityIdQuery(baseOptions: Apollo.QueryHookOptions<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables> & ({ variables: FindAllTransactionsByCommunityIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>(FindAllTransactionsByCommunityIdDocument, options);
      }
export function useFindAllTransactionsByCommunityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>(FindAllTransactionsByCommunityIdDocument, options);
        }
// @ts-ignore
export function useFindAllTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>;
export function useFindAllTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllTransactionsByCommunityIdQuery | undefined, FindAllTransactionsByCommunityIdQueryVariables>;
export function useFindAllTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>(FindAllTransactionsByCommunityIdDocument, options);
        }
export type FindAllTransactionsByCommunityIdQueryHookResult = ReturnType<typeof useFindAllTransactionsByCommunityIdQuery>;
export type FindAllTransactionsByCommunityIdLazyQueryHookResult = ReturnType<typeof useFindAllTransactionsByCommunityIdLazyQuery>;
export type FindAllTransactionsByCommunityIdSuspenseQueryHookResult = ReturnType<typeof useFindAllTransactionsByCommunityIdSuspenseQuery>;
export type FindAllTransactionsByCommunityIdQueryResult = Apollo.QueryResult<FindAllTransactionsByCommunityIdQuery, FindAllTransactionsByCommunityIdQueryVariables>;
export const FindTransactionsByCommunityIdDocument = gql`
    query FindTransactionsByCommunityId($communityId: String!, $page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findTransactionsByCommunityId(
    communityId: $communityId
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      transaction {
        id
        amount
        charge
        reference
        type
        status
        currency
        transferTypes
        bankPreference {
          id
        }
        offer {
          id
          title
          description
          category {
            name
          }
          createdBy {
            id
            role
          }
        }
        njoyCode
        partnerVoucher
        user {
          id
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
    }
    redeemedOffers
    totalSpend
    totalCustomers
    totalCommunitySize
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindTransactionsByCommunityIdQuery__
 *
 * To run a query within a React component, call `useFindTransactionsByCommunityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsByCommunityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsByCommunityIdQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindTransactionsByCommunityIdQuery(baseOptions: Apollo.QueryHookOptions<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables> & ({ variables: FindTransactionsByCommunityIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>(FindTransactionsByCommunityIdDocument, options);
      }
export function useFindTransactionsByCommunityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>(FindTransactionsByCommunityIdDocument, options);
        }
// @ts-ignore
export function useFindTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>;
export function useFindTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByCommunityIdQuery | undefined, FindTransactionsByCommunityIdQueryVariables>;
export function useFindTransactionsByCommunityIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>(FindTransactionsByCommunityIdDocument, options);
        }
export type FindTransactionsByCommunityIdQueryHookResult = ReturnType<typeof useFindTransactionsByCommunityIdQuery>;
export type FindTransactionsByCommunityIdLazyQueryHookResult = ReturnType<typeof useFindTransactionsByCommunityIdLazyQuery>;
export type FindTransactionsByCommunityIdSuspenseQueryHookResult = ReturnType<typeof useFindTransactionsByCommunityIdSuspenseQuery>;
export type FindTransactionsByCommunityIdQueryResult = Apollo.QueryResult<FindTransactionsByCommunityIdQuery, FindTransactionsByCommunityIdQueryVariables>;
export const FindTransactionsBySessionDocument = gql`
    query FindTransactionsBySession($page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findTransactionsBySession(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        amount
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community {
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy {
          id
          role
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
        customer {
          firstname
          lastname
        }
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindTransactionsBySessionQuery__
 *
 * To run a query within a React component, call `useFindTransactionsBySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsBySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsBySessionQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindTransactionsBySessionQuery(baseOptions: Apollo.QueryHookOptions<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables> & ({ variables: FindTransactionsBySessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>(FindTransactionsBySessionDocument, options);
      }
export function useFindTransactionsBySessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>(FindTransactionsBySessionDocument, options);
        }
// @ts-ignore
export function useFindTransactionsBySessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>;
export function useFindTransactionsBySessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsBySessionQuery | undefined, FindTransactionsBySessionQueryVariables>;
export function useFindTransactionsBySessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>(FindTransactionsBySessionDocument, options);
        }
export type FindTransactionsBySessionQueryHookResult = ReturnType<typeof useFindTransactionsBySessionQuery>;
export type FindTransactionsBySessionLazyQueryHookResult = ReturnType<typeof useFindTransactionsBySessionLazyQuery>;
export type FindTransactionsBySessionSuspenseQueryHookResult = ReturnType<typeof useFindTransactionsBySessionSuspenseQuery>;
export type FindTransactionsBySessionQueryResult = Apollo.QueryResult<FindTransactionsBySessionQuery, FindTransactionsBySessionQueryVariables>;
export const FindTransactionsByUserIdDocument = gql`
    query FindTransactionsByUserId($userId: String!, $page: Int!, $pageSize: Int!, $statusFilter: String, $typeFilter: String, $searchText: String, $sortBy: String, $sortOrder: String) {
  findTransactionsByUserId(
    userId: $userId
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      bankPreference {
        id
      }
      offer {
        id
        title
        description
        category {
          name
        }
      }
      njoyCode
      partnerVoucher
      user {
        id
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindTransactionsByUserIdQuery__
 *
 * To run a query within a React component, call `useFindTransactionsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindTransactionsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables> & ({ variables: FindTransactionsByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>(FindTransactionsByUserIdDocument, options);
      }
export function useFindTransactionsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>(FindTransactionsByUserIdDocument, options);
        }
// @ts-ignore
export function useFindTransactionsByUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>;
export function useFindTransactionsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByUserIdQuery | undefined, FindTransactionsByUserIdQueryVariables>;
export function useFindTransactionsByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>(FindTransactionsByUserIdDocument, options);
        }
export type FindTransactionsByUserIdQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdQuery>;
export type FindTransactionsByUserIdLazyQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdLazyQuery>;
export type FindTransactionsByUserIdSuspenseQueryHookResult = ReturnType<typeof useFindTransactionsByUserIdSuspenseQuery>;
export type FindTransactionsByUserIdQueryResult = Apollo.QueryResult<FindTransactionsByUserIdQuery, FindTransactionsByUserIdQueryVariables>;
export const FindTransactionsByRecipientWalletIdQueryDocument = gql`
    query FindTransactionsByRecipientWalletIdQuery($page: Int!, $pageSize: Int!, $duration: String, $statusFilter: String, $typeFilter: String, $searchText: String) {
  findTransactionsByRecipientWalletId(
    page: $page
    pageSize: $pageSize
    duration: $duration
    statusFilter: $statusFilter
    typeFilter: $typeFilter
    searchText: $searchText
  ) {
    pageTransactions {
      data {
        id
        amount
        charge
        reference
        type
        status
        currency
        transferTypes
        bankPreference {
          id
        }
        offer {
          id
          title
          description
          bannerUrl
          category {
            id
            name
            imgSrc
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          offerType
          discountType
          discountValue
          partnerVoucher
          amount
          referralUrl
          status
          usageLimitPerUser
          totalUsageLimit
          startDate
          endDate
          community {
            id
            name
            alias
          }
          redemptions
          revenueGenerated
          clickThroughs
          featured
          createdBy {
            id
            role
            admin {
              id
              shortId
              firstname
              lastname
              email
              phone
              merchantProfile {
                id
                businessName
                businessType
                regCountry
                businessRegNumber
                taxId
                address
                addressAlt
                city
                country
                postcode
                companyName
                username
                industry {
                  id
                  name
                  createdBy {
                    id
                    role
                  }
                  createdAt
                  updatedAt
                }
                companyLocation
                logoUrl
                bannerUrl
                description
                commissionRate
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
          createdAt
          updatedAt
        }
        njoyCode
        partnerVoucher
        user {
          id
        }
        createdAt
        updatedAt
      }
      total
      page
      pageSize
      totalPages
    }
    currentBalance
    amountWithdrawn
    amountReceived
  }
}
    `;

/**
 * __useFindTransactionsByRecipientWalletIdQueryQuery__
 *
 * To run a query within a React component, call `useFindTransactionsByRecipientWalletIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsByRecipientWalletIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsByRecipientWalletIdQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      duration: // value for 'duration'
 *      statusFilter: // value for 'statusFilter'
 *      typeFilter: // value for 'typeFilter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindTransactionsByRecipientWalletIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables> & ({ variables: FindTransactionsByRecipientWalletIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>(FindTransactionsByRecipientWalletIdQueryDocument, options);
      }
export function useFindTransactionsByRecipientWalletIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>(FindTransactionsByRecipientWalletIdQueryDocument, options);
        }
// @ts-ignore
export function useFindTransactionsByRecipientWalletIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>;
export function useFindTransactionsByRecipientWalletIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindTransactionsByRecipientWalletIdQueryQuery | undefined, FindTransactionsByRecipientWalletIdQueryQueryVariables>;
export function useFindTransactionsByRecipientWalletIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>(FindTransactionsByRecipientWalletIdQueryDocument, options);
        }
export type FindTransactionsByRecipientWalletIdQueryQueryHookResult = ReturnType<typeof useFindTransactionsByRecipientWalletIdQueryQuery>;
export type FindTransactionsByRecipientWalletIdQueryLazyQueryHookResult = ReturnType<typeof useFindTransactionsByRecipientWalletIdQueryLazyQuery>;
export type FindTransactionsByRecipientWalletIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindTransactionsByRecipientWalletIdQuerySuspenseQuery>;
export type FindTransactionsByRecipientWalletIdQueryQueryResult = Apollo.QueryResult<FindTransactionsByRecipientWalletIdQueryQuery, FindTransactionsByRecipientWalletIdQueryQueryVariables>;
export const UpdateAdminMutationDocument = gql`
    mutation UpdateAdminMutation($input: UpdateAdminInput!) {
  updateAdmin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateAdminMutationMutationFn = Apollo.MutationFunction<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>;

/**
 * __useUpdateAdminMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAdminMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminMutationMutation, { data, loading, error }] = useUpdateAdminMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>(UpdateAdminMutationDocument, options);
      }
export type UpdateAdminMutationMutationHookResult = ReturnType<typeof useUpdateAdminMutationMutation>;
export type UpdateAdminMutationMutationResult = Apollo.MutationResult<UpdateAdminMutationMutation>;
export type UpdateAdminMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAdminMutationMutation, UpdateAdminMutationMutationVariables>;
export const UpdateBusinessInfoMutationDocument = gql`
    mutation UpdateBusinessInfoMutation($input: UpdateBusinessInfoInput!) {
  updateBusinessInfo(input: $input) {
    errors {
      path
      message
    }
    message
    logoUrl
    bannerUrl
  }
}
    `;
export type UpdateBusinessInfoMutationMutationFn = Apollo.MutationFunction<UpdateBusinessInfoMutationMutation, UpdateBusinessInfoMutationMutationVariables>;

/**
 * __useUpdateBusinessInfoMutationMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessInfoMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessInfoMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessInfoMutationMutation, { data, loading, error }] = useUpdateBusinessInfoMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessInfoMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessInfoMutationMutation, UpdateBusinessInfoMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessInfoMutationMutation, UpdateBusinessInfoMutationMutationVariables>(UpdateBusinessInfoMutationDocument, options);
      }
export type UpdateBusinessInfoMutationMutationHookResult = ReturnType<typeof useUpdateBusinessInfoMutationMutation>;
export type UpdateBusinessInfoMutationMutationResult = Apollo.MutationResult<UpdateBusinessInfoMutationMutation>;
export type UpdateBusinessInfoMutationMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessInfoMutationMutation, UpdateBusinessInfoMutationMutationVariables>;
export const UpdateMyBankPreferenceMutationDocument = gql`
    mutation UpdateMyBankPreferenceMutation($bankPreferenceId: String!, $input: UpdateMyBankPreferenceInput!) {
  updateMyBankPreference(bankPreferenceId: $bankPreferenceId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateMyBankPreferenceMutationMutationFn = Apollo.MutationFunction<UpdateMyBankPreferenceMutationMutation, UpdateMyBankPreferenceMutationMutationVariables>;

/**
 * __useUpdateMyBankPreferenceMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMyBankPreferenceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyBankPreferenceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyBankPreferenceMutationMutation, { data, loading, error }] = useUpdateMyBankPreferenceMutationMutation({
 *   variables: {
 *      bankPreferenceId: // value for 'bankPreferenceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyBankPreferenceMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyBankPreferenceMutationMutation, UpdateMyBankPreferenceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyBankPreferenceMutationMutation, UpdateMyBankPreferenceMutationMutationVariables>(UpdateMyBankPreferenceMutationDocument, options);
      }
export type UpdateMyBankPreferenceMutationMutationHookResult = ReturnType<typeof useUpdateMyBankPreferenceMutationMutation>;
export type UpdateMyBankPreferenceMutationMutationResult = Apollo.MutationResult<UpdateMyBankPreferenceMutationMutation>;
export type UpdateMyBankPreferenceMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMyBankPreferenceMutationMutation, UpdateMyBankPreferenceMutationMutationVariables>;
export const CreateWithdrawalMutationDocument = gql`
    mutation CreateWithdrawalMutation($input: CreateWithdrawalInput!) {
  createWithdrawal(input: $input) {
    errors {
      path
      message
    }
    message
    data {
      id
      account_number
      bank_code
      full_name
      currency
      debit_currency
      amount
      fee
      status
      reference
      narration
      complete_message
      requires_approval
      is_approved
      bank_name
      created_at
    }
  }
}
    `;
export type CreateWithdrawalMutationMutationFn = Apollo.MutationFunction<CreateWithdrawalMutationMutation, CreateWithdrawalMutationMutationVariables>;

/**
 * __useCreateWithdrawalMutationMutation__
 *
 * To run a mutation, you first call `useCreateWithdrawalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWithdrawalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWithdrawalMutationMutation, { data, loading, error }] = useCreateWithdrawalMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWithdrawalMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWithdrawalMutationMutation, CreateWithdrawalMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWithdrawalMutationMutation, CreateWithdrawalMutationMutationVariables>(CreateWithdrawalMutationDocument, options);
      }
export type CreateWithdrawalMutationMutationHookResult = ReturnType<typeof useCreateWithdrawalMutationMutation>;
export type CreateWithdrawalMutationMutationResult = Apollo.MutationResult<CreateWithdrawalMutationMutation>;
export type CreateWithdrawalMutationMutationOptions = Apollo.BaseMutationOptions<CreateWithdrawalMutationMutation, CreateWithdrawalMutationMutationVariables>;
export const FindMyWithdrawalsDocument = gql`
    query FindMyWithdrawals($page: Int!, $pageSize: Int!, $statusFilter: String, $searchText: String) {
  findMyWithdrawals(
    page: $page
    pageSize: $pageSize
    statusFilter: $statusFilter
    searchText: $searchText
  ) {
    data {
      withdrawal {
        id
        transaction {
          id
          amount
          charge
          reference
          type
          status
          currency
          transferTypes
          wallet {
            id
            balance
            createdAt
            updatedAt
          }
          recipientWallet {
            id
            balance
            currency
            owner {
              admin {
                merchantProfile {
                  companyName
                }
              }
            }
            createdAt
            updatedAt
          }
          offer {
            id
            title
            description
            bannerUrl
            category {
              id
              name
              imgSrc
              createdBy {
                id
                role
              }
              createdAt
              updatedAt
            }
            offerType
            discountType
            discountValue
            partnerVoucher
            referralUrl
            amount
            status
            usageLimitPerUser
            totalUsageLimit
            startDate
            endDate
            community {
              id
              name
              alias
            }
            redemptions
            revenueGenerated
            clickThroughs
            featured
            createdBy {
              id
              role
              admin {
                id
                shortId
                firstname
                lastname
                email
                phone
                merchantProfile {
                  id
                  businessName
                  businessType
                  regCountry
                  businessRegNumber
                  taxId
                  address
                  addressAlt
                  city
                  country
                  postcode
                  companyName
                  username
                  industry {
                    id
                    name
                    createdBy {
                      id
                      role
                    }
                    createdAt
                    updatedAt
                  }
                  companyLocation
                  logoUrl
                  bannerUrl
                  description
                  commissionRate
                  createdAt
                  updatedAt
                }
                createdAt
                updatedAt
              }
            }
            createdAt
            updatedAt
          }
          njoyCode
          partnerVoucher
          user {
            id
          }
          createdAt
          updatedAt
        }
        bankPreference {
          id
          bank {
            id
            bank
            bankCode
            pictureUrl
            createdAt
            updatedAt
          }
          accountNo
          owner {
            id
          }
          createdAt
          updatedAt
        }
        user {
          id
        }
        createdAt
        updatedAt
      }
      totalWithdrawal
    }
    pageSize
    page
    total
    totalPages
  }
}
    `;

/**
 * __useFindMyWithdrawalsQuery__
 *
 * To run a query within a React component, call `useFindMyWithdrawalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyWithdrawalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyWithdrawalsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      statusFilter: // value for 'statusFilter'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFindMyWithdrawalsQuery(baseOptions: Apollo.QueryHookOptions<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables> & ({ variables: FindMyWithdrawalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>(FindMyWithdrawalsDocument, options);
      }
export function useFindMyWithdrawalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>(FindMyWithdrawalsDocument, options);
        }
// @ts-ignore
export function useFindMyWithdrawalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>): Apollo.UseSuspenseQueryResult<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>;
export function useFindMyWithdrawalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>): Apollo.UseSuspenseQueryResult<FindMyWithdrawalsQuery | undefined, FindMyWithdrawalsQueryVariables>;
export function useFindMyWithdrawalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>(FindMyWithdrawalsDocument, options);
        }
export type FindMyWithdrawalsQueryHookResult = ReturnType<typeof useFindMyWithdrawalsQuery>;
export type FindMyWithdrawalsLazyQueryHookResult = ReturnType<typeof useFindMyWithdrawalsLazyQuery>;
export type FindMyWithdrawalsSuspenseQueryHookResult = ReturnType<typeof useFindMyWithdrawalsSuspenseQuery>;
export type FindMyWithdrawalsQueryResult = Apollo.QueryResult<FindMyWithdrawalsQuery, FindMyWithdrawalsQueryVariables>;
export const MyAppSettingQueryDocument = gql`
    query MyAppSettingQuery {
  myAppSetting {
    id
    isNotification
    isPush
    isEmail
    isSMS
    topUpLimit
    location {
      id
      city
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyAppSettingQueryQuery__
 *
 * To run a query within a React component, call `useMyAppSettingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAppSettingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAppSettingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAppSettingQueryQuery(baseOptions?: Apollo.QueryHookOptions<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>(MyAppSettingQueryDocument, options);
      }
export function useMyAppSettingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>(MyAppSettingQueryDocument, options);
        }
// @ts-ignore
export function useMyAppSettingQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>;
export function useMyAppSettingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyAppSettingQueryQuery | undefined, MyAppSettingQueryQueryVariables>;
export function useMyAppSettingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>(MyAppSettingQueryDocument, options);
        }
export type MyAppSettingQueryQueryHookResult = ReturnType<typeof useMyAppSettingQueryQuery>;
export type MyAppSettingQueryLazyQueryHookResult = ReturnType<typeof useMyAppSettingQueryLazyQuery>;
export type MyAppSettingQuerySuspenseQueryHookResult = ReturnType<typeof useMyAppSettingQuerySuspenseQuery>;
export type MyAppSettingQueryQueryResult = Apollo.QueryResult<MyAppSettingQueryQuery, MyAppSettingQueryQueryVariables>;
export const UpdateMyAppSettingMutationDocument = gql`
    mutation UpdateMyAppSettingMutation($input: UpdateMyAppSettingInput!) {
  updateMyAppSetting(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateMyAppSettingMutationMutationFn = Apollo.MutationFunction<UpdateMyAppSettingMutationMutation, UpdateMyAppSettingMutationMutationVariables>;

/**
 * __useUpdateMyAppSettingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMyAppSettingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyAppSettingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyAppSettingMutationMutation, { data, loading, error }] = useUpdateMyAppSettingMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyAppSettingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyAppSettingMutationMutation, UpdateMyAppSettingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyAppSettingMutationMutation, UpdateMyAppSettingMutationMutationVariables>(UpdateMyAppSettingMutationDocument, options);
      }
export type UpdateMyAppSettingMutationMutationHookResult = ReturnType<typeof useUpdateMyAppSettingMutationMutation>;
export type UpdateMyAppSettingMutationMutationResult = Apollo.MutationResult<UpdateMyAppSettingMutationMutation>;
export type UpdateMyAppSettingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMyAppSettingMutationMutation, UpdateMyAppSettingMutationMutationVariables>;
export const ViewCategoryQueryDocument = gql`
    query ViewCategoryQuery($id: String!) {
  viewCategory(id: $id) {
    id
    name
    imgSrc
    createdBy {
      id
      role
      admin {
        id
        firstname
        lastname
        level
      }
    }
    createdAt
    updatedAt
    isArchive
  }
}
    `;

/**
 * __useViewCategoryQueryQuery__
 *
 * To run a query within a React component, call `useViewCategoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCategoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCategoryQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewCategoryQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables> & ({ variables: ViewCategoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>(ViewCategoryQueryDocument, options);
      }
export function useViewCategoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>(ViewCategoryQueryDocument, options);
        }
// @ts-ignore
export function useViewCategoryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>;
export function useViewCategoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryQueryQuery | undefined, ViewCategoryQueryQueryVariables>;
export function useViewCategoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>(ViewCategoryQueryDocument, options);
        }
export type ViewCategoryQueryQueryHookResult = ReturnType<typeof useViewCategoryQueryQuery>;
export type ViewCategoryQueryLazyQueryHookResult = ReturnType<typeof useViewCategoryQueryLazyQuery>;
export type ViewCategoryQuerySuspenseQueryHookResult = ReturnType<typeof useViewCategoryQuerySuspenseQuery>;
export type ViewCategoryQueryQueryResult = Apollo.QueryResult<ViewCategoryQueryQuery, ViewCategoryQueryQueryVariables>;
export const ViewCategoryPwaQueryDocument = gql`
    query ViewCategoryPWAQuery($id: String!) {
  viewCategoryPWA(id: $id) {
    id
    name
    imgSrc
    isArchive
    createdAt
  }
}
    `;

/**
 * __useViewCategoryPwaQueryQuery__
 *
 * To run a query within a React component, call `useViewCategoryPwaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCategoryPwaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCategoryPwaQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewCategoryPwaQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables> & ({ variables: ViewCategoryPwaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>(ViewCategoryPwaQueryDocument, options);
      }
export function useViewCategoryPwaQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>(ViewCategoryPwaQueryDocument, options);
        }
// @ts-ignore
export function useViewCategoryPwaQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>;
export function useViewCategoryPwaQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryPwaQueryQuery | undefined, ViewCategoryPwaQueryQueryVariables>;
export function useViewCategoryPwaQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>(ViewCategoryPwaQueryDocument, options);
        }
export type ViewCategoryPwaQueryQueryHookResult = ReturnType<typeof useViewCategoryPwaQueryQuery>;
export type ViewCategoryPwaQueryLazyQueryHookResult = ReturnType<typeof useViewCategoryPwaQueryLazyQuery>;
export type ViewCategoryPwaQuerySuspenseQueryHookResult = ReturnType<typeof useViewCategoryPwaQuerySuspenseQuery>;
export type ViewCategoryPwaQueryQueryResult = Apollo.QueryResult<ViewCategoryPwaQueryQuery, ViewCategoryPwaQueryQueryVariables>;
export const CreateBankPreferenceMutationDocument = gql`
    mutation CreateBankPreferenceMutation($bankId: String!, $accountNo: String!) {
  createBankPreference(input: {bankId: $bankId, accountNo: $accountNo}) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateBankPreferenceMutationMutationFn = Apollo.MutationFunction<CreateBankPreferenceMutationMutation, CreateBankPreferenceMutationMutationVariables>;

/**
 * __useCreateBankPreferenceMutationMutation__
 *
 * To run a mutation, you first call `useCreateBankPreferenceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankPreferenceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankPreferenceMutationMutation, { data, loading, error }] = useCreateBankPreferenceMutationMutation({
 *   variables: {
 *      bankId: // value for 'bankId'
 *      accountNo: // value for 'accountNo'
 *   },
 * });
 */
export function useCreateBankPreferenceMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankPreferenceMutationMutation, CreateBankPreferenceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankPreferenceMutationMutation, CreateBankPreferenceMutationMutationVariables>(CreateBankPreferenceMutationDocument, options);
      }
export type CreateBankPreferenceMutationMutationHookResult = ReturnType<typeof useCreateBankPreferenceMutationMutation>;
export type CreateBankPreferenceMutationMutationResult = Apollo.MutationResult<CreateBankPreferenceMutationMutation>;
export type CreateBankPreferenceMutationMutationOptions = Apollo.BaseMutationOptions<CreateBankPreferenceMutationMutation, CreateBankPreferenceMutationMutationVariables>;
export const AddIdentityMutationDocument = gql`
    mutation AddIdentityMutation($communityId: String!, $communityEntityId: String, $idNumber: String!) {
  addIdentity(
    communityId: $communityId
    communityEntityId: $communityEntityId
    idNumber: $idNumber
  ) {
    errors {
      message
      path
    }
    message
  }
}
    `;
export type AddIdentityMutationMutationFn = Apollo.MutationFunction<AddIdentityMutationMutation, AddIdentityMutationMutationVariables>;

/**
 * __useAddIdentityMutationMutation__
 *
 * To run a mutation, you first call `useAddIdentityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIdentityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIdentityMutationMutation, { data, loading, error }] = useAddIdentityMutationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      communityEntityId: // value for 'communityEntityId'
 *      idNumber: // value for 'idNumber'
 *   },
 * });
 */
export function useAddIdentityMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddIdentityMutationMutation, AddIdentityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIdentityMutationMutation, AddIdentityMutationMutationVariables>(AddIdentityMutationDocument, options);
      }
export type AddIdentityMutationMutationHookResult = ReturnType<typeof useAddIdentityMutationMutation>;
export type AddIdentityMutationMutationResult = Apollo.MutationResult<AddIdentityMutationMutation>;
export type AddIdentityMutationMutationOptions = Apollo.BaseMutationOptions<AddIdentityMutationMutation, AddIdentityMutationMutationVariables>;
export const ForgotPasswordChangeMutationDocument = gql`
    mutation ForgotPasswordChangeMutation($newPassword: String!, $confirmNewPassword: String!, $key: String!) {
  forgotPasswordChange(
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
    key: $key
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ForgotPasswordChangeMutationMutationFn = Apollo.MutationFunction<ForgotPasswordChangeMutationMutation, ForgotPasswordChangeMutationMutationVariables>;

/**
 * __useForgotPasswordChangeMutationMutation__
 *
 * To run a mutation, you first call `useForgotPasswordChangeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordChangeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordChangeMutationMutation, { data, loading, error }] = useForgotPasswordChangeMutationMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      confirmNewPassword: // value for 'confirmNewPassword'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useForgotPasswordChangeMutationMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordChangeMutationMutation, ForgotPasswordChangeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordChangeMutationMutation, ForgotPasswordChangeMutationMutationVariables>(ForgotPasswordChangeMutationDocument, options);
      }
export type ForgotPasswordChangeMutationMutationHookResult = ReturnType<typeof useForgotPasswordChangeMutationMutation>;
export type ForgotPasswordChangeMutationMutationResult = Apollo.MutationResult<ForgotPasswordChangeMutationMutation>;
export type ForgotPasswordChangeMutationMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordChangeMutationMutation, ForgotPasswordChangeMutationMutationVariables>;
export const SendForgotPasswordEmailMutationDocument = gql`
    mutation SendForgotPasswordEmailMutation($email: String!) {
  sendForgotPasswordEmail(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type SendForgotPasswordEmailMutationMutationFn = Apollo.MutationFunction<SendForgotPasswordEmailMutationMutation, SendForgotPasswordEmailMutationMutationVariables>;

/**
 * __useSendForgotPasswordEmailMutationMutation__
 *
 * To run a mutation, you first call `useSendForgotPasswordEmailMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForgotPasswordEmailMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForgotPasswordEmailMutationMutation, { data, loading, error }] = useSendForgotPasswordEmailMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendForgotPasswordEmailMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendForgotPasswordEmailMutationMutation, SendForgotPasswordEmailMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendForgotPasswordEmailMutationMutation, SendForgotPasswordEmailMutationMutationVariables>(SendForgotPasswordEmailMutationDocument, options);
      }
export type SendForgotPasswordEmailMutationMutationHookResult = ReturnType<typeof useSendForgotPasswordEmailMutationMutation>;
export type SendForgotPasswordEmailMutationMutationResult = Apollo.MutationResult<SendForgotPasswordEmailMutationMutation>;
export type SendForgotPasswordEmailMutationMutationOptions = Apollo.BaseMutationOptions<SendForgotPasswordEmailMutationMutation, SendForgotPasswordEmailMutationMutationVariables>;
export const LoginMutationDocument = gql`
    mutation LoginMutation($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    errors {
      path
      message
    }
    sessionId
    message
  }
}
    `;
export type LoginMutationMutationFn = Apollo.MutationFunction<LoginMutationMutation, LoginMutationMutationVariables>;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutationMutation, { data, loading, error }] = useLoginMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationMutation, LoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
      }
export type LoginMutationMutationHookResult = ReturnType<typeof useLoginMutationMutation>;
export type LoginMutationMutationResult = Apollo.MutationResult<LoginMutationMutation>;
export type LoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>;
export const OtpValidateMutationDocument = gql`
    mutation OTPValidateMutation($verificationCode: String!, $email: String!) {
  otpValidate(verificationCode: $verificationCode, email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type OtpValidateMutationMutationFn = Apollo.MutationFunction<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>;

/**
 * __useOtpValidateMutationMutation__
 *
 * To run a mutation, you first call `useOtpValidateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpValidateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpValidateMutationMutation, { data, loading, error }] = useOtpValidateMutationMutation({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useOtpValidateMutationMutation(baseOptions?: Apollo.MutationHookOptions<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>(OtpValidateMutationDocument, options);
      }
export type OtpValidateMutationMutationHookResult = ReturnType<typeof useOtpValidateMutationMutation>;
export type OtpValidateMutationMutationResult = Apollo.MutationResult<OtpValidateMutationMutation>;
export type OtpValidateMutationMutationOptions = Apollo.BaseMutationOptions<OtpValidateMutationMutation, OtpValidateMutationMutationVariables>;
export const RegisterMutationDocument = gql`
    mutation RegisterMutation($email: String!, $phone: String!, $password: String!, $confirmPassword: String!, $nda: Boolean!, $memberId: String) {
  register(
    email: $email
    phone: $phone
    password: $password
    confirmPassword: $confirmPassword
    nda: $nda
    memberId: $memberId
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type RegisterMutationMutationFn = Apollo.MutationFunction<RegisterMutationMutation, RegisterMutationMutationVariables>;

/**
 * __useRegisterMutationMutation__
 *
 * To run a mutation, you first call `useRegisterMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutationMutation, { data, loading, error }] = useRegisterMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *      nda: // value for 'nda'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useRegisterMutationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutationMutation, RegisterMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutationMutation, RegisterMutationMutationVariables>(RegisterMutationDocument, options);
      }
export type RegisterMutationMutationHookResult = ReturnType<typeof useRegisterMutationMutation>;
export type RegisterMutationMutationResult = Apollo.MutationResult<RegisterMutationMutation>;
export type RegisterMutationMutationOptions = Apollo.BaseMutationOptions<RegisterMutationMutation, RegisterMutationMutationVariables>;
export const ResendOtpMutationDocument = gql`
    mutation ResendOtpMutation($email: String!) {
  resendOtp(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ResendOtpMutationMutationFn = Apollo.MutationFunction<ResendOtpMutationMutation, ResendOtpMutationMutationVariables>;

/**
 * __useResendOtpMutationMutation__
 *
 * To run a mutation, you first call `useResendOtpMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOtpMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOtpMutationMutation, { data, loading, error }] = useResendOtpMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendOtpMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResendOtpMutationMutation, ResendOtpMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOtpMutationMutation, ResendOtpMutationMutationVariables>(ResendOtpMutationDocument, options);
      }
export type ResendOtpMutationMutationHookResult = ReturnType<typeof useResendOtpMutationMutation>;
export type ResendOtpMutationMutationResult = Apollo.MutationResult<ResendOtpMutationMutation>;
export type ResendOtpMutationMutationOptions = Apollo.BaseMutationOptions<ResendOtpMutationMutation, ResendOtpMutationMutationVariables>;
export const UpdatePasswordMutationDocument = gql`
    mutation UpdatePasswordMutation($oldPassword: String!, $newPassword: String!, $confirmNewPassword: String!) {
  updatePassword(
    oldPassword: $oldPassword
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdatePasswordMutationMutationFn = Apollo.MutationFunction<UpdatePasswordMutationMutation, UpdatePasswordMutationMutationVariables>;

/**
 * __useUpdatePasswordMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutationMutation, { data, loading, error }] = useUpdatePasswordMutationMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *      confirmNewPassword: // value for 'confirmNewPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutationMutation, UpdatePasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutationMutation, UpdatePasswordMutationMutationVariables>(UpdatePasswordMutationDocument, options);
      }
export type UpdatePasswordMutationMutationHookResult = ReturnType<typeof useUpdatePasswordMutationMutation>;
export type UpdatePasswordMutationMutationResult = Apollo.MutationResult<UpdatePasswordMutationMutation>;
export type UpdatePasswordMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutationMutation, UpdatePasswordMutationMutationVariables>;
export const GetCbmMutationDocument = gql`
    mutation GetCbmMutation($memberId: String!) {
  getCBM(memberId: $memberId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type GetCbmMutationMutationFn = Apollo.MutationFunction<GetCbmMutationMutation, GetCbmMutationMutationVariables>;

/**
 * __useGetCbmMutationMutation__
 *
 * To run a mutation, you first call `useGetCbmMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCbmMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCbmMutationMutation, { data, loading, error }] = useGetCbmMutationMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetCbmMutationMutation(baseOptions?: Apollo.MutationHookOptions<GetCbmMutationMutation, GetCbmMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCbmMutationMutation, GetCbmMutationMutationVariables>(GetCbmMutationDocument, options);
      }
export type GetCbmMutationMutationHookResult = ReturnType<typeof useGetCbmMutationMutation>;
export type GetCbmMutationMutationResult = Apollo.MutationResult<GetCbmMutationMutation>;
export type GetCbmMutationMutationOptions = Apollo.BaseMutationOptions<GetCbmMutationMutation, GetCbmMutationMutationVariables>;
export const CountClickThroughMutationDocument = gql`
    mutation CountClickThroughMutation($offerId: String!) {
  countClickThrough(offerId: $offerId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CountClickThroughMutationMutationFn = Apollo.MutationFunction<CountClickThroughMutationMutation, CountClickThroughMutationMutationVariables>;

/**
 * __useCountClickThroughMutationMutation__
 *
 * To run a mutation, you first call `useCountClickThroughMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountClickThroughMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countClickThroughMutationMutation, { data, loading, error }] = useCountClickThroughMutationMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCountClickThroughMutationMutation(baseOptions?: Apollo.MutationHookOptions<CountClickThroughMutationMutation, CountClickThroughMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountClickThroughMutationMutation, CountClickThroughMutationMutationVariables>(CountClickThroughMutationDocument, options);
      }
export type CountClickThroughMutationMutationHookResult = ReturnType<typeof useCountClickThroughMutationMutation>;
export type CountClickThroughMutationMutationResult = Apollo.MutationResult<CountClickThroughMutationMutation>;
export type CountClickThroughMutationMutationOptions = Apollo.BaseMutationOptions<CountClickThroughMutationMutation, CountClickThroughMutationMutationVariables>;
export const CountOfferViewMutationDocument = gql`
    mutation CountOfferViewMutation($offerId: String!) {
  countOfferView(offerId: $offerId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CountOfferViewMutationMutationFn = Apollo.MutationFunction<CountOfferViewMutationMutation, CountOfferViewMutationMutationVariables>;

/**
 * __useCountOfferViewMutationMutation__
 *
 * To run a mutation, you first call `useCountOfferViewMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountOfferViewMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countOfferViewMutationMutation, { data, loading, error }] = useCountOfferViewMutationMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCountOfferViewMutationMutation(baseOptions?: Apollo.MutationHookOptions<CountOfferViewMutationMutation, CountOfferViewMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountOfferViewMutationMutation, CountOfferViewMutationMutationVariables>(CountOfferViewMutationDocument, options);
      }
export type CountOfferViewMutationMutationHookResult = ReturnType<typeof useCountOfferViewMutationMutation>;
export type CountOfferViewMutationMutationResult = Apollo.MutationResult<CountOfferViewMutationMutation>;
export type CountOfferViewMutationMutationOptions = Apollo.BaseMutationOptions<CountOfferViewMutationMutation, CountOfferViewMutationMutationVariables>;
export const CustomerTransactionsQueryDocument = gql`
    query CustomerTransactionsQuery($offset: Int!, $limit: Int!, $duration: String, $filterBy: String, $typeFilter: String, $startDate: String, $endDate: String, $searchText: String) {
  customerTransactions(
    offset: $offset
    limit: $limit
    duration: $duration
    filterBy: $filterBy
    typeFilter: $typeFilter
    startDate: $startDate
    endDate: $endDate
    searchText: $searchText
  ) {
    createdAt
    transactions {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      wallet {
        id
        balance
        currency
        createdAt
        updatedAt
        barterId
        flAccountReference
        owner {
          id
          customer {
            id
            firstname
            lastname
            avatarUrl
          }
        }
      }
      recipientWallet {
        id
        balance
        currency
        createdAt
        updatedAt
        barterId
        flAccountReference
        owner {
          id
          customer {
            id
            firstname
            lastname
            avatarUrl
          }
          admin {
            id
            merchantProfile {
              id
              companyName
              logoUrl
            }
          }
        }
      }
      offer {
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community {
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy {
          id
          role
          admin {
            id
            shortId
            firstname
            lastname
            email
            phone
            merchantProfile {
              id
              businessName
              businessType
              regCountry
              businessRegNumber
              taxId
              address
              addressAlt
              city
              country
              postcode
              companyName
              username
              industry {
                id
                name
                createdBy {
                  id
                  role
                }
                createdAt
                updatedAt
              }
              companyLocation
              logoUrl
              bannerUrl
              description
              commissionRate
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      user {
        id
      }
      njoyCode
      partnerVoucher
      point
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useCustomerTransactionsQueryQuery__
 *
 * To run a query within a React component, call `useCustomerTransactionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTransactionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTransactionsQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      duration: // value for 'duration'
 *      filterBy: // value for 'filterBy'
 *      typeFilter: // value for 'typeFilter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useCustomerTransactionsQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables> & ({ variables: CustomerTransactionsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>(CustomerTransactionsQueryDocument, options);
      }
export function useCustomerTransactionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>(CustomerTransactionsQueryDocument, options);
        }
// @ts-ignore
export function useCustomerTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>;
export function useCustomerTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerTransactionsQueryQuery | undefined, CustomerTransactionsQueryQueryVariables>;
export function useCustomerTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>(CustomerTransactionsQueryDocument, options);
        }
export type CustomerTransactionsQueryQueryHookResult = ReturnType<typeof useCustomerTransactionsQueryQuery>;
export type CustomerTransactionsQueryLazyQueryHookResult = ReturnType<typeof useCustomerTransactionsQueryLazyQuery>;
export type CustomerTransactionsQuerySuspenseQueryHookResult = ReturnType<typeof useCustomerTransactionsQuerySuspenseQuery>;
export type CustomerTransactionsQueryQueryResult = Apollo.QueryResult<CustomerTransactionsQueryQuery, CustomerTransactionsQueryQueryVariables>;
export const DeactivateCustomerMutationDocument = gql`
    mutation DeactivateCustomerMutation($input: DeactivateCustomerInput!) {
  deactivateCustomer(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DeactivateCustomerMutationMutationFn = Apollo.MutationFunction<DeactivateCustomerMutationMutation, DeactivateCustomerMutationMutationVariables>;

/**
 * __useDeactivateCustomerMutationMutation__
 *
 * To run a mutation, you first call `useDeactivateCustomerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCustomerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCustomerMutationMutation, { data, loading, error }] = useDeactivateCustomerMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateCustomerMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCustomerMutationMutation, DeactivateCustomerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCustomerMutationMutation, DeactivateCustomerMutationMutationVariables>(DeactivateCustomerMutationDocument, options);
      }
export type DeactivateCustomerMutationMutationHookResult = ReturnType<typeof useDeactivateCustomerMutationMutation>;
export type DeactivateCustomerMutationMutationResult = Apollo.MutationResult<DeactivateCustomerMutationMutation>;
export type DeactivateCustomerMutationMutationOptions = Apollo.BaseMutationOptions<DeactivateCustomerMutationMutation, DeactivateCustomerMutationMutationVariables>;
export const EarnedPointsQueryDocument = gql`
    query EarnedPointsQuery {
  earnedPoints {
    errors {
      path
      message
    }
    message
    totalPoints
  }
}
    `;

/**
 * __useEarnedPointsQueryQuery__
 *
 * To run a query within a React component, call `useEarnedPointsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnedPointsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnedPointsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnedPointsQueryQuery(baseOptions?: Apollo.QueryHookOptions<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>(EarnedPointsQueryDocument, options);
      }
export function useEarnedPointsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>(EarnedPointsQueryDocument, options);
        }
// @ts-ignore
export function useEarnedPointsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>;
export function useEarnedPointsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EarnedPointsQueryQuery | undefined, EarnedPointsQueryQueryVariables>;
export function useEarnedPointsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>(EarnedPointsQueryDocument, options);
        }
export type EarnedPointsQueryQueryHookResult = ReturnType<typeof useEarnedPointsQueryQuery>;
export type EarnedPointsQueryLazyQueryHookResult = ReturnType<typeof useEarnedPointsQueryLazyQuery>;
export type EarnedPointsQuerySuspenseQueryHookResult = ReturnType<typeof useEarnedPointsQuerySuspenseQuery>;
export type EarnedPointsQueryQueryResult = Apollo.QueryResult<EarnedPointsQueryQuery, EarnedPointsQueryQueryVariables>;
export const FindAllCustomersQueryDocument = gql`
    query FindAllCustomersQuery {
  findAllCustomers {
    id
    avatarUrl
    firstname
    lastname
    email
    username
    phone
    community {
      id
      name
      alias
    }
    createdAt
    updatedAt
    address
    gender
    dob
    nin
  }
}
    `;

/**
 * __useFindAllCustomersQueryQuery__
 *
 * To run a query within a React component, call `useFindAllCustomersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCustomersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCustomersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllCustomersQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>(FindAllCustomersQueryDocument, options);
      }
export function useFindAllCustomersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>(FindAllCustomersQueryDocument, options);
        }
// @ts-ignore
export function useFindAllCustomersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>;
export function useFindAllCustomersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllCustomersQueryQuery | undefined, FindAllCustomersQueryQueryVariables>;
export function useFindAllCustomersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>(FindAllCustomersQueryDocument, options);
        }
export type FindAllCustomersQueryQueryHookResult = ReturnType<typeof useFindAllCustomersQueryQuery>;
export type FindAllCustomersQueryLazyQueryHookResult = ReturnType<typeof useFindAllCustomersQueryLazyQuery>;
export type FindAllCustomersQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllCustomersQuerySuspenseQuery>;
export type FindAllCustomersQueryQueryResult = Apollo.QueryResult<FindAllCustomersQueryQuery, FindAllCustomersQueryQueryVariables>;
export const FindBaseUrlQueryDocument = gql`
    query FindBaseUrlQuery {
  findBaseUrl {
    baseUrl
  }
}
    `;

/**
 * __useFindBaseUrlQueryQuery__
 *
 * To run a query within a React component, call `useFindBaseUrlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBaseUrlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBaseUrlQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindBaseUrlQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>(FindBaseUrlQueryDocument, options);
      }
export function useFindBaseUrlQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>(FindBaseUrlQueryDocument, options);
        }
// @ts-ignore
export function useFindBaseUrlQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>;
export function useFindBaseUrlQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindBaseUrlQueryQuery | undefined, FindBaseUrlQueryQueryVariables>;
export function useFindBaseUrlQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>(FindBaseUrlQueryDocument, options);
        }
export type FindBaseUrlQueryQueryHookResult = ReturnType<typeof useFindBaseUrlQueryQuery>;
export type FindBaseUrlQueryLazyQueryHookResult = ReturnType<typeof useFindBaseUrlQueryLazyQuery>;
export type FindBaseUrlQuerySuspenseQueryHookResult = ReturnType<typeof useFindBaseUrlQuerySuspenseQuery>;
export type FindBaseUrlQueryQueryResult = Apollo.QueryResult<FindBaseUrlQueryQuery, FindBaseUrlQueryQueryVariables>;
export const FinishSignupMutationDocument = gql`
    mutation FinishSignupMutation($firstname: String!, $lastname: String!, $username: String!, $locationId: String!, $pin: String!, $referralCode: String) {
  finishSignup(
    firstname: $firstname
    lastname: $lastname
    username: $username
    locationId: $locationId
    pin: $pin
    referralCode: $referralCode
  ) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type FinishSignupMutationMutationFn = Apollo.MutationFunction<FinishSignupMutationMutation, FinishSignupMutationMutationVariables>;

/**
 * __useFinishSignupMutationMutation__
 *
 * To run a mutation, you first call `useFinishSignupMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishSignupMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishSignupMutationMutation, { data, loading, error }] = useFinishSignupMutationMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      username: // value for 'username'
 *      locationId: // value for 'locationId'
 *      pin: // value for 'pin'
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function useFinishSignupMutationMutation(baseOptions?: Apollo.MutationHookOptions<FinishSignupMutationMutation, FinishSignupMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishSignupMutationMutation, FinishSignupMutationMutationVariables>(FinishSignupMutationDocument, options);
      }
export type FinishSignupMutationMutationHookResult = ReturnType<typeof useFinishSignupMutationMutation>;
export type FinishSignupMutationMutationResult = Apollo.MutationResult<FinishSignupMutationMutation>;
export type FinishSignupMutationMutationOptions = Apollo.BaseMutationOptions<FinishSignupMutationMutation, FinishSignupMutationMutationVariables>;
export const GetCommunityPointQueryDocument = gql`
    query GetCommunityPointQuery($communityId: String!) {
  getCommunityPoint(communityId: $communityId) {
    errors {
      path
      message
    }
    message
    data {
      memberCommunityPoint
      partnerCommunityExchangeRate
    }
  }
}
    `;

/**
 * __useGetCommunityPointQueryQuery__
 *
 * To run a query within a React component, call `useGetCommunityPointQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPointQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPointQueryQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityPointQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables> & ({ variables: GetCommunityPointQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>(GetCommunityPointQueryDocument, options);
      }
export function useGetCommunityPointQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>(GetCommunityPointQueryDocument, options);
        }
// @ts-ignore
export function useGetCommunityPointQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>;
export function useGetCommunityPointQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityPointQueryQuery | undefined, GetCommunityPointQueryQueryVariables>;
export function useGetCommunityPointQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>(GetCommunityPointQueryDocument, options);
        }
export type GetCommunityPointQueryQueryHookResult = ReturnType<typeof useGetCommunityPointQueryQuery>;
export type GetCommunityPointQueryLazyQueryHookResult = ReturnType<typeof useGetCommunityPointQueryLazyQuery>;
export type GetCommunityPointQuerySuspenseQueryHookResult = ReturnType<typeof useGetCommunityPointQuerySuspenseQuery>;
export type GetCommunityPointQueryQueryResult = Apollo.QueryResult<GetCommunityPointQueryQuery, GetCommunityPointQueryQueryVariables>;
export const FindIsInterestedQueryDocument = gql`
    query FindIsInterestedQuery($merchantUserId: String!) {
  findIsInterested(merchantUserId: $merchantUserId) {
    errors {
      path
      message
    }
    message
    status
  }
}
    `;

/**
 * __useFindIsInterestedQueryQuery__
 *
 * To run a query within a React component, call `useFindIsInterestedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindIsInterestedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindIsInterestedQueryQuery({
 *   variables: {
 *      merchantUserId: // value for 'merchantUserId'
 *   },
 * });
 */
export function useFindIsInterestedQueryQuery(baseOptions: Apollo.QueryHookOptions<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables> & ({ variables: FindIsInterestedQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>(FindIsInterestedQueryDocument, options);
      }
export function useFindIsInterestedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>(FindIsInterestedQueryDocument, options);
        }
// @ts-ignore
export function useFindIsInterestedQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>;
export function useFindIsInterestedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindIsInterestedQueryQuery | undefined, FindIsInterestedQueryQueryVariables>;
export function useFindIsInterestedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>(FindIsInterestedQueryDocument, options);
        }
export type FindIsInterestedQueryQueryHookResult = ReturnType<typeof useFindIsInterestedQueryQuery>;
export type FindIsInterestedQueryLazyQueryHookResult = ReturnType<typeof useFindIsInterestedQueryLazyQuery>;
export type FindIsInterestedQuerySuspenseQueryHookResult = ReturnType<typeof useFindIsInterestedQuerySuspenseQuery>;
export type FindIsInterestedQueryQueryResult = Apollo.QueryResult<FindIsInterestedQueryQuery, FindIsInterestedQueryQueryVariables>;
export const ToggleInterestMutationDocument = gql`
    mutation ToggleInterestMutation($merchantUserId: String!) {
  toggleInterest(merchantUserId: $merchantUserId) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ToggleInterestMutationMutationFn = Apollo.MutationFunction<ToggleInterestMutationMutation, ToggleInterestMutationMutationVariables>;

/**
 * __useToggleInterestMutationMutation__
 *
 * To run a mutation, you first call `useToggleInterestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleInterestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleInterestMutationMutation, { data, loading, error }] = useToggleInterestMutationMutation({
 *   variables: {
 *      merchantUserId: // value for 'merchantUserId'
 *   },
 * });
 */
export function useToggleInterestMutationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleInterestMutationMutation, ToggleInterestMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleInterestMutationMutation, ToggleInterestMutationMutationVariables>(ToggleInterestMutationDocument, options);
      }
export type ToggleInterestMutationMutationHookResult = ReturnType<typeof useToggleInterestMutationMutation>;
export type ToggleInterestMutationMutationResult = Apollo.MutationResult<ToggleInterestMutationMutation>;
export type ToggleInterestMutationMutationOptions = Apollo.BaseMutationOptions<ToggleInterestMutationMutation, ToggleInterestMutationMutationVariables>;
export const MyIdentitiesQueryDocument = gql`
    query MyIdentitiesQuery($offset: Int!, $limit: Int!) {
  myIdentities(offset: $offset, limit: $limit) {
    id
    idNumber
    name
    validity
    dob
    gender
    community {
      id
      name
      alias
      logoUrl
      colorCode
    }
    idType
  }
}
    `;

/**
 * __useMyIdentitiesQueryQuery__
 *
 * To run a query within a React component, call `useMyIdentitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyIdentitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyIdentitiesQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyIdentitiesQueryQuery(baseOptions: Apollo.QueryHookOptions<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables> & ({ variables: MyIdentitiesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>(MyIdentitiesQueryDocument, options);
      }
export function useMyIdentitiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>(MyIdentitiesQueryDocument, options);
        }
// @ts-ignore
export function useMyIdentitiesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>;
export function useMyIdentitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyIdentitiesQueryQuery | undefined, MyIdentitiesQueryQueryVariables>;
export function useMyIdentitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>(MyIdentitiesQueryDocument, options);
        }
export type MyIdentitiesQueryQueryHookResult = ReturnType<typeof useMyIdentitiesQueryQuery>;
export type MyIdentitiesQueryLazyQueryHookResult = ReturnType<typeof useMyIdentitiesQueryLazyQuery>;
export type MyIdentitiesQuerySuspenseQueryHookResult = ReturnType<typeof useMyIdentitiesQuerySuspenseQuery>;
export type MyIdentitiesQueryQueryResult = Apollo.QueryResult<MyIdentitiesQueryQuery, MyIdentitiesQueryQueryVariables>;
export const NewIdentitySubscriptionDocument = gql`
    subscription NewIdentitySubscription {
  newIdentity {
    id
    photo
    idNumber
    community {
      id
      name
      alias
      logoUrl
      colorCode
      createdAt
      updatedAt
    }
    phoneNumber
    name
    validity
    dob
    gender
    logoUrl
    idType
    address
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewIdentitySubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewIdentitySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewIdentitySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewIdentitySubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewIdentitySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewIdentitySubscriptionSubscription, NewIdentitySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewIdentitySubscriptionSubscription, NewIdentitySubscriptionSubscriptionVariables>(NewIdentitySubscriptionDocument, options);
      }
export type NewIdentitySubscriptionSubscriptionHookResult = ReturnType<typeof useNewIdentitySubscriptionSubscription>;
export type NewIdentitySubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewIdentitySubscriptionSubscription>;
export const EmailOtpRequestMutationDocument = gql`
    mutation EmailOtpRequestMutation($input: EmailOtpRequestInput!) {
  emailOtpRequest(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type EmailOtpRequestMutationMutationFn = Apollo.MutationFunction<EmailOtpRequestMutationMutation, EmailOtpRequestMutationMutationVariables>;

/**
 * __useEmailOtpRequestMutationMutation__
 *
 * To run a mutation, you first call `useEmailOtpRequestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailOtpRequestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailOtpRequestMutationMutation, { data, loading, error }] = useEmailOtpRequestMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailOtpRequestMutationMutation(baseOptions?: Apollo.MutationHookOptions<EmailOtpRequestMutationMutation, EmailOtpRequestMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailOtpRequestMutationMutation, EmailOtpRequestMutationMutationVariables>(EmailOtpRequestMutationDocument, options);
      }
export type EmailOtpRequestMutationMutationHookResult = ReturnType<typeof useEmailOtpRequestMutationMutation>;
export type EmailOtpRequestMutationMutationResult = Apollo.MutationResult<EmailOtpRequestMutationMutation>;
export type EmailOtpRequestMutationMutationOptions = Apollo.BaseMutationOptions<EmailOtpRequestMutationMutation, EmailOtpRequestMutationMutationVariables>;
export const OtpValidatePhoneMutationDocument = gql`
    mutation OtpValidatePhoneMutation($verificationCode: String!, $phone: String!) {
  otpValidatePhone(verificationCode: $verificationCode, phone: $phone) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type OtpValidatePhoneMutationMutationFn = Apollo.MutationFunction<OtpValidatePhoneMutationMutation, OtpValidatePhoneMutationMutationVariables>;

/**
 * __useOtpValidatePhoneMutationMutation__
 *
 * To run a mutation, you first call `useOtpValidatePhoneMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOtpValidatePhoneMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [otpValidatePhoneMutationMutation, { data, loading, error }] = useOtpValidatePhoneMutationMutation({
 *   variables: {
 *      verificationCode: // value for 'verificationCode'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useOtpValidatePhoneMutationMutation(baseOptions?: Apollo.MutationHookOptions<OtpValidatePhoneMutationMutation, OtpValidatePhoneMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OtpValidatePhoneMutationMutation, OtpValidatePhoneMutationMutationVariables>(OtpValidatePhoneMutationDocument, options);
      }
export type OtpValidatePhoneMutationMutationHookResult = ReturnType<typeof useOtpValidatePhoneMutationMutation>;
export type OtpValidatePhoneMutationMutationResult = Apollo.MutationResult<OtpValidatePhoneMutationMutation>;
export type OtpValidatePhoneMutationMutationOptions = Apollo.BaseMutationOptions<OtpValidatePhoneMutationMutation, OtpValidatePhoneMutationMutationVariables>;
export const PhoneOtpRequestMutationDocument = gql`
    mutation PhoneOtpRequestMutation($input: PhoneOtpRequestInput!) {
  phoneOtpRequest(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type PhoneOtpRequestMutationMutationFn = Apollo.MutationFunction<PhoneOtpRequestMutationMutation, PhoneOtpRequestMutationMutationVariables>;

/**
 * __usePhoneOtpRequestMutationMutation__
 *
 * To run a mutation, you first call `usePhoneOtpRequestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneOtpRequestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneOtpRequestMutationMutation, { data, loading, error }] = usePhoneOtpRequestMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhoneOtpRequestMutationMutation(baseOptions?: Apollo.MutationHookOptions<PhoneOtpRequestMutationMutation, PhoneOtpRequestMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PhoneOtpRequestMutationMutation, PhoneOtpRequestMutationMutationVariables>(PhoneOtpRequestMutationDocument, options);
      }
export type PhoneOtpRequestMutationMutationHookResult = ReturnType<typeof usePhoneOtpRequestMutationMutation>;
export type PhoneOtpRequestMutationMutationResult = Apollo.MutationResult<PhoneOtpRequestMutationMutation>;
export type PhoneOtpRequestMutationMutationOptions = Apollo.BaseMutationOptions<PhoneOtpRequestMutationMutation, PhoneOtpRequestMutationMutationVariables>;
export const UpdatePinMutationDocument = gql`
    mutation UpdatePinMutation($input: UpdatePinInput!) {
  updatePin(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdatePinMutationMutationFn = Apollo.MutationFunction<UpdatePinMutationMutation, UpdatePinMutationMutationVariables>;

/**
 * __useUpdatePinMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePinMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePinMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePinMutationMutation, { data, loading, error }] = useUpdatePinMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePinMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePinMutationMutation, UpdatePinMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePinMutationMutation, UpdatePinMutationMutationVariables>(UpdatePinMutationDocument, options);
      }
export type UpdatePinMutationMutationHookResult = ReturnType<typeof useUpdatePinMutationMutation>;
export type UpdatePinMutationMutationResult = Apollo.MutationResult<UpdatePinMutationMutation>;
export type UpdatePinMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePinMutationMutation, UpdatePinMutationMutationVariables>;
export const ValidatePinMutationDocument = gql`
    mutation ValidatePinMutation($pin: String!) {
  validatePin(pin: $pin) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ValidatePinMutationMutationFn = Apollo.MutationFunction<ValidatePinMutationMutation, ValidatePinMutationMutationVariables>;

/**
 * __useValidatePinMutationMutation__
 *
 * To run a mutation, you first call `useValidatePinMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePinMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePinMutationMutation, { data, loading, error }] = useValidatePinMutationMutation({
 *   variables: {
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useValidatePinMutationMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePinMutationMutation, ValidatePinMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePinMutationMutation, ValidatePinMutationMutationVariables>(ValidatePinMutationDocument, options);
      }
export type ValidatePinMutationMutationHookResult = ReturnType<typeof useValidatePinMutationMutation>;
export type ValidatePinMutationMutationResult = Apollo.MutationResult<ValidatePinMutationMutation>;
export type ValidatePinMutationMutationOptions = Apollo.BaseMutationOptions<ValidatePinMutationMutation, ValidatePinMutationMutationVariables>;
export const ReactivateCustomerMutationDocument = gql`
    mutation ReactivateCustomerMutation($email: String!) {
  reactivateCustomer(email: $email) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type ReactivateCustomerMutationMutationFn = Apollo.MutationFunction<ReactivateCustomerMutationMutation, ReactivateCustomerMutationMutationVariables>;

/**
 * __useReactivateCustomerMutationMutation__
 *
 * To run a mutation, you first call `useReactivateCustomerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCustomerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateCustomerMutationMutation, { data, loading, error }] = useReactivateCustomerMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReactivateCustomerMutationMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateCustomerMutationMutation, ReactivateCustomerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateCustomerMutationMutation, ReactivateCustomerMutationMutationVariables>(ReactivateCustomerMutationDocument, options);
      }
export type ReactivateCustomerMutationMutationHookResult = ReturnType<typeof useReactivateCustomerMutationMutation>;
export type ReactivateCustomerMutationMutationResult = Apollo.MutationResult<ReactivateCustomerMutationMutation>;
export type ReactivateCustomerMutationMutationOptions = Apollo.BaseMutationOptions<ReactivateCustomerMutationMutation, ReactivateCustomerMutationMutationVariables>;
export const RecentBeneficiariesQueryDocument = gql`
    query RecentBeneficiariesQuery($offset: Int!, $limit: Int!) {
  recentBeneficiaries(offset: $offset, limit: $limit) {
    id
    customer {
      id
      avatarUrl
      firstname
      lastname
      email
      username
      phone
      community {
        id
        name
        alias
      }
      createdAt
      updatedAt
      address
      gender
      dob
      nin
    }
    admin {
      id
      shortId
      firstname
      lastname
      email
      phone
      merchantProfile {
        id
        businessName
        businessType
        regCountry
        businessRegNumber
        taxId
        address
        addressAlt
        city
        country
        postcode
        companyName
        username
        industry {
          id
          name
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        companyLocation
        logoUrl
        bannerUrl
        description
        commissionRate
      }
    }
    suspended
    isLocked
    isVerified
    onboarding {
      id
      status
      currentStep
    }
    role
  }
}
    `;

/**
 * __useRecentBeneficiariesQueryQuery__
 *
 * To run a query within a React component, call `useRecentBeneficiariesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentBeneficiariesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentBeneficiariesQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentBeneficiariesQueryQuery(baseOptions: Apollo.QueryHookOptions<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables> & ({ variables: RecentBeneficiariesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>(RecentBeneficiariesQueryDocument, options);
      }
export function useRecentBeneficiariesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>(RecentBeneficiariesQueryDocument, options);
        }
// @ts-ignore
export function useRecentBeneficiariesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>;
export function useRecentBeneficiariesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RecentBeneficiariesQueryQuery | undefined, RecentBeneficiariesQueryQueryVariables>;
export function useRecentBeneficiariesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>(RecentBeneficiariesQueryDocument, options);
        }
export type RecentBeneficiariesQueryQueryHookResult = ReturnType<typeof useRecentBeneficiariesQueryQuery>;
export type RecentBeneficiariesQueryLazyQueryHookResult = ReturnType<typeof useRecentBeneficiariesQueryLazyQuery>;
export type RecentBeneficiariesQuerySuspenseQueryHookResult = ReturnType<typeof useRecentBeneficiariesQuerySuspenseQuery>;
export type RecentBeneficiariesQueryQueryResult = Apollo.QueryResult<RecentBeneficiariesQueryQuery, RecentBeneficiariesQueryQueryVariables>;
export const RedeemOfferMutationDocument = gql`
    mutation RedeemOfferMutation($id: String!, $referralCode: String, $points: Int) {
  redeemOffer(id: $id, referralCode: $referralCode, points: $points) {
    errors {
      path
      message
    }
    message
    njoyCode
    partnerVoucher
    referralUrl
  }
}
    `;
export type RedeemOfferMutationMutationFn = Apollo.MutationFunction<RedeemOfferMutationMutation, RedeemOfferMutationMutationVariables>;

/**
 * __useRedeemOfferMutationMutation__
 *
 * To run a mutation, you first call `useRedeemOfferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemOfferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemOfferMutationMutation, { data, loading, error }] = useRedeemOfferMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      referralCode: // value for 'referralCode'
 *      points: // value for 'points'
 *   },
 * });
 */
export function useRedeemOfferMutationMutation(baseOptions?: Apollo.MutationHookOptions<RedeemOfferMutationMutation, RedeemOfferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemOfferMutationMutation, RedeemOfferMutationMutationVariables>(RedeemOfferMutationDocument, options);
      }
export type RedeemOfferMutationMutationHookResult = ReturnType<typeof useRedeemOfferMutationMutation>;
export type RedeemOfferMutationMutationResult = Apollo.MutationResult<RedeemOfferMutationMutation>;
export type RedeemOfferMutationMutationOptions = Apollo.BaseMutationOptions<RedeemOfferMutationMutation, RedeemOfferMutationMutationVariables>;
export const ReferrerDataQueryDocument = gql`
    query ReferrerDataQuery {
  referrerData {
    errors {
      path
      message
    }
    message
    referralCode
    referralPoint
    referrals
  }
}
    `;

/**
 * __useReferrerDataQueryQuery__
 *
 * To run a query within a React component, call `useReferrerDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferrerDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferrerDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferrerDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>(ReferrerDataQueryDocument, options);
      }
export function useReferrerDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>(ReferrerDataQueryDocument, options);
        }
// @ts-ignore
export function useReferrerDataQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>;
export function useReferrerDataQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ReferrerDataQueryQuery | undefined, ReferrerDataQueryQueryVariables>;
export function useReferrerDataQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>(ReferrerDataQueryDocument, options);
        }
export type ReferrerDataQueryQueryHookResult = ReturnType<typeof useReferrerDataQueryQuery>;
export type ReferrerDataQueryLazyQueryHookResult = ReturnType<typeof useReferrerDataQueryLazyQuery>;
export type ReferrerDataQuerySuspenseQueryHookResult = ReturnType<typeof useReferrerDataQuerySuspenseQuery>;
export type ReferrerDataQueryQueryResult = Apollo.QueryResult<ReferrerDataQueryQuery, ReferrerDataQueryQueryVariables>;
export const SearchMerchantQueryDocument = gql`
    query SearchMerchantQuery($page: Int!, $pageSize: Int!, $searchText: String) {
  searchMerchant(page: $page, pageSize: $pageSize, searchText: $searchText) {
    data {
      adminId
      merchantUserId
      merchantId
      companyName
      username
      logoUrl
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useSearchMerchantQueryQuery__
 *
 * To run a query within a React component, call `useSearchMerchantQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMerchantQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMerchantQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useSearchMerchantQueryQuery(baseOptions: Apollo.QueryHookOptions<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables> & ({ variables: SearchMerchantQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>(SearchMerchantQueryDocument, options);
      }
export function useSearchMerchantQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>(SearchMerchantQueryDocument, options);
        }
// @ts-ignore
export function useSearchMerchantQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>;
export function useSearchMerchantQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMerchantQueryQuery | undefined, SearchMerchantQueryQueryVariables>;
export function useSearchMerchantQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>(SearchMerchantQueryDocument, options);
        }
export type SearchMerchantQueryQueryHookResult = ReturnType<typeof useSearchMerchantQueryQuery>;
export type SearchMerchantQueryLazyQueryHookResult = ReturnType<typeof useSearchMerchantQueryLazyQuery>;
export type SearchMerchantQuerySuspenseQueryHookResult = ReturnType<typeof useSearchMerchantQuerySuspenseQuery>;
export type SearchMerchantQueryQueryResult = Apollo.QueryResult<SearchMerchantQueryQuery, SearchMerchantQueryQueryVariables>;
export const SharedTransactionsQueryDocument = gql`
    query SharedTransactionsQuery($offset: Int!, $limit: Int!, $walletId: String!, $recipientWalletId: String!) {
  sharedTransactions(
    offset: $offset
    limit: $limit
    walletId: $walletId
    recipientWalletId: $recipientWalletId
  ) {
    createdAt
    transactions {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      wallet {
        id
        balance
        currency
        barterId
        flAccountReference
        owner {
          id
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      recipientWallet {
        id
        balance
        currency
        barterId
        flAccountReference
        owner {
          id
          customer {
            id
            firstname
            lastname
          }
        }
        createdAt
        updatedAt
      }
      user {
        id
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useSharedTransactionsQueryQuery__
 *
 * To run a query within a React component, call `useSharedTransactionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedTransactionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedTransactionsQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      walletId: // value for 'walletId'
 *      recipientWalletId: // value for 'recipientWalletId'
 *   },
 * });
 */
export function useSharedTransactionsQueryQuery(baseOptions: Apollo.QueryHookOptions<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables> & ({ variables: SharedTransactionsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>(SharedTransactionsQueryDocument, options);
      }
export function useSharedTransactionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>(SharedTransactionsQueryDocument, options);
        }
// @ts-ignore
export function useSharedTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>;
export function useSharedTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SharedTransactionsQueryQuery | undefined, SharedTransactionsQueryQueryVariables>;
export function useSharedTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>(SharedTransactionsQueryDocument, options);
        }
export type SharedTransactionsQueryQueryHookResult = ReturnType<typeof useSharedTransactionsQueryQuery>;
export type SharedTransactionsQueryLazyQueryHookResult = ReturnType<typeof useSharedTransactionsQueryLazyQuery>;
export type SharedTransactionsQuerySuspenseQueryHookResult = ReturnType<typeof useSharedTransactionsQuerySuspenseQuery>;
export type SharedTransactionsQueryQueryResult = Apollo.QueryResult<SharedTransactionsQueryQuery, SharedTransactionsQueryQueryVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateUserPointExchangeMutationDocument = gql`
    mutation CreateUserPointExchangeMutation($communityId: String!, $point: Int!) {
  createUserPointExchange(communityId: $communityId, point: $point) {
    errors {
      path
      message
    }
    message
    data {
      id
      communityId
      communityName
      point
      rate
      exchangedPoint
      createdAt
    }
  }
}
    `;
export type CreateUserPointExchangeMutationMutationFn = Apollo.MutationFunction<CreateUserPointExchangeMutationMutation, CreateUserPointExchangeMutationMutationVariables>;

/**
 * __useCreateUserPointExchangeMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserPointExchangeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPointExchangeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPointExchangeMutationMutation, { data, loading, error }] = useCreateUserPointExchangeMutationMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      point: // value for 'point'
 *   },
 * });
 */
export function useCreateUserPointExchangeMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPointExchangeMutationMutation, CreateUserPointExchangeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserPointExchangeMutationMutation, CreateUserPointExchangeMutationMutationVariables>(CreateUserPointExchangeMutationDocument, options);
      }
export type CreateUserPointExchangeMutationMutationHookResult = ReturnType<typeof useCreateUserPointExchangeMutationMutation>;
export type CreateUserPointExchangeMutationMutationResult = Apollo.MutationResult<CreateUserPointExchangeMutationMutation>;
export type CreateUserPointExchangeMutationMutationOptions = Apollo.BaseMutationOptions<CreateUserPointExchangeMutationMutation, CreateUserPointExchangeMutationMutationVariables>;
export const FindAllUserPointExchangeHistoryQueryDocument = gql`
    query FindAllUserPointExchangeHistoryQuery($page: Int!, $pageSize: Int!, $sortOrder: String) {
  findAllUserPointExchangeHistory(
    page: $page
    pageSize: $pageSize
    sortOrder: $sortOrder
  ) {
    data {
      id
      communityId
      communityName
      point
      rate
      exchangedPoint
      createdAt
    }
    total
    page
    pageSize
    totalPages
  }
}
    `;

/**
 * __useFindAllUserPointExchangeHistoryQueryQuery__
 *
 * To run a query within a React component, call `useFindAllUserPointExchangeHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllUserPointExchangeHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllUserPointExchangeHistoryQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useFindAllUserPointExchangeHistoryQueryQuery(baseOptions: Apollo.QueryHookOptions<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables> & ({ variables: FindAllUserPointExchangeHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>(FindAllUserPointExchangeHistoryQueryDocument, options);
      }
export function useFindAllUserPointExchangeHistoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>(FindAllUserPointExchangeHistoryQueryDocument, options);
        }
// @ts-ignore
export function useFindAllUserPointExchangeHistoryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>;
export function useFindAllUserPointExchangeHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllUserPointExchangeHistoryQueryQuery | undefined, FindAllUserPointExchangeHistoryQueryQueryVariables>;
export function useFindAllUserPointExchangeHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>(FindAllUserPointExchangeHistoryQueryDocument, options);
        }
export type FindAllUserPointExchangeHistoryQueryQueryHookResult = ReturnType<typeof useFindAllUserPointExchangeHistoryQueryQuery>;
export type FindAllUserPointExchangeHistoryQueryLazyQueryHookResult = ReturnType<typeof useFindAllUserPointExchangeHistoryQueryLazyQuery>;
export type FindAllUserPointExchangeHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllUserPointExchangeHistoryQuerySuspenseQuery>;
export type FindAllUserPointExchangeHistoryQueryQueryResult = Apollo.QueryResult<FindAllUserPointExchangeHistoryQueryQuery, FindAllUserPointExchangeHistoryQueryQueryVariables>;
export const FindUserPointExchangeHistoryByIdQueryDocument = gql`
    query FindUserPointExchangeHistoryByIdQuery($id: String!) {
  findUserPointExchangeHistoryById(id: $id) {
    id
    communityId
    communityName
    point
    rate
    exchangedPoint
    createdAt
  }
}
    `;

/**
 * __useFindUserPointExchangeHistoryByIdQueryQuery__
 *
 * To run a query within a React component, call `useFindUserPointExchangeHistoryByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserPointExchangeHistoryByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserPointExchangeHistoryByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindUserPointExchangeHistoryByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables> & ({ variables: FindUserPointExchangeHistoryByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>(FindUserPointExchangeHistoryByIdQueryDocument, options);
      }
export function useFindUserPointExchangeHistoryByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>(FindUserPointExchangeHistoryByIdQueryDocument, options);
        }
// @ts-ignore
export function useFindUserPointExchangeHistoryByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>;
export function useFindUserPointExchangeHistoryByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindUserPointExchangeHistoryByIdQueryQuery | undefined, FindUserPointExchangeHistoryByIdQueryQueryVariables>;
export function useFindUserPointExchangeHistoryByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>(FindUserPointExchangeHistoryByIdQueryDocument, options);
        }
export type FindUserPointExchangeHistoryByIdQueryQueryHookResult = ReturnType<typeof useFindUserPointExchangeHistoryByIdQueryQuery>;
export type FindUserPointExchangeHistoryByIdQueryLazyQueryHookResult = ReturnType<typeof useFindUserPointExchangeHistoryByIdQueryLazyQuery>;
export type FindUserPointExchangeHistoryByIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindUserPointExchangeHistoryByIdQuerySuspenseQuery>;
export type FindUserPointExchangeHistoryByIdQueryQueryResult = Apollo.QueryResult<FindUserPointExchangeHistoryByIdQueryQuery, FindUserPointExchangeHistoryByIdQueryQueryVariables>;
export const ViewCustomerWithSpendDocument = gql`
    query ViewCustomerWithSpend($id: String!) {
  viewCustomerWithSpend(id: $id) {
    customer {
      id
      firstname
      lastname
      username
      community {
        id
        name
        alias
      }
    }
    userId
    totalSpent
  }
}
    `;

/**
 * __useViewCustomerWithSpendQuery__
 *
 * To run a query within a React component, call `useViewCustomerWithSpendQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCustomerWithSpendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCustomerWithSpendQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewCustomerWithSpendQuery(baseOptions: Apollo.QueryHookOptions<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables> & ({ variables: ViewCustomerWithSpendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>(ViewCustomerWithSpendDocument, options);
      }
export function useViewCustomerWithSpendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>(ViewCustomerWithSpendDocument, options);
        }
// @ts-ignore
export function useViewCustomerWithSpendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>;
export function useViewCustomerWithSpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCustomerWithSpendQuery | undefined, ViewCustomerWithSpendQueryVariables>;
export function useViewCustomerWithSpendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>(ViewCustomerWithSpendDocument, options);
        }
export type ViewCustomerWithSpendQueryHookResult = ReturnType<typeof useViewCustomerWithSpendQuery>;
export type ViewCustomerWithSpendLazyQueryHookResult = ReturnType<typeof useViewCustomerWithSpendLazyQuery>;
export type ViewCustomerWithSpendSuspenseQueryHookResult = ReturnType<typeof useViewCustomerWithSpendSuspenseQuery>;
export type ViewCustomerWithSpendQueryResult = Apollo.QueryResult<ViewCustomerWithSpendQuery, ViewCustomerWithSpendQueryVariables>;
export const FindAllBanksQueryDocument = gql`
    query FindAllBanksQuery {
  findAllBanks {
    id
    bank
    bankCode
    pictureUrl
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindAllBanksQueryQuery__
 *
 * To run a query within a React component, call `useFindAllBanksQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllBanksQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllBanksQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllBanksQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>(FindAllBanksQueryDocument, options);
      }
export function useFindAllBanksQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>(FindAllBanksQueryDocument, options);
        }
// @ts-ignore
export function useFindAllBanksQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>;
export function useFindAllBanksQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllBanksQueryQuery | undefined, FindAllBanksQueryQueryVariables>;
export function useFindAllBanksQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>(FindAllBanksQueryDocument, options);
        }
export type FindAllBanksQueryQueryHookResult = ReturnType<typeof useFindAllBanksQueryQuery>;
export type FindAllBanksQueryLazyQueryHookResult = ReturnType<typeof useFindAllBanksQueryLazyQuery>;
export type FindAllBanksQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllBanksQuerySuspenseQuery>;
export type FindAllBanksQueryQueryResult = Apollo.QueryResult<FindAllBanksQueryQuery, FindAllBanksQueryQueryVariables>;
export const NewBankSubscriptionDocument = gql`
    subscription NewBankSubscription {
  newBank {
    id
    bank
    bankCode
    pictureUrl
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewBankSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewBankSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewBankSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewBankSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewBankSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewBankSubscriptionSubscription, NewBankSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewBankSubscriptionSubscription, NewBankSubscriptionSubscriptionVariables>(NewBankSubscriptionDocument, options);
      }
export type NewBankSubscriptionSubscriptionHookResult = ReturnType<typeof useNewBankSubscriptionSubscription>;
export type NewBankSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewBankSubscriptionSubscription>;
export const FindBankPreferenceByUserIdQueryDocument = gql`
    query FindBankPreferenceByUserIdQuery($id: String!) {
  findBankPreferenceByUserId(id: $id) {
    id
    bank {
      id
      bank
      bankCode
      pictureUrl
    }
    accountNo
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindBankPreferenceByUserIdQueryQuery__
 *
 * To run a query within a React component, call `useFindBankPreferenceByUserIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBankPreferenceByUserIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBankPreferenceByUserIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindBankPreferenceByUserIdQueryQuery(baseOptions: Apollo.QueryHookOptions<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables> & ({ variables: FindBankPreferenceByUserIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>(FindBankPreferenceByUserIdQueryDocument, options);
      }
export function useFindBankPreferenceByUserIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>(FindBankPreferenceByUserIdQueryDocument, options);
        }
// @ts-ignore
export function useFindBankPreferenceByUserIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>;
export function useFindBankPreferenceByUserIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindBankPreferenceByUserIdQueryQuery | undefined, FindBankPreferenceByUserIdQueryQueryVariables>;
export function useFindBankPreferenceByUserIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>(FindBankPreferenceByUserIdQueryDocument, options);
        }
export type FindBankPreferenceByUserIdQueryQueryHookResult = ReturnType<typeof useFindBankPreferenceByUserIdQueryQuery>;
export type FindBankPreferenceByUserIdQueryLazyQueryHookResult = ReturnType<typeof useFindBankPreferenceByUserIdQueryLazyQuery>;
export type FindBankPreferenceByUserIdQuerySuspenseQueryHookResult = ReturnType<typeof useFindBankPreferenceByUserIdQuerySuspenseQuery>;
export type FindBankPreferenceByUserIdQueryQueryResult = Apollo.QueryResult<FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables>;
export const CreateLocationMutationDocument = gql`
    mutation CreateLocationMutation($input: CreateLocationInput) {
  createLocation(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateLocationMutationMutationFn = Apollo.MutationFunction<CreateLocationMutationMutation, CreateLocationMutationMutationVariables>;

/**
 * __useCreateLocationMutationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutationMutation, { data, loading, error }] = useCreateLocationMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutationMutation, CreateLocationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutationMutation, CreateLocationMutationMutationVariables>(CreateLocationMutationDocument, options);
      }
export type CreateLocationMutationMutationHookResult = ReturnType<typeof useCreateLocationMutationMutation>;
export type CreateLocationMutationMutationResult = Apollo.MutationResult<CreateLocationMutationMutation>;
export type CreateLocationMutationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutationMutation, CreateLocationMutationMutationVariables>;
export const FindAllLocationsQueryDocument = gql`
    query FindAllLocationsQuery {
  findAllLocations {
    id
    district
    city
    streetName
    country
    postalCode
    landmark
    latitude
    longitude
    isArchive
    createdAt
    createdBy {
      id
      role
      admin {
        id
        level
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useFindAllLocationsQueryQuery__
 *
 * To run a query within a React component, call `useFindAllLocationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllLocationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllLocationsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllLocationsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>(FindAllLocationsQueryDocument, options);
      }
export function useFindAllLocationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>(FindAllLocationsQueryDocument, options);
        }
// @ts-ignore
export function useFindAllLocationsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>;
export function useFindAllLocationsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindAllLocationsQueryQuery | undefined, FindAllLocationsQueryQueryVariables>;
export function useFindAllLocationsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>(FindAllLocationsQueryDocument, options);
        }
export type FindAllLocationsQueryQueryHookResult = ReturnType<typeof useFindAllLocationsQueryQuery>;
export type FindAllLocationsQueryLazyQueryHookResult = ReturnType<typeof useFindAllLocationsQueryLazyQuery>;
export type FindAllLocationsQuerySuspenseQueryHookResult = ReturnType<typeof useFindAllLocationsQuerySuspenseQuery>;
export type FindAllLocationsQueryQueryResult = Apollo.QueryResult<FindAllLocationsQueryQuery, FindAllLocationsQueryQueryVariables>;
export const NewLocationSubscriptionDocument = gql`
    subscription NewLocationSubscription {
  newLocation {
    id
    district
    city
    streetName
    country
    postalCode
    landmark
    latitude
    longitude
    isArchive
    createdAt
    createdBy {
      id
      role
      admin {
        id
        level
        firstname
        lastname
      }
    }
  }
}
    `;

/**
 * __useNewLocationSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewLocationSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewLocationSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewLocationSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewLocationSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewLocationSubscriptionSubscription, NewLocationSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewLocationSubscriptionSubscription, NewLocationSubscriptionSubscriptionVariables>(NewLocationSubscriptionDocument, options);
      }
export type NewLocationSubscriptionSubscriptionHookResult = ReturnType<typeof useNewLocationSubscriptionSubscription>;
export type NewLocationSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewLocationSubscriptionSubscription>;
export const UpdateLocationMutationDocument = gql`
    mutation UpdateLocationMutation($locationId: String!, $input: UpdateLocationInput!) {
  updateLocation(locationId: $locationId, input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UpdateLocationMutationMutationFn = Apollo.MutationFunction<UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables>;

/**
 * __useUpdateLocationMutationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutationMutation, { data, loading, error }] = useUpdateLocationMutationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables>(UpdateLocationMutationDocument, options);
      }
export type UpdateLocationMutationMutationHookResult = ReturnType<typeof useUpdateLocationMutationMutation>;
export type UpdateLocationMutationMutationResult = Apollo.MutationResult<UpdateLocationMutationMutation>;
export type UpdateLocationMutationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables>;
export const LogoutMutationDocument = gql`
    mutation LogoutMutation {
  logout
}
    `;
export type LogoutMutationMutationFn = Apollo.MutationFunction<LogoutMutationMutation, LogoutMutationMutationVariables>;

/**
 * __useLogoutMutationMutation__
 *
 * To run a mutation, you first call `useLogoutMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutationMutation, { data, loading, error }] = useLogoutMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutationMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutationMutation, LogoutMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutationMutation, LogoutMutationMutationVariables>(LogoutMutationDocument, options);
      }
export type LogoutMutationMutationHookResult = ReturnType<typeof useLogoutMutationMutation>;
export type LogoutMutationMutationResult = Apollo.MutationResult<LogoutMutationMutation>;
export type LogoutMutationMutationOptions = Apollo.BaseMutationOptions<LogoutMutationMutation, LogoutMutationMutationVariables>;
export const MarkAsSeenMutationDocument = gql`
    mutation MarkAsSeenMutation($id: ID!, $provider: String) {
  markAsSeen(id: $id, provider: $provider) {
    errors {
      message
      path
    }
    message
  }
}
    `;
export type MarkAsSeenMutationMutationFn = Apollo.MutationFunction<MarkAsSeenMutationMutation, MarkAsSeenMutationMutationVariables>;

/**
 * __useMarkAsSeenMutationMutation__
 *
 * To run a mutation, you first call `useMarkAsSeenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsSeenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsSeenMutationMutation, { data, loading, error }] = useMarkAsSeenMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useMarkAsSeenMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsSeenMutationMutation, MarkAsSeenMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsSeenMutationMutation, MarkAsSeenMutationMutationVariables>(MarkAsSeenMutationDocument, options);
      }
export type MarkAsSeenMutationMutationHookResult = ReturnType<typeof useMarkAsSeenMutationMutation>;
export type MarkAsSeenMutationMutationResult = Apollo.MutationResult<MarkAsSeenMutationMutation>;
export type MarkAsSeenMutationMutationOptions = Apollo.BaseMutationOptions<MarkAsSeenMutationMutation, MarkAsSeenMutationMutationVariables>;
export const TrackAlertClickMutationDocument = gql`
    mutation TrackAlertClickMutation($id: ID!, $provider: String) {
  trackAlertClick(id: $id, provider: $provider) {
    errors {
      message
      path
    }
    message
  }
}
    `;
export type TrackAlertClickMutationMutationFn = Apollo.MutationFunction<TrackAlertClickMutationMutation, TrackAlertClickMutationMutationVariables>;

/**
 * __useTrackAlertClickMutationMutation__
 *
 * To run a mutation, you first call `useTrackAlertClickMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackAlertClickMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackAlertClickMutationMutation, { data, loading, error }] = useTrackAlertClickMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useTrackAlertClickMutationMutation(baseOptions?: Apollo.MutationHookOptions<TrackAlertClickMutationMutation, TrackAlertClickMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackAlertClickMutationMutation, TrackAlertClickMutationMutationVariables>(TrackAlertClickMutationDocument, options);
      }
export type TrackAlertClickMutationMutationHookResult = ReturnType<typeof useTrackAlertClickMutationMutation>;
export type TrackAlertClickMutationMutationResult = Apollo.MutationResult<TrackAlertClickMutationMutation>;
export type TrackAlertClickMutationMutationOptions = Apollo.BaseMutationOptions<TrackAlertClickMutationMutation, TrackAlertClickMutationMutationVariables>;
export const MeQueryDocument = gql`
    query MeQuery {
  me {
    id
    customer {
      id
      avatarUrl
      firstname
      lastname
      email
      username
      phone
      community {
        id
        name
        alias
      }
      createdAt
      updatedAt
      address
      gender
      dob
      nin
    }
    admin {
      id
      shortId
      firstname
      lastname
      email
      phone
      level
      tenantId
      tenant {
        id
        name
        slug
        branding {
          appName
          logoUrl
          iconUrl
          primaryColor
        }
      }
      merchantProfile {
        id
        businessName
        businessType
        regCountry
        businessRegNumber
        taxId
        address
        addressAlt
        city
        country
        postcode
        companyName
        username
        industry {
          id
          name
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        companyLocation
        logoUrl
        bannerUrl
        description
        commissionRate
        websiteOrSocials
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
    suspended
    isLocked
    isVerified
    onboarding {
      id
      status
      currentStep
    }
    role
  }
}
    `;

/**
 * __useMeQueryQuery__
 *
 * To run a query within a React component, call `useMeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQueryQuery(baseOptions?: Apollo.QueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
      }
export function useMeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
        }
// @ts-ignore
export function useMeQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MeQueryQuery, MeQueryQueryVariables>;
export function useMeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MeQueryQuery | undefined, MeQueryQueryVariables>;
export function useMeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
        }
export type MeQueryQueryHookResult = ReturnType<typeof useMeQueryQuery>;
export type MeQueryLazyQueryHookResult = ReturnType<typeof useMeQueryLazyQuery>;
export type MeQuerySuspenseQueryHookResult = ReturnType<typeof useMeQuerySuspenseQuery>;
export type MeQueryQueryResult = Apollo.QueryResult<MeQueryQuery, MeQueryQueryVariables>;
export const MyBankPreferencesQueryDocument = gql`
    query MyBankPreferencesQuery {
  myBankPreferences {
    id
    bank {
      id
      bank
      bankCode
      pictureUrl
    }
    accountNo
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyBankPreferencesQueryQuery__
 *
 * To run a query within a React component, call `useMyBankPreferencesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBankPreferencesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBankPreferencesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBankPreferencesQueryQuery(baseOptions?: Apollo.QueryHookOptions<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>(MyBankPreferencesQueryDocument, options);
      }
export function useMyBankPreferencesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>(MyBankPreferencesQueryDocument, options);
        }
// @ts-ignore
export function useMyBankPreferencesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>;
export function useMyBankPreferencesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyBankPreferencesQueryQuery | undefined, MyBankPreferencesQueryQueryVariables>;
export function useMyBankPreferencesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>(MyBankPreferencesQueryDocument, options);
        }
export type MyBankPreferencesQueryQueryHookResult = ReturnType<typeof useMyBankPreferencesQueryQuery>;
export type MyBankPreferencesQueryLazyQueryHookResult = ReturnType<typeof useMyBankPreferencesQueryLazyQuery>;
export type MyBankPreferencesQuerySuspenseQueryHookResult = ReturnType<typeof useMyBankPreferencesQuerySuspenseQuery>;
export type MyBankPreferencesQueryQueryResult = Apollo.QueryResult<MyBankPreferencesQueryQuery, MyBankPreferencesQueryQueryVariables>;
export const NewBankPreferenceSubscriptionDocument = gql`
    subscription NewBankPreferenceSubscription {
  newBankPreference {
    id
    bank {
      id
      bank
      bankCode
      pictureUrl
    }
    accountNo
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewBankPreferenceSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewBankPreferenceSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewBankPreferenceSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewBankPreferenceSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewBankPreferenceSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewBankPreferenceSubscriptionSubscription, NewBankPreferenceSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewBankPreferenceSubscriptionSubscription, NewBankPreferenceSubscriptionSubscriptionVariables>(NewBankPreferenceSubscriptionDocument, options);
      }
export type NewBankPreferenceSubscriptionSubscriptionHookResult = ReturnType<typeof useNewBankPreferenceSubscriptionSubscription>;
export type NewBankPreferenceSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewBankPreferenceSubscriptionSubscription>;
export const WalletQueryDocument = gql`
    query WalletQuery {
  wallet {
    id
    flId
    currency
    barterId
    balance
    owner {
      id
    }
    flNuban
    bankName
    bankCode
    flAccountReference
    flNuban
    status
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useWalletQueryQuery__
 *
 * To run a query within a React component, call `useWalletQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletQueryQuery(baseOptions?: Apollo.QueryHookOptions<WalletQueryQuery, WalletQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletQueryQuery, WalletQueryQueryVariables>(WalletQueryDocument, options);
      }
export function useWalletQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletQueryQuery, WalletQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletQueryQuery, WalletQueryQueryVariables>(WalletQueryDocument, options);
        }
// @ts-ignore
export function useWalletQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WalletQueryQuery, WalletQueryQueryVariables>): Apollo.UseSuspenseQueryResult<WalletQueryQuery, WalletQueryQueryVariables>;
export function useWalletQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletQueryQuery, WalletQueryQueryVariables>): Apollo.UseSuspenseQueryResult<WalletQueryQuery | undefined, WalletQueryQueryVariables>;
export function useWalletQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WalletQueryQuery, WalletQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WalletQueryQuery, WalletQueryQueryVariables>(WalletQueryDocument, options);
        }
export type WalletQueryQueryHookResult = ReturnType<typeof useWalletQueryQuery>;
export type WalletQueryLazyQueryHookResult = ReturnType<typeof useWalletQueryLazyQuery>;
export type WalletQuerySuspenseQueryHookResult = ReturnType<typeof useWalletQuerySuspenseQuery>;
export type WalletQueryQueryResult = Apollo.QueryResult<WalletQueryQuery, WalletQueryQueryVariables>;
export const WalletUpdateSubscriptionDocument = gql`
    subscription WalletUpdateSubscription {
  walletUpdate {
    id
    flId
    currency
    barterId
    balance
    owner {
      id
    }
    flNuban
    bankName
    bankCode
    flAccountReference
    flNuban
    status
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useWalletUpdateSubscriptionSubscription__
 *
 * To run a query within a React component, call `useWalletUpdateSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWalletUpdateSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletUpdateSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWalletUpdateSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WalletUpdateSubscriptionSubscription, WalletUpdateSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WalletUpdateSubscriptionSubscription, WalletUpdateSubscriptionSubscriptionVariables>(WalletUpdateSubscriptionDocument, options);
      }
export type WalletUpdateSubscriptionSubscriptionHookResult = ReturnType<typeof useWalletUpdateSubscriptionSubscription>;
export type WalletUpdateSubscriptionSubscriptionResult = Apollo.SubscriptionResult<WalletUpdateSubscriptionSubscription>;
export const FindOffersQueryDocument = gql`
    query FindOffersQuery {
  findOffers {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    location {
      id
      city
      district
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      createdAt
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    offerTOR
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindOffersQueryQuery__
 *
 * To run a query within a React component, call `useFindOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOffersQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindOffersQueryQuery(baseOptions?: Apollo.QueryHookOptions<FindOffersQueryQuery, FindOffersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOffersQueryQuery, FindOffersQueryQueryVariables>(FindOffersQueryDocument, options);
      }
export function useFindOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOffersQueryQuery, FindOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOffersQueryQuery, FindOffersQueryQueryVariables>(FindOffersQueryDocument, options);
        }
// @ts-ignore
export function useFindOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOffersQueryQuery, FindOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOffersQueryQuery, FindOffersQueryQueryVariables>;
export function useFindOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOffersQueryQuery, FindOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOffersQueryQuery | undefined, FindOffersQueryQueryVariables>;
export function useFindOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOffersQueryQuery, FindOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOffersQueryQuery, FindOffersQueryQueryVariables>(FindOffersQueryDocument, options);
        }
export type FindOffersQueryQueryHookResult = ReturnType<typeof useFindOffersQueryQuery>;
export type FindOffersQueryLazyQueryHookResult = ReturnType<typeof useFindOffersQueryLazyQuery>;
export type FindOffersQuerySuspenseQueryHookResult = ReturnType<typeof useFindOffersQuerySuspenseQuery>;
export type FindOffersQueryQueryResult = Apollo.QueryResult<FindOffersQueryQuery, FindOffersQueryQueryVariables>;
export const NewOfferSubscriptionDocument = gql`
    subscription NewOfferSubscription {
  newOffer {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    location {
      id
      city
      district
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      createdAt
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewOfferSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewOfferSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewOfferSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewOfferSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewOfferSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewOfferSubscriptionSubscription, NewOfferSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewOfferSubscriptionSubscription, NewOfferSubscriptionSubscriptionVariables>(NewOfferSubscriptionDocument, options);
      }
export type NewOfferSubscriptionSubscriptionHookResult = ReturnType<typeof useNewOfferSubscriptionSubscription>;
export type NewOfferSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewOfferSubscriptionSubscription>;
export const FindOffersEndingSoonQueryDocument = gql`
    query FindOffersEndingSoonQuery($offset: Int!, $limit: Int!, $locationId: String!) {
  findOffersEndingSoon(offset: $offset, limit: $limit, locationId: $locationId) {
    id
    title
    description
    bannerUrl
    offerType
    status
    offerTOR
    startDate
    endDate
    createdBy {
      id
      admin {
        id
        merchantProfile {
          id
          companyName
          username
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindOffersEndingSoonQueryQuery__
 *
 * To run a query within a React component, call `useFindOffersEndingSoonQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOffersEndingSoonQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOffersEndingSoonQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFindOffersEndingSoonQueryQuery(baseOptions: Apollo.QueryHookOptions<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables> & ({ variables: FindOffersEndingSoonQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>(FindOffersEndingSoonQueryDocument, options);
      }
export function useFindOffersEndingSoonQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>(FindOffersEndingSoonQueryDocument, options);
        }
// @ts-ignore
export function useFindOffersEndingSoonQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>;
export function useFindOffersEndingSoonQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>): Apollo.UseSuspenseQueryResult<FindOffersEndingSoonQueryQuery | undefined, FindOffersEndingSoonQueryQueryVariables>;
export function useFindOffersEndingSoonQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>(FindOffersEndingSoonQueryDocument, options);
        }
export type FindOffersEndingSoonQueryQueryHookResult = ReturnType<typeof useFindOffersEndingSoonQueryQuery>;
export type FindOffersEndingSoonQueryLazyQueryHookResult = ReturnType<typeof useFindOffersEndingSoonQueryLazyQuery>;
export type FindOffersEndingSoonQuerySuspenseQueryHookResult = ReturnType<typeof useFindOffersEndingSoonQuerySuspenseQuery>;
export type FindOffersEndingSoonQueryQueryResult = Apollo.QueryResult<FindOffersEndingSoonQueryQuery, FindOffersEndingSoonQueryQueryVariables>;
export const MarkSharedOfferMutationDocument = gql`
    mutation MarkSharedOfferMutation($id: String!) {
  markSharedOffer(id: $id) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type MarkSharedOfferMutationMutationFn = Apollo.MutationFunction<MarkSharedOfferMutationMutation, MarkSharedOfferMutationMutationVariables>;

/**
 * __useMarkSharedOfferMutationMutation__
 *
 * To run a mutation, you first call `useMarkSharedOfferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSharedOfferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSharedOfferMutationMutation, { data, loading, error }] = useMarkSharedOfferMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSharedOfferMutationMutation(baseOptions?: Apollo.MutationHookOptions<MarkSharedOfferMutationMutation, MarkSharedOfferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSharedOfferMutationMutation, MarkSharedOfferMutationMutationVariables>(MarkSharedOfferMutationDocument, options);
      }
export type MarkSharedOfferMutationMutationHookResult = ReturnType<typeof useMarkSharedOfferMutationMutation>;
export type MarkSharedOfferMutationMutationResult = Apollo.MutationResult<MarkSharedOfferMutationMutation>;
export type MarkSharedOfferMutationMutationOptions = Apollo.BaseMutationOptions<MarkSharedOfferMutationMutation, MarkSharedOfferMutationMutationVariables>;
export const RelatedOffersQueryDocument = gql`
    query RelatedOffersQuery($communityId: String!, $limit: Int!, $offset: Int!) {
  relatedOffers(communityId: $communityId, limit: $limit, offset: $offset) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    location {
      id
      city
      district
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      createdAt
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useRelatedOffersQueryQuery__
 *
 * To run a query within a React component, call `useRelatedOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedOffersQueryQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRelatedOffersQueryQuery(baseOptions: Apollo.QueryHookOptions<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables> & ({ variables: RelatedOffersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>(RelatedOffersQueryDocument, options);
      }
export function useRelatedOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>(RelatedOffersQueryDocument, options);
        }
// @ts-ignore
export function useRelatedOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>;
export function useRelatedOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<RelatedOffersQueryQuery | undefined, RelatedOffersQueryQueryVariables>;
export function useRelatedOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>(RelatedOffersQueryDocument, options);
        }
export type RelatedOffersQueryQueryHookResult = ReturnType<typeof useRelatedOffersQueryQuery>;
export type RelatedOffersQueryLazyQueryHookResult = ReturnType<typeof useRelatedOffersQueryLazyQuery>;
export type RelatedOffersQuerySuspenseQueryHookResult = ReturnType<typeof useRelatedOffersQuerySuspenseQuery>;
export type RelatedOffersQueryQueryResult = Apollo.QueryResult<RelatedOffersQueryQuery, RelatedOffersQueryQueryVariables>;
export const SearchOffersQueryDocument = gql`
    query SearchOffersQuery($input: SearchOffersInput, $offset: Int!, $limit: Int!) {
  searchOffers(input: $input, offset: $offset, limit: $limit) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdAt
    }
    offerType
    status
    offerTOR
    startDate
    endDate
    createdBy {
      id
      admin {
        id
        merchantProfile {
          id
          companyName
          username
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSearchOffersQueryQuery__
 *
 * To run a query within a React component, call `useSearchOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOffersQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchOffersQueryQuery(baseOptions: Apollo.QueryHookOptions<SearchOffersQueryQuery, SearchOffersQueryQueryVariables> & ({ variables: SearchOffersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>(SearchOffersQueryDocument, options);
      }
export function useSearchOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>(SearchOffersQueryDocument, options);
        }
// @ts-ignore
export function useSearchOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>;
export function useSearchOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOffersQueryQuery | undefined, SearchOffersQueryQueryVariables>;
export function useSearchOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>(SearchOffersQueryDocument, options);
        }
export type SearchOffersQueryQueryHookResult = ReturnType<typeof useSearchOffersQueryQuery>;
export type SearchOffersQueryLazyQueryHookResult = ReturnType<typeof useSearchOffersQueryLazyQuery>;
export type SearchOffersQuerySuspenseQueryHookResult = ReturnType<typeof useSearchOffersQuerySuspenseQuery>;
export type SearchOffersQueryQueryResult = Apollo.QueryResult<SearchOffersQueryQuery, SearchOffersQueryQueryVariables>;
export const SearchOffersByCategoryQueryDocument = gql`
    query SearchOffersByCategoryQuery($input: SearchOffersByCategoryInput, $offset: Int!, $limit: Int!) {
  searchOffersByCategory(input: $input, offset: $offset, limit: $limit) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    location {
      id
      city
      district
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      createdAt
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    location {
      id
      district
      city
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSearchOffersByCategoryQueryQuery__
 *
 * To run a query within a React component, call `useSearchOffersByCategoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOffersByCategoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOffersByCategoryQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchOffersByCategoryQueryQuery(baseOptions: Apollo.QueryHookOptions<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables> & ({ variables: SearchOffersByCategoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>(SearchOffersByCategoryQueryDocument, options);
      }
export function useSearchOffersByCategoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>(SearchOffersByCategoryQueryDocument, options);
        }
// @ts-ignore
export function useSearchOffersByCategoryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>;
export function useSearchOffersByCategoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOffersByCategoryQueryQuery | undefined, SearchOffersByCategoryQueryQueryVariables>;
export function useSearchOffersByCategoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>(SearchOffersByCategoryQueryDocument, options);
        }
export type SearchOffersByCategoryQueryQueryHookResult = ReturnType<typeof useSearchOffersByCategoryQueryQuery>;
export type SearchOffersByCategoryQueryLazyQueryHookResult = ReturnType<typeof useSearchOffersByCategoryQueryLazyQuery>;
export type SearchOffersByCategoryQuerySuspenseQueryHookResult = ReturnType<typeof useSearchOffersByCategoryQuerySuspenseQuery>;
export type SearchOffersByCategoryQueryQueryResult = Apollo.QueryResult<SearchOffersByCategoryQueryQuery, SearchOffersByCategoryQueryQueryVariables>;
export const ViewCategoryOffersQueryDocument = gql`
    query ViewCategoryOffersQuery($categoryId: String!, $offset: Int!, $limit: Int!) {
  categoryOffers(categoryId: $categoryId, offset: $offset, limit: $limit) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewCategoryOffersQueryQuery__
 *
 * To run a query within a React component, call `useViewCategoryOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCategoryOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCategoryOffersQueryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useViewCategoryOffersQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables> & ({ variables: ViewCategoryOffersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>(ViewCategoryOffersQueryDocument, options);
      }
export function useViewCategoryOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>(ViewCategoryOffersQueryDocument, options);
        }
// @ts-ignore
export function useViewCategoryOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>;
export function useViewCategoryOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCategoryOffersQueryQuery | undefined, ViewCategoryOffersQueryQueryVariables>;
export function useViewCategoryOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>(ViewCategoryOffersQueryDocument, options);
        }
export type ViewCategoryOffersQueryQueryHookResult = ReturnType<typeof useViewCategoryOffersQueryQuery>;
export type ViewCategoryOffersQueryLazyQueryHookResult = ReturnType<typeof useViewCategoryOffersQueryLazyQuery>;
export type ViewCategoryOffersQuerySuspenseQueryHookResult = ReturnType<typeof useViewCategoryOffersQuerySuspenseQuery>;
export type ViewCategoryOffersQueryQueryResult = Apollo.QueryResult<ViewCategoryOffersQueryQuery, ViewCategoryOffersQueryQueryVariables>;
export const NewCategoryOfferSubscriptionDocument = gql`
    subscription NewCategoryOfferSubscription($categoryId: String!) {
  newCategoryOffer(categoryId: $categoryId) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewCategoryOfferSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewCategoryOfferSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCategoryOfferSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCategoryOfferSubscriptionSubscription({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useNewCategoryOfferSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewCategoryOfferSubscriptionSubscription, NewCategoryOfferSubscriptionSubscriptionVariables> & ({ variables: NewCategoryOfferSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCategoryOfferSubscriptionSubscription, NewCategoryOfferSubscriptionSubscriptionVariables>(NewCategoryOfferSubscriptionDocument, options);
      }
export type NewCategoryOfferSubscriptionSubscriptionHookResult = ReturnType<typeof useNewCategoryOfferSubscriptionSubscription>;
export type NewCategoryOfferSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewCategoryOfferSubscriptionSubscription>;
export const ViewChildOffersQueryDocument = gql`
    query ViewChildOffersQuery($userId: String!, $offset: Int!, $limit: Int!) {
  childOffers(userId: $userId, offset: $offset, limit: $limit) {
    id
    title
    description
    bannerUrl
    offerType
    status
    offerTOR
    startDate
    endDate
    createdBy {
      id
      admin {
        id
        merchantProfile {
          id
          companyName
          username
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewChildOffersQueryQuery__
 *
 * To run a query within a React component, call `useViewChildOffersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewChildOffersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewChildOffersQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useViewChildOffersQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables> & ({ variables: ViewChildOffersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>(ViewChildOffersQueryDocument, options);
      }
export function useViewChildOffersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>(ViewChildOffersQueryDocument, options);
        }
// @ts-ignore
export function useViewChildOffersQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>;
export function useViewChildOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewChildOffersQueryQuery | undefined, ViewChildOffersQueryQueryVariables>;
export function useViewChildOffersQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>(ViewChildOffersQueryDocument, options);
        }
export type ViewChildOffersQueryQueryHookResult = ReturnType<typeof useViewChildOffersQueryQuery>;
export type ViewChildOffersQueryLazyQueryHookResult = ReturnType<typeof useViewChildOffersQueryLazyQuery>;
export type ViewChildOffersQuerySuspenseQueryHookResult = ReturnType<typeof useViewChildOffersQuerySuspenseQuery>;
export type ViewChildOffersQueryQueryResult = Apollo.QueryResult<ViewChildOffersQueryQuery, ViewChildOffersQueryQueryVariables>;
export const NewChildOfferSubscriptionDocument = gql`
    subscription NewChildOfferSubscription($userId: String!) {
  newChildOffer(userId: $userId) {
    id
    title
    description
    bannerUrl
    category {
      id
      name
      imgSrc
      createdBy {
        id
        role
      }
      createdAt
      updatedAt
    }
    offerType
    discountType
    discountValue
    partnerVoucher
    referralUrl
    status
    usageLimitPerUser
    totalUsageLimit
    startDate
    endDate
    community {
      id
      name
      alias
    }
    location {
      id
      city
      district
      streetName
      country
      postalCode
      landmark
      latitude
      longitude
      createdAt
    }
    redemptions
    revenueGenerated
    clickThroughs
    featured
    createdBy {
      id
      role
      admin {
        id
        shortId
        firstname
        lastname
        email
        phone
        merchantProfile {
          id
          businessName
          businessType
          regCountry
          businessRegNumber
          taxId
          address
          addressAlt
          city
          country
          postcode
          companyName
          username
          industry {
            id
            name
            createdBy {
              id
              role
            }
            createdAt
            updatedAt
          }
          companyLocation
          logoUrl
          bannerUrl
          description
          commissionRate
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useNewChildOfferSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewChildOfferSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewChildOfferSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewChildOfferSubscriptionSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNewChildOfferSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewChildOfferSubscriptionSubscription, NewChildOfferSubscriptionSubscriptionVariables> & ({ variables: NewChildOfferSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewChildOfferSubscriptionSubscription, NewChildOfferSubscriptionSubscriptionVariables>(NewChildOfferSubscriptionDocument, options);
      }
export type NewChildOfferSubscriptionSubscriptionHookResult = ReturnType<typeof useNewChildOfferSubscriptionSubscription>;
export type NewChildOfferSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewChildOfferSubscriptionSubscription>;
export const ViewOfferQueryDocument = gql`
    query ViewOfferQuery($id: String!) {
  viewOffer(id: $id) {
    id
    title
    description
    offerType
    startDate
    endDate
    offerTOR
    status
    category {
      id
      name
      imgSrc
    }
    community {
      id
      name
      alias
    }
    usageLimitPerUser
    totalUsageLimit
    location {
      id
      city
      country
    }
    bannerUrl
    discountType
    discountValue
    partnerVoucher
    referralUrl
    amount
    redemptions
    shareCount
    offerPointsDeduction {
      id
      offerId
      point
      createdAt
      updatedAt
    }
    createdBy {
      id
      admin {
        shortId
        merchantProfile {
          id
          companyName
          logoUrl
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewOfferQueryQuery__
 *
 * To run a query within a React component, call `useViewOfferQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewOfferQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewOfferQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewOfferQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewOfferQueryQuery, ViewOfferQueryQueryVariables> & ({ variables: ViewOfferQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>(ViewOfferQueryDocument, options);
      }
export function useViewOfferQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>(ViewOfferQueryDocument, options);
        }
// @ts-ignore
export function useViewOfferQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>;
export function useViewOfferQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewOfferQueryQuery | undefined, ViewOfferQueryQueryVariables>;
export function useViewOfferQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>(ViewOfferQueryDocument, options);
        }
export type ViewOfferQueryQueryHookResult = ReturnType<typeof useViewOfferQueryQuery>;
export type ViewOfferQueryLazyQueryHookResult = ReturnType<typeof useViewOfferQueryLazyQuery>;
export type ViewOfferQuerySuspenseQueryHookResult = ReturnType<typeof useViewOfferQuerySuspenseQuery>;
export type ViewOfferQueryQueryResult = Apollo.QueryResult<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>;
export const ViewOfferPwaQueryDocument = gql`
    query ViewOfferPWAQuery($id: String!) {
  viewOfferPWA(id: $id) {
    id
    title
    description
    bannerUrl
    offerType
    amount
    status
    offerTOR
    startDate
    endDate
    createdBy {
      id
      admin {
        id
        merchantProfile {
          id
          companyName
          username
          companyLocation
          logoUrl
          bannerUrl
          description
        }
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewOfferPwaQueryQuery__
 *
 * To run a query within a React component, call `useViewOfferPwaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewOfferPwaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewOfferPwaQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewOfferPwaQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables> & ({ variables: ViewOfferPwaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>(ViewOfferPwaQueryDocument, options);
      }
export function useViewOfferPwaQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>(ViewOfferPwaQueryDocument, options);
        }
// @ts-ignore
export function useViewOfferPwaQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>;
export function useViewOfferPwaQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewOfferPwaQueryQuery | undefined, ViewOfferPwaQueryQueryVariables>;
export function useViewOfferPwaQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>(ViewOfferPwaQueryDocument, options);
        }
export type ViewOfferPwaQueryQueryHookResult = ReturnType<typeof useViewOfferPwaQueryQuery>;
export type ViewOfferPwaQueryLazyQueryHookResult = ReturnType<typeof useViewOfferPwaQueryLazyQuery>;
export type ViewOfferPwaQuerySuspenseQueryHookResult = ReturnType<typeof useViewOfferPwaQuerySuspenseQuery>;
export type ViewOfferPwaQueryQueryResult = Apollo.QueryResult<ViewOfferPwaQueryQuery, ViewOfferPwaQueryQueryVariables>;
export const CashOutPointsMutationDocument = gql`
    mutation CashOutPointsMutation($points: Int!) {
  cashOutPoints(points: $points) {
    amount
    pointsSpent
    transactionId
    message
  }
}
    `;
export type CashOutPointsMutationMutationFn = Apollo.MutationFunction<CashOutPointsMutationMutation, CashOutPointsMutationMutationVariables>;

/**
 * __useCashOutPointsMutationMutation__
 *
 * To run a mutation, you first call `useCashOutPointsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCashOutPointsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cashOutPointsMutationMutation, { data, loading, error }] = useCashOutPointsMutationMutation({
 *   variables: {
 *      points: // value for 'points'
 *   },
 * });
 */
export function useCashOutPointsMutationMutation(baseOptions?: Apollo.MutationHookOptions<CashOutPointsMutationMutation, CashOutPointsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CashOutPointsMutationMutation, CashOutPointsMutationMutationVariables>(CashOutPointsMutationDocument, options);
      }
export type CashOutPointsMutationMutationHookResult = ReturnType<typeof useCashOutPointsMutationMutation>;
export type CashOutPointsMutationMutationResult = Apollo.MutationResult<CashOutPointsMutationMutation>;
export type CashOutPointsMutationMutationOptions = Apollo.BaseMutationOptions<CashOutPointsMutationMutation, CashOutPointsMutationMutationVariables>;
export const GetPointsHistoryQueryDocument = gql`
    query GetPointsHistoryQuery($offset: Int!, $limit: Int!, $typeFilter: String) {
  getPointsHistory(offset: $offset, limit: $limit, typeFilter: $typeFilter) {
    createdAt
    pointHistory {
      action
      category
      point
      referredFirstName
      referredLastName
      referredProfileImage
      createdAt
      type
    }
  }
}
    `;

/**
 * __useGetPointsHistoryQueryQuery__
 *
 * To run a query within a React component, call `useGetPointsHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsHistoryQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      typeFilter: // value for 'typeFilter'
 *   },
 * });
 */
export function useGetPointsHistoryQueryQuery(baseOptions: Apollo.QueryHookOptions<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables> & ({ variables: GetPointsHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>(GetPointsHistoryQueryDocument, options);
      }
export function useGetPointsHistoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>(GetPointsHistoryQueryDocument, options);
        }
// @ts-ignore
export function useGetPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>;
export function useGetPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPointsHistoryQueryQuery | undefined, GetPointsHistoryQueryQueryVariables>;
export function useGetPointsHistoryQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>(GetPointsHistoryQueryDocument, options);
        }
export type GetPointsHistoryQueryQueryHookResult = ReturnType<typeof useGetPointsHistoryQueryQuery>;
export type GetPointsHistoryQueryLazyQueryHookResult = ReturnType<typeof useGetPointsHistoryQueryLazyQuery>;
export type GetPointsHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useGetPointsHistoryQuerySuspenseQuery>;
export type GetPointsHistoryQueryQueryResult = Apollo.QueryResult<GetPointsHistoryQueryQuery, GetPointsHistoryQueryQueryVariables>;
export const PointsCardQueryDocument = gql`
    query PointsCardQuery {
  pointsCard {
    customerTier
    lifeTimePoint
    pointBalance
    currentMonthPoints
    pointsForNextTier
    tiers {
      name
      threshold
    }
  }
}
    `;

/**
 * __usePointsCardQueryQuery__
 *
 * To run a query within a React component, call `usePointsCardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsCardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsCardQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePointsCardQueryQuery(baseOptions?: Apollo.QueryHookOptions<PointsCardQueryQuery, PointsCardQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointsCardQueryQuery, PointsCardQueryQueryVariables>(PointsCardQueryDocument, options);
      }
export function usePointsCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointsCardQueryQuery, PointsCardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointsCardQueryQuery, PointsCardQueryQueryVariables>(PointsCardQueryDocument, options);
        }
// @ts-ignore
export function usePointsCardQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointsCardQueryQuery, PointsCardQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PointsCardQueryQuery, PointsCardQueryQueryVariables>;
export function usePointsCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsCardQueryQuery, PointsCardQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PointsCardQueryQuery | undefined, PointsCardQueryQueryVariables>;
export function usePointsCardQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsCardQueryQuery, PointsCardQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointsCardQueryQuery, PointsCardQueryQueryVariables>(PointsCardQueryDocument, options);
        }
export type PointsCardQueryQueryHookResult = ReturnType<typeof usePointsCardQueryQuery>;
export type PointsCardQueryLazyQueryHookResult = ReturnType<typeof usePointsCardQueryLazyQuery>;
export type PointsCardQuerySuspenseQueryHookResult = ReturnType<typeof usePointsCardQuerySuspenseQuery>;
export type PointsCardQueryQueryResult = Apollo.QueryResult<PointsCardQueryQuery, PointsCardQueryQueryVariables>;
export const DisableMyPushSubscriptionsMutationDocument = gql`
    mutation DisableMyPushSubscriptionsMutation($provider: String) {
  disableMyPushSubscriptions(provider: $provider) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type DisableMyPushSubscriptionsMutationMutationFn = Apollo.MutationFunction<DisableMyPushSubscriptionsMutationMutation, DisableMyPushSubscriptionsMutationMutationVariables>;

/**
 * __useDisableMyPushSubscriptionsMutationMutation__
 *
 * To run a mutation, you first call `useDisableMyPushSubscriptionsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMyPushSubscriptionsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMyPushSubscriptionsMutationMutation, { data, loading, error }] = useDisableMyPushSubscriptionsMutationMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDisableMyPushSubscriptionsMutationMutation(baseOptions?: Apollo.MutationHookOptions<DisableMyPushSubscriptionsMutationMutation, DisableMyPushSubscriptionsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMyPushSubscriptionsMutationMutation, DisableMyPushSubscriptionsMutationMutationVariables>(DisableMyPushSubscriptionsMutationDocument, options);
      }
export type DisableMyPushSubscriptionsMutationMutationHookResult = ReturnType<typeof useDisableMyPushSubscriptionsMutationMutation>;
export type DisableMyPushSubscriptionsMutationMutationResult = Apollo.MutationResult<DisableMyPushSubscriptionsMutationMutation>;
export type DisableMyPushSubscriptionsMutationMutationOptions = Apollo.BaseMutationOptions<DisableMyPushSubscriptionsMutationMutation, DisableMyPushSubscriptionsMutationMutationVariables>;
export const RegisterPushSubscriptionMutationDocument = gql`
    mutation RegisterPushSubscriptionMutation($input: RegisterPushSubscriptionInput!) {
  registerPushSubscription(input: $input) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type RegisterPushSubscriptionMutationMutationFn = Apollo.MutationFunction<RegisterPushSubscriptionMutationMutation, RegisterPushSubscriptionMutationMutationVariables>;

/**
 * __useRegisterPushSubscriptionMutationMutation__
 *
 * To run a mutation, you first call `useRegisterPushSubscriptionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushSubscriptionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPushSubscriptionMutationMutation, { data, loading, error }] = useRegisterPushSubscriptionMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPushSubscriptionMutationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPushSubscriptionMutationMutation, RegisterPushSubscriptionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPushSubscriptionMutationMutation, RegisterPushSubscriptionMutationMutationVariables>(RegisterPushSubscriptionMutationDocument, options);
      }
export type RegisterPushSubscriptionMutationMutationHookResult = ReturnType<typeof useRegisterPushSubscriptionMutationMutation>;
export type RegisterPushSubscriptionMutationMutationResult = Apollo.MutationResult<RegisterPushSubscriptionMutationMutation>;
export type RegisterPushSubscriptionMutationMutationOptions = Apollo.BaseMutationOptions<RegisterPushSubscriptionMutationMutation, RegisterPushSubscriptionMutationMutationVariables>;
export const UnregisterPushSubscriptionMutationDocument = gql`
    mutation UnregisterPushSubscriptionMutation($provider: String!, $token: String!) {
  unregisterPushSubscription(provider: $provider, token: $token) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type UnregisterPushSubscriptionMutationMutationFn = Apollo.MutationFunction<UnregisterPushSubscriptionMutationMutation, UnregisterPushSubscriptionMutationMutationVariables>;

/**
 * __useUnregisterPushSubscriptionMutationMutation__
 *
 * To run a mutation, you first call `useUnregisterPushSubscriptionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterPushSubscriptionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterPushSubscriptionMutationMutation, { data, loading, error }] = useUnregisterPushSubscriptionMutationMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUnregisterPushSubscriptionMutationMutation(baseOptions?: Apollo.MutationHookOptions<UnregisterPushSubscriptionMutationMutation, UnregisterPushSubscriptionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnregisterPushSubscriptionMutationMutation, UnregisterPushSubscriptionMutationMutationVariables>(UnregisterPushSubscriptionMutationDocument, options);
      }
export type UnregisterPushSubscriptionMutationMutationHookResult = ReturnType<typeof useUnregisterPushSubscriptionMutationMutation>;
export type UnregisterPushSubscriptionMutationMutationResult = Apollo.MutationResult<UnregisterPushSubscriptionMutationMutation>;
export type UnregisterPushSubscriptionMutationMutationOptions = Apollo.BaseMutationOptions<UnregisterPushSubscriptionMutationMutation, UnregisterPushSubscriptionMutationMutationVariables>;
export const SearchUserDocument = gql`
    query SearchUser($input: SearchUserInput!, $limit: Int!, $offset: Int!) {
  searchUser(input: $input, limit: $limit, offset: $offset) {
    ... on CustomerPWA {
      __typename
      id
      firstname
      lastname
      email
      phone
      username
    }
    ... on AdminPWA {
      __typename
      id
      merchantProfile {
        id
        companyName
        username
        companyLocation
        logoUrl
        bannerUrl
        description
        websiteOrSocials
      }
    }
  }
}
    `;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables> & ({ variables: SearchUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
// @ts-ignore
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserQuery, SearchUserQueryVariables>;
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUserQuery | undefined, SearchUserQueryVariables>;
export function useSearchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserSuspenseQueryHookResult = ReturnType<typeof useSearchUserSuspenseQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const CreateWalletKycMutationDocument = gql`
    mutation CreateWalletKycMutation($nin: String!, $dob: String!, $bvn: String!) {
  createWalletKyc(nin: $nin, dob: $dob, bvn: $bvn) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type CreateWalletKycMutationMutationFn = Apollo.MutationFunction<CreateWalletKycMutationMutation, CreateWalletKycMutationMutationVariables>;

/**
 * __useCreateWalletKycMutationMutation__
 *
 * To run a mutation, you first call `useCreateWalletKycMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWalletKycMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWalletKycMutationMutation, { data, loading, error }] = useCreateWalletKycMutationMutation({
 *   variables: {
 *      nin: // value for 'nin'
 *      dob: // value for 'dob'
 *      bvn: // value for 'bvn'
 *   },
 * });
 */
export function useCreateWalletKycMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWalletKycMutationMutation, CreateWalletKycMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWalletKycMutationMutation, CreateWalletKycMutationMutationVariables>(CreateWalletKycMutationDocument, options);
      }
export type CreateWalletKycMutationMutationHookResult = ReturnType<typeof useCreateWalletKycMutationMutation>;
export type CreateWalletKycMutationMutationResult = Apollo.MutationResult<CreateWalletKycMutationMutation>;
export type CreateWalletKycMutationMutationOptions = Apollo.BaseMutationOptions<CreateWalletKycMutationMutation, CreateWalletKycMutationMutationVariables>;
export const GetBalanceMutationDocument = gql`
    mutation GetBalanceMutation {
  getBalance {
    errors {
      path
      message
    }
    message
    data {
      currency
      available_balance
      ledger_balance
    }
  }
}
    `;
export type GetBalanceMutationMutationFn = Apollo.MutationFunction<GetBalanceMutationMutation, GetBalanceMutationMutationVariables>;

/**
 * __useGetBalanceMutationMutation__
 *
 * To run a mutation, you first call `useGetBalanceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBalanceMutationMutation, { data, loading, error }] = useGetBalanceMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetBalanceMutationMutation(baseOptions?: Apollo.MutationHookOptions<GetBalanceMutationMutation, GetBalanceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBalanceMutationMutation, GetBalanceMutationMutationVariables>(GetBalanceMutationDocument, options);
      }
export type GetBalanceMutationMutationHookResult = ReturnType<typeof useGetBalanceMutationMutation>;
export type GetBalanceMutationMutationResult = Apollo.MutationResult<GetBalanceMutationMutation>;
export type GetBalanceMutationMutationOptions = Apollo.BaseMutationOptions<GetBalanceMutationMutation, GetBalanceMutationMutationVariables>;
export const GetBankListMutationDocument = gql`
    mutation GetBankListMutation {
  getBankList {
    errors {
      path
      message
    }
    message
    data {
      id
      code
      name
      provider_type
    }
  }
}
    `;
export type GetBankListMutationMutationFn = Apollo.MutationFunction<GetBankListMutationMutation, GetBankListMutationMutationVariables>;

/**
 * __useGetBankListMutationMutation__
 *
 * To run a mutation, you first call `useGetBankListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetBankListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getBankListMutationMutation, { data, loading, error }] = useGetBankListMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetBankListMutationMutation(baseOptions?: Apollo.MutationHookOptions<GetBankListMutationMutation, GetBankListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetBankListMutationMutation, GetBankListMutationMutationVariables>(GetBankListMutationDocument, options);
      }
export type GetBankListMutationMutationHookResult = ReturnType<typeof useGetBankListMutationMutation>;
export type GetBankListMutationMutationResult = Apollo.MutationResult<GetBankListMutationMutation>;
export type GetBankListMutationMutationOptions = Apollo.BaseMutationOptions<GetBankListMutationMutation, GetBankListMutationMutationVariables>;
export const GetVirtualAccountMutationDocument = gql`
    mutation GetVirtualAccountMutation {
  getVirtualAccount {
    errors {
      path
      message
    }
    message
    data {
      static_account
      bank_name
      bank_code
      currency
      is_default
    }
  }
}
    `;
export type GetVirtualAccountMutationMutationFn = Apollo.MutationFunction<GetVirtualAccountMutationMutation, GetVirtualAccountMutationMutationVariables>;

/**
 * __useGetVirtualAccountMutationMutation__
 *
 * To run a mutation, you first call `useGetVirtualAccountMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualAccountMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVirtualAccountMutationMutation, { data, loading, error }] = useGetVirtualAccountMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetVirtualAccountMutationMutation(baseOptions?: Apollo.MutationHookOptions<GetVirtualAccountMutationMutation, GetVirtualAccountMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVirtualAccountMutationMutation, GetVirtualAccountMutationMutationVariables>(GetVirtualAccountMutationDocument, options);
      }
export type GetVirtualAccountMutationMutationHookResult = ReturnType<typeof useGetVirtualAccountMutationMutation>;
export type GetVirtualAccountMutationMutationResult = Apollo.MutationResult<GetVirtualAccountMutationMutation>;
export type GetVirtualAccountMutationMutationOptions = Apollo.BaseMutationOptions<GetVirtualAccountMutationMutation, GetVirtualAccountMutationMutationVariables>;
export const WalletTransferMutationDocument = gql`
    mutation WalletTransferMutation($input: WalletTransferInput!) {
  walletTransfer(input: $input) {
    errors {
      path
      message
    }
    message
    data {
      id
      account_number
      bank_code
      full_name
      currency
      debit_currency
      amount
      fee
      status
      reference
      narration
      complete_message
      requires_approval
      is_approved
      bank_name
      created_at
    }
  }
}
    `;
export type WalletTransferMutationMutationFn = Apollo.MutationFunction<WalletTransferMutationMutation, WalletTransferMutationMutationVariables>;

/**
 * __useWalletTransferMutationMutation__
 *
 * To run a mutation, you first call `useWalletTransferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalletTransferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walletTransferMutationMutation, { data, loading, error }] = useWalletTransferMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalletTransferMutationMutation(baseOptions?: Apollo.MutationHookOptions<WalletTransferMutationMutation, WalletTransferMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalletTransferMutationMutation, WalletTransferMutationMutationVariables>(WalletTransferMutationDocument, options);
      }
export type WalletTransferMutationMutationHookResult = ReturnType<typeof useWalletTransferMutationMutation>;
export type WalletTransferMutationMutationResult = Apollo.MutationResult<WalletTransferMutationMutation>;
export type WalletTransferMutationMutationOptions = Apollo.BaseMutationOptions<WalletTransferMutationMutation, WalletTransferMutationMutationVariables>;
export const MyTransactionsQueryDocument = gql`
    query MyTransactionsQuery($offset: Int!, $limit: Int!, $duration: String, $filterBy: String, $typeFilter: String, $startDate: String, $endDate: String, $searchText: String) {
  myTransactions(
    offset: $offset
    limit: $limit
    duration: $duration
    filterBy: $filterBy
    typeFilter: $typeFilter
    startDate: $startDate
    endDate: $endDate
    searchText: $searchText
  ) {
    createdAt
    transactions {
      id
      amount
      charge
      reference
      type
      status
      currency
      transferTypes
      offer {
        id
        title
        description
        bannerUrl
        category {
          id
          name
          imgSrc
          createdBy {
            id
            role
          }
          createdAt
          updatedAt
        }
        offerType
        discountType
        discountValue
        partnerVoucher
        referralUrl
        status
        usageLimitPerUser
        totalUsageLimit
        startDate
        endDate
        community {
          id
          name
          alias
        }
        redemptions
        revenueGenerated
        clickThroughs
        featured
        createdBy {
          id
          role
          admin {
            id
            shortId
            firstname
            lastname
            email
            phone
            merchantProfile {
              id
              businessName
              businessType
              regCountry
              businessRegNumber
              taxId
              address
              addressAlt
              city
              country
              postcode
              companyName
              username
              industry {
                id
                name
                createdBy {
                  id
                  role
                }
                createdAt
                updatedAt
              }
              companyLocation
              logoUrl
              bannerUrl
              description
              commissionRate
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      njoyCode
      partnerVoucher
      user {
        id
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useMyTransactionsQueryQuery__
 *
 * To run a query within a React component, call `useMyTransactionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTransactionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTransactionsQueryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      duration: // value for 'duration'
 *      filterBy: // value for 'filterBy'
 *      typeFilter: // value for 'typeFilter'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useMyTransactionsQueryQuery(baseOptions: Apollo.QueryHookOptions<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables> & ({ variables: MyTransactionsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>(MyTransactionsQueryDocument, options);
      }
export function useMyTransactionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>(MyTransactionsQueryDocument, options);
        }
// @ts-ignore
export function useMyTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>;
export function useMyTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MyTransactionsQueryQuery | undefined, MyTransactionsQueryQueryVariables>;
export function useMyTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>(MyTransactionsQueryDocument, options);
        }
export type MyTransactionsQueryQueryHookResult = ReturnType<typeof useMyTransactionsQueryQuery>;
export type MyTransactionsQueryLazyQueryHookResult = ReturnType<typeof useMyTransactionsQueryLazyQuery>;
export type MyTransactionsQuerySuspenseQueryHookResult = ReturnType<typeof useMyTransactionsQuerySuspenseQuery>;
export type MyTransactionsQueryQueryResult = Apollo.QueryResult<MyTransactionsQueryQuery, MyTransactionsQueryQueryVariables>;
export const ViewTransactionQueryDocument = gql`
    query ViewTransactionQuery($id: String!) {
  viewTransaction(id: $id) {
    id
    amount
    transferTypes
    charge
    reference
    type
    status
    currency
    offer {
      id
      title
      description
      bannerUrl
      category {
        id
        name
        imgSrc
        createdBy {
          id
          role
        }
        createdAt
        updatedAt
      }
      offerType
      discountType
      discountValue
      partnerVoucher
      referralUrl
      status
      usageLimitPerUser
      totalUsageLimit
      startDate
      endDate
      community {
        id
        name
        alias
      }
      location {
        id
        city
      }
      redemptions
      revenueGenerated
      clickThroughs
      featured
      createdBy {
        id
        admin {
          id
          merchantProfile {
            id
            companyName
            logoUrl
          }
        }
      }
      offerTOR
      createdAt
      updatedAt
    }
    njoyCode
    partnerVoucher
    partnerVoucher
    user {
      id
      customer {
        firstname
        lastname
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useViewTransactionQueryQuery__
 *
 * To run a query within a React component, call `useViewTransactionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewTransactionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewTransactionQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewTransactionQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables> & ({ variables: ViewTransactionQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>(ViewTransactionQueryDocument, options);
      }
export function useViewTransactionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>(ViewTransactionQueryDocument, options);
        }
// @ts-ignore
export function useViewTransactionQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>;
export function useViewTransactionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewTransactionQueryQuery | undefined, ViewTransactionQueryQueryVariables>;
export function useViewTransactionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>(ViewTransactionQueryDocument, options);
        }
export type ViewTransactionQueryQueryHookResult = ReturnType<typeof useViewTransactionQueryQuery>;
export type ViewTransactionQueryLazyQueryHookResult = ReturnType<typeof useViewTransactionQueryLazyQuery>;
export type ViewTransactionQuerySuspenseQueryHookResult = ReturnType<typeof useViewTransactionQuerySuspenseQuery>;
export type ViewTransactionQueryQueryResult = Apollo.QueryResult<ViewTransactionQueryQuery, ViewTransactionQueryQueryVariables>;
export const VerifyNinMutationDocument = gql`
    mutation VerifyNinMutation($nin: String!, $firstname: String!, $lastname: String!) {
  verifyNIN(nin: $nin, firstname: $firstname, lastname: $lastname) {
    errors {
      path
      message
    }
    message
  }
}
    `;
export type VerifyNinMutationMutationFn = Apollo.MutationFunction<VerifyNinMutationMutation, VerifyNinMutationMutationVariables>;

/**
 * __useVerifyNinMutationMutation__
 *
 * To run a mutation, you first call `useVerifyNinMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyNinMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyNinMutationMutation, { data, loading, error }] = useVerifyNinMutationMutation({
 *   variables: {
 *      nin: // value for 'nin'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *   },
 * });
 */
export function useVerifyNinMutationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyNinMutationMutation, VerifyNinMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyNinMutationMutation, VerifyNinMutationMutationVariables>(VerifyNinMutationDocument, options);
      }
export type VerifyNinMutationMutationHookResult = ReturnType<typeof useVerifyNinMutationMutation>;
export type VerifyNinMutationMutationResult = Apollo.MutationResult<VerifyNinMutationMutation>;
export type VerifyNinMutationMutationOptions = Apollo.BaseMutationOptions<VerifyNinMutationMutation, VerifyNinMutationMutationVariables>;
export const ViewCommunityQueryDocument = gql`
    query ViewCommunityQuery($id: String!) {
  viewCommunity(id: $id) {
    id
    name
    alias
    logoUrl
    colorCode
    createdBy {
      id
      role
      admin {
        id
        shortId
        level
        firstname
        lastname
        email
      }
    }
    createdAt
    updatedAt
    isArchive
  }
}
    `;

/**
 * __useViewCommunityQueryQuery__
 *
 * To run a query within a React component, call `useViewCommunityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewCommunityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewCommunityQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewCommunityQueryQuery(baseOptions: Apollo.QueryHookOptions<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables> & ({ variables: ViewCommunityQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>(ViewCommunityQueryDocument, options);
      }
export function useViewCommunityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>(ViewCommunityQueryDocument, options);
        }
// @ts-ignore
export function useViewCommunityQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>;
export function useViewCommunityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ViewCommunityQueryQuery | undefined, ViewCommunityQueryQueryVariables>;
export function useViewCommunityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>(ViewCommunityQueryDocument, options);
        }
export type ViewCommunityQueryQueryHookResult = ReturnType<typeof useViewCommunityQueryQuery>;
export type ViewCommunityQueryLazyQueryHookResult = ReturnType<typeof useViewCommunityQueryLazyQuery>;
export type ViewCommunityQuerySuspenseQueryHookResult = ReturnType<typeof useViewCommunityQuerySuspenseQuery>;
export type ViewCommunityQueryQueryResult = Apollo.QueryResult<ViewCommunityQueryQuery, ViewCommunityQueryQueryVariables>;
export const ViewUserDocument = gql`
    query ViewUser($id: String!) {
  viewUser(id: $id) {
    ... on CustomerPWA {
      __typename
      id
      avatarUrl
      firstname
      lastname
      email
      username
      phone
      createdAt
      updatedAt
    }
    ... on AdminPWA {
      __typename
      id
      merchantProfile {
        id
        companyName
        username
        companyLocation
        logoUrl
        bannerUrl
        description
      }
    }
    ... on ErrorType {
      __typename
      errors {
        path
        message
      }
    }
  }
}
    `;

/**
 * __useViewUserQuery__
 *
 * To run a query within a React component, call `useViewUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewUserQuery(baseOptions: Apollo.QueryHookOptions<ViewUserQuery, ViewUserQueryVariables> & ({ variables: ViewUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewUserQuery, ViewUserQueryVariables>(ViewUserDocument, options);
      }
export function useViewUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewUserQuery, ViewUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewUserQuery, ViewUserQueryVariables>(ViewUserDocument, options);
        }
// @ts-ignore
export function useViewUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewUserQuery, ViewUserQueryVariables>): Apollo.UseSuspenseQueryResult<ViewUserQuery, ViewUserQueryVariables>;
export function useViewUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewUserQuery, ViewUserQueryVariables>): Apollo.UseSuspenseQueryResult<ViewUserQuery | undefined, ViewUserQueryVariables>;
export function useViewUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewUserQuery, ViewUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewUserQuery, ViewUserQueryVariables>(ViewUserDocument, options);
        }
export type ViewUserQueryHookResult = ReturnType<typeof useViewUserQuery>;
export type ViewUserLazyQueryHookResult = ReturnType<typeof useViewUserLazyQuery>;
export type ViewUserSuspenseQueryHookResult = ReturnType<typeof useViewUserSuspenseQuery>;
export type ViewUserQueryResult = Apollo.QueryResult<ViewUserQuery, ViewUserQueryVariables>;
export const ViewUserWalletDocument = gql`
    query ViewUserWallet($userId: String!) {
  viewUserWallet(userId: $userId) {
    id
    barterId
    currency
    status
    owner {
      id
    }
  }
}
    `;

/**
 * __useViewUserWalletQuery__
 *
 * To run a query within a React component, call `useViewUserWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUserWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUserWalletQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useViewUserWalletQuery(baseOptions: Apollo.QueryHookOptions<ViewUserWalletQuery, ViewUserWalletQueryVariables> & ({ variables: ViewUserWalletQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewUserWalletQuery, ViewUserWalletQueryVariables>(ViewUserWalletDocument, options);
      }
export function useViewUserWalletLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewUserWalletQuery, ViewUserWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewUserWalletQuery, ViewUserWalletQueryVariables>(ViewUserWalletDocument, options);
        }
// @ts-ignore
export function useViewUserWalletSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewUserWalletQuery, ViewUserWalletQueryVariables>): Apollo.UseSuspenseQueryResult<ViewUserWalletQuery, ViewUserWalletQueryVariables>;
export function useViewUserWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewUserWalletQuery, ViewUserWalletQueryVariables>): Apollo.UseSuspenseQueryResult<ViewUserWalletQuery | undefined, ViewUserWalletQueryVariables>;
export function useViewUserWalletSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewUserWalletQuery, ViewUserWalletQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewUserWalletQuery, ViewUserWalletQueryVariables>(ViewUserWalletDocument, options);
        }
export type ViewUserWalletQueryHookResult = ReturnType<typeof useViewUserWalletQuery>;
export type ViewUserWalletLazyQueryHookResult = ReturnType<typeof useViewUserWalletLazyQuery>;
export type ViewUserWalletSuspenseQueryHookResult = ReturnType<typeof useViewUserWalletSuspenseQuery>;
export type ViewUserWalletQueryResult = Apollo.QueryResult<ViewUserWalletQuery, ViewUserWalletQueryVariables>;